
export const mockDetectedObjects = [
  {
    id: "obj_1",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 876, y: 579 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_2",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 763, y: 1056 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_3",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 763, y: 843 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_4",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 948, y: 662 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "b17 type",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_5",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 948, y: 841 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "b17 type",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_6",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 948, y: 1048 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "b17 type",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_none_7",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 763, y: 666 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Led is depicted in plan but not installed in real",
    detectionDate: "2025-07-25",
    frameReference: "frame_00001",
  },
  {
    id: "obj_none_8",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 1040, y: 594 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Not installed yet",
    detectionDate: "2025-07-25",
    frameReference: "frame_00006",
  },
  {
    id: "obj_none_9",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1151, y: 566 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Not installed yet",
    detectionDate: "2025-07-25",
    frameReference: "frame_00007",
  },
  {
    id: "obj_7",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1210, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00007",
  },
  {
    id: "obj_8",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1335, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00007",
  },
  {
    id: "obj_9",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1408, y: 604 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00007",
  },
  {
    id: "obj_10",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1479, y: 604 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_none_14",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1622, y: 604 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Not installed Aussen/an KT 14.18",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_11",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1586, y: 582 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "2xRJ45 WLAN",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_12",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1688, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_13",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1762, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_14",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1833, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_15",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 1633, y: 574 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00011",
  },
  {
    id: "obj_16",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1942, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_17",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2047, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_18",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2118, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_19",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2188, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_20",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 2295, y: 577 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_21",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2406, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00016",
  },
  {
    id: "obj_22",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2475, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_23",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2549, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_24",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2648, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_25",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2755, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_26",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2825, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_27",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2896, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00021",
  },
  {
    id: "obj_28",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3113, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00026",
  },
  {
    id: "obj_29",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3182, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00026",
  },
  {
    id: "obj_30",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3248, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00026",
  },
  {
    id: "obj_31",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3354, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00026",
  },
  {
    id: "obj_32",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3462, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_33",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3536, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_34",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3604, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_35",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3677, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_36",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 3713, y: 581 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_37",
    type: "steckdosen_1-fach",
    confidence: 0.95,
    position: { x: 3830, y: 569 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00031",
  },
  {
    id: "obj_38",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4170, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00036",
  },
  {
    id: "obj_39",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4241, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00036",
  },
  {
    id: "obj_40",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4309, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00036",
  },
  {
    id: "obj_41",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4420, y: 603 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00036",
  },
  {
    id: "obj_42",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4525, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_43",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4596, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_44",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4668, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_45",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4880, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_46",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4952, y: 605 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_47",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 5128, y: 580 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00041",
  },
  {
    id: "obj_48",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5235, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00044",
  },
  {
    id: "obj_49",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5305, y: 606 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00044",
  },
  {
    id: "obj_none_54",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5378, y: 606 },
    size: { width: 40, height: 40 },
    status: "occluded",
    description: "Check",
    detectionDate: "2025-07-25",
    frameReference: "frame_00044",
  },
  {
    id: "obj_50",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 5468, y: 836 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "WLAN/Reserve RJ45",
    detectionDate: "2025-07-25",
    frameReference: "frame_00044",
  },
  {
    id: "obj_51",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5478, y: 800 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00046",
  },
  {
    id: "obj_114",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5450, y: 770 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00046",
  },
  {
    id: "obj_52",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5458, y: 911 },
    size: { width: 40, height: 40 },
    status: "real_vs_plan_dev",
    description: "CHECK",
    detectionDate: "2025-07-25",
    frameReference: "frame_00046",
  },
  {
    id: "obj_none_58",
    type: "steckdosen_1-fach",
    confidence: 0.95,
    position: { x: 5458, y: 984 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00046",
  },
  {
    id: "obj_53",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 5448, y: 1780 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_54",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5342, y: 1544 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_55",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5273, y: 1544 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_56",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4986, y: 1544 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_57",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4919, y: 1544 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_58",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4776, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "WLAN",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_59",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4634, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00051",
  },
  {
    id: "obj_60",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4563, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00054",
  },
  {
    id: "obj_61",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4281, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00056",
  },
  {
    id: "obj_62",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4206, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00056",
  },
  {
    id: "obj_63",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4078, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "WLAN",
    detectionDate: "2025-07-25",
    frameReference: "frame_00061",
  },
  {
    id: "obj_64",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 3712, y: 1565 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 2",
    detectionDate: "2025-07-25",
    frameReference: "frame_00061",
  },
  {
    id: "obj_65",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3607, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00061",
  },
  {
    id: "obj_66",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3535, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00061",
  },
  {
    id: "obj_67",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3464, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00066",
  },
  {
    id: "obj_113",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3296, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00066",
  },
  {
    id: "obj_68",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3183, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00066",
  },
  {
    id: "obj_69",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3068, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00066",
  },
  {
    id: "obj_70",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 3238, y: 1569 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00066",
  },
  {
    id: "obj_71",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2900, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_72",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2825, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_73",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2753, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_74",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2651, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "WLAN",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_75",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2548, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_76",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2477, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_77",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2406, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00071",
  },
  {
    id: "obj_78",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2293, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00076",
  },
  {
    id: "obj_79",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2190, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00076",
  },
  {
    id: "obj_80",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2118, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00076",
  },
  {
    id: "obj_81",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2046, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00076",
  },
  {
    id: "obj_82",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1836, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_83",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1764, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_84",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1690, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_85",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1587, y: 1546 },
    size: { width: 40, height: 40 },
    status: "real_vs_plan_dev",
    description: "Installed in reality not in plan",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_86",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1479, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_87",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1408, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_88",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1338, y: 1546 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00081",
  },
  {
    id: "obj_none_96",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 576, y: 1576 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Exists in plan not in reality",
    detectionDate: "2025-07-25",
    frameReference: "frame_00091",
  },
  {
    id: "obj_89",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 877, y: 1619 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 1",
    detectionDate: "2025-07-25",
    frameReference: "frame_00091",
  },
  {
    id: "obj_90",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 763, y: 1634 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00091",
  },
  {
    id: "obj_91",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 763, y: 1782 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00091",
  },
  {
    id: "obj_none_100",
    type: "hemlet",
    confidence: 0.95,
    position: { x: 763, y: 1882 },
    size: { width: 40, height: 40 },
    status: "occluded",
    description: "HEMLET NOT WARING",
    detectionDate: "2025-07-25",
    frameReference: "frame_00091",
  },
  {
    id: "obj_92",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 874, y: 2413 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Led b17",
    detectionDate: "2025-07-25",
    frameReference: "frame_00096",
  },
  {
    id: "obj_93",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 1052, y: 2290 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Led b17",
    detectionDate: "2025-07-25",
    frameReference: "frame_00096",
  },
  {
    id: "obj_94",
    type: "led_b2",
    confidence: 0.95,
    position: { x: 1054, y: 2507 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Led b17",
    detectionDate: "2025-07-25",
    frameReference: "frame_00096",
  },
  {
    id: "obj_95",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 2294, y: 2636 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 2",
    detectionDate: "2025-07-25",
    frameReference: "frame_00106",
  },
  {
    id: "obj_none_105",
    type: "hemlet",
    confidence: 0.95,
    position: { x: 3276, y: 2386 },
    size: { width: 40, height: 40 },
    status: "occluded",
    description: "HEMLET NOT WARING",
    detectionDate: "2025-07-25",
    frameReference: "frame_00116",
  },
  {
    id: "obj_none_106",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 3728, y: 1744 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00126",
  },
  {
    id: "obj_none_107",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 3719, y: 2539 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "Typ 1",
    detectionDate: "2025-07-25",
    frameReference: "frame_00126",
  },
  {
    id: "obj_96",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 5105, y: 2305 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 2",
    detectionDate: "2025-07-25",
    frameReference: "frame_00133",
  },
  {
    id: "obj_none_109",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 3733, y: 3523 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00146",
  },
  {
    id: "obj_97",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 884, y: 3398 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 1",
    detectionDate: "2025-07-25",
    frameReference: "frame_00171",
  },
  {
    id: "obj_98",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3470 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_99",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3530 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_100",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3585 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_101",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3643 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_102",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3697 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_103",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3751 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_104",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3806 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_105",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3859 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_106",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3921 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_107",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 477, y: 3976 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00176",
  },
  {
    id: "obj_108",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 3717, y: 3727 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 2",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_109",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 4759, y: 3756 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 2",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_110",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 3334, y: 4729 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 3",
    detectionDate: "2025-07-25",
    frameReference: "frame_00231",
  },
  {
    id: "obj_111",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 2277, y: 4728 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "Typ 1",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_124",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 1416, y: 4708 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00256",
  },
  {
    id: "obj_112",
    type: "steckdosen_V",
    confidence: 0.95,
    position: { x: 863, y: 4464 },
    size: { width: 40, height: 40 },
    status: "installed",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00256",
  },
  {
    id: "obj_none_125",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 1430, y: 4718 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_126",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1336, y: 4722 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_127",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1400, y: 4723 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_128",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1472, y: 4723 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_129",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1504, y: 4765 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_130",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 1621, y: 4751 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_131",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1682, y: 4722 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00251",
  },
  {
    id: "obj_none_132",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1753, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_133",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1824, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_134",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1930, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_135",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2038, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_136",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2105, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_137",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2177, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00246",
  },
  {
    id: "obj_none_138",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2388, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_139",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2461, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_140",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2532, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_141",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2637, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_142",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2743, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_143",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2816, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00241",
  },
  {
    id: "obj_none_144",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2882, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_145",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3098, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_146",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3168, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_147",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3241, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_148",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3337, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_149",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3452, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_150",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3520, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_151",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3594, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00236",
  },
  {
    id: "obj_none_152",
    type: "steckdosen_1-fach",
    confidence: 0.95,
    position: { x: 3828, y: 4761 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00231",
  },
  {
    id: "obj_none_153",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4064, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_154",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4177, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_155",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4237, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_156",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4297, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_157",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4309, y: 4760 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_158",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4515, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_159",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4587, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_160",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4658, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_161",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4761, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_162",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4870, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_163",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4942, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_164",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5013, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_165",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5227, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_166",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5293, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_167",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 5367, y: 4720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_168",
    type: "steckdosen_1-fach",
    confidence: 0.95,
    position: { x: 5450, y: 4348 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00211",
  },
  {
    id: "obj_none_169",
    type: "elektro_V",
    confidence: 0.95,
    position: { x: 4362, y: 4752 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_170",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4680 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_171",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4650 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_172",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4620 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_173",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4590 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_174",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4560 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_175",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4530 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_176",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4500 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_177",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4470 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_178",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4440 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_179",
    type: "Staplerladestation",
    confidence: 0.95,
    position: { x: 4259, y: 4410 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00221",
  },
  {
    id: "obj_none_180",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4650, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_181",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4570, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_182",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4500, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_183",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4295, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_184",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4225, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_185",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4158, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_186",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 4042, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_187",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3940, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_188",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3870, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_189",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3800, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_190",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3590, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_191",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3510, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_192",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3440, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_193",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3228, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_194",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3158, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_195",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 3090, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_196",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2980, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00204",
  },
  {
    id: "obj_none_197",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2877, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00196",
  },
  {
    id: "obj_none_198",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2877, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00196",
  },
  {
    id: "obj_none_199",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2800, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00196",
  },
  {
    id: "obj_none_200",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2730, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00196",
  },
  {
    id: "obj_none_201",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2526, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00196",
  },
  {
    id: "obj_none_202",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2458, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_203",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2380, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_204",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2270, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_205",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2166, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_206",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2090, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_207",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2026, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00191",
  },
  {
    id: "obj_none_208",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1810, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_209",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1740, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_210",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1670, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_211",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1560, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_212",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1460, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_213",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1390, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_214",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1315, y: 3770 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00186",
  },
  {
    id: "obj_none_215",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1320, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_216",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1386, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_217",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1454, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_218",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1673, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_219",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1740, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_220",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 1813, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_221",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2023, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_222",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2095, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_223",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2170, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00166",
  },
  {
    id: "obj_none_224",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2380, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
  {
    id: "obj_none_225",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2450, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
  {
    id: "obj_none_226",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2520, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
  {
    id: "obj_none_227",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2730, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
  {
    id: "obj_none_228",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2800, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
  {
    id: "obj_none_229",
    type: "rj_45",
    confidence: 0.95,
    position: { x: 2880, y: 3720 },
    size: { width: 40, height: 40 },
    status: "uninstalled",
    description: "",
    detectionDate: "2025-07-25",
    frameReference: "frame_00161",
  },
];


export const mockDetectedNewObjects = [
  {
    "id": "obj_1",
    "source_ids": {
      "object_id": "obj_1",
      "dwg_id": "C8AE"
    },
    "position": {
      "x": 876,
      "y": 579
    },
    "dwg_pos_img": [
      885.0372384776484,
      588.026937233074
    ],
    "pos_dxf": [
      282.1463160667329,
      1169.685436310882
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CBQKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 3 1F4 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 12.773303218500192,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_2",
    "source_ids": {
      "object_id": "obj_2",
      "dwg_id": "92A3"
    },
    "position": {
      "x": 763,
      "y": 1056
    },
    "dwg_pos_img": [
      775.7285086694238,
      1105.7502610878573
    ],
    "pos_dxf": [
      263.6063194914998,
      1081.865463705752
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": 51.35273518769539,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_3",
    "source_ids": {
      "object_id": "obj_3",
      "dwg_id": "92CC"
    },
    "position": {
      "x": 763,
      "y": 843
    },
    "dwg_pos_img": [
      775.7285086694868,
      906.3338949144854
    ],
    "pos_dxf": [
      263.6063194914998,
      1115.686417606176
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "upper side",
    "match": {
      "distance_px": 64.60028775468639,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_4",
    "source_ids": {
      "object_id": "obj_4",
      "dwg_id": "167EA"
    },
    "position": {
      "x": 948,
      "y": 662
    },
    "dwg_pos_img": [
      969.4239740148429,
      611.8227866205716
    ],
    "pos_dxf": [
      296.4592606101562,
      1165.660674340528
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "b17 type",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GX1KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 54.559503343719605,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_5",
    "source_ids": {
      "object_id": "obj_5",
      "dwg_id": "8E50"
    },
    "position": {
      "x": 948,
      "y": 841
    },
    "dwg_pos_img": [
      957.32017350701,
      906.4735491891515
    ],
    "pos_dxf": [
      294.40631918128,
      1115.686417606176
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "b17 type",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCBXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 66.13358660790307,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_6",
    "source_ids": {
      "object_id": "obj_6",
      "dwg_id": "8E27"
    },
    "position": {
      "x": 948,
      "y": 1048
    },
    "dwg_pos_img": [
      957.3201735069471,
      1105.8899153625234
    ],
    "pos_dxf": [
      294.40631918128,
      1081.865463705752
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00001",
    "description": "b17 type",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYC9XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 58.63538125466333,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_7",
    "source_ids": {
      "object_id": "obj_7",
      "dwg_id": "16489"
    },
    "position": {
      "x": 1210,
      "y": 603
    },
    "dwg_pos_img": [
      1212.5384127777324,
      614.9275963674236
    ],
    "pos_dxf": [
      337.6942184215616,
      1165.1658094155068
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00007",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQSKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 12.194715844755525,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_8",
    "source_ids": {
      "object_id": "obj_8",
      "dwg_id": "11C23"
    },
    "position": {
      "x": 1335,
      "y": 605
    },
    "dwg_pos_img": [
      1342.0053610824043,
      615.0506308661033
    ],
    "pos_dxf": [
      359.6532767912754,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00007",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CRRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.01 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G1,G2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.251133200709809,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_9",
    "source_ids": {
      "object_id": "obj_9",
      "dwg_id": "11C39"
    },
    "position": {
      "x": 1408,
      "y": 604
    },
    "dwg_pos_img": [
      1412.755360369751,
      615.1050416224662
    ],
    "pos_dxf": [
      371.6532766704106,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00007",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CRUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.02 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G1,G2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.080372580467253,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_10",
    "source_ids": {
      "object_id": "obj_10",
      "dwg_id": "11C4D"
    },
    "position": {
      "x": 1479,
      "y": 604
    },
    "dwg_pos_img": [
      1483.5053596570979,
      615.1594523788299
    ],
    "pos_dxf": [
      383.6532765495458,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CRXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.03 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G1,G2],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 12.034601905970009,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_11",
    "source_ids": {
      "object_id": "obj_11",
      "dwg_id": "14ADE"
    },
    "position": {
      "x": 1586,
      "y": 582
    },
    "dwg_pos_img": [
      1585.0665215303538,
      591.6291430582842
    ],
    "pos_dxf": [
      400.8791979980251,
      1169.1658093755939
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "2xRJ45 WLAN",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FGRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 18.21/22 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G1,G2],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 9.674284370959704,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_12",
    "source_ids": {
      "object_id": "obj_12",
      "dwg_id": "11C75"
    },
    "position": {
      "x": 1688,
      "y": 603
    },
    "dwg_pos_img": [
      1695.7553575191373,
      615.3226846479192
    ],
    "pos_dxf": [
      419.6532761869512,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CS3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.04 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 14.560018103756049,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_13",
    "source_ids": {
      "object_id": "obj_13",
      "dwg_id": "11C89"
    },
    "position": {
      "x": 1762,
      "y": 603
    },
    "dwg_pos_img": [
      1766.5053568064832,
      615.377095404283
    ],
    "pos_dxf": [
      431.65327606608616,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CS6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.05 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 13.171588006024427,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_14",
    "source_ids": {
      "object_id": "obj_14",
      "dwg_id": "11C61"
    },
    "position": {
      "x": 1833,
      "y": 603
    },
    "dwg_pos_img": [
      1837.2553560938313,
      615.4315061606458
    ],
    "pos_dxf": [
      443.6532759452216,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CS0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.06 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 13.13964995376517,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_15",
    "source_ids": {
      "object_id": "obj_15",
      "dwg_id": "17BEC"
    },
    "position": {
      "x": 1633,
      "y": 574
    },
    "dwg_pos_img": [
      1611.9946792568003,
      572.7818933294366
    ],
    "pos_dxf": [
      405.4465180364355,
      1172.36580937571
    ],
    "type": "elektro_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00011",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYNKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 21.040610337762722,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_16",
    "source_ids": {
      "object_id": "obj_16",
      "dwg_id": "166B4"
    },
    "position": {
      "x": 1942,
      "y": 606
    },
    "dwg_pos_img": [
      1943.3803549831305,
      615.5131222951586
    ],
    "pos_dxf": [
      461.65327575684796,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GUSKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Reserve/an KT 14.14 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 9.612745480979768,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_17",
    "source_ids": {
      "object_id": "obj_17",
      "dwg_id": "11C9D"
    },
    "position": {
      "x": 2047,
      "y": 606
    },
    "dwg_pos_img": [
      2049.5053539558694,
      615.5947384297351
    ],
    "pos_dxf": [
      479.65327558262675,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CS9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.07 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G3,G4],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 9.916441094426283,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_18",
    "source_ids": {
      "object_id": "obj_18",
      "dwg_id": "11CC5"
    },
    "position": {
      "x": 2118,
      "y": 606
    },
    "dwg_pos_img": [
      2120.2553532432166,
      615.6491491860988
    ],
    "pos_dxf": [
      491.65327546176195,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.08 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G3,G4],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 9.909222889171465,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_19",
    "source_ids": {
      "object_id": "obj_19",
      "dwg_id": "11CB1"
    },
    "position": {
      "x": 2188,
      "y": 606
    },
    "dwg_pos_img": [
      2191.0053525305634,
      615.7035599424617
    ],
    "pos_dxf": [
      503.65327534089715,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.09 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G3,G4],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 10.158307899936402,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_20",
    "source_ids": {
      "object_id": "obj_20",
      "dwg_id": "11682"
    },
    "position": {
      "x": 2295,
      "y": 577
    },
    "dwg_pos_img": [
      2300.0372241828586,
      589.1380435883857
    ],
    "pos_dxf": [
      522.1463136423592,
      1169.681553965694
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCTKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F5 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 13.141755195632232,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_21",
    "source_ids": {
      "object_id": "obj_21",
      "dwg_id": "18110"
    },
    "position": {
      "x": 2406,
      "y": 606
    },
    "dwg_pos_img": [
      2412.8985073321533,
      604.9928633756545
    ],
    "pos_dxf": [
      541.2888634344813,
      1167.0073021400337
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00016",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 6.97163736807003,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_22",
    "source_ids": {
      "object_id": "obj_22",
      "dwg_id": "11CED"
    },
    "position": {
      "x": 2475,
      "y": 606
    },
    "dwg_pos_img": [
      2478.433215536907,
      615.9246082475302
    ],
    "pos_dxf": [
      552.4042909745194,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.11 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 10.50165785910984,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_23",
    "source_ids": {
      "object_id": "obj_23",
      "dwg_id": "11CD9"
    },
    "position": {
      "x": 2549,
      "y": 606
    },
    "dwg_pos_img": [
      2549.1832148242543,
      615.979019003893
    ],
    "pos_dxf": [
      564.4042908536546,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.12 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 9.980700774589108,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_24",
    "source_ids": {
      "object_id": "obj_24",
      "dwg_id": "16475"
    },
    "position": {
      "x": 2648,
      "y": 606
    },
    "dwg_pos_img": [
      2648.517056026144,
      616.05541241008
    ],
    "pos_dxf": [
      581.25243353102,
      1165.1618293958948
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQPKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an KT 14.19 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 10.068697317476664,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_25",
    "source_ids": {
      "object_id": "obj_25",
      "dwg_id": "11D29"
    },
    "position": {
      "x": 2755,
      "y": 606
    },
    "dwg_pos_img": [
      2757.005634711818,
      616.1388462147652
    ],
    "pos_dxf": [
      599.6533232021025,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.13 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G5,G6],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.33531679068945,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_26",
    "source_ids": {
      "object_id": "obj_26",
      "dwg_id": "11D3D"
    },
    "position": {
      "x": 2825,
      "y": 606
    },
    "dwg_pos_img": [
      2827.755633999165,
      616.1932569711289
    ],
    "pos_dxf": [
      611.6533230812377,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.14 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G5,G6],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.559166937634005,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_27",
    "source_ids": {
      "object_id": "obj_27",
      "dwg_id": "11D15"
    },
    "position": {
      "x": 2896,
      "y": 606
    },
    "dwg_pos_img": [
      2898.505633286508,
      616.2476677274917
    ],
    "pos_dxf": [
      623.6533229603722,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00021",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.15 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G5,G6],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 10.549544635648095,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_28",
    "source_ids": {
      "object_id": "obj_28",
      "dwg_id": "11D51"
    },
    "position": {
      "x": 3113,
      "y": 606
    },
    "dwg_pos_img": [
      3110.755343266067,
      616.4108997751837
    ],
    "pos_dxf": [
      659.6532737696537,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00026",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CT0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.16 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G6,G7],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.650132298807852,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_29",
    "source_ids": {
      "object_id": "obj_29",
      "dwg_id": "11D65"
    },
    "position": {
      "x": 3182,
      "y": 606
    },
    "dwg_pos_img": [
      3181.505342553414,
      616.4653105315465
    ],
    "pos_dxf": [
      671.6532736487889,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00026",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CT3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.17 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G6,G7],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.4769943452863,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_30",
    "source_ids": {
      "object_id": "obj_30",
      "dwg_id": "11D79"
    },
    "position": {
      "x": 3248,
      "y": 606
    },
    "dwg_pos_img": [
      3252.2553418407565,
      616.5197212879102
    ],
    "pos_dxf": [
      683.6532735279234,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00026",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CT6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.18 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G6,G7],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 11.34779582813351,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_31",
    "source_ids": {
      "object_id": "obj_31",
      "dwg_id": "16399"
    },
    "position": {
      "x": 3354,
      "y": 606
    },
    "dwg_pos_img": [
      3358.3803407300597,
      616.5671063865993
    ],
    "pos_dxf": [
      701.6532733395504,
      1165.1676349785528
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00026",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/ Aussen/an KT 14.20 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G6,G7],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 11.439017540730006,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_32",
    "source_ids": {
      "object_id": "obj_32",
      "dwg_id": "11D8D"
    },
    "position": {
      "x": 3462,
      "y": 606
    },
    "dwg_pos_img": [
      3464.505339702799,
      616.6829535569996
    ],
    "pos_dxf": [
      719.6532731653292,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CT9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.19 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.97279470907167,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_33",
    "source_ids": {
      "object_id": "obj_33",
      "dwg_id": "11DB5"
    },
    "position": {
      "x": 3536,
      "y": 606
    },
    "dwg_pos_img": [
      3535.2553389901454,
      616.7373643133633
    ],
    "pos_dxf": [
      731.6532730444644,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.20 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 10.763155318840523,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_34",
    "source_ids": {
      "object_id": "obj_34",
      "dwg_id": "11DA1"
    },
    "position": {
      "x": 3604,
      "y": 606
    },
    "dwg_pos_img": [
      3606.00533827749,
      616.7917750697261
    ],
    "pos_dxf": [
      743.6532729235992,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.21 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 10.976510864693212,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_35",
    "source_ids": {
      "object_id": "obj_35",
      "dwg_id": "165AB"
    },
    "position": {
      "x": 3677,
      "y": 606
    },
    "dwg_pos_img": [
      3676.097641986758,
      616.1608914580538
    ],
    "pos_dxf": [
      755.5417201958517,
      1165.2779693335237
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GT0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Reserve/an KT 14.15 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 10.200880609359816,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_36",
    "source_ids": {
      "object_id": "obj_36",
      "dwg_id": "1031E"
    },
    "position": {
      "x": 3713,
      "y": 581
    },
    "dwg_pos_img": [
      3715.0366342065395,
      590.2033670448063
    ],
    "pos_dxf": [
      762.1462135758889,
      1169.685436310882
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCEKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F4 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 9.426019512640202,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_37",
    "source_ids": {
      "object_id": "obj_37",
      "dwg_id": "C733"
    },
    "position": {
      "x": 3830,
      "y": 569
    },
    "dwg_pos_img": [
      3833.779311151359,
      574.726421526836
    ],
    "pos_dxf": [
      782.2863142591236,
      1172.325809291319
    ],
    "type": "steckdosen_1-fach",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00031",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C96KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 6.861129373637837,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_38",
    "source_ids": {
      "object_id": "obj_38",
      "dwg_id": "11DC9"
    },
    "position": {
      "x": 4170,
      "y": 605
    },
    "dwg_pos_img": [
      4172.005332576263,
      617.2270611206313
    ],
    "pos_dxf": [
      839.6532719566803,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00036",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.01 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H1,H2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.390414940149315,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_39",
    "source_ids": {
      "object_id": "obj_39",
      "dwg_id": "11DDD"
    },
    "position": {
      "x": 4241,
      "y": 603
    },
    "dwg_pos_img": [
      4242.755331863608,
      617.281471876995
    ],
    "pos_dxf": [
      851.6532718358153,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00036",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.02 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H1,H2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 14.38894120235395,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_40",
    "source_ids": {
      "object_id": "obj_40",
      "dwg_id": "11DF1"
    },
    "position": {
      "x": 4309,
      "y": 603
    },
    "dwg_pos_img": [
      4313.505331150956,
      617.3358826333579
    ],
    "pos_dxf": [
      863.6532717149507,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00036",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.03 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H1,H2],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 15.027160066266346,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_41",
    "source_ids": {
      "object_id": "obj_41",
      "dwg_id": "165BF"
    },
    "position": {
      "x": 4420,
      "y": 603
    },
    "dwg_pos_img": [
      4419.630330040258,
      617.4174987678707
    ],
    "pos_dxf": [
      881.6532715265776,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00036",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GT3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an KT 10.11 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H1,H2],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 14.42223722591919,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_42",
    "source_ids": {
      "object_id": "obj_42",
      "dwg_id": "11E05"
    },
    "position": {
      "x": 4525,
      "y": 605
    },
    "dwg_pos_img": [
      4525.755329012994,
      617.4991149024481
    ],
    "pos_dxf": [
      899.6532713523557,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.04 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H2,H3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 12.521916597009849,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_43",
    "source_ids": {
      "object_id": "obj_43",
      "dwg_id": "11E2D"
    },
    "position": {
      "x": 4596,
      "y": 605
    },
    "dwg_pos_img": [
      4596.505328300342,
      617.5535256588109
    ],
    "pos_dxf": [
      911.6532712314911,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.05 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H2,H3],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.563692258152095,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_44",
    "source_ids": {
      "object_id": "obj_44",
      "dwg_id": "11E19"
    },
    "position": {
      "x": 4668,
      "y": 605
    },
    "dwg_pos_img": [
      4667.255327587684,
      617.6079364151747
    ],
    "pos_dxf": [
      923.6532711106256,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CTUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.06 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H2,H3],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 12.629908853620096,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_45",
    "source_ids": {
      "object_id": "obj_45",
      "dwg_id": "11E69"
    },
    "position": {
      "x": 4880,
      "y": 605
    },
    "dwg_pos_img": [
      4879.505325449726,
      617.771168684264
    ],
    "pos_dxf": [
      959.6532707480314,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CU6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.07 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H3,I],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 12.780745380165213,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_46",
    "source_ids": {
      "object_id": "obj_46",
      "dwg_id": "11E55"
    },
    "position": {
      "x": 4952,
      "y": 605
    },
    "dwg_pos_img": [
      4950.255324737072,
      617.8255794406268
    ],
    "pos_dxf": [
      971.6532706271664,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CU3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.08 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H3,I],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.943700389027121,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_47",
    "source_ids": {
      "object_id": "obj_47",
      "dwg_id": "111A9"
    },
    "position": {
      "x": 5128,
      "y": 580
    },
    "dwg_pos_img": [
      5130.03719571844,
      591.2915826148665
    ],
    "pos_dxf": [
      1002.146308814841,
      1169.685436310882
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00041",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCKKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F5 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H3,I],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 11.473883577219341,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_48",
    "source_ids": {
      "object_id": "obj_48",
      "dwg_id": "11E91"
    },
    "position": {
      "x": 5235,
      "y": 606
    },
    "dwg_pos_img": [
      5233.255321886459,
      618.0432224660799
    ],
    "pos_dxf": [
      1019.653270143707,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00044",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.10 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 12.168940343652018,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_49",
    "source_ids": {
      "object_id": "obj_49",
      "dwg_id": "11E7D"
    },
    "position": {
      "x": 5305,
      "y": 606
    },
    "dwg_pos_img": [
      5304.005321173804,
      618.0976332224427
    ],
    "pos_dxf": [
      1031.653270022842,
      1165.1618294054858
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00044",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CU9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.11 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 12.138456061296761,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_50",
    "source_ids": {
      "object_id": "obj_50",
      "dwg_id": "17C0C"
    },
    "position": {
      "x": 5468,
      "y": 836
    },
    "dwg_pos_img": [
      5458.199294799088,
      846.9667506434589
    ],
    "pos_dxf": [
      1057.80631148582,
      1126.365809813806
    ],
    "type": "elektro_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00044",
    "description": "WLAN/Reserve RJ45",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYPKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 14.707938064561656,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_51",
    "source_ids": {
      "object_id": "obj_51",
      "dwg_id": "14B2E"
    },
    "position": {
      "x": 5478,
      "y": 800
    },
    "dwg_pos_img": [
      5477.3066542449105,
      814.7120474268331
    ],
    "pos_dxf": [
      1061.04713570278,
      1131.838689689709
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FH9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 20.05/06 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 14.728376279328543,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_114",
    "source_ids": {
      "object_id": "obj_114",
      "dwg_id": "16411"
    },
    "position": {
      "x": 5450,
      "y": 770
    },
    "dwg_pos_img": [
      5435.961731363912,
      780.4497435069825
    ],
    "pos_dxf": [
      1054.034569277727,
      1137.644173124691
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQ6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.10 WLAN/Reserve/an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 17.500575009430335,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_53",
    "source_ids": {
      "object_id": "obj_53",
      "dwg_id": "13D9F"
    },
    "position": {
      "x": 5448,
      "y": 1780
    },
    "dwg_pos_img": [
      5455.698250082492,
      1769.5506396219444
    ],
    "pos_dxf": [
      1057.38210602157,
      969.8955419520721
    ],
    "type": "elektro_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EXMKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "25F01 EDV Rack ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I,I1],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 12.978913153383616,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_54",
    "source_ids": {
      "object_id": "obj_54",
      "dwg_id": "129BD"
    },
    "position": {
      "x": 5342,
      "y": 1544
    },
    "dwg_pos_img": [
      5339.380896582158,
      1548.4095482662133
    ],
    "pos_dxf": [
      1037.6533676186596,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D69KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.20 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I,I1],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 5.128724853744398,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_55",
    "source_ids": {
      "object_id": "obj_55",
      "dwg_id": "129A9"
    },
    "position": {
      "x": 5273,
      "y": 1544
    },
    "dwg_pos_img": [
      5268.630897294809,
      1548.355137509856
    ],
    "pos_dxf": [
      1025.653367739524,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D66KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.19 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I,I1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 6.168977320290674,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_56",
    "source_ids": {
      "object_id": "obj_56",
      "dwg_id": "12995"
    },
    "position": {
      "x": 4986,
      "y": 1544
    },
    "dwg_pos_img": [
      4985.630900145427,
      1548.1374944843974
    ],
    "pos_dxf": [
      977.6533682229842,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D63KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.18 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 4.153925289538122,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_57",
    "source_ids": {
      "object_id": "obj_57",
      "dwg_id": "12981"
    },
    "position": {
      "x": 4919,
      "y": 1544
    },
    "dwg_pos_img": [
      4914.8809008580765,
      1548.08308372804
    ],
    "pos_dxf": [
      965.6533683438483,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D60KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.17 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 5.7998750392728295,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_58",
    "source_ids": {
      "object_id": "obj_58",
      "dwg_id": "16385"
    },
    "position": {
      "x": 4776,
      "y": 1546
    },
    "dwg_pos_img": [
      4773.380326476693,
      1547.9742617724796
    ],
    "pos_dxf": [
      941.6532709222524,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "WLAN",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.13 WLAN/an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 3.280304698498333,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_59",
    "source_ids": {
      "object_id": "obj_59",
      "dwg_id": "12959"
    },
    "position": {
      "x": 4634,
      "y": 1546
    },
    "dwg_pos_img": [
      4631.880903708695,
      1547.8654407025815
    ],
    "pos_dxf": [
      917.6533688273084,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00051",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.16 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 2.8231964343047395,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_60",
    "source_ids": {
      "object_id": "obj_60",
      "dwg_id": "1296D"
    },
    "position": {
      "x": 4563,
      "y": 1546
    },
    "dwg_pos_img": [
      4561.130904421346,
      1547.8110299462242
    ],
    "pos_dxf": [
      905.653368948173,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00054",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.15 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 2.6025656088301257,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_61",
    "source_ids": {
      "object_id": "obj_61",
      "dwg_id": "12945"
    },
    "position": {
      "x": 4281,
      "y": 1546
    },
    "dwg_pos_img": [
      4278.130331506989,
      1547.59338647797
    ],
    "pos_dxf": [
      857.653271775383,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00056",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.14 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 3.282358561759722,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_62",
    "source_ids": {
      "object_id": "obj_62",
      "dwg_id": "12931"
    },
    "position": {
      "x": 4206,
      "y": 1546
    },
    "dwg_pos_img": [
      4207.380332219644,
      1547.5389757216117
    ],
    "pos_dxf": [
      845.653271896248,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00056",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.13 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 2.0673082276952384,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_63",
    "source_ids": {
      "object_id": "obj_63",
      "dwg_id": "1644D"
    },
    "position": {
      "x": 4078,
      "y": 1546
    },
    "dwg_pos_img": [
      4077.672000151119,
      1547.439222668242
    ],
    "pos_dxf": [
      823.6532721107569,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00061",
    "description": "WLAN",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.12 WLAN/an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": 1.4761252621806653,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_64",
    "source_ids": {
      "object_id": "obj_64",
      "dwg_id": "E10E"
    },
    "position": {
      "x": 3712,
      "y": 1565
    },
    "dwg_pos_img": [
      3715.037209630212,
      1589.731286228961
    ],
    "pos_dxf": [
      762.1463111743037,
      1000.165811063287
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00061",
    "description": "Typ 2",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CC0KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F6 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 24.917085721982932,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_65",
    "source_ids": {
      "object_id": "obj_65",
      "dwg_id": "1223D"
    },
    "position": {
      "x": 3607,
      "y": 1546
    },
    "dwg_pos_img": [
      3606.0053382772,
      1547.0764842925191
    ],
    "pos_dxf": [
      743.6532729235996,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00061",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CY9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.18 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.4656638000729274,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_66",
    "source_ids": {
      "object_id": "obj_66",
      "dwg_id": "12251"
    },
    "position": {
      "x": 3535,
      "y": 1546
    },
    "dwg_pos_img": [
      3535.2553389898526,
      1547.0220735361563
    ],
    "pos_dxf": [
      731.6532730444644,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00061",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.17 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 1.053485791574813,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_67",
    "source_ids": {
      "object_id": "obj_67",
      "dwg_id": "12229"
    },
    "position": {
      "x": 3464,
      "y": 1546
    },
    "dwg_pos_img": [
      3464.5053397025035,
      1546.967662779798
    ],
    "pos_dxf": [
      719.6532731653288,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00066",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CY6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.16 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 1.091668205240422,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_113",
    "source_ids": {
      "object_id": "obj_113",
      "dwg_id": "1214D"
    },
    "position": {
      "x": 3296,
      "y": 1546
    },
    "dwg_pos_img": [
      3295.5629656861415,
      1546.8377365261586
    ],
    "pos_dxf": [
      690.9987362296695,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00066",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CX9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.15 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 0.9448817273870552,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_68",
    "source_ids": {
      "object_id": "obj_68",
      "dwg_id": "1219D"
    },
    "position": {
      "x": 3183,
      "y": 1546
    },
    "dwg_pos_img": [
      3181.5053425531205,
      1546.7500197543395
    ],
    "pos_dxf": [
      671.6532736487889,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00066",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.14 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 1.6722830249129061,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_69",
    "source_ids": {
      "object_id": "obj_69",
      "dwg_id": "14BCA"
    },
    "position": {
      "x": 3068,
      "y": 1546
    },
    "dwg_pos_img": [
      3067.447719420098,
      1546.6623029825214
    ],
    "pos_dxf": [
      652.307811067908,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00066",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1FI3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.13 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": 0.8623567009036948,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_70",
    "source_ids": {
      "object_id": "obj_70",
      "dwg_id": "13914"
    },
    "position": {
      "x": 3238,
      "y": 1569
    },
    "dwg_pos_img": [
      3240.2442208531675,
      1577.432214374181
    ],
    "pos_dxf": [
      681.6160515936824,
      1002.189801749717
    ],
    "type": "elektro_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00066",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EHFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F02 EDV Rack ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 8.725753061480559,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_71",
    "source_ids": {
      "object_id": "obj_71",
      "dwg_id": "12279"
    },
    "position": {
      "x": 2900,
      "y": 1546
    },
    "dwg_pos_img": [
      2898.505633286216,
      1546.5323769502847
    ],
    "pos_dxf": [
      623.6533229603724,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.12 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.5863660020500623,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_72",
    "source_ids": {
      "object_id": "obj_72",
      "dwg_id": "12265"
    },
    "position": {
      "x": 2825,
      "y": 1546
    },
    "dwg_pos_img": [
      2827.755633998869,
      1546.477966193922
    ],
    "pos_dxf": [
      611.6533230812372,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.11 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 2.7967785786965265,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_73",
    "source_ids": {
      "object_id": "obj_73",
      "dwg_id": "1228D"
    },
    "position": {
      "x": 2753,
      "y": 1546
    },
    "dwg_pos_img": [
      2757.005634711522,
      1546.4235554375637
    ],
    "pos_dxf": [
      599.653323202102,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.10 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 4.027965820465578,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_74",
    "source_ids": {
      "object_id": "obj_74",
      "dwg_id": "16655"
    },
    "position": {
      "x": 2651,
      "y": 1546
    },
    "dwg_pos_img": [
      2650.880347856301,
      1546.3419390815834
    ],
    "pos_dxf": [
      581.6532745481991,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "WLAN",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTWKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.22 WLAN/an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 0.362269196876985,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_75",
    "source_ids": {
      "object_id": "obj_75",
      "dwg_id": "12125"
    },
    "position": {
      "x": 2548,
      "y": 1546
    },
    "dwg_pos_img": [
      2549.183214823961,
      1546.263728226686
    ],
    "pos_dxf": [
      564.4042908536546,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CX3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.09 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.2122499318176465,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_76",
    "source_ids": {
      "object_id": "obj_76",
      "dwg_id": "12189"
    },
    "position": {
      "x": 2477,
      "y": 1546
    },
    "dwg_pos_img": [
      2478.4332155366137,
      1546.2093174703232
    ],
    "pos_dxf": [
      552.4042909745194,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.08 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.4484200280904151,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_77",
    "source_ids": {
      "object_id": "obj_77",
      "dwg_id": "121ED"
    },
    "position": {
      "x": 2406,
      "y": 1546
    },
    "dwg_pos_img": [
      2407.6832162492683,
      1546.1549067139595
    ],
    "pos_dxf": [
      540.4042910953845,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00071",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.07 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 1.6903292672821342,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_78",
    "source_ids": {
      "object_id": "obj_78",
      "dwg_id": "164ED"
    },
    "position": {
      "x": 2293,
      "y": 1546
    },
    "dwg_pos_img": [
      2297.130351419569,
      1546.0698852997675
    ],
    "pos_dxf": [
      521.6532751525235,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00076",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GRDKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.16 WLAN/Reserve/an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 4.130942604812801,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_79",
    "source_ids": {
      "object_id": "obj_79",
      "dwg_id": "12201"
    },
    "position": {
      "x": 2190,
      "y": 1546
    },
    "dwg_pos_img": [
      2191.005352530266,
      1545.9882691652547
    ],
    "pos_dxf": [
      503.65327534089647,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00076",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CY0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.06 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.0054209678518191,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_80",
    "source_ids": {
      "object_id": "obj_80",
      "dwg_id": "121D9"
    },
    "position": {
      "x": 2118,
      "y": 1546
    },
    "dwg_pos_img": [
      2120.2553532429206,
      1545.9338584088919
    ],
    "pos_dxf": [
      491.6532754617615,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00076",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.05 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 2.2563228847899284,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_81",
    "source_ids": {
      "object_id": "obj_81",
      "dwg_id": "12215"
    },
    "position": {
      "x": 2046,
      "y": 1546
    },
    "dwg_pos_img": [
      2049.5053539555747,
      1545.8794476525281
    ],
    "pos_dxf": [
      479.6532755826265,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00076",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CY3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.04 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 3.5074262960672895,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_82",
    "source_ids": {
      "object_id": "obj_82",
      "dwg_id": "12175"
    },
    "position": {
      "x": 1836,
      "y": 1546
    },
    "dwg_pos_img": [
      1837.2553560935366,
      1545.7162153834388
    ],
    "pos_dxf": [
      443.65327594522137,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.03 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 1.2870324899459156,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_83",
    "source_ids": {
      "object_id": "obj_83",
      "dwg_id": "12139"
    },
    "position": {
      "x": 1764,
      "y": 1546
    },
    "dwg_pos_img": [
      1766.5053568061899,
      1545.661804627076
    ],
    "pos_dxf": [
      431.65327606608616,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CX6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.02 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 2.528080069259892,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_84",
    "source_ids": {
      "object_id": "obj_84",
      "dwg_id": "121C5"
    },
    "position": {
      "x": 1690,
      "y": 1546
    },
    "dwg_pos_img": [
      1695.755357518844,
      1545.6073938707123
    ],
    "pos_dxf": [
      419.6532761869512,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.01 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 5.768732940817108,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_86",
    "source_ids": {
      "object_id": "obj_86",
      "dwg_id": "12161"
    },
    "position": {
      "x": 1479,
      "y": 1546
    },
    "dwg_pos_img": [
      1483.5053596568046,
      1545.444161601623
    ],
    "pos_dxf": [
      383.6532765495458,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.24 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": 4.539517811648335,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_87",
    "source_ids": {
      "object_id": "obj_87",
      "dwg_id": "12111"
    },
    "position": {
      "x": 1408,
      "y": 1546
    },
    "dwg_pos_img": [
      1412.7553603694578,
      1545.3897508452592
    ],
    "pos_dxf": [
      371.6532766704106,
      1007.3858310326161
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CX0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.23 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 4.794356711204483,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_88",
    "source_ids": {
      "object_id": "obj_88",
      "dwg_id": "121B1"
    },
    "position": {
      "x": 1338,
      "y": 1546
    },
    "dwg_pos_img": [
      1342.0053610821124,
      1545.3353400889018
    ],
    "pos_dxf": [
      359.65327679127563,
      1007.3858310326152
    ],
    "type": "rj_45",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CXOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.22 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 4.060134258312317,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_89",
    "source_ids": {
      "object_id": "obj_89",
      "dwg_id": "F493"
    },
    "position": {
      "x": 877,
      "y": 1619
    },
    "dwg_pos_img": [
      885.037238477321,
      1625.7640963354024
    ],
    "pos_dxf": [
      282.1463160667329,
      993.6855357398154
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00091",
    "description": "Typ 1",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CC8KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F6 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 10.504770419953685,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_90",
    "source_ids": {
      "object_id": "obj_90",
      "dwg_id": "931E"
    },
    "position": {
      "x": 763,
      "y": 1634
    },
    "dwg_pos_img": [
      775.7285086692426,
      1680.4144110873713
    ],
    "pos_dxf": [
      263.6063194914998,
      984.4026019641906
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00091",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F1,G],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 48.128084207980656,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_91",
    "source_ids": {
      "object_id": "obj_91",
      "dwg_id": "B4F0"
    },
    "position": {
      "x": 763,
      "y": 1782
    },
    "dwg_pos_img": [
      775.728508669196,
      1828.5074475080692
    ],
    "pos_dxf": [
      263.6063194914998,
      959.2860688838327
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00091",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT238XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F1,G],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": 48.21781420447848,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_92",
    "source_ids": {
      "object_id": "obj_92",
      "dwg_id": "13569"
    },
    "position": {
      "x": 874,
      "y": 2413
    },
    "dwg_pos_img": [
      900.6053456150972,
      2391.047588538553
    ],
    "pos_dxf": [
      284.7868430724764,
      863.8957232124685
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00096",
    "description": "Led b17",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1EG1KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 34.49279322222888,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_93",
    "source_ids": {
      "object_id": "obj_93",
      "dwg_id": "AF55"
    },
    "position": {
      "x": 1052,
      "y": 2290
    },
    "dwg_pos_img": [
      1065.8057575688817,
      2339.6201347605584
    ],
    "pos_dxf": [
      312.8067009303809,
      872.6393508165856
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00096",
    "description": "Led b17",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21AXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": 51.504919335017966,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_94",
    "source_ids": {
      "object_id": "obj_94",
      "dwg_id": "AFD0"
    },
    "position": {
      "x": 1054,
      "y": 2507
    },
    "dwg_pos_img": [
      1065.8057575688135,
      2554.7874343663652
    ],
    "pos_dxf": [
      312.8067009303809,
      836.1470434875073
    ],
    "type": "led_b2",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00096",
    "description": "Led b17",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21GXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": 49.22412818012385,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_95",
    "source_ids": {
      "object_id": "obj_95",
      "dwg_id": "DC24"
    },
    "position": {
      "x": 2294,
      "y": 2636
    },
    "dwg_pos_img": [
      2317.0023828672715,
      2644.4746540198266
    ],
    "pos_dxf": [
      525.0237963875309,
      821.0993146164974
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00106",
    "description": "Typ 2",
    "confidence": 0.95,
    "dwg_name": [
      "Steckdosenverteiler_A01U1CBWKH",
      "Bauteilbeschriftung_A01U1CBXKH"
    ],
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F7 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": 24.51386094290964,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_96",
    "source_ids": {
      "object_id": "obj_96",
      "dwg_id": "E5F2"
    },
    "position": {
      "x": 5105,
      "y": 2305
    },
    "dwg_pos_img": [
      5109.835520077725,
      2317.800574603306
    ],
    "pos_dxf": [
      998.7198761974241,
      876.8674114043824
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00133",
    "description": "Typ 2",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CC2KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F7 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H3,I],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 13.683455871850581,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_97",
    "source_ids": {
      "object_id": "obj_97",
      "dwg_id": "EFBA"
    },
    "position": {
      "x": 884,
      "y": 3398
    },
    "dwg_pos_img": [
      885.0372384767628,
      3394.635811185373
    ],
    "pos_dxf": [
      282.1463160667329,
      693.6854411051886
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00171",
    "description": "Typ 1",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CC6KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F5 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 3.5204587823378364,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_98",
    "source_ids": {
      "object_id": "obj_98",
      "dwg_id": "13159"
    },
    "position": {
      "x": 477,
      "y": 3470
    },
    "dwg_pos_img": [
      493.5843035106699,
      3479.2001234275726
    ],
    "pos_dxf": [
      215.75147197349747,
      679.2923020588819
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1E18KH",
      "Schaltkreis_A01U1E19KH",
      "1xAP-SD_ SchuKo_A01U1E1CKH",
      "AP-SD_ Drehstrom_A01U1FDUKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F02 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": 18.96526809767234,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_99",
    "source_ids": {
      "object_id": "obj_99",
      "dwg_id": "13175"
    },
    "position": {
      "x": 477,
      "y": 3530
    },
    "dwg_pos_img": [
      493.58430351065283,
      3533.293914514463
    ],
    "pos_dxf": [
      215.75147197349747,
      670.1180118551465
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EG9KH",
      "Schaltkreis_A01U1E1DKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Staplerladestation 12F04 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": 16.90825229768117,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_100",
    "source_ids": {
      "object_id": "obj_100",
      "dwg_id": "135A6"
    },
    "position": {
      "x": 477,
      "y": 3585
    },
    "dwg_pos_img": [
      493.70250805876674,
      3586.878895247227
    ],
    "pos_dxf": [
      215.77152080144901,
      661.0300311474098
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EGDKH",
      "Schaltkreis_A01U1EGAKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F03 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": 16.807855984723915,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_101",
    "source_ids": {
      "object_id": "obj_101",
      "dwg_id": "135C2"
    },
    "position": {
      "x": 477,
      "y": 3643
    },
    "dwg_pos_img": [
      493.58430351061645,
      3648.3115586571457
    ],
    "pos_dxf": [
      215.75147197349747,
      650.611055054504
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EGHKH",
      "Schaltkreis_A01U1EGEKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F02 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 17.414125826481925,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_102",
    "source_ids": {
      "object_id": "obj_102",
      "dwg_id": "135DE"
    },
    "position": {
      "x": 477,
      "y": 3697
    },
    "dwg_pos_img": [
      493.7025080587306,
      3701.89653938991
    ],
    "pos_dxf": [
      215.77152080144901,
      641.5230743467673
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1EGLKH",
      "Schaltkreis_A01U1EGIKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F01 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": 17.405455278414816,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_103",
    "source_ids": {
      "object_id": "obj_103",
      "dwg_id": "135FD"
    },
    "position": {
      "x": 477,
      "y": 3751
    },
    "dwg_pos_img": [
      493.5843035105826,
      3755.9902395708064
    ],
    "pos_dxf": [
      215.75147197349747,
      632.3487841430322
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EGPKH",
      "Schaltkreis_A01U1EGMKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F01 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F,F1],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 17.318822532295982,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_104",
    "source_ids": {
      "object_id": "obj_104",
      "dwg_id": "13619"
    },
    "position": {
      "x": 477,
      "y": 3806
    },
    "dwg_pos_img": [
      493.5843035105655,
      3810.084030657694
    ],
    "pos_dxf": [
      215.75147197349747,
      623.1744939392972
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EGTKH",
      "Schaltkreis_A01U1EGQKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Staplerladestation 11F04 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F,F1],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": 17.079766665371594,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_105",
    "source_ids": {
      "object_id": "obj_105",
      "dwg_id": "13635"
    },
    "position": {
      "x": 477,
      "y": 3859
    },
    "dwg_pos_img": [
      493.7025080586794,
      3863.669011390459
    ],
    "pos_dxf": [
      215.77152080144901,
      614.0865132315603
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EGXKH",
      "Schaltkreis_A01U1EGUKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 11F03 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F,F1],[35-34]",
    "position_description": "center",
    "match": {
      "distance_px": 17.34282107427996,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_106",
    "source_ids": {
      "object_id": "obj_106",
      "dwg_id": "13651"
    },
    "position": {
      "x": 477,
      "y": 3921
    },
    "dwg_pos_img": [
      493.58430351052914,
      3925.1016748003767
    ],
    "pos_dxf": [
      215.75147197349747,
      603.6675371386548
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1EH1KH",
      "Schaltkreis_A01U1EGYKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 11F02 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F,F1],[35-34]",
    "position_description": "center",
    "match": {
      "distance_px": 17.08399423722083,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_107",
    "source_ids": {
      "object_id": "obj_107",
      "dwg_id": "1366D"
    },
    "position": {
      "x": 477,
      "y": 3976
    },
    "dwg_pos_img": [
      493.7025080586433,
      3978.686655533142
    ],
    "pos_dxf": [
      215.77152080144901,
      594.5795564309178
    ],
    "type": "Staplerladestation",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00176",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1EH2KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 11F01 Staplerladestation ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F,F1],[35-34]",
    "position_description": "center",
    "match": {
      "distance_px": 16.917207021337973,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_108",
    "source_ids": {
      "object_id": "obj_108",
      "dwg_id": "DC2A"
    },
    "position": {
      "x": 3717,
      "y": 3727
    },
    "dwg_pos_img": [
      3734.492903100459,
      3731.849217202897
    ],
    "pos_dxf": [
      765.4462167806819,
      636.8658114899677
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00204",
    "description": "Typ 2",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CBYKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F4 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H,H1],[36-35]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": 18.152591174896173,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_109",
    "source_ids": {
      "object_id": "obj_109",
      "dwg_id": "107F7"
    },
    "position": {
      "x": 4759,
      "y": 3756
    },
    "dwg_pos_img": [
      4776.287199280709,
      3751.4020547900554
    ],
    "pos_dxf": [
      942.1463094191649,
      633.685539365762
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00211",
    "description": "Typ 2",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCGKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F5 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H2,H3],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": 17.888218444679833,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_110",
    "source_ids": {
      "object_id": "obj_110",
      "dwg_id": "14D26"
    },
    "position": {
      "x": 3334,
      "y": 4729
    },
    "dwg_pos_img": [
      3330.954438731273,
      4717.756236690494
    ],
    "pos_dxf": [
      697.0015302445656,
      469.6036522995767
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00231",
    "description": "Typ 3",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJEKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S021/3 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 11.64893371951969,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_111",
    "source_ids": {
      "object_id": "obj_111",
      "dwg_id": "F96C"
    },
    "position": {
      "x": 2277,
      "y": 4728
    },
    "dwg_pos_img": [
      2300.036648459882,
      4749.026172387983
    ],
    "pos_dxf": [
      522.1462159934551,
      464.1658164674459
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00241",
    "description": "Typ 1",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCAKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F6 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": 31.189535064719546,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_112",
    "source_ids": {
      "object_id": "obj_112",
      "dwg_id": "D262"
    },
    "position": {
      "x": 863,
      "y": 4464
    },
    "dwg_pos_img": [
      885.0372384764279,
      4456.4655960395
    ],
    "pos_dxf": [
      282.1463160667329,
      513.599438673338
    ],
    "type": "steckdosen_V",
    "status": "installed",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00256",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CBUKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F4 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": 23.289635521127156,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_113",
    "source_ids": {
      "object_id": "obj_113",
      "dwg_id": ""
    },
    "position": {
      "x": 5458,
      "y": 911
    },
    "dwg_pos_img": [
      5458,
      911
    ],
    "pos_dxf": [
      282.1463160667329,
      513.599438673338
    ],
    "type": "rj_45",
    "status": "real_vs_plan_dev",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "CHECK",
    "confidence": 0.95,
    "dwg_name": "",
    "dwg_layer": "",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "43",
      "44"
    ],
    "chessboard_id": "[I,I1],[43-44]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 23.289635521127156,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_114",
    "source_ids": {
      "object_id": "obj_114",
      "dwg_id": ""
    },
    "position": {
      "x": 1587,
      "y": 1546
    },
    "dwg_pos_img": [
      1587,
      1546
    ],
    "pos_dxf": [
      282.1463160667329,
      513.599438673338
    ],
    "type": "rj_45",
    "status": "real_vs_plan_dev",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00081",
    "description": "CHECK",
    "confidence": 0.95,
    "dwg_name": "",
    "dwg_layer": "",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[41-42]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": 23.289635521127156,
      "method": "nearest_neighbor_fixed_threshold"
    }
  },
  {
    "id": "obj_none_1",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B4"
    },
    "position": {
      "x": 1063.7532897069846,
      "y": 469.77809553999305
    },
    "dwg_pos_img": [
      1063.7532897069846,
      469.77809553999305
    ],
    "pos_dxf": [
      312.4585791727857,
      1189.763713465006
    ],
    "type": "B14_A01KSY2BXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KSY2BXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_2",
    "source_ids": {
      "object_id": null,
      "dwg_id": "F3"
    },
    "position": {
      "x": 896.9468412333105,
      "y": 469.64981193406857
    },
    "dwg_pos_img": [
      896.9468412333105,
      469.64981193406857
    ],
    "pos_dxf": [
      284.1663193609747,
      1189.763713465006
    ],
    "type": "B14_A01KSY2EXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KSY2EXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_3",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E"
    },
    "position": {
      "x": 1759.4616156016664,
      "y": 470.3131346438995
    },
    "dwg_pos_img": [
      1759.4616156016664,
      470.3131346438995
    ],
    "pos_dxf": [
      430.4585779111969,
      1189.763713465006
    ],
    "type": "B14_A01KSY2HXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KSY2HXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B14 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_4",
    "source_ids": {
      "object_id": null,
      "dwg_id": "169"
    },
    "position": {
      "x": 1592.6551671572397,
      "y": 470.18485103799867
    },
    "dwg_pos_img": [
      1592.6551671572397,
      470.18485103799867
    ],
    "pos_dxf": [
      402.1663181043466,
      1189.763713465006
    ],
    "type": "B14_A01KSY2KXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KSY2KXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B14 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_5",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1A4"
    },
    "position": {
      "x": 581.4068153820368,
      "y": 538.26283667999
    },
    "dwg_pos_img": [
      581.4068153820368,
      538.26283667999
    ],
    "pos_dxf": [
      230.647163032806,
      1178.085809289356
    ],
    "type": "S12_A01KSY3HXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3HXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-01-03 S12 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[F1,G],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_6",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1E5"
    },
    "position": {
      "x": 1593.1268338434365,
      "y": 286.68195779759753
    },
    "dwg_pos_img": [
      1593.1268338434365,
      286.68195779759753
    ],
    "pos_dxf": [
      402.2463181076494,
      1220.885808808178
    ],
    "type": "S12_A01KSY3KXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3KXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-1-02-03 S12 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_7",
    "source_ids": {
      "object_id": null,
      "dwg_id": "221"
    },
    "position": {
      "x": 2399.912889282109,
      "y": 539.7576492900844
    },
    "dwg_pos_img": [
      2399.912889282109,
      539.7576492900844
    ],
    "pos_dxf": [
      539.086355779345,
      1178.069480494319
    ],
    "type": "S12_A01KSY3NXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3NXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-1-02-01 S12 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G4,G5],[45-44]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_8",
    "source_ids": {
      "object_id": null,
      "dwg_id": "25D"
    },
    "position": {
      "x": 3836.2556762862273,
      "y": 540.7658943287197
    },
    "dwg_pos_img": [
      3836.2556762862273,
      540.7658943287197
    ],
    "pos_dxf": [
      782.7063337872978,
      1178.085827175845
    ],
    "type": "S12_A01KSY3QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3QXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-1-02-03 S12 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[H,H1],[45-44]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_9",
    "source_ids": {
      "object_id": null,
      "dwg_id": "299"
    },
    "position": {
      "x": 6750.351449191195,
      "y": 804.800032987916
    },
    "dwg_pos_img": [
      6750.351449191195,
      804.800032987916
    ],
    "pos_dxf": [
      1276.96992777864,
      1133.685809748613
    ],
    "type": "S12_A01KSY3TXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3TXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-3-02-05 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_10",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2D5"
    },
    "position": {
      "x": 5937.412277883126,
      "y": 4799.701080906723
    },
    "dwg_pos_img": [
      5937.412277883126,
      4799.701080906723
    ],
    "pos_dxf": [
      1139.086252079853,
      456.0457970179814
    ],
    "type": "S12_A01KSY3WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3WXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-4-01-02 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[I2,I3],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_11",
    "source_ids": {
      "object_id": null,
      "dwg_id": "311"
    },
    "position": {
      "x": 3837.7884781446132,
      "y": 4798.086351292974
    },
    "dwg_pos_img": [
      3837.7884781446132,
      4798.086351292974
    ],
    "pos_dxf": [
      782.9663143147432,
      456.0457970179814
    ],
    "type": "S12_A01KSY3ZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY3ZXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-2-01-04 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_12",
    "source_ids": {
      "object_id": null,
      "dwg_id": "34D"
    },
    "position": {
      "x": 2399.9128892807676,
      "y": 4796.980543531358
    },
    "dwg_pos_img": [
      2399.9128892807676,
      4796.980543531358
    ],
    "pos_dxf": [
      539.0863557793452,
      456.0457970179814
    ],
    "type": "S12_A01KSY42XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY42XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-2-02-01 S12 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_13",
    "source_ids": {
      "object_id": null,
      "dwg_id": "389"
    },
    "position": {
      "x": 6905.980228739729,
      "y": 2071.195836871747
    },
    "dwg_pos_img": [
      6905.980228739729,
      2071.195836871747
    ],
    "pos_dxf": [
      1303.366328550211,
      918.9257728245707
    ],
    "type": "S12_A01KSY4HXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KSY4HXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-01-03 S12 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_14",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3C5"
    },
    "position": {
      "x": 2423.825659302344,
      "y": 565.7408103531052
    },
    "dwg_pos_img": [
      2423.825659302344,
      565.7408103531052
    ],
    "pos_dxf": [
      543.1422319665271,
      1173.665863415507
    ],
    "type": "S07_A01KSY9GXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9GXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-1-01-02 S07 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_15",
    "source_ids": {
      "object_id": null,
      "dwg_id": "408"
    },
    "position": {
      "x": 3700.981562495597,
      "y": 570.4969261947708
    },
    "dwg_pos_img": [
      3700.981562495597,
      570.4969261947708
    ],
    "pos_dxf": [
      759.7623144871043,
      1173.025809343844
    ],
    "type": "S07_A01KSY9JXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9JXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "1,8 m US03-1-01-02 S07 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_16",
    "source_ids": {
      "object_id": null,
      "dwg_id": "450"
    },
    "position": {
      "x": 6879.981736802589,
      "y": 2087.889124889921
    },
    "dwg_pos_img": [
      6879.981736802589,
      2087.889124889921
    ],
    "pos_dxf": [
      1298.956690341789,
      916.0912053209863
    ],
    "type": "S07_A01KSY9NXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9NXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-01-02 S07 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_17",
    "source_ids": {
      "object_id": null,
      "dwg_id": "493"
    },
    "position": {
      "x": 3700.981562070469,
      "y": 4768.617762862588
    },
    "dwg_pos_img": [
      3700.981562070469,
      4768.617762862588
    ],
    "pos_dxf": [
      759.7623144152224,
      461.0258165151599
    ],
    "type": "S07_A01KSY9QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9QXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-2-02-05 S07 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G7,H],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_18",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4D6"
    },
    "position": {
      "x": 2423.8256593010165,
      "y": 4769.356437269811
    },
    "dwg_pos_img": [
      2423.8256593010165,
      4769.356437269811
    ],
    "pos_dxf": [
      543.1422319665269,
      460.7339558635972
    ],
    "type": "S07_A01KSY9TXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9TXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-2-01-02 S07 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_19",
    "source_ids": {
      "object_id": null,
      "dwg_id": "519"
    },
    "position": {
      "x": 478.6544138557816,
      "y": 4719.6249362216495
    },
    "dwg_pos_img": [
      478.6544138557816,
      4719.6249362216495
    ],
    "pos_dxf": [
      213.2191938695526,
      468.9146909062154
    ],
    "type": "S07_A01KSY9WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSY9WXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS01-02-05 Warnschild ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_20",
    "source_ids": {
      "object_id": null,
      "dwg_id": "55C"
    },
    "position": {
      "x": 478.6953603795499,
      "y": 613.0157977987028
    },
    "dwg_pos_img": [
      478.6953603795499,
      613.0157977987028
    ],
    "pos_dxf": [
      213.2261388627635,
      1165.394333414299
    ],
    "type": "S07_A01KSYA5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYA5XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS01-02-01 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_21",
    "source_ids": {
      "object_id": null,
      "dwg_id": "59F"
    },
    "position": {
      "x": 1590.7685004585064,
      "y": 4748.480705012918
    },
    "dwg_pos_img": [
      1590.7685004585064,
      4748.480705012918
    ],
    "pos_dxf": [
      401.8463180991364,
      464.1658164674459
    ],
    "type": "E-Verteiler_A01KSYA8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYA8XE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-2",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_22",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5C5"
    },
    "position": {
      "x": 1229.9435040469948,
      "y": 2689.2372043046735
    },
    "dwg_pos_img": [
      1229.9435040469948,
      2689.2372043046735
    ],
    "pos_dxf": [
      340.6463187076274,
      813.3658129505693
    ],
    "type": "E-Verteiler_A01KSYA9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYA9XE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS02",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_23",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5E7"
    },
    "position": {
      "x": 1343.143502954113,
      "y": 567.3645626573134
    },
    "dwg_pos_img": [
      1343.143502954113,
      567.3645626573134
    ],
    "pos_dxf": [
      359.8463185221635,
      1173.249520244815
    ],
    "type": "E-Verteiler_A01KSYAAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYAAXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-1",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G1,G2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_24",
    "source_ids": {
      "object_id": null,
      "dwg_id": "60A"
    },
    "position": {
      "x": 4420.7720678444375,
      "y": 4750.657138612928
    },
    "dwg_pos_img": [
      4420.7720678444375,
      4750.657138612928
    ],
    "pos_dxf": [
      881.8469231684971,
      464.1658163690718
    ],
    "type": "E-Verteiler_A01KSYABXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYABXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-2",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_25",
    "source_ids": {
      "object_id": null,
      "dwg_id": "62B"
    },
    "position": {
      "x": 4755.651801871402,
      "y": 2680.156199230928
    },
    "dwg_pos_img": [
      4755.651801871402,
      2680.156199230928
    ],
    "pos_dxf": [
      938.646312685371,
      815.3658129596324
    ],
    "type": "E-Verteiler_A01KSYACXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYACXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS03",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H2,H3],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_26",
    "source_ids": {
      "object_id": null,
      "dwg_id": "64E"
    },
    "position": {
      "x": 4774.518468348691,
      "y": 588.8461535059778
    },
    "dwg_pos_img": [
      4774.518468348691,
      588.8461535059778
    ],
    "pos_dxf": [
      941.846312653141,
      1170.053809394086
    ],
    "type": "E-Verteiler_A01KSYADXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYADXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-1",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H2,H3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_27",
    "source_ids": {
      "object_id": null,
      "dwg_id": "670"
    },
    "position": {
      "x": 5503.243461007074,
      "y": 1419.2772700870091
    },
    "dwg_pos_img": [
      5503.243461007074,
      1419.2772700870091
    ],
    "pos_dxf": [
      1065.446311408059,
      1029.307998275293
    ],
    "type": "E-Verteiler_A01KSYAEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYAEXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I1,I2],[42-41]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_28",
    "source_ids": {
      "object_id": null,
      "dwg_id": "692"
    },
    "position": {
      "x": 5483.433691554381,
      "y": 4494.398446130517
    },
    "dwg_pos_img": [
      5483.433691554381,
      4494.398446130517
    ],
    "pos_dxf": [
      1062.086350511651,
      507.7658160283036
    ],
    "type": "E-Verteiler_A01KSYAFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KSYAFXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-4",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I,I1],[33-32]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_29",
    "source_ids": {
      "object_id": null,
      "dwg_id": "90B"
    },
    "position": {
      "x": 957.084340174849,
      "y": 4722.9745140682635
    },
    "dwg_pos_img": [
      957.084340174849,
      4722.9745140682635
    ],
    "pos_dxf": [
      294.3663191816831,
      468.4090060021572
    ],
    "type": "Einspeisestück_A01KSYAVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYAVXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.4 03F02 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_30",
    "source_ids": {
      "object_id": null,
      "dwg_id": "DE7"
    },
    "position": {
      "x": 1065.5699242371738,
      "y": 4723.057945626464
    },
    "dwg_pos_img": [
      1065.5699242371738,
      4723.057945626464
    ],
    "pos_dxf": [
      312.7667009307841,
      468.4090060021574
    ],
    "type": "Einspeisestück_A01KSYBTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYBTXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.5 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_31",
    "source_ids": {
      "object_id": null,
      "dwg_id": "E10"
    },
    "position": {
      "x": 1174.0510046560426,
      "y": 4723.14137372111
    },
    "dwg_pos_img": [
      1174.0510046560426,
      4723.14137372111
    ],
    "pos_dxf": [
      331.1663188110304,
      468.4090060021574
    ],
    "type": "Einspeisestück_A01KSYBXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYBXXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.6 03F02 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_32",
    "source_ids": {
      "object_id": null,
      "dwg_id": "F2A"
    },
    "position": {
      "x": 1063.9190909204735,
      "y": 4704.639884841197
    },
    "dwg_pos_img": [
      1063.9190909204735,
      4704.639884841197
    ],
    "pos_dxf": [
      312.486700933604,
      471.5324880821568
    ],
    "type": "S02_A01KSYD1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYD1XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-05 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_33",
    "source_ids": {
      "object_id": null,
      "dwg_id": "F71"
    },
    "position": {
      "x": 1063.91909092066,
      "y": 4113.186856278544
    },
    "dwg_pos_img": [
      1063.91909092066,
      4113.186856278544
    ],
    "pos_dxf": [
      312.486700933604,
      571.842738424863
    ],
    "type": "S02_A01KSYD4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYD4XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-05 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G,G1],[34-33]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_34",
    "source_ids": {
      "object_id": null,
      "dwg_id": "FB4"
    },
    "position": {
      "x": 1063.9190909208637,
      "y": 3467.6849574611247
    },
    "dwg_pos_img": [
      1063.9190909208637,
      3467.6849574611247
    ],
    "pos_dxf": [
      312.486700933604,
      681.3196604120981
    ],
    "type": "S02_A01KSYD7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYD7XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-06 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_35",
    "source_ids": {
      "object_id": null,
      "dwg_id": "FF7"
    },
    "position": {
      "x": 1063.9190909210674,
      "y": 2822.1830586437054
    },
    "dwg_pos_img": [
      1063.9190909210674,
      2822.1830586437054
    ],
    "pos_dxf": [
      312.486700933604,
      790.7965823993331
    ],
    "type": "S02_A01KSYDAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYDAXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-07 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_36",
    "source_ids": {
      "object_id": null,
      "dwg_id": "103A"
    },
    "position": {
      "x": 1063.9190909212666,
      "y": 2190.8321289386486
    },
    "dwg_pos_img": [
      1063.9190909212666,
      2190.8321289386486
    ],
    "pos_dxf": [
      312.486700933604,
      897.8735044107416
    ],
    "type": "S02_A01KSYDDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYDDXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-13 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_37",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17AD"
    },
    "position": {
      "x": 775.4926753373269,
      "y": 4722.8348597935965
    },
    "dwg_pos_img": [
      775.4926753373269,
      4722.8348597935965
    ],
    "pos_dxf": [
      263.566319491903,
      468.4090060021574
    ],
    "type": "Einspeisestück_A01KSYEQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYEQXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.02 03F02 4,2 m ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_38",
    "source_ids": {
      "object_id": null,
      "dwg_id": "188F"
    },
    "position": {
      "x": 773.8418420206768,
      "y": 4543.298369657289
    },
    "dwg_pos_img": [
      773.8418420206768,
      4543.298369657289
    ],
    "pos_dxf": [
      263.2863194947229,
      498.8581237667063
    ],
    "type": "S02_A01KSYGWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYGWXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-03 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_39",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18D2"
    },
    "position": {
      "x": 773.8418420208806,
      "y": 3897.7964708398686
    },
    "dwg_pos_img": [
      773.8418420208806,
      3897.7964708398686
    ],
    "pos_dxf": [
      263.2863194947229,
      608.3350457539416
    ],
    "type": "S02_A01KSYGZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYGZXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-03 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F1,G],[35-34]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_40",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1915"
    },
    "position": {
      "x": 773.8418420210843,
      "y": 3252.2945720224507
    },
    "dwg_pos_img": [
      773.8418420210843,
      3252.2945720224507
    ],
    "pos_dxf": [
      263.2863194947229,
      717.8119677411764
    ],
    "type": "S02_A01KSYH2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYH2XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-04 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F1,G],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_41",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1958"
    },
    "position": {
      "x": 773.8418420212837,
      "y": 2620.046750008956
    },
    "dwg_pos_img": [
      773.8418420212837,
      2620.046750008956
    ],
    "pos_dxf": [
      263.2863194947229,
      825.0410024101334
    ],
    "type": "S02_A01KSYH5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYH5XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-10 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_42",
    "source_ids": {
      "object_id": null,
      "dwg_id": "199B"
    },
    "position": {
      "x": 773.8418420214192,
      "y": 2190.840932036913
    },
    "dwg_pos_img": [
      773.8418420214192,
      2190.840932036913
    ],
    "pos_dxf": [
      263.2863194947229,
      897.8341761198881
    ],
    "type": "S02_A01KSYH8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYH8XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-11 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_43",
    "source_ids": {
      "object_id": null,
      "dwg_id": "19DE"
    },
    "position": {
      "x": 773.8418420216248,
      "y": 1539.5018719816808
    },
    "dwg_pos_img": [
      773.8418420216248,
      1539.5018719816808
    ],
    "pos_dxf": [
      263.2863194947229,
      1008.301078844019
    ],
    "type": "S02_A01KSYHBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHBXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-09 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_44",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1A21"
    },
    "position": {
      "x": 773.841842021806,
      "y": 964.8377219821696
    },
    "dwg_pos_img": [
      773.841842021806,
      964.8377219821696
    ],
    "pos_dxf": [
      263.2863194947229,
      1105.76394058558
    ],
    "type": "S02_A01KSYHEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHEXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-10 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_45",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1A64"
    },
    "position": {
      "x": 575.741844016242,
      "y": 4112.81142032786
    },
    "dwg_pos_img": [
      575.741844016242,
      4112.81142032786
    ],
    "pos_dxf": [
      229.6863198331444,
      571.842738424863
    ],
    "type": "S02_A01KSYHHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHHXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-01 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_46",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1AA7"
    },
    "position": {
      "x": 575.7418440164248,
      "y": 3533.25596612041
    },
    "dwg_pos_img": [
      575.7418440164248,
      3533.25596612041
    ],
    "pos_dxf": [
      229.6863198331444,
      670.1351638441906
    ],
    "type": "S02_A01KSYHKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHKXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-02 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_47",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1AEA"
    },
    "position": {
      "x": 575.7418440166447,
      "y": 2835.9585918053854
    },
    "dwg_pos_img": [
      575.7418440166447,
      2835.9585918053854
    ],
    "pos_dxf": [
      229.6863198331444,
      788.3965824235061
    ],
    "type": "S02_A01KSYHNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHNXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-02 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_48",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1B2D"
    },
    "position": {
      "x": 575.7418440167806,
      "y": 2405.6239925937725
    },
    "dwg_pos_img": [
      575.7418440167806,
      2405.6239925937725
    ],
    "pos_dxf": [
      229.6863198331444,
      861.3811970816628
    ],
    "type": "S02_A01KSYHQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHQXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-09 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_49",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1B70"
    },
    "position": {
      "x": 575.7418440169989,
      "y": 1713.4579973887076
    },
    "dwg_pos_img": [
      575.7418440169989,
      1713.4579973887076
    ],
    "pos_dxf": [
      229.6863198331444,
      978.7723353542324
    ],
    "type": "S02_A01KSYHTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHTXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-08 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F1,G],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_50",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1BB3"
    },
    "position": {
      "x": 575.7418440171722,
      "y": 1164.1017380377234
    },
    "dwg_pos_img": [
      575.7418440171722,
      1164.1017380377234
    ],
    "pos_dxf": [
      229.6863198331444,
      1071.942986685156
    ],
    "type": "S02_A01KSYHWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHWXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-08 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_51",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1BF6"
    },
    "position": {
      "x": 575.7418440173432,
      "y": 622.5960404116195
    },
    "dwg_pos_img": [
      575.7418440173432,
      622.5960404116195
    ],
    "pos_dxf": [
      229.6863198331444,
      1163.782185180565
    ],
    "type": "S02_A01KSYHZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYHZXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-07 S02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_52",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1C39"
    },
    "position": {
      "x": 1172.4001713403418,
      "y": 1539.4546116813826
    },
    "dwg_pos_img": [
      1172.4001713403418,
      1539.4546116813826
    ],
    "pos_dxf": [
      330.8863188138505,
      1008.361078843415
    ],
    "type": "S02_A01KSYI2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYI2XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-12 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_53",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1C7C"
    },
    "position": {
      "x": 1172.4001713405232,
      "y": 965.1442359096827
    },
    "dwg_pos_img": [
      1172.4001713405232,
      965.1442359096827
    ],
    "pos_dxf": [
      330.8863188138505,
      1105.76394058558
    ],
    "type": "S02_A01KSYI5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYI5XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-13 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_54",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1CBF"
    },
    "position": {
      "x": 955.433506859392,
      "y": 765.5610100834583
    },
    "dwg_pos_img": [
      955.433506859392,
      765.5610100834583
    ],
    "pos_dxf": [
      294.0863191845031,
      1139.584894486005
    ],
    "type": "S02_A01KSYI8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYI8XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-03-11 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_55",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1D02"
    },
    "position": {
      "x": 955.4335068592069,
      "y": 1352.0176343432804
    },
    "dwg_pos_img": [
      955.4335068592069,
      1352.0176343432804
    ],
    "pos_dxf": [
      294.0863191845031,
      1040.122032764587
    ],
    "type": "S02_A01KSYIBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYIBXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-04-12 S02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_56",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1D6D"
    },
    "position": {
      "x": 1174.0510046573436,
      "y": 600.5757086598733
    },
    "dwg_pos_img": [
      1174.0510046573436,
      600.5757086598733
    ],
    "pos_dxf": [
      331.1663188110304,
      1167.594865142164
    ],
    "type": "Einspeisestück_A01KSYIFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYIFXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.14 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_57",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1D9B"
    },
    "position": {
      "x": 929.4919556068013,
      "y": 1478.6737518690888
    },
    "dwg_pos_img": [
      929.4919556068013,
      1478.6737518690888
    ],
    "pos_dxf": [
      289.6863387600702,
      1018.637810882764
    ],
    "type": "Einspeisestück_A01KSYILXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYILXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.15 03F01 3 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_58",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1DEC"
    },
    "position": {
      "x": 575.7418440160553,
      "y": 4704.264448890513
    },
    "dwg_pos_img": [
      575.7418440160553,
      4704.264448890513
    ],
    "pos_dxf": [
      229.6863198331444,
      471.5324880821568
    ],
    "type": "S02_A01KSYIQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSYIQXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 LPS01-04-01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_59",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1E2F"
    },
    "position": {
      "x": 5469.736399922572,
      "y": 899.501082052604
    },
    "dwg_pos_img": [
      5469.736399922572,
      899.501082052604
    ],
    "pos_dxf": [
      1059.763134969666,
      1117.457508293119
    ],
    "type": "S07_A01KSYJ4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYJ4XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-1-02-01 S07 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_60",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1E72"
    },
    "position": {
      "x": 5792.471915891475,
      "y": 906.870044963126
    },
    "dwg_pos_img": [
      5792.471915891475,
      906.870044963126
    ],
    "pos_dxf": [
      1114.502727784222,
      1116.249829430858
    ],
    "type": "S07_A01KSYJAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYJAXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-02-04 S07 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_61",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1EB5"
    },
    "position": {
      "x": 5356.213589338148,
      "y": 2318.801370177468
    },
    "dwg_pos_img": [
      5356.213589338148,
      2318.801370177468
    ],
    "pos_dxf": [
      1040.508382644454,
      876.7298123120713
    ],
    "type": "S07_A01KSYJDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYJDXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS03-01-01 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I,I1],[39-38]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_62",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1EF8"
    },
    "position": {
      "x": 478.5077616626787,
      "y": 3020.8538833802586
    },
    "dwg_pos_img": [
      478.5077616626787,
      3020.8538833802586
    ],
    "pos_dxf": [
      213.1943199992534,
      757.0257158614895
    ],
    "type": "S07_A01KSYJGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYJGXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-01-05 S07 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_63",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1F3B"
    },
    "position": {
      "x": 5501.852044396884,
      "y": 2317.1680882070877
    },
    "dwg_pos_img": [
      5501.852044396884,
      2317.1680882070877
    ],
    "pos_dxf": [
      1065.210311417686,
      877.0258123090898
    ],
    "type": "S07_A01KSYJJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSYJJXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-02-01 S07 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I1,I2],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_64",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1FA6"
    },
    "position": {
      "x": 1065.679684743066,
      "y": 599.7848165216556
    },
    "dwg_pos_img": [
      1065.679684743066,
      599.7848165216556
    ],
    "pos_dxf": [
      312.785317553471,
      1167.714865140955
    ],
    "type": "Einspeisestück_A01KSYNFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYNFXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.13 03F02 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_65",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1FCF"
    },
    "position": {
      "x": 957.0843401761491,
      "y": 599.70130055141
    },
    "dwg_pos_img": [
      957.0843401761491,
      599.70130055141
    ],
    "pos_dxf": [
      294.3663191816829,
      1167.714865140955
    ],
    "type": "Einspeisestück_A01KSYNJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KSYNJXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.12 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_66",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1FF8"
    },
    "position": {
      "x": 5959.693325414123,
      "y": 4771.977986971973
    },
    "dwg_pos_img": [
      5959.693325414123,
      4771.977986971973
    ],
    "pos_dxf": [
      1142.865369682285,
      460.750531313847
    ],
    "type": "S07_A01KSZ9AXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSZ9AXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 US03-4-02-02 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_67",
    "source_ids": {
      "object_id": null,
      "dwg_id": "203B"
    },
    "position": {
      "x": 5640.830068708449,
      "y": 916.4241739749368
    },
    "dwg_pos_img": [
      5640.830068708449,
      916.4241739749368
    ],
    "pos_dxf": [
      1088.782555823831,
      1114.609673197378
    ],
    "type": "S07_A01KSZ9JXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSZ9JXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-01-04 1,8 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_68",
    "source_ids": {
      "object_id": null,
      "dwg_id": "207E"
    },
    "position": {
      "x": 5469.7315446764915,
      "y": 4086.3682989442095
    },
    "dwg_pos_img": [
      5469.7315446764915,
      4086.3682989442095
    ],
    "pos_dxf": [
      1059.762311465201,
      576.9658153402761
    ],
    "type": "S07_A01KSZ9RXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSZ9RXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-2-01-05 S07 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[I,I1],[35-34]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_69",
    "source_ids": {
      "object_id": null,
      "dwg_id": "20C1"
    },
    "position": {
      "x": 4069.730558822301,
      "y": 2684.8415365494093
    },
    "dwg_pos_img": [
      4069.730558822301,
      2684.8415365494093
    ],
    "pos_dxf": [
      822.3063138642328,
      814.4817152827886
    ],
    "type": "S07_A01KSZB8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KSZB8XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS03-02-01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H,H1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_70",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2154"
    },
    "position": {
      "x": 4307.666353223717,
      "y": 4904.250482571002
    },
    "dwg_pos_img": [
      4307.666353223717,
      4904.250482571002
    ],
    "pos_dxf": [
      862.6629150349409,
      438.1016802568092
    ],
    "type": "S04_A01KSZC7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KSZC7XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S04 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_71",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2200"
    },
    "position": {
      "x": 5637.432626320984,
      "y": 753.707692869858
    },
    "dwg_pos_img": [
      5637.432626320984,
      753.707692869858
    ],
    "pos_dxf": [
      1088.206311178598,
      1142.205894829735
    ],
    "type": "S02_A01KSZDGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDGXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-01-09 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_72",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2243"
    },
    "position": {
      "x": 5910.0559569135285,
      "y": 753.9173556510477
    },
    "dwg_pos_img": [
      5910.0559569135285,
      753.9173556510477
    ],
    "pos_dxf": [
      1134.446310713765,
      1142.205894829735
    ],
    "type": "S02_A01KSZDJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDJXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-02-09 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_73",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2286"
    },
    "position": {
      "x": 6182.679287506082,
      "y": 754.1270184322384
    },
    "dwg_pos_img": [
      6182.679287506082,
      754.1270184322384
    ],
    "pos_dxf": [
      1180.686310248933,
      1142.205894829735
    ],
    "type": "S02_A01KSZDMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDMXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-01-08 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_74",
    "source_ids": {
      "object_id": null,
      "dwg_id": "22C9"
    },
    "position": {
      "x": 6455.302618098621,
      "y": 754.3366812134282
    },
    "dwg_pos_img": [
      6455.302618098621,
      754.3366812134282
    ],
    "pos_dxf": [
      1226.926309784099,
      1142.205894829735
    ],
    "type": "S02_A01KSZDPXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDPXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-02-08 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_75",
    "source_ids": {
      "object_id": null,
      "dwg_id": "230C"
    },
    "position": {
      "x": 5917.427882777671,
      "y": 1091.1867847242293
    },
    "dwg_pos_img": [
      5917.427882777671,
      1091.1867847242293
    ],
    "pos_dxf": [
      1135.696672697808,
      1085.006065717867
    ],
    "type": "S02_A01KSZDSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDSXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-02-07 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_76",
    "source_ids": {
      "object_id": null,
      "dwg_id": "234F"
    },
    "position": {
      "x": 6178.905954210649,
      "y": 1091.3878761699161
    },
    "dwg_pos_img": [
      6178.905954210649,
      1091.3878761699161
    ],
    "pos_dxf": [
      1180.046310255379,
      1085.006065717867
    ],
    "type": "S02_A01KSZDVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDVXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-01-07 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_77",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2392"
    },
    "position": {
      "x": 6451.529284803189,
      "y": 1091.5975389511068
    },
    "dwg_pos_img": [
      6451.529284803189,
      1091.5975389511068
    ],
    "pos_dxf": [
      1226.286309790545,
      1085.006065717867
    ],
    "type": "S02_A01KSZDYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZDYXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-02-06 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_78",
    "source_ids": {
      "object_id": null,
      "dwg_id": "23D5"
    },
    "position": {
      "x": 6700.569282299957,
      "y": 1091.789064813509
    },
    "dwg_pos_img": [
      6700.569282299957,
      1091.789064813509
    ],
    "pos_dxf": [
      1268.526309366001,
      1085.006065717867
    ],
    "type": "S02_A01KSZE1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KSZE1XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 US03-3-01-06 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_79",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2558"
    },
    "position": {
      "x": 1464.0937473049175,
      "y": 431.29994779435856
    },
    "dwg_pos_img": [
      1464.0937473049175,
      431.29994779435856
    ],
    "pos_dxf": [
      380.3608475993403,
      1196.341812510875
    ],
    "type": "S04_A01KSZECXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KSZECXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S04 US02-1-02-02 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_80",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2DA2"
    },
    "position": {
      "x": 517.7268444900247,
      "y": 4767.466838146493
    },
    "dwg_pos_img": [
      517.7268444900247,
      4767.466838146493
    ],
    "pos_dxf": [
      219.8463199135308,
      460.8058154529601
    ],
    "type": "S10_A01KT0PGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0PGXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-02-06 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_81",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3007"
    },
    "position": {
      "x": 527.1601780457753,
      "y": 570.7689227805558
    },
    "dwg_pos_img": [
      527.1601780457753,
      570.7689227805558
    ],
    "pos_dxf": [
      221.4463199510319,
      1172.565711676141
    ],
    "type": "S10_A01KT0PJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0PJXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-02-02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_82",
    "source_ids": {
      "object_id": null,
      "dwg_id": "326C"
    },
    "position": {
      "x": 480.937190431095,
      "y": 1206.8191483838327
    },
    "dwg_pos_img": [
      480.937190431095,
      1206.8191483838327
    ],
    "pos_dxf": [
      213.6063785888527,
      1064.685761590841
    ],
    "type": "S10_A01KT0PMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0PMXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-01-02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F,F1],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_83",
    "source_ids": {
      "object_id": null,
      "dwg_id": "34D1"
    },
    "position": {
      "x": 480.93719043053704,
      "y": 2975.218588458991
    },
    "dwg_pos_img": [
      480.93719043053704,
      2975.218588458991
    ],
    "pos_dxf": [
      213.6063785888527,
      764.7657646116563
    ],
    "type": "S10_A01KT0PRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0PRXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-01-04 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_84",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3736"
    },
    "position": {
      "x": 480.9354631355985,
      "y": 3078.3896186901193
    },
    "dwg_pos_img": [
      480.9354631355985,
      3078.3896186901193
    ],
    "pos_dxf": [
      213.6060856201054,
      747.267989633649
    ],
    "type": "S10_A01KT0PUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0PUXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-02-03 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_85",
    "source_ids": {
      "object_id": null,
      "dwg_id": "399B"
    },
    "position": {
      "x": 480.93719043016756,
      "y": 4146.2126924356235
    },
    "dwg_pos_img": [
      480.93719043016756,
      4146.2126924356235
    ],
    "pos_dxf": [
      213.6063785888527,
      566.1655274885388
    ],
    "type": "S10_A01KT0QFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0QFXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-01-06 S10 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_86",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3C00"
    },
    "position": {
      "x": 2350.8591534073935,
      "y": 572.1714505774144
    },
    "dwg_pos_img": [
      2350.8591534073935,
      572.1714505774144
    ],
    "pos_dxf": [
      530.7662875037702,
      1172.565711676141
    ],
    "type": "S10_A01KT0QNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0QNXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US02-1-01-01 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_87",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3E65"
    },
    "position": {
      "x": 3785.309194153205,
      "y": 573.2741622356752
    },
    "dwg_pos_img": [
      3785.309194153205,
      573.2741622356752
    ],
    "pos_dxf": [
      774.0652343442362,
      1172.565789974017
    ],
    "type": "S10_A01KT0QQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0QQXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-1-01-01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_88",
    "source_ids": {
      "object_id": null,
      "dwg_id": "40CA"
    },
    "position": {
      "x": 5503.243460920065,
      "y": 965.161990475498
    },
    "dwg_pos_img": [
      5503.243460920065,
      965.161990475498
    ],
    "pos_dxf": [
      1065.446311393277,
      1106.325808959217
    ],
    "type": "S10_A01KT0QZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0QZXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-3-02-03 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_89",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4384"
    },
    "position": {
      "x": 973.1399976387307,
      "y": 1655.3117596903649
    },
    "dwg_pos_img": [
      973.1399976387307,
      1655.3117596903649
    ],
    "pos_dxf": [
      297.0895402354656,
      988.685752590693
    ],
    "type": "Einspeisestück_A01KT0RMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT0RMXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.16 03F02 3 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_90",
    "source_ids": {
      "object_id": null,
      "dwg_id": "43AD"
    },
    "position": {
      "x": 6717.785115482779,
      "y": 852.6527211771136
    },
    "dwg_pos_img": [
      6717.785115482779,
      852.6527211771136
    ],
    "pos_dxf": [
      1271.446309340462,
      1125.565760977653
    ],
    "type": "S10_A01KT0S3XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0S3XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-01-05 S10 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_91",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4612"
    },
    "position": {
      "x": 6873.435113914574,
      "y": 2029.189772209902
    },
    "dwg_pos_img": [
      6873.435113914574,
      2029.189772209902
    ],
    "pos_dxf": [
      1297.84630907456,
      926.0457434559826
    ],
    "type": "S10_A01KT0SJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0SJXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-3-02-02 S10 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_92",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4877"
    },
    "position": {
      "x": 5888.359117773396,
      "y": 4771.597152348078
    },
    "dwg_pos_img": [
      5888.359117773396,
      4771.597152348078
    ],
    "pos_dxf": [
      1130.766281460527,
      460.8058165012881
    ],
    "type": "S10_A01KT0SVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0SVXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-4-02-01 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_93",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4ADC"
    },
    "position": {
      "x": 5503.24346104888,
      "y": 4394.885313369099
    },
    "dwg_pos_img": [
      5503.24346104888,
      4394.885313369099
    ],
    "pos_dxf": [
      1065.446311415309,
      524.6457963270373
    ],
    "type": "S10_A01KT0TBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0TBXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-4-01-01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_94",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4D41"
    },
    "position": {
      "x": 5503.243461049555,
      "y": 2272.239658612213
    },
    "dwg_pos_img": [
      5503.243461049555,
      2272.239658612213
    ],
    "pos_dxf": [
      1065.44631141531,
      884.6458415292159
    ],
    "type": "S10_A01KT0TEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0TEXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-3-01-01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_95",
    "source_ids": {
      "object_id": null,
      "dwg_id": "4FA6"
    },
    "position": {
      "x": 3785.433478310269,
      "y": 4769.036492600862
    },
    "dwg_pos_img": [
      3785.433478310269,
      4769.036492600862
    ],
    "pos_dxf": [
      774.0863143428319,
      460.9658152939749
    ],
    "type": "S10_A01KT0U0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0U0XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-2-02-04 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_96",
    "source_ids": {
      "object_id": null,
      "dwg_id": "520B"
    },
    "position": {
      "x": 2354.868492793995,
      "y": 4767.936299998151
    },
    "dwg_pos_img": [
      2354.868492793995,
      4767.936299998151
    ],
    "pos_dxf": [
      531.4463167992492,
      460.9658164996765
    ],
    "type": "S10_A01KT0UBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT0UBXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US02-2-01-01 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_97",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5470"
    },
    "position": {
      "x": 3008.4799937471344,
      "y": 2684.025374761165
    },
    "dwg_pos_img": [
      3008.4799937471344,
      2684.025374761165
    ],
    "pos_dxf": [
      642.3062180209567,
      814.4817152827886
    ],
    "type": "S07_A01KT0UQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KT0UQXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS02-02-01 ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G5,G6],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_98",
    "source_ids": {
      "object_id": null,
      "dwg_id": "54B3"
    },
    "position": {
      "x": 1593.4805837651725,
      "y": 2682.937160076697
    },
    "dwg_pos_img": [
      1593.4805837651725,
      2682.937160076697
    ],
    "pos_dxf": [
      402.3063180945032,
      814.4817152827886
    ],
    "type": "S07_A01KT0UTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S07_A01KT0UTXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S07 LPS02-01-01 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G2,G3],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_99",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5500"
    },
    "position": {
      "x": 3433.3342192716523,
      "y": 3124.5429152608767
    },
    "dwg_pos_img": [
      3433.3342192716523,
      3124.5429152608767
    ],
    "pos_dxf": [
      714.3662986753709,
      739.8254914253571
    ],
    "type": "Einspeisestück_A01KT0XWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT0XWXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.7 03F01 5,3 m ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_100",
    "source_ids": {
      "object_id": null,
      "dwg_id": "555B"
    },
    "position": {
      "x": 3540.166526274061,
      "y": 2578.18548369405
    },
    "dwg_pos_img": [
      3540.166526274061,
      2578.18548369405
    ],
    "pos_dxf": [
      732.4862659407818,
      832.5014768200422
    ],
    "type": "S02_A01KT0Y7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KT0Y7XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S02 LPS03-02-03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_101",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5774"
    },
    "position": {
      "x": 3650.300499909538,
      "y": 3124.7097746185264
    },
    "dwg_pos_img": [
      3650.300499909538,
      3124.7097746185264
    ],
    "pos_dxf": [
      751.1662332005528,
      739.8254914253571
    ],
    "type": "Einspeisestück_A01KT0ZLXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT0ZLXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.9 03F01 5,3 m ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_102",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5851"
    },
    "position": {
      "x": 3541.817359590595,
      "y": 3124.626344939701
    },
    "dwg_pos_img": [
      3541.817359590595,
      3124.626344939701
    ],
    "pos_dxf": [
      732.7662659379619,
      739.8254914253571
    ],
    "type": "Einspeisestück_A01KT10FXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT10FXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-00.8 03F01 5,3 m ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_103",
    "source_ids": {
      "object_id": null,
      "dwg_id": "58B1"
    },
    "position": {
      "x": 3540.1665262739293,
      "y": 2995.9220227945225
    },
    "dwg_pos_img": [
      3540.1665262739293,
      2995.9220227945225
    ],
    "pos_dxf": [
      732.4862659407818,
      761.6534892523782
    ],
    "type": "S02_A01KT10TXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S02_A01KT10TXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS03-01-03 S02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_104",
    "source_ids": {
      "object_id": null,
      "dwg_id": "58F4"
    },
    "position": {
      "x": 5471.070968212565,
      "y": 2525.6446818928
    },
    "dwg_pos_img": [
      5471.070968212565,
      2525.6446818928
    ],
    "pos_dxf": [
      1059.989492842261,
      841.6642318003396
    ],
    "type": "S10_A01KT12LXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT12LXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-2-02-06 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I,I1],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_105",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5B54"
    },
    "position": {
      "x": 4775.6976350450905,
      "y": 934.8860010653034
    },
    "dwg_pos_img": [
      4775.6976350450905,
      934.8860010653034
    ],
    "pos_dxf": [
      942.0463126582026,
      1111.365712292552
    ],
    "type": "S10_A01KT12OXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT12OXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-1-02-02 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[H2,H3],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_106",
    "source_ids": {
      "object_id": null,
      "dwg_id": "5DB9"
    },
    "position": {
      "x": 3689.685145983914,
      "y": 2231.22238878414
    },
    "dwg_pos_img": [
      3689.685145983914,
      2231.22238878414
    ],
    "pos_dxf": [
      757.8463145134785,
      891.3658121646563
    ],
    "type": "S10_A01KT12RXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT12RXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS03-02-02 S10 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_107",
    "source_ids": {
      "object_id": null,
      "dwg_id": "6019"
    },
    "position": {
      "x": 884.4476742406986,
      "y": 1997.9330825967927
    },
    "dwg_pos_img": [
      884.4476742406986,
      1997.9330825967927
    ],
    "pos_dxf": [
      282.0463193057708,
      930.5657141135821
    ],
    "type": "S10_A01KT12UXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT12UXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS01-01-01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_108",
    "source_ids": {
      "object_id": null,
      "dwg_id": "64A9"
    },
    "position": {
      "x": 884.44767424027,
      "y": 3356.4261173837867
    },
    "dwg_pos_img": [
      884.44767424027,
      3356.4261173837867
    ],
    "pos_dxf": [
      282.0463193057708,
      700.1657164341877
    ],
    "type": "S10_A01KT12XXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT12XXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-02-04 S10 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G,G1],[37-36]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_109",
    "source_ids": {
      "object_id": null,
      "dwg_id": "6939"
    },
    "position": {
      "x": 765.3518421064542,
      "y": 3718.9243845076567
    },
    "dwg_pos_img": [
      765.3518421064542,
      3718.9243845076567
    ],
    "pos_dxf": [
      261.8463195092265,
      638.6705887946425
    ],
    "type": "S11_A01KT130XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S11_A01KT130XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S11 LPS01-03-04 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_110",
    "source_ids": {
      "object_id": null,
      "dwg_id": "6B9E"
    },
    "position": {
      "x": 1055.5388515108943,
      "y": 3719.1475887085776
    },
    "dwg_pos_img": [
      1055.5388515108943,
      3719.1475887085776
    ],
    "pos_dxf": [
      311.0653175707948,
      638.6705830357139
    ],
    "type": "S11_A01KT133XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S11_A01KT133XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S11 LPS01-04-06 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_111",
    "source_ids": {
      "object_id": null,
      "dwg_id": "6E03"
    },
    "position": {
      "x": 3697.6566119681643,
      "y": 1941.6052362990022
    },
    "dwg_pos_img": [
      3697.6566119681643,
      1941.6052362990022
    ],
    "pos_dxf": [
      759.1983652811107,
      940.4858312011661
    ],
    "type": "S10_A01KT136XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT136XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 US03-1-01-03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_112",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7293"
    },
    "position": {
      "x": 3708.7102451641053,
      "y": 3417.0889227443286
    },
    "dwg_pos_img": [
      3708.7102451641053,
      3417.0889227443286
    ],
    "pos_dxf": [
      761.0731864593013,
      690.2456970028529
    ],
    "type": "S10_A01KT139XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT139XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-2-02-02 S10 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_113",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7723"
    },
    "position": {
      "x": 4775.697635044756,
      "y": 1996.2086844926462
    },
    "dwg_pos_img": [
      4775.697635044756,
      1996.2086844926462
    ],
    "pos_dxf": [
      942.0463126582026,
      931.3657141055246
    ],
    "type": "S10_A01KT13CXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT13CXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S10 LPS03-01-02 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[H2,H3],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_114",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7988"
    },
    "position": {
      "x": 5384.241971941157,
      "y": 2396.8182351878577
    },
    "dwg_pos_img": [
      5384.241971941157,
      2396.8182351878577
    ],
    "pos_dxf": [
      1045.26231326264,
      863.5018319765513
    ],
    "type": "S04_A01KT14IXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KT14IXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-2-01-06 S04 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I,I1],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_115",
    "source_ids": {
      "object_id": null,
      "dwg_id": "79F3"
    },
    "position": {
      "x": 1290.0832284729586,
      "y": 4936.929050897723
    },
    "dwg_pos_img": [
      1290.0832284729586,
      4936.929050897723
    ],
    "pos_dxf": [
      350.8466959955515,
      432.1658164974731
    ],
    "type": "B14_A01KT16JXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KT16JXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_116",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7A2E"
    },
    "position": {
      "x": 1290.0832284730072,
      "y": 4781.903648631129
    },
    "dwg_pos_img": [
      1290.0832284730072,
      4781.903648631129
    ],
    "pos_dxf": [
      350.8466959955515,
      458.4580766768349
    ],
    "type": "B14_A01KT16MXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KT16MXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_117",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7A91"
    },
    "position": {
      "x": 4159.231314102294,
      "y": 4524.646183811909
    },
    "dwg_pos_img": [
      4159.231314102294,
      4524.646183811909
    ],
    "pos_dxf": [
      837.4866539825043,
      502.4630910359908
    ],
    "type": "S04_A01KT170XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KT170XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S04 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_118",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7AD4"
    },
    "position": {
      "x": 4696.551882809647,
      "y": 4908.451983124991
    },
    "dwg_pos_img": [
      4696.551882809647,
      4908.451983124991
    ],
    "pos_dxf": [
      928.6222981449728,
      437.4398300917223
    ],
    "type": "S04_A01KT17FXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KT17FXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S04 US03-2-01-01 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_119",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7B17"
    },
    "position": {
      "x": 4595.341526689046,
      "y": 4908.374146629107
    },
    "dwg_pos_img": [
      4595.341526689046,
      4908.374146629107
    ],
    "pos_dxf": [
      911.4558773188505,
      437.4398300917223
    ],
    "type": "S04_A01KT17QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KT17QXE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-2-01-02 S04 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_120",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7B5A"
    },
    "position": {
      "x": 1204.08749992392,
      "y": 431.09998826472383
    },
    "dwg_pos_img": [
      1204.08749992392,
      431.09998826472383
    ],
    "pos_dxf": [
      336.2608480435188,
      1196.341812510875
    ],
    "type": "S04_A01KT183XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S04_A01KT183XE",
    "dwg_layer": "ADE_ET_SIBE_Decke",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S04 US02-1-01-03 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_121",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7DFF"
    },
    "position": {
      "x": 707.2189259782161,
      "y": 539.6282872833108
    },
    "dwg_pos_img": [
      707.2189259782161,
      539.6282872833108
    ],
    "pos_dxf": [
      251.9863196003723,
      1177.870639186094
    ],
    "type": "A1_A01KT1PQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "A1_A01KT1PQXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      255,
      255
    ],
    "dwg_txt": "A1 05F02 (EV 51_00.3) 5,5 m ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[F1,G],[45-44]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_122",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7E56"
    },
    "position": {
      "x": 1051.894393106968,
      "y": 286.2657193957275
    },
    "dwg_pos_img": [
      1051.894393106968,
      286.2657193957275
    ],
    "pos_dxf": [
      310.447176215881,
      1220.885808808578
    ],
    "type": "S12_A01KT1QHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KT1QHXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US02-1-01-04 S12 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_123",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7ED8"
    },
    "position": {
      "x": 479.9935116529067,
      "y": 2320.7352532726463
    },
    "dwg_pos_img": [
      479.9935116529067,
      2320.7352532726463
    ],
    "pos_dxf": [
      213.4463199975587,
      875.7658123378683
    ],
    "type": "E-Verteiler_A01KT1SJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01KT1SJXE",
    "dwg_layer": "ADE_ET_SIBE_Zentrale",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F,F1],[39-38]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_124",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7FAE"
    },
    "position": {
      "x": 888.6969467664081,
      "y": 2986.80389100498
    },
    "dwg_pos_img": [
      888.6969467664081,
      2986.80389100498
    ],
    "pos_dxf": [
      282.7670439744959,
      762.8540857158382
    ],
    "type": "Einspeisestück_A01KT1XDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT1XDXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.03 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_125",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8027"
    },
    "position": {
      "x": 888.6926741610793,
      "y": 2346.125144891006
    },
    "dwg_pos_img": [
      888.6926741610793,
      2346.125144891006
    ],
    "pos_dxf": [
      282.7663192922857,
      871.513001942064
    ],
    "type": "Einspeisestück_A01KT1XJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT1XJXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.17 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_126",
    "source_ids": {
      "object_id": null,
      "dwg_id": "81A4"
    },
    "position": {
      "x": 1476.3903425200906,
      "y": 4782.046929353294
    },
    "dwg_pos_img": [
      1476.3903425200906,
      4782.046929353294
    ],
    "pos_dxf": [
      382.4464891908408,
      458.4580766768349
    ],
    "type": "B14_A01KT24MXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KT24MXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_127",
    "source_ids": {
      "object_id": null,
      "dwg_id": "81DF"
    },
    "position": {
      "x": 574.3268440517257,
      "y": 4793.689653389596
    },
    "dwg_pos_img": [
      574.3268440517257,
      4793.689653389596
    ],
    "pos_dxf": [
      229.4463198391991,
      456.3658165525837
    ],
    "type": "S12_A01KT24WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KT24WXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "LPS01-01-07 S12 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_128",
    "source_ids": {
      "object_id": null,
      "dwg_id": "821B"
    },
    "position": {
      "x": 4101.217808984403,
      "y": 5050.649292755441
    },
    "dwg_pos_img": [
      4101.217808984403,
      5050.649292755441
    ],
    "pos_dxf": [
      827.646907531434,
      413.2455599726484
    ],
    "type": "S12_A01KT24ZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KT24ZXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-2-02-02 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_129",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8257"
    },
    "position": {
      "x": 4550.476812604583,
      "y": 5050.993857912101
    },
    "dwg_pos_img": [
      4550.476812604583,
      5050.993857912101
    ],
    "pos_dxf": [
      903.84631450594,
      413.2457194745109
    ],
    "type": "S12_A01KT252XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KT252XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-2-02-01 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_130",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8293"
    },
    "position": {
      "x": 1174.051004656903,
      "y": 1997.0043441211255
    },
    "dwg_pos_img": [
      1174.051004656903,
      1997.0043441211255
    ],
    "pos_dxf": [
      331.1663188110304,
      930.7610013453141
    ],
    "type": "Einspeisestück_A01KT259XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT259XE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.20 03F02 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_131",
    "source_ids": {
      "object_id": null,
      "dwg_id": "82BC"
    },
    "position": {
      "x": 1065.5699242380324,
      "y": 1996.92091602648
    },
    "dwg_pos_img": [
      1065.5699242380324,
      1996.92091602648
    ],
    "pos_dxf": [
      312.7667009307838,
      930.7610013453141
    ],
    "type": "Einspeisestück_A01KT25DXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT25DXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.19 03F01 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_132",
    "source_ids": {
      "object_id": null,
      "dwg_id": "82E5"
    },
    "position": {
      "x": 775.492675338624,
      "y": 605.3439681055388
    },
    "dwg_pos_img": [
      775.492675338624,
      605.3439681055388
    ],
    "pos_dxf": [
      263.5663194919027,
      1166.734185150833
    ],
    "type": "Einspeisestück_A01KT25HXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT25HXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.11 03F02 4,2 m ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_133",
    "source_ids": {
      "object_id": null,
      "dwg_id": "835E"
    },
    "position": {
      "x": 577.3926773340532,
      "y": 605.1916179877217
    },
    "dwg_pos_img": [
      577.3926773340532,
      605.1916179877217
    ],
    "pos_dxf": [
      229.9663198303242,
      1166.734185150833
    ],
    "type": "Einspeisestück_A01KT25NXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT25NXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51-0.10 03F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_134",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8382"
    },
    "position": {
      "x": 957.0843401757082,
      "y": 1996.8374844682785
    },
    "dwg_pos_img": [
      957.0843401757082,
      1996.8374844682785
    ],
    "pos_dxf": [
      294.3663191816829,
      930.7610013453141
    ],
    "type": "Einspeisestück_A01KT25QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT25QXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Lichtband 51.0.18 03F02 4,2 m ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_135",
    "source_ids": {
      "object_id": null,
      "dwg_id": "83AB"
    },
    "position": {
      "x": 1476.390342520042,
      "y": 4937.072331619888
    },
    "dwg_pos_img": [
      1476.390342520042,
      4937.072331619888
    ],
    "pos_dxf": [
      382.4464891908408,
      432.1658164974731
    ],
    "type": "B14_A01KT25UXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KT25UXE",
    "dwg_layer": "ADE_ET_BEL_Wand",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F01 B14 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_136",
    "source_ids": {
      "object_id": null,
      "dwg_id": "83E6"
    },
    "position": {
      "x": 6839.090769876305,
      "y": 1202.6659025010476
    },
    "dwg_pos_img": [
      6839.090769876305,
      1202.6659025010476
    ],
    "pos_dxf": [
      1292.021119979681,
      1066.21945601109
    ],
    "type": "Einspeisestück_A01KT25XXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT25XXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F01 Lichtband 51-0.12 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_137",
    "source_ids": {
      "object_id": null,
      "dwg_id": "840F"
    },
    "position": {
      "x": 6839.09076987634,
      "y": 1090.2446492861518
    },
    "dwg_pos_img": [
      6839.09076987634,
      1090.2446492861518
    ],
    "pos_dxf": [
      1292.021119979681,
      1085.286065715046
    ],
    "type": "Einspeisestück_A01KT261XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT261XE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F02 Lichtband 51-0.13 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_138",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8438"
    },
    "position": {
      "x": 6839.090769876376,
      "y": 977.8233960712578
    },
    "dwg_pos_img": [
      6839.090769876376,
      977.8233960712578
    ],
    "pos_dxf": [
      1292.021119979681,
      1104.352675419002
    ],
    "type": "Einspeisestück_A01KT265XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT265XE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F01 Lichtband 51-0.14 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_139",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8461"
    },
    "position": {
      "x": 6711.013741577109,
      "y": 752.8823911530908
    },
    "dwg_pos_img": [
      6711.013741577109,
      752.8823911530908
    ],
    "pos_dxf": [
      1270.297807759282,
      1142.485894826914
    ],
    "type": "Einspeisestück_A01KT269XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT269XE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F01 Lichtband 51-0.16 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_140",
    "source_ids": {
      "object_id": null,
      "dwg_id": "848A"
    },
    "position": {
      "x": 6711.013741577144,
      "y": 640.4611379381913
    },
    "dwg_pos_img": [
      6711.013741577144,
      640.4611379381913
    ],
    "pos_dxf": [
      1270.297807759282,
      1161.552504530871
    ],
    "type": "Einspeisestück_A01KT26DXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT26DXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F02 Lichtband 51-0.17 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_141",
    "source_ids": {
      "object_id": null,
      "dwg_id": "84B3"
    },
    "position": {
      "x": 577.3926773327552,
      "y": 4722.68250967578
    },
    "dwg_pos_img": [
      577.3926773327552,
      4722.68250967578
    ],
    "pos_dxf": [
      229.9663198303244,
      468.4090060021574
    ],
    "type": "Einspeisestück_A01KT26HXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT26HXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,2 m Lichtband 51-0.01 03F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_142",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8586"
    },
    "position": {
      "x": 6711.013741577073,
      "y": 865.3036443679866
    },
    "dwg_pos_img": [
      6711.013741577073,
      865.3036443679866
    ],
    "pos_dxf": [
      1270.297807759282,
      1123.419285122958
    ],
    "type": "Einspeisestück_A01KT2TEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Einspeisestück_A01KT2TEXE",
    "dwg_layer": "ADE_ET_BEL_Lichtschiene-Anschluss",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4,6 m 03F02 Lichtband 51-0.15 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_143",
    "source_ids": {
      "object_id": null,
      "dwg_id": "882F"
    },
    "position": {
      "x": 6873.4351136256055,
      "y": 2821.4077952162006
    },
    "dwg_pos_img": [
      6873.4351136256055,
      2821.4077952162006
    ],
    "pos_dxf": [
      1297.84630902559,
      791.6858122761396
    ],
    "type": "S10_A01KT35YXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S10_A01KT35YXE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "US03-4-01-03 S10 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_144",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8A94"
    },
    "position": {
      "x": 6906.001447569358,
      "y": 2774.970486638971
    },
    "dwg_pos_img": [
      6906.001447569358,
      2774.970486638971
    ],
    "pos_dxf": [
      1303.369927503684,
      799.5658131035912
    ],
    "type": "S12_A01KT363XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "S12_A01KT363XE",
    "dwg_layer": "ADE_ET_SIBE_Wand",
    "dwg_rgb": [
      0,
      255,
      0
    ],
    "dwg_txt": "S12 US03-4-02-03 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_145",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8DD2"
    },
    "position": {
      "x": 957.3201735068288,
      "y": 1481.1376991886627
    },
    "dwg_pos_img": [
      957.3201735068288,
      1481.1376991886627
    ],
    "pos_dxf": [
      294.40631918128,
      1018.223555864615
    ],
    "type": "B17_A01KSYC5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYC5XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_146",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8DFE"
    },
    "position": {
      "x": 957.3201735068843,
      "y": 1305.3062815359017
    },
    "dwg_pos_img": [
      957.3201735068843,
      1305.3062815359017
    ],
    "pos_dxf": [
      294.40631918128,
      1048.044509805327
    ],
    "type": "B17_A01KSYC7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYC7XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_147",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8E79"
    },
    "position": {
      "x": 957.3201735070685,
      "y": 721.6798510985554
    },
    "dwg_pos_img": [
      957.3201735070685,
      721.6798510985554
    ],
    "pos_dxf": [
      294.40631918128,
      1147.027371531579
    ],
    "type": "B17_A01KSYCDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCDXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_148",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8EA2"
    },
    "position": {
      "x": 1065.9155180737457,
      "y": 1481.2212151589083
    },
    "dwg_pos_img": [
      1065.9155180737457,
      1481.2212151589083
    ],
    "pos_dxf": [
      312.8253175530681,
      1018.223555864615
    ],
    "type": "B17_A01KSYCFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCFXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_149",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8ECB"
    },
    "position": {
      "x": 1065.9155180738012,
      "y": 1305.3897975061473
    },
    "dwg_pos_img": [
      1065.9155180738012,
      1305.3897975061473
    ],
    "pos_dxf": [
      312.8253175530681,
      1048.044509805327
    ],
    "type": "B17_A01KSYCHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCHXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_150",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8EF4"
    },
    "position": {
      "x": 1065.915518073864,
      "y": 1105.973431332769
    },
    "dwg_pos_img": [
      1065.915518073864,
      1105.973431332769
    ],
    "pos_dxf": [
      312.8253175530681,
      1081.865463705752
    ],
    "type": "B17_A01KSYCJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_151",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8F1D"
    },
    "position": {
      "x": 1065.9155180739272,
      "y": 906.5570651593971
    },
    "dwg_pos_img": [
      1065.9155180739272,
      906.5570651593971
    ],
    "pos_dxf": [
      312.8253175530681,
      1115.686417606176
    ],
    "type": "B17_A01KSYCLXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCLXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_152",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8F46"
    },
    "position": {
      "x": 1065.9155180739854,
      "y": 721.763367068801
    },
    "dwg_pos_img": [
      1065.9155180739854,
      721.763367068801
    ],
    "pos_dxf": [
      312.8253175530681,
      1147.027371531579
    ],
    "type": "B17_A01KSYCNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCNXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_153",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8F6F"
    },
    "position": {
      "x": 1174.2868379880229,
      "y": 1481.3045588415098
    },
    "dwg_pos_img": [
      1174.2868379880229,
      1481.3045588415098
    ],
    "pos_dxf": [
      331.2063188106274,
      1018.223555864615
    ],
    "type": "B17_A01KSYCPXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCPXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_154",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8F98"
    },
    "position": {
      "x": 1174.2868379880783,
      "y": 1305.4731411887487
    },
    "dwg_pos_img": [
      1174.2868379880783,
      1305.4731411887487
    ],
    "pos_dxf": [
      331.2063188106274,
      1048.044509805327
    ],
    "type": "B17_A01KSYCRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCRXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_155",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8FC1"
    },
    "position": {
      "x": 1174.286837988141,
      "y": 1106.0567750153705
    },
    "dwg_pos_img": [
      1174.286837988141,
      1106.0567750153705
    ],
    "pos_dxf": [
      331.2063188106274,
      1081.865463705752
    ],
    "type": "B17_A01KSYCTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCTXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_156",
    "source_ids": {
      "object_id": null,
      "dwg_id": "8FEA"
    },
    "position": {
      "x": 1174.2868379882038,
      "y": 906.6404088419986
    },
    "dwg_pos_img": [
      1174.2868379882038,
      906.6404088419986
    ],
    "pos_dxf": [
      331.2063188106274,
      1115.686417606176
    ],
    "type": "B17_A01KSYCVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCVXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_157",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9013"
    },
    "position": {
      "x": 1174.2868379882625,
      "y": 721.8467107514025
    },
    "dwg_pos_img": [
      1174.2868379882625,
      721.8467107514025
    ],
    "pos_dxf": [
      331.2063188106274,
      1147.027371531579
    ],
    "type": "B17_A01KSYCXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCXXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_158",
    "source_ids": {
      "object_id": null,
      "dwg_id": "903C"
    },
    "position": {
      "x": 1174.2868379879596,
      "y": 1680.7209250148844
    },
    "dwg_pos_img": [
      1174.2868379879596,
      1680.7209250148844
    ],
    "pos_dxf": [
      331.2063188106274,
      984.4026019641906
    ],
    "type": "B17_A01KSYCZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYCZXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_159",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9065"
    },
    "position": {
      "x": 775.7285086682924,
      "y": 4692.086375479196
    },
    "dwg_pos_img": [
      775.7285086682924,
      4692.086375479196
    ],
    "pos_dxf": [
      263.6063194914998,
      473.6239701725508
    ],
    "type": "B2_A01KSYEUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYEUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_160",
    "source_ids": {
      "object_id": null,
      "dwg_id": "908E"
    },
    "position": {
      "x": 775.7285086683604,
      "y": 4476.919075873389
    },
    "dwg_pos_img": [
      775.7285086683604,
      4476.919075873389
    ],
    "pos_dxf": [
      263.6063194914998,
      510.1162775016292
    ],
    "type": "B2_A01KSYEWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYEWXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_161",
    "source_ids": {
      "object_id": null,
      "dwg_id": "90B7"
    },
    "position": {
      "x": 775.7285086684282,
      "y": 4261.751776267583
    },
    "dwg_pos_img": [
      775.7285086684282,
      4261.751776267583
    ],
    "pos_dxf": [
      263.6063194914998,
      546.6085848307075
    ],
    "type": "B2_A01KSYEYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYEYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_162",
    "source_ids": {
      "object_id": null,
      "dwg_id": "90E0"
    },
    "position": {
      "x": 775.7285086684961,
      "y": 4046.584476661777
    },
    "dwg_pos_img": [
      775.7285086684961,
      4046.584476661777
    ],
    "pos_dxf": [
      263.6063194914998,
      583.1008921597859
    ],
    "type": "B2_A01KSYF0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYF0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F1,G],[35-34]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_163",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9109"
    },
    "position": {
      "x": 775.7285086685639,
      "y": 3831.4171770559697
    },
    "dwg_pos_img": [
      775.7285086685639,
      3831.4171770559697
    ],
    "pos_dxf": [
      263.6063194914998,
      619.5931994888645
    ],
    "type": "B2_A01KSYF2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYF2XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F1,G],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_164",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9132"
    },
    "position": {
      "x": 775.7285086686308,
      "y": 3619.9792633906577
    },
    "dwg_pos_img": [
      775.7285086686308,
      3619.9792633906577
    ],
    "pos_dxf": [
      263.6063194914998,
      655.4530041182361
    ],
    "type": "B2_A01KSYF4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYF4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_165",
    "source_ids": {
      "object_id": null,
      "dwg_id": "915B"
    },
    "position": {
      "x": 775.7285086686996,
      "y": 3401.082577844358
    },
    "dwg_pos_img": [
      775.7285086686996,
      3401.082577844358
    ],
    "pos_dxf": [
      263.6063194914998,
      692.577814147021
    ],
    "type": "B2_A01KSYF6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYF6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_166",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9184"
    },
    "position": {
      "x": 775.7285086687676,
      "y": 3185.9152782385518
    },
    "dwg_pos_img": [
      775.7285086687676,
      3185.9152782385518
    ],
    "pos_dxf": [
      263.6063194914998,
      729.0701214760993
    ],
    "type": "B2_A01KSYF8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYF8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F1,G],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_167",
    "source_ids": {
      "object_id": null,
      "dwg_id": "91AD"
    },
    "position": {
      "x": 775.7285086689034,
      "y": 2755.580679026939
    },
    "dwg_pos_img": [
      775.7285086689034,
      2755.580679026939
    ],
    "pos_dxf": [
      263.6063194914998,
      802.054736134256
    ],
    "type": "B2_A01KSYFAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_168",
    "source_ids": {
      "object_id": null,
      "dwg_id": "91D6"
    },
    "position": {
      "x": 775.7285086689668,
      "y": 2554.5643485334977
    },
    "dwg_pos_img": [
      775.7285086689668,
      2554.5643485334977
    ],
    "pos_dxf": [
      263.6063194914998,
      836.1470434875073
    ],
    "type": "B2_A01KSYFCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_169",
    "source_ids": {
      "object_id": null,
      "dwg_id": "91FF"
    },
    "position": {
      "x": 775.7285086690348,
      "y": 2339.397048927691
    },
    "dwg_pos_img": [
      775.7285086690348,
      2339.397048927691
    ],
    "pos_dxf": [
      263.6063194914998,
      872.6393508165856
    ],
    "type": "B2_A01KSYFEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_170",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9228"
    },
    "position": {
      "x": 775.7285086691026,
      "y": 2124.6935271841394
    },
    "dwg_pos_img": [
      775.7285086691026,
      2124.6935271841394
    ],
    "pos_dxf": [
      263.6063194914998,
      909.0530015639583
    ],
    "type": "B2_A01KSYFGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_171",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9251"
    },
    "position": {
      "x": 775.7285086693056,
      "y": 1480.9980449139966
    },
    "dwg_pos_img": [
      775.7285086693056,
      1480.9980449139966
    ],
    "pos_dxf": [
      263.6063194914998,
      1018.223555864615
    ],
    "type": "B2_A01KSYFIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_172",
    "source_ids": {
      "object_id": null,
      "dwg_id": "927A"
    },
    "position": {
      "x": 775.7285086693611,
      "y": 1305.1666272612356
    },
    "dwg_pos_img": [
      775.7285086693611,
      1305.1666272612356
    ],
    "pos_dxf": [
      263.6063194914998,
      1048.044509805327
    ],
    "type": "B2_A01KSYFKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_173",
    "source_ids": {
      "object_id": null,
      "dwg_id": "92F5"
    },
    "position": {
      "x": 775.7285086695452,
      "y": 721.5401968238893
    },
    "dwg_pos_img": [
      775.7285086695452,
      721.5401968238893
    ],
    "pos_dxf": [
      263.6063194914998,
      1147.027371531579
    ],
    "type": "B2_A01KSYFQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_174",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9347"
    },
    "position": {
      "x": 577.6285106637225,
      "y": 4691.934025361379
    },
    "dwg_pos_img": [
      577.6285106637225,
      4691.934025361379
    ],
    "pos_dxf": [
      230.0063198299215,
      473.6239701725508
    ],
    "type": "B2_A01KSYFUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_175",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9370"
    },
    "position": {
      "x": 577.6285106637905,
      "y": 4476.766725755573
    },
    "dwg_pos_img": [
      577.6285106637905,
      4476.766725755573
    ],
    "pos_dxf": [
      230.0063198299215,
      510.1162775016292
    ],
    "type": "B2_A01KSYFWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFWXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_176",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9399"
    },
    "position": {
      "x": 577.6285106638583,
      "y": 4261.599426149767
    },
    "dwg_pos_img": [
      577.6285106638583,
      4261.599426149767
    ],
    "pos_dxf": [
      230.0063198299215,
      546.6085848307075
    ],
    "type": "B2_A01KSYFYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYFYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_177",
    "source_ids": {
      "object_id": null,
      "dwg_id": "93C2"
    },
    "position": {
      "x": 577.6285106639262,
      "y": 4046.4321265439603
    },
    "dwg_pos_img": [
      577.6285106639262,
      4046.4321265439603
    ],
    "pos_dxf": [
      230.0063198299215,
      583.1008921597859
    ],
    "type": "B2_A01KSYG0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYG0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F1,G],[35-34]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_178",
    "source_ids": {
      "object_id": null,
      "dwg_id": "93EB"
    },
    "position": {
      "x": 577.628510663994,
      "y": 3831.264826938153
    },
    "dwg_pos_img": [
      577.628510663994,
      3831.264826938153
    ],
    "pos_dxf": [
      230.0063198299215,
      619.5931994888645
    ],
    "type": "B2_A01KSYG2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYG2XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[F1,G],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_179",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9414"
    },
    "position": {
      "x": 577.6285106640609,
      "y": 3619.826913272841
    },
    "dwg_pos_img": [
      577.6285106640609,
      3619.826913272841
    ],
    "pos_dxf": [
      230.0063198299215,
      655.4530041182361
    ],
    "type": "B2_A01KSYG4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYG4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_180",
    "source_ids": {
      "object_id": null,
      "dwg_id": "943D"
    },
    "position": {
      "x": 577.6285106641297,
      "y": 3400.9302277265415
    },
    "dwg_pos_img": [
      577.6285106641297,
      3400.9302277265415
    ],
    "pos_dxf": [
      230.0063198299215,
      692.577814147021
    ],
    "type": "B2_A01KSYG6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYG6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F1,G],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_181",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9466"
    },
    "position": {
      "x": 577.6285106641977,
      "y": 3185.7629281207346
    },
    "dwg_pos_img": [
      577.6285106641977,
      3185.7629281207346
    ],
    "pos_dxf": [
      230.0063198299215,
      729.0701214760993
    ],
    "type": "B2_A01KSYG8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYG8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F1,G],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_182",
    "source_ids": {
      "object_id": null,
      "dwg_id": "948F"
    },
    "position": {
      "x": 577.6285106642657,
      "y": 2970.5956285149277
    },
    "dwg_pos_img": [
      577.6285106642657,
      2970.5956285149277
    ],
    "pos_dxf": [
      230.0063198299215,
      765.5624288051777
    ],
    "type": "B2_A01KSYGAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_183",
    "source_ids": {
      "object_id": null,
      "dwg_id": "94B8"
    },
    "position": {
      "x": 577.6285106643335,
      "y": 2755.428328909122
    },
    "dwg_pos_img": [
      577.6285106643335,
      2755.428328909122
    ],
    "pos_dxf": [
      230.0063198299215,
      802.054736134256
    ],
    "type": "B2_A01KSYGCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_184",
    "source_ids": {
      "object_id": null,
      "dwg_id": "94E1"
    },
    "position": {
      "x": 577.6285106643969,
      "y": 2554.4119984156805
    },
    "dwg_pos_img": [
      577.6285106643969,
      2554.4119984156805
    ],
    "pos_dxf": [
      230.0063198299215,
      836.1470434875073
    ],
    "type": "B2_A01KSYGEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_185",
    "source_ids": {
      "object_id": null,
      "dwg_id": "950A"
    },
    "position": {
      "x": 577.6285106644649,
      "y": 2339.2446988098736
    },
    "dwg_pos_img": [
      577.6285106644649,
      2339.2446988098736
    ],
    "pos_dxf": [
      230.0063198299215,
      872.6393508165856
    ],
    "type": "B2_A01KSYGGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_186",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9533"
    },
    "position": {
      "x": 577.6285106645327,
      "y": 2124.5411770663222
    },
    "dwg_pos_img": [
      577.6285106645327,
      2124.5411770663222
    ],
    "pos_dxf": [
      230.0063198299215,
      909.0530015639583
    ],
    "type": "B2_A01KSYGIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_187",
    "source_ids": {
      "object_id": null,
      "dwg_id": "955C"
    },
    "position": {
      "x": 577.6285106647357,
      "y": 1480.8456947961795
    },
    "dwg_pos_img": [
      577.6285106647357,
      1480.8456947961795
    ],
    "pos_dxf": [
      230.0063198299215,
      1018.223555864615
    ],
    "type": "B2_A01KSYGKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_188",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9585"
    },
    "position": {
      "x": 577.6285106647912,
      "y": 1305.0142771434184
    },
    "dwg_pos_img": [
      577.6285106647912,
      1305.0142771434184
    ],
    "pos_dxf": [
      230.0063198299215,
      1048.044509805327
    ],
    "type": "B2_A01KSYGMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_189",
    "source_ids": {
      "object_id": null,
      "dwg_id": "95AE"
    },
    "position": {
      "x": 577.6285106648539,
      "y": 1105.5979109700402
    },
    "dwg_pos_img": [
      577.6285106648539,
      1105.5979109700402
    ],
    "pos_dxf": [
      230.0063198299215,
      1081.865463705752
    ],
    "type": "B2_A01KSYGOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_190",
    "source_ids": {
      "object_id": null,
      "dwg_id": "95D7"
    },
    "position": {
      "x": 577.6285106649169,
      "y": 906.1815447966683
    },
    "dwg_pos_img": [
      577.6285106649169,
      906.1815447966683
    ],
    "pos_dxf": [
      230.0063198299215,
      1115.686417606176
    ],
    "type": "B2_A01KSYGQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_191",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9600"
    },
    "position": {
      "x": 577.6285106649754,
      "y": 721.3878467060722
    },
    "dwg_pos_img": [
      577.6285106649754,
      721.3878467060722
    ],
    "pos_dxf": [
      230.0063198299215,
      1147.027371531579
    ],
    "type": "B2_A01KSYGSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_192",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9629"
    },
    "position": {
      "x": 577.6285106646727,
      "y": 1680.262060969554
    },
    "dwg_pos_img": [
      577.6285106646727,
      1680.262060969554
    ],
    "pos_dxf": [
      230.0063198299215,
      984.4026019641906
    ],
    "type": "B2_A01KSYGUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSYGUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F1,G],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_193",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9652"
    },
    "position": {
      "x": 929.7277889377202,
      "y": 1595.8010795734062
    },
    "dwg_pos_img": [
      929.7277889377202,
      1595.8010795734062
    ],
    "pos_dxf": [
      289.726338759667,
      998.7730831640538
    ],
    "type": "B17_A01KSYIJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KSYIJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_194",
    "source_ids": {
      "object_id": null,
      "dwg_id": "967B"
    },
    "position": {
      "x": 5929.307817831978,
      "y": 976.887871970559
    },
    "dwg_pos_img": [
      5929.307817831978,
      976.887871970559
    ],
    "pos_dxf": [
      1137.711644014435,
      1104.3926754186
    ],
    "type": "B2_A01KSZCAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_195",
    "source_ids": {
      "object_id": null,
      "dwg_id": "96A4"
    },
    "position": {
      "x": 5933.238373347906,
      "y": 1089.3121480052587
    },
    "dwg_pos_img": [
      5933.238373347906,
      1089.3121480052587
    ],
    "pos_dxf": [
      1138.378310674387,
      1085.326065714643
    ],
    "type": "B2_A01KSZCCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_196",
    "source_ids": {
      "object_id": null,
      "dwg_id": "96CD"
    },
    "position": {
      "x": 5929.307817831907,
      "y": 1201.7303784003543
    },
    "dwg_pos_img": [
      5929.307817831907,
      1201.7303784003543
    ],
    "pos_dxf": [
      1137.711644014435,
      1066.259456010687
    ],
    "type": "B2_A01KSZCEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_197",
    "source_ids": {
      "object_id": null,
      "dwg_id": "96F6"
    },
    "position": {
      "x": 6069.550038644217,
      "y": 976.9957261809523
    },
    "dwg_pos_img": [
      6069.550038644217,
      976.9957261809523
    ],
    "pos_dxf": [
      1161.498310441971,
      1104.3926754186
    ],
    "type": "B2_A01KSZCGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_198",
    "source_ids": {
      "object_id": null,
      "dwg_id": "971F"
    },
    "position": {
      "x": 6069.550038644182,
      "y": 1089.4169793958536
    },
    "dwg_pos_img": [
      6069.550038644182,
      1089.4169793958536
    ],
    "pos_dxf": [
      1161.498310441971,
      1085.326065714643
    ],
    "type": "B2_A01KSZCIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_199",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9748"
    },
    "position": {
      "x": 6069.550038644146,
      "y": 1201.8382326107476
    },
    "dwg_pos_img": [
      6069.550038644146,
      1201.8382326107476
    ],
    "pos_dxf": [
      1161.498310441971,
      1066.259456010687
    ],
    "type": "B2_A01KSZCKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I2,I3],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_200",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9771"
    },
    "position": {
      "x": 6205.861703940488,
      "y": 977.1005575715471
    },
    "dwg_pos_img": [
      6205.861703940488,
      977.1005575715471
    ],
    "pos_dxf": [
      1184.618310209554,
      1104.3926754186
    ],
    "type": "B2_A01KSZCMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_201",
    "source_ids": {
      "object_id": null,
      "dwg_id": "979A"
    },
    "position": {
      "x": 6205.861703940453,
      "y": 1089.5218107864484
    },
    "dwg_pos_img": [
      6205.861703940453,
      1089.5218107864484
    ],
    "pos_dxf": [
      1184.618310209554,
      1085.326065714643
    ],
    "type": "B2_A01KSZCOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_202",
    "source_ids": {
      "object_id": null,
      "dwg_id": "97C3"
    },
    "position": {
      "x": 6205.861703940417,
      "y": 1201.9430640013425
    },
    "dwg_pos_img": [
      6205.861703940417,
      1201.9430640013425
    ],
    "pos_dxf": [
      1184.618310209554,
      1066.259456010687
    ],
    "type": "B2_A01KSZCQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_203",
    "source_ids": {
      "object_id": null,
      "dwg_id": "97EC"
    },
    "position": {
      "x": 6342.173369236759,
      "y": 977.2053889621429
    },
    "dwg_pos_img": [
      6342.173369236759,
      977.2053889621429
    ],
    "pos_dxf": [
      1207.738309977137,
      1104.3926754186
    ],
    "type": "B2_A01KSZCSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_204",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9815"
    },
    "position": {
      "x": 6342.173369236723,
      "y": 1089.6266421770442
    },
    "dwg_pos_img": [
      6342.173369236723,
      1089.6266421770442
    ],
    "pos_dxf": [
      1207.738309977137,
      1085.326065714643
    ],
    "type": "B2_A01KSZCUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_205",
    "source_ids": {
      "object_id": null,
      "dwg_id": "983E"
    },
    "position": {
      "x": 6342.173369236688,
      "y": 1202.0478953919383
    },
    "dwg_pos_img": [
      6342.173369236688,
      1202.0478953919383
    ],
    "pos_dxf": [
      1207.738309977137,
      1066.259456010687
    ],
    "type": "B2_A01KSZCWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCWXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_206",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9867"
    },
    "position": {
      "x": 6478.485034533028,
      "y": 977.3102203527378
    },
    "dwg_pos_img": [
      6478.485034533028,
      977.3102203527378
    ],
    "pos_dxf": [
      1230.85830974472,
      1104.3926754186
    ],
    "type": "B2_A01KSZCYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZCYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_207",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9890"
    },
    "position": {
      "x": 6478.485034532992,
      "y": 1089.7314735676391
    },
    "dwg_pos_img": [
      6478.485034532992,
      1089.7314735676391
    ],
    "pos_dxf": [
      1230.85830974472,
      1085.326065714643
    ],
    "type": "B2_A01KSZD0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZD0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_208",
    "source_ids": {
      "object_id": null,
      "dwg_id": "98B9"
    },
    "position": {
      "x": 6478.485034532957,
      "y": 1202.1527267825331
    },
    "dwg_pos_img": [
      6478.485034532957,
      1202.1527267825331
    ],
    "pos_dxf": [
      1230.85830974472,
      1066.259456010687
    ],
    "type": "B2_A01KSZD2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZD2XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I3,I4],[43-42]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_209",
    "source_ids": {
      "object_id": null,
      "dwg_id": "98E2"
    },
    "position": {
      "x": 6591.21336673352,
      "y": 977.3969148245451
    },
    "dwg_pos_img": [
      6591.21336673352,
      977.3969148245451
    ],
    "pos_dxf": [
      1249.978309552592,
      1104.3926754186
    ],
    "type": "B2_A01KSZD4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZD4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_210",
    "source_ids": {
      "object_id": null,
      "dwg_id": "990B"
    },
    "position": {
      "x": 6591.213366733485,
      "y": 1089.8181680394464
    },
    "dwg_pos_img": [
      6591.213366733485,
      1089.8181680394464
    ],
    "pos_dxf": [
      1249.978309552592,
      1085.326065714643
    ],
    "type": "B2_A01KSZD6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZD6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_211",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9934"
    },
    "position": {
      "x": 6591.213366733449,
      "y": 1202.2394212543404
    },
    "dwg_pos_img": [
      6591.213366733449,
      1202.2394212543404
    ],
    "pos_dxf": [
      1249.978309552592,
      1066.259456010687
    ],
    "type": "B2_A01KSZD8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZD8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_212",
    "source_ids": {
      "object_id": null,
      "dwg_id": "995D"
    },
    "position": {
      "x": 6727.525032029796,
      "y": 977.5017462151409
    },
    "dwg_pos_img": [
      6727.525032029796,
      977.5017462151409
    ],
    "pos_dxf": [
      1273.098309320176,
      1104.3926754186
    ],
    "type": "B2_A01KSZDAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZDAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_213",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9986"
    },
    "position": {
      "x": 6727.525032029761,
      "y": 1089.9229994300422
    },
    "dwg_pos_img": [
      6727.525032029761,
      1089.9229994300422
    ],
    "pos_dxf": [
      1273.098309320176,
      1085.326065714643
    ],
    "type": "B2_A01KSZDCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZDCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_214",
    "source_ids": {
      "object_id": null,
      "dwg_id": "99AF"
    },
    "position": {
      "x": 6727.5250320297255,
      "y": 1202.3442526449362
    },
    "dwg_pos_img": [
      6727.5250320297255,
      1202.3442526449362
    ],
    "pos_dxf": [
      1273.098309320176,
      1066.259456010687
    ],
    "type": "B2_A01KSZDEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KSZDEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_215",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9B20"
    },
    "position": {
      "x": 5528.076710754558,
      "y": 639.3155428808941
    },
    "dwg_pos_img": [
      5528.076710754558,
      639.3155428808941
    ],
    "pos_dxf": [
      1069.658311365191,
      1161.592504530468
    ],
    "type": "B2_A01KT0ECXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0ECXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_216",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9B49"
    },
    "position": {
      "x": 5528.0767107545225,
      "y": 751.7367960957881
    },
    "dwg_pos_img": [
      5528.0767107545225,
      751.7367960957881
    ],
    "pos_dxf": [
      1069.658311365191,
      1142.525894826512
    ],
    "type": "B2_A01KT0EEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_217",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9B72"
    },
    "position": {
      "x": 5528.076710754487,
      "y": 864.1580493106894
    },
    "dwg_pos_img": [
      5528.076710754487,
      864.1580493106894
    ],
    "pos_dxf": [
      1069.658311365191,
      1123.459285122555
    ],
    "type": "B2_A01KT0EGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_218",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9B9B"
    },
    "position": {
      "x": 5664.388376050828,
      "y": 639.420374271489
    },
    "dwg_pos_img": [
      5664.388376050828,
      639.420374271489
    ],
    "pos_dxf": [
      1092.778311132774,
      1161.592504530468
    ],
    "type": "B2_A01KT0EIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_219",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9BC4"
    },
    "position": {
      "x": 5664.388376050792,
      "y": 751.841627486383
    },
    "dwg_pos_img": [
      5664.388376050792,
      751.841627486383
    ],
    "pos_dxf": [
      1092.778311132774,
      1142.525894826512
    ],
    "type": "B2_A01KT0EKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_220",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9BED"
    },
    "position": {
      "x": 5664.388376050757,
      "y": 864.2628807012843
    },
    "dwg_pos_img": [
      5664.388376050757,
      864.2628807012843
    ],
    "pos_dxf": [
      1092.778311132774,
      1123.459285122555
    ],
    "type": "B2_A01KT0EMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_221",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9C16"
    },
    "position": {
      "x": 5800.700041347104,
      "y": 639.5252056620839
    },
    "dwg_pos_img": [
      5800.700041347104,
      639.5252056620839
    ],
    "pos_dxf": [
      1115.898310900358,
      1161.592504530468
    ],
    "type": "B2_A01KT0EOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_222",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9C3F"
    },
    "position": {
      "x": 5800.700041347069,
      "y": 751.9464588769779
    },
    "dwg_pos_img": [
      5800.700041347069,
      751.9464588769779
    ],
    "pos_dxf": [
      1115.898310900358,
      1142.525894826512
    ],
    "type": "B2_A01KT0EQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_223",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9C68"
    },
    "position": {
      "x": 5800.700041347033,
      "y": 864.3677120918792
    },
    "dwg_pos_img": [
      5800.700041347033,
      864.3677120918792
    ],
    "pos_dxf": [
      1115.898310900358,
      1123.459285122555
    ],
    "type": "B2_A01KT0ESXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0ESXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_224",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9C91"
    },
    "position": {
      "x": 5937.011706643374,
      "y": 639.6300370526797
    },
    "dwg_pos_img": [
      5937.011706643374,
      639.6300370526797
    ],
    "pos_dxf": [
      1139.018310667941,
      1161.592504530468
    ],
    "type": "B2_A01KT0EUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_225",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9CBA"
    },
    "position": {
      "x": 5937.011706643339,
      "y": 752.0512902675737
    },
    "dwg_pos_img": [
      5937.011706643339,
      752.0512902675737
    ],
    "pos_dxf": [
      1139.018310667941,
      1142.525894826512
    ],
    "type": "B2_A01KT0EWXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EWXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_226",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9CE3"
    },
    "position": {
      "x": 5937.011706643303,
      "y": 864.472543482475
    },
    "dwg_pos_img": [
      5937.011706643303,
      864.472543482475
    ],
    "pos_dxf": [
      1139.018310667941,
      1123.459285122555
    ],
    "type": "B2_A01KT0EYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0EYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_227",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9D0C"
    },
    "position": {
      "x": 6073.32337193965,
      "y": 639.7348684432745
    },
    "dwg_pos_img": [
      6073.32337193965,
      639.7348684432745
    ],
    "pos_dxf": [
      1162.138310435525,
      1161.592504530468
    ],
    "type": "B2_A01KT0F0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0F0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_228",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9D35"
    },
    "position": {
      "x": 6073.323371939615,
      "y": 752.1561216581686
    },
    "dwg_pos_img": [
      6073.323371939615,
      752.1561216581686
    ],
    "pos_dxf": [
      1162.138310435525,
      1142.525894826512
    ],
    "type": "B2_A01KT0F2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0F2XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_229",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9D5E"
    },
    "position": {
      "x": 6073.323371939579,
      "y": 864.5773748730699
    },
    "dwg_pos_img": [
      6073.323371939579,
      864.5773748730699
    ],
    "pos_dxf": [
      1162.138310435525,
      1123.459285122555
    ],
    "type": "B2_A01KT0F4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0F4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_230",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9D87"
    },
    "position": {
      "x": 6209.635037235921,
      "y": 639.8396998338694
    },
    "dwg_pos_img": [
      6209.635037235921,
      639.8396998338694
    ],
    "pos_dxf": [
      1185.258310203108,
      1161.592504530468
    ],
    "type": "B2_A01KT0F6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0F6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_231",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9DB0"
    },
    "position": {
      "x": 6209.635037235886,
      "y": 752.2609530487634
    },
    "dwg_pos_img": [
      6209.635037235886,
      752.2609530487634
    ],
    "pos_dxf": [
      1185.258310203108,
      1142.525894826512
    ],
    "type": "B2_A01KT0F8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0F8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_232",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9DD9"
    },
    "position": {
      "x": 6209.63503723585,
      "y": 864.6822062636647
    },
    "dwg_pos_img": [
      6209.63503723585,
      864.6822062636647
    ],
    "pos_dxf": [
      1185.258310203108,
      1123.459285122555
    ],
    "type": "B2_A01KT0FAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_233",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9E02"
    },
    "position": {
      "x": 6345.94670253219,
      "y": 639.9445312244652
    },
    "dwg_pos_img": [
      6345.94670253219,
      639.9445312244652
    ],
    "pos_dxf": [
      1208.378309970691,
      1161.592504530468
    ],
    "type": "B2_A01KT0FCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_234",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9E2B"
    },
    "position": {
      "x": 6345.946702532155,
      "y": 752.3657844393592
    },
    "dwg_pos_img": [
      6345.946702532155,
      752.3657844393592
    ],
    "pos_dxf": [
      1208.378309970691,
      1142.525894826512
    ],
    "type": "B2_A01KT0FEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_235",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9E54"
    },
    "position": {
      "x": 6345.946702532119,
      "y": 864.7870376542605
    },
    "dwg_pos_img": [
      6345.946702532119,
      864.7870376542605
    ],
    "pos_dxf": [
      1208.378309970691,
      1123.459285122555
    ],
    "type": "B2_A01KT0FGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_236",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9E7D"
    },
    "position": {
      "x": 6482.258367828467,
      "y": 640.0493626150601
    },
    "dwg_pos_img": [
      6482.258367828467,
      640.0493626150601
    ],
    "pos_dxf": [
      1231.498309738275,
      1161.592504530468
    ],
    "type": "B2_A01KT0FIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_237",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9EA6"
    },
    "position": {
      "x": 6482.258367828432,
      "y": 752.4706158299541
    },
    "dwg_pos_img": [
      6482.258367828432,
      752.4706158299541
    ],
    "pos_dxf": [
      1231.498309738275,
      1142.525894826512
    ],
    "type": "B2_A01KT0FKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_238",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9ECF"
    },
    "position": {
      "x": 6482.258367828396,
      "y": 864.8918690448554
    },
    "dwg_pos_img": [
      6482.258367828396,
      864.8918690448554
    ],
    "pos_dxf": [
      1231.498309738275,
      1123.459285122555
    ],
    "type": "B2_A01KT0FMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_239",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9EF8"
    },
    "position": {
      "x": 6594.986700028953,
      "y": 640.1360570868674
    },
    "dwg_pos_img": [
      6594.986700028953,
      640.1360570868674
    ],
    "pos_dxf": [
      1250.618309546146,
      1161.592504530468
    ],
    "type": "B2_A01KT0FOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_240",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9F21"
    },
    "position": {
      "x": 6594.986700028918,
      "y": 752.5573103017614
    },
    "dwg_pos_img": [
      6594.986700028918,
      752.5573103017614
    ],
    "pos_dxf": [
      1250.618309546146,
      1142.525894826512
    ],
    "type": "B2_A01KT0FQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_241",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9F4A"
    },
    "position": {
      "x": 6594.986700028882,
      "y": 864.9785635166627
    },
    "dwg_pos_img": [
      6594.986700028882,
      864.9785635166627
    ],
    "pos_dxf": [
      1250.618309546146,
      1123.459285122555
    ],
    "type": "B2_A01KT0FSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT0FSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_242",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9F73"
    },
    "position": {
      "x": 999.3689557290548,
      "y": 1655.0960817594023
    },
    "dwg_pos_img": [
      999.3689557290548,
      1655.0960817594023
    ],
    "pos_dxf": [
      301.5382681094463,
      988.7257525902901
    ],
    "type": "B17_A01KT0RJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT0RJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_243",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9F9C"
    },
    "position": {
      "x": 3433.5700526026144,
      "y": 3106.665705651446
    },
    "dwg_pos_img": [
      3433.5700526026144,
      3106.665705651446
    ],
    "pos_dxf": [
      714.4062986749677,
      742.8574913948182
    ],
    "type": "B16_A01KT0XQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0XQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_244",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9FC5"
    },
    "position": {
      "x": 3433.570052602659,
      "y": 2967.4201926179558
    },
    "dwg_pos_img": [
      3433.570052602659,
      2967.4201926179558
    ],
    "pos_dxf": [
      714.4062986749677,
      766.4734872507061
    ],
    "type": "B16_A01KT0XTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0XTXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_245",
    "source_ids": {
      "object_id": null,
      "dwg_id": "9FEE"
    },
    "position": {
      "x": 3593.2527188864638,
      "y": 2304.6145247594777
    },
    "dwg_pos_img": [
      3593.2527188864638,
      2304.6145247594777
    ],
    "pos_dxf": [
      741.4902844757398,
      878.9059507968768
    ],
    "type": "B13_A01KT0Y1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0Y1XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_246",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A099"
    },
    "position": {
      "x": 3433.5700526027463,
      "y": 2688.9291665509736
    },
    "dwg_pos_img": [
      3433.5700526027463,
      2688.9291665509736
    ],
    "pos_dxf": [
      714.4062986749677,
      813.7054789624822
    ],
    "type": "B16_A01KT0YDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0YDXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_247",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A0C2"
    },
    "position": {
      "x": 3530.0495816939424,
      "y": 2304.5659179674803
    },
    "dwg_pos_img": [
      3530.0495816939424,
      2304.5659179674803
    ],
    "pos_dxf": [
      730.7703177434312,
      878.9059507968768
    ],
    "type": "B13_A01KT0YGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0YGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_248",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A16D"
    },
    "position": {
      "x": 3650.5363332406755,
      "y": 2549.850512875133
    },
    "dwg_pos_img": [
      3650.5363332406755,
      2549.850512875133
    ],
    "pos_dxf": [
      751.2062332001497,
      837.32147481837
    ],
    "type": "B16_A01KT0YKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0YKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_249",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A196"
    },
    "position": {
      "x": 3650.5363332405436,
      "y": 2967.5870519756054
    },
    "dwg_pos_img": [
      3650.5363332405436,
      2967.5870519756054
    ],
    "pos_dxf": [
      751.2062332001497,
      766.4734872507061
    ],
    "type": "B16_A01KT0YMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0YMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_250",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A1BF"
    },
    "position": {
      "x": 3638.0376465040986,
      "y": 2398.6596417307683
    },
    "dwg_pos_img": [
      3638.0376465040986,
      2398.6596417307683
    ],
    "pos_dxf": [
      749.08631460171,
      862.961769481994
    ],
    "type": "B13_A01KT0YRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0YRXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F03 B13 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_251",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A26A"
    },
    "position": {
      "x": 3542.0531929217327,
      "y": 2549.767083196308
    },
    "dwg_pos_img": [
      3542.0531929217327,
      2549.767083196308
    ],
    "pos_dxf": [
      732.8062659375587,
      837.32147481837
    ],
    "type": "B16_A01KT0YUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0YUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_252",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A293"
    },
    "position": {
      "x": 3483.5904674774033,
      "y": 2304.5301882774456
    },
    "dwg_pos_img": [
      3483.5904674774033,
      2304.5301882774456
    ],
    "pos_dxf": [
      722.8903266395598,
      878.9059507968768
    ],
    "type": "B13_A01KT0Z1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0Z1XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_253",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A33E"
    },
    "position": {
      "x": 3650.536333240631,
      "y": 2689.0960259086232
    },
    "dwg_pos_img": [
      3650.536333240631,
      2689.0960259086232
    ],
    "pos_dxf": [
      751.2062332001497,
      813.7054789624822
    ],
    "type": "B16_A01KT0Z8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0Z8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_254",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A367"
    },
    "position": {
      "x": 3416.3777206680766,
      "y": 2363.4408691700883
    },
    "dwg_pos_img": [
      3416.3777206680766,
      2363.4408691700883
    ],
    "pos_dxf": [
      711.4902847779017,
      868.9059508975974
    ],
    "type": "B13_A01KT0ZBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0ZBXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_255",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A412"
    },
    "position": {
      "x": 3433.570052602791,
      "y": 2549.6836535174834
    },
    "dwg_pos_img": [
      3433.570052602791,
      2549.6836535174834
    ],
    "pos_dxf": [
      714.4062986749677,
      837.32147481837
    ],
    "type": "B16_A01KT0ZJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0ZJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_256",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A43B"
    },
    "position": {
      "x": 3542.0531929216445,
      "y": 2828.258109263291
    },
    "dwg_pos_img": [
      3542.0531929216445,
      2828.258109263291
    ],
    "pos_dxf": [
      732.8062659375587,
      790.0894831065939
    ],
    "type": "B16_A01KT0ZPXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0ZPXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_257",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A464"
    },
    "position": {
      "x": 3437.603048732945,
      "y": 2304.494821347943
    },
    "dwg_pos_img": [
      3437.603048732945,
      2304.494821347943
    ],
    "pos_dxf": [
      715.0903404214125,
      878.9059507968768
    ],
    "type": "B13_A01KT0ZRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0ZRXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_258",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A50F"
    },
    "position": {
      "x": 3650.5363332405873,
      "y": 2828.341538942116
    },
    "dwg_pos_img": [
      3650.5363332405873,
      2828.341538942116
    ],
    "pos_dxf": [
      751.2062332001497,
      790.0894831065939
    ],
    "type": "B16_A01KT0ZVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT0ZVXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_259",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A538"
    },
    "position": {
      "x": 3534.294386146987,
      "y": 2363.531553764027
    },
    "dwg_pos_img": [
      3534.294386146987,
      2363.531553764027
    ],
    "pos_dxf": [
      731.4902845764602,
      868.9059508975974
    ],
    "type": "B13_A01KT0ZXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT0ZXXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_260",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A5E3"
    },
    "position": {
      "x": 3433.5700526027026,
      "y": 2828.1746795844665
    },
    "dwg_pos_img": [
      3433.5700526027026,
      2828.1746795844665
    ],
    "pos_dxf": [
      714.4062986749677,
      790.0894831065939
    ],
    "type": "B16_A01KT101XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT101XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_261",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A60C"
    },
    "position": {
      "x": 3391.1436466558357,
      "y": 2304.459091436527
    },
    "dwg_pos_img": [
      3391.1436466558357,
      2304.459091436527
    ],
    "pos_dxf": [
      707.2103004931334,
      878.9059507968768
    ],
    "type": "B13_A01KT103XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT103XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_262",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A6B7"
    },
    "position": {
      "x": 3542.053192921688,
      "y": 2689.012596229798
    },
    "dwg_pos_img": [
      3542.053192921688,
      2689.012596229798
    ],
    "pos_dxf": [
      732.8062659375587,
      813.7054789624822
    ],
    "type": "B16_A01KT106XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT106XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_263",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A6E0"
    },
    "position": {
      "x": 3650.536333240499,
      "y": 3106.8325650090956
    },
    "dwg_pos_img": [
      3650.536333240499,
      3106.8325650090956
    ],
    "pos_dxf": [
      751.2062332001497,
      742.8574913948182
    ],
    "type": "B16_A01KT108XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT108XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_264",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A709"
    },
    "position": {
      "x": 3542.053192921601,
      "y": 2967.50362229678
    },
    "dwg_pos_img": [
      3542.053192921601,
      2967.50362229678
    ],
    "pos_dxf": [
      732.8062659375587,
      766.4734872507061
    ],
    "type": "B16_A01KT10CXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT10CXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_265",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A732"
    },
    "position": {
      "x": 3652.2111607384745,
      "y": 2304.6597580203324
    },
    "dwg_pos_img": [
      3652.2111607384745,
      2304.6597580203324
    ],
    "pos_dxf": [
      751.4903028817423,
      878.9059693035997
    ],
    "type": "B13_A01KT10OXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT10OXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_266",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A7DD"
    },
    "position": {
      "x": 3542.0531929215563,
      "y": 3106.7491353302703
    },
    "dwg_pos_img": [
      3542.0531929215563,
      3106.7491353302703
    ],
    "pos_dxf": [
      732.8062659375587,
      742.8574913948182
    ],
    "type": "B16_A01KT10RXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B16_A01KT10RXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B16 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_267",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A806"
    },
    "position": {
      "x": 6524.732277296507,
      "y": 1337.016514348301
    },
    "dwg_pos_img": [
      6524.732277296507,
      1337.016514348301
    ],
    "pos_dxf": [
      1238.702365054452,
      1043.392631545741
    ],
    "type": "B13_A01KT1GEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT1GEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F02 B13 02F02 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_268",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A8B1"
    },
    "position": {
      "x": 6530.863810548309,
      "y": 1425.4647867958292
    },
    "dwg_pos_img": [
      6530.863810548309,
      1425.4647867958292
    ],
    "pos_dxf": [
      1239.742342425788,
      1028.392631697005
    ],
    "type": "B13_A01KT1GRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT1GRXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B13 B13 02F02 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_269",
    "source_ids": {
      "object_id": null,
      "dwg_id": "A95C"
    },
    "position": {
      "x": 6566.474798052367,
      "y": 1337.0486167097633
    },
    "dwg_pos_img": [
      6566.474798052367,
      1337.0486167097633
    ],
    "pos_dxf": [
      1245.782368574886,
      1043.392631545924
    ],
    "type": "B13_A01KT1H0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT1H0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F02 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_270",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AA07"
    },
    "position": {
      "x": 6471.90547780885,
      "y": 1425.4194444988598
    },
    "dwg_pos_img": [
      6471.90547780885,
      1425.4194444988598
    ],
    "pos_dxf": [
      1229.742342526508,
      1028.392631697005
    ],
    "type": "B13_A01KT1H5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT1H5XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B13 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_271",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AAB2"
    },
    "position": {
      "x": 6446.431420414859,
      "y": 1332.0231147812428
    },
    "dwg_pos_img": [
      6446.431420414859,
      1332.0231147812428
    ],
    "pos_dxf": [
      1225.4216543466,
      1044.229297645659
    ],
    "type": "B13_A01KT1H8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B13_A01KT1H8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B13 02F02 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_272",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AB5D"
    },
    "position": {
      "x": 4160.365020945959,
      "y": 4480.802287365944
    },
    "dwg_pos_img": [
      4160.365020945959,
      4480.802287365944
    ],
    "pos_dxf": [
      837.6789434824877,
      509.8991501566318
    ],
    "type": "B11_A01KT1NHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NHXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_273",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AB86"
    },
    "position": {
      "x": 4160.365020945919,
      "y": 4606.588669953165
    },
    "dwg_pos_img": [
      4160.365020945919,
      4606.588669953165
    ],
    "pos_dxf": [
      837.6789434824877,
      488.5658186532139
    ],
    "type": "B11_A01KT1NKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_274",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ABAF"
    },
    "position": {
      "x": 4160.36502094588,
      "y": 4732.375052540387
    },
    "dwg_pos_img": [
      4160.36502094588,
      4732.375052540387
    ],
    "pos_dxf": [
      837.6789434824877,
      467.2324871497958
    ],
    "type": "B11_A01KT1NNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NNXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_275",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ABD8"
    },
    "position": {
      "x": 4596.656556824471,
      "y": 4866.240808229082
    },
    "dwg_pos_img": [
      4596.656556824471,
      4866.240808229082
    ],
    "pos_dxf": [
      911.6789212994154,
      444.5858027482207
    ],
    "type": "B11_A01KT1NSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F02 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_276",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AC01"
    },
    "position": {
      "x": 4596.656556824433,
      "y": 4988.646913639606
    },
    "dwg_pos_img": [
      4596.656556824433,
      4988.646913639606
    ],
    "pos_dxf": [
      911.6789212994154,
      423.8257652063642
    ],
    "type": "B11_A01KT1NVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NVXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F02 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_277",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AC2A"
    },
    "position": {
      "x": 4697.866912945073,
      "y": 4866.318644724965
    },
    "dwg_pos_img": [
      4697.866912945073,
      4866.318644724965
    ],
    "pos_dxf": [
      928.8453421255376,
      444.5858027482207
    ],
    "type": "B11_A01KT1NZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1NZXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B11 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_278",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AC53"
    },
    "position": {
      "x": 4697.8669129450345,
      "y": 4988.7247501354905
    },
    "dwg_pos_img": [
      4697.8669129450345,
      4988.7247501354905
    ],
    "pos_dxf": [
      928.8453421255376,
      423.8257652063642
    ],
    "type": "B11_A01KT1O2XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1O2XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 B11 02F02 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_279",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AC7C"
    },
    "position": {
      "x": 1238.6730832710991,
      "y": 429.8529993169486
    },
    "dwg_pos_img": [
      1238.6730832710991,
      429.8529993169486
    ],
    "pos_dxf": [
      342.1269540529388,
      1196.5578125087
    ],
    "type": "B11_A01KT1O8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1O8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_280",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ACA5"
    },
    "position": {
      "x": 1114.622227607239,
      "y": 429.75755664138796
    },
    "dwg_pos_img": [
      1114.622227607239,
      429.75755664138796
    ],
    "pos_dxf": [
      321.0865262371442,
      1196.557819384604
    ],
    "type": "B11_A01KT1OBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1OBXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_281",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ACCE"
    },
    "position": {
      "x": 1371.680558278581,
      "y": 429.9552490561182
    },
    "dwg_pos_img": [
      1371.680558278581,
      429.9552490561182
    ],
    "pos_dxf": [
      364.6865257856739,
      1196.557819384604
    ],
    "type": "B11_A01KT1OFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1OFXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_282",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ACF7"
    },
    "position": {
      "x": 1495.7314139424402,
      "y": 430.05069173167885
    },
    "dwg_pos_img": [
      1495.7314139424402,
      430.05069173167885
    ],
    "pos_dxf": [
      385.7269536014683,
      1196.5578125087
    ],
    "type": "B11_A01KT1OIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT1OIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_283",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AD20"
    },
    "position": {
      "x": 1575.4393340215993,
      "y": 286.6671216583345
    },
    "dwg_pos_img": [
      1575.4393340215993,
      286.6671216583345
    ],
    "pos_dxf": [
      399.2463181378655,
      1220.886018000945
    ],
    "type": "B12_A01KT1QEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B12_A01KT1QEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B12 05F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_284",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AD51"
    },
    "position": {
      "x": 1034.2068932851307,
      "y": 286.25211669327473
    },
    "dwg_pos_img": [
      1034.2068932851307,
      286.25211669327473
    ],
    "pos_dxf": [
      307.4471762460971,
      1220.885808810844
    ],
    "type": "B12_A01KT1QKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B12_A01KT1QKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B12 05F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_285",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AD82"
    },
    "position": {
      "x": 4122.907478555043,
      "y": 5048.779801016636
    },
    "dwg_pos_img": [
      4122.907478555043,
      5048.779801016636
    ],
    "pos_dxf": [
      831.3257207448314,
      413.5654542140878
    ],
    "type": "B12_A01KT1QNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B12_A01KT1QNXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B12 06F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_286",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ADB3"
    },
    "position": {
      "x": 4573.116807985669,
      "y": 5049.184534582975
    },
    "dwg_pos_img": [
      4573.116807985669,
      5049.184534582975
    ],
    "pos_dxf": [
      907.6863137225228,
      413.5555331249905
    ],
    "type": "B12_A01KT1QQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B12_A01KT1QQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B12 06F01 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_287",
    "source_ids": {
      "object_id": null,
      "dwg_id": "ADE4"
    },
    "position": {
      "x": 888.9285074920009,
      "y": 2465.6179281169116
    },
    "dwg_pos_img": [
      888.9285074920009,
      2465.6179281169116
    ],
    "pos_dxf": [
      282.806319291883,
      851.247093699988
    ],
    "type": "B17_A01KT1X3XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT1X3XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_288",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AE0D"
    },
    "position": {
      "x": 888.9285074919559,
      "y": 2607.9079324884897
    },
    "dwg_pos_img": [
      888.9285074919559,
      2607.9079324884897
    ],
    "pos_dxf": [
      282.806319291883,
      827.1147530567009
    ],
    "type": "B17_A01KT1X5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT1X5XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_289",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AE36"
    },
    "position": {
      "x": 888.9306437847173,
      "y": 2793.2358738178973
    },
    "dwg_pos_img": [
      888.9306437847173,
      2793.2358738178973
    ],
    "pos_dxf": [
      282.8066816313012,
      795.6831919222072
    ],
    "type": "B17_A01KT1X9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT1X9XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_290",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AE5F"
    },
    "position": {
      "x": 888.9306437846659,
      "y": 2955.97201861299
    },
    "dwg_pos_img": [
      888.9306437846659,
      2955.97201861299
    ],
    "pos_dxf": [
      282.8066816313012,
      768.0831921997046
    ],
    "type": "B17_A01KT1XBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT1XBXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_291",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AE88"
    },
    "position": {
      "x": 775.7285086688356,
      "y": 2970.747978632745
    },
    "dwg_pos_img": [
      775.7285086688356,
      2970.747978632745
    ],
    "pos_dxf": [
      263.6063194914998,
      765.5624288051777
    ],
    "type": "B2_A01KT1ZXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT1ZXXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_292",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AEB1"
    },
    "position": {
      "x": 1174.2875885132175,
      "y": 2124.536263826594
    },
    "dwg_pos_img": [
      1174.2875885132175,
      2124.536263826594
    ],
    "pos_dxf": [
      331.2064461082214,
      909.131658145664
    ],
    "type": "B17_A01KT212XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT212XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_293",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AEDA"
    },
    "position": {
      "x": 1065.8057575689495,
      "y": 2124.4528351547524
    },
    "dwg_pos_img": [
      1065.8057575689495,
      2124.4528351547524
    ],
    "pos_dxf": [
      312.8067009303809,
      909.131658145664
    ],
    "type": "B17_A01KT214XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT214XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_294",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AF03"
    },
    "position": {
      "x": 957.3239266246829,
      "y": 2124.3694064829106
    },
    "dwg_pos_img": [
      957.3239266246829,
      2124.3694064829106
    ],
    "pos_dxf": [
      294.4069557525406,
      909.131658145664
    ],
    "type": "B17_A01KT216XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT216XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G,G1],[40-39]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_295",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AF2C"
    },
    "position": {
      "x": 1174.2875885131498,
      "y": 2339.7035634324
    },
    "dwg_pos_img": [
      1174.2875885131498,
      2339.7035634324
    ],
    "pos_dxf": [
      331.2064461082214,
      872.6393508165856
    ],
    "type": "B17_A01KT218XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT218XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_296",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AF7E"
    },
    "position": {
      "x": 957.3239266246152,
      "y": 2339.5367060887165
    },
    "dwg_pos_img": [
      957.3239266246152,
      2339.5367060887165
    ],
    "pos_dxf": [
      294.4069557525406,
      872.6393508165856
    ],
    "type": "B17_A01KT21CXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21CXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_297",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AFA7"
    },
    "position": {
      "x": 1174.287588513082,
      "y": 2554.870863038207
    },
    "dwg_pos_img": [
      1174.287588513082,
      2554.870863038207
    ],
    "pos_dxf": [
      331.2064461082214,
      836.1470434875073
    ],
    "type": "B17_A01KT21EXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21EXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_298",
    "source_ids": {
      "object_id": null,
      "dwg_id": "AFF9"
    },
    "position": {
      "x": 957.3239266245472,
      "y": 2554.7040056945234
    },
    "dwg_pos_img": [
      957.3239266245472,
      2554.7040056945234
    ],
    "pos_dxf": [
      294.4069557525406,
      836.1470434875073
    ],
    "type": "B17_A01KT21IXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21IXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_299",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B022"
    },
    "position": {
      "x": 1174.2875885130184,
      "y": 2755.8871935316483
    },
    "dwg_pos_img": [
      1174.2875885130184,
      2755.8871935316483
    ],
    "pos_dxf": [
      331.2064461082214,
      802.054736134256
    ],
    "type": "B17_A01KT21KXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21KXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_300",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B04B"
    },
    "position": {
      "x": 1065.8057575687503,
      "y": 2755.8037648598065
    },
    "dwg_pos_img": [
      1065.8057575687503,
      2755.8037648598065
    ],
    "pos_dxf": [
      312.8067009303809,
      802.054736134256
    ],
    "type": "B17_A01KT21MXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21MXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_301",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B074"
    },
    "position": {
      "x": 957.3239266244838,
      "y": 2755.7203361879647
    },
    "dwg_pos_img": [
      957.3239266244838,
      2755.7203361879647
    ],
    "pos_dxf": [
      294.4069557525406,
      802.054736134256
    ],
    "type": "B17_A01KT21OXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21OXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_302",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B09D"
    },
    "position": {
      "x": 1174.2875885129506,
      "y": 2971.0544931374543
    },
    "dwg_pos_img": [
      1174.2875885129506,
      2971.0544931374543
    ],
    "pos_dxf": [
      331.2064461082214,
      765.5624288051777
    ],
    "type": "B17_A01KT21QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21QXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_303",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B0C6"
    },
    "position": {
      "x": 1065.8057575686826,
      "y": 2970.9710644656125
    },
    "dwg_pos_img": [
      1065.8057575686826,
      2970.9710644656125
    ],
    "pos_dxf": [
      312.8067009303809,
      765.5624288051777
    ],
    "type": "B17_A01KT21SXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21SXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_304",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B0EF"
    },
    "position": {
      "x": 957.323926624416,
      "y": 2970.8876357937706
    },
    "dwg_pos_img": [
      957.323926624416,
      2970.8876357937706
    ],
    "pos_dxf": [
      294.4069557525406,
      765.5624288051777
    ],
    "type": "B17_A01KT21UXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21UXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_305",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B118"
    },
    "position": {
      "x": 1174.2875885128828,
      "y": 3186.221792743261
    },
    "dwg_pos_img": [
      1174.2875885128828,
      3186.221792743261
    ],
    "pos_dxf": [
      331.2064461082214,
      729.0701214760993
    ],
    "type": "B17_A01KT21WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21WXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G,G1],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_306",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B141"
    },
    "position": {
      "x": 1065.8057575686144,
      "y": 3186.1383640714193
    },
    "dwg_pos_img": [
      1065.8057575686144,
      3186.1383640714193
    ],
    "pos_dxf": [
      312.8067009303809,
      729.0701214760993
    ],
    "type": "B17_A01KT21YXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT21YXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G,G1],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_307",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B16A"
    },
    "position": {
      "x": 957.323926624348,
      "y": 3186.0549353995775
    },
    "dwg_pos_img": [
      957.323926624348,
      3186.0549353995775
    ],
    "pos_dxf": [
      294.4069557525406,
      729.0701214760993
    ],
    "type": "B17_A01KT220XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT220XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G,G1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_308",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B193"
    },
    "position": {
      "x": 1174.2875885128146,
      "y": 3401.3890923490676
    },
    "dwg_pos_img": [
      1174.2875885128146,
      3401.3890923490676
    ],
    "pos_dxf": [
      331.2064461082214,
      692.577814147021
    ],
    "type": "B17_A01KT222XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT222XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_309",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B1BC"
    },
    "position": {
      "x": 1065.8057575685466,
      "y": 3401.3056636772258
    },
    "dwg_pos_img": [
      1065.8057575685466,
      3401.3056636772258
    ],
    "pos_dxf": [
      312.8067009303809,
      692.577814147021
    ],
    "type": "B17_A01KT224XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT224XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_310",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B1E5"
    },
    "position": {
      "x": 957.32392662428,
      "y": 3401.2222350053844
    },
    "dwg_pos_img": [
      957.32392662428,
      3401.2222350053844
    ],
    "pos_dxf": [
      294.4069557525406,
      692.577814147021
    ],
    "type": "B17_A01KT226XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT226XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_311",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B20E"
    },
    "position": {
      "x": 1174.2875885127469,
      "y": 3616.556391954874
    },
    "dwg_pos_img": [
      1174.2875885127469,
      3616.556391954874
    ],
    "pos_dxf": [
      331.2064461082214,
      656.0855068179426
    ],
    "type": "B17_A01KT228XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT228XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_312",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B237"
    },
    "position": {
      "x": 1065.8057575684788,
      "y": 3616.472963283032
    },
    "dwg_pos_img": [
      1065.8057575684788,
      3616.472963283032
    ],
    "pos_dxf": [
      312.8067009303809,
      656.0855068179426
    ],
    "type": "B17_A01KT22AXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22AXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_313",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B260"
    },
    "position": {
      "x": 957.3239266242123,
      "y": 3616.389534611191
    },
    "dwg_pos_img": [
      957.3239266242123,
      3616.389534611191
    ],
    "pos_dxf": [
      294.4069557525406,
      656.0855068179426
    ],
    "type": "B17_A01KT22CXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22CXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G,G1],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_314",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B289"
    },
    "position": {
      "x": 1174.2875885126791,
      "y": 3831.723691560679
    },
    "dwg_pos_img": [
      1174.2875885126791,
      3831.723691560679
    ],
    "pos_dxf": [
      331.2064461082214,
      619.5931994888645
    ],
    "type": "B17_A01KT22EXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22EXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_315",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B2B2"
    },
    "position": {
      "x": 1065.8057575684106,
      "y": 3831.6402628888372
    },
    "dwg_pos_img": [
      1065.8057575684106,
      3831.6402628888372
    ],
    "pos_dxf": [
      312.8067009303809,
      619.5931994888645
    ],
    "type": "B17_A01KT22GXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22GXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_316",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B2DB"
    },
    "position": {
      "x": 957.3239266241443,
      "y": 3831.556834216996
    },
    "dwg_pos_img": [
      957.3239266241443,
      3831.556834216996
    ],
    "pos_dxf": [
      294.4069557525406,
      619.5931994888645
    ],
    "type": "B17_A01KT22IXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22IXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_317",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B304"
    },
    "position": {
      "x": 1174.2875885126114,
      "y": 4046.8909911664864
    },
    "dwg_pos_img": [
      1174.2875885126114,
      4046.8909911664864
    ],
    "pos_dxf": [
      331.2064461082214,
      583.1008921597859
    ],
    "type": "B17_A01KT22KXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22KXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_318",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B32D"
    },
    "position": {
      "x": 1065.8057575683429,
      "y": 4046.8075624946446
    },
    "dwg_pos_img": [
      1065.8057575683429,
      4046.8075624946446
    ],
    "pos_dxf": [
      312.8067009303809,
      583.1008921597859
    ],
    "type": "B17_A01KT22MXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22MXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_319",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B356"
    },
    "position": {
      "x": 957.3239266240765,
      "y": 4046.724133822803
    },
    "dwg_pos_img": [
      957.3239266240765,
      4046.724133822803
    ],
    "pos_dxf": [
      294.4069557525406,
      583.1008921597859
    ],
    "type": "B17_A01KT22OXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22OXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G,G1],[35-34]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_320",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B37F"
    },
    "position": {
      "x": 1174.2875885125432,
      "y": 4262.058290772293
    },
    "dwg_pos_img": [
      1174.2875885125432,
      4262.058290772293
    ],
    "pos_dxf": [
      331.2064461082214,
      546.6085848307075
    ],
    "type": "B17_A01KT22QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22QXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G,G1],[34-33]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_321",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B3A8"
    },
    "position": {
      "x": 1065.805757568275,
      "y": 4261.974862100451
    },
    "dwg_pos_img": [
      1065.805757568275,
      4261.974862100451
    ],
    "pos_dxf": [
      312.8067009303809,
      546.6085848307075
    ],
    "type": "B17_A01KT22SXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22SXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G,G1],[34-33]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_322",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B3D1"
    },
    "position": {
      "x": 957.3239266240085,
      "y": 4261.891433428609
    },
    "dwg_pos_img": [
      957.3239266240085,
      4261.891433428609
    ],
    "pos_dxf": [
      294.4069557525406,
      546.6085848307075
    ],
    "type": "B17_A01KT22UXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22UXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G,G1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_323",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B3FA"
    },
    "position": {
      "x": 1174.2875885124754,
      "y": 4477.225590378099
    },
    "dwg_pos_img": [
      1174.2875885124754,
      4477.225590378099
    ],
    "pos_dxf": [
      331.2064461082214,
      510.1162775016292
    ],
    "type": "B17_A01KT22WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22WXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_324",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B423"
    },
    "position": {
      "x": 1065.8057575682074,
      "y": 4477.142161706257
    },
    "dwg_pos_img": [
      1065.8057575682074,
      4477.142161706257
    ],
    "pos_dxf": [
      312.8067009303809,
      510.1162775016292
    ],
    "type": "B17_A01KT22YXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT22YXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_325",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B44C"
    },
    "position": {
      "x": 957.3239266239408,
      "y": 4477.058733034416
    },
    "dwg_pos_img": [
      957.3239266239408,
      4477.058733034416
    ],
    "pos_dxf": [
      294.4069557525406,
      510.1162775016292
    ],
    "type": "B17_A01KT230XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT230XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_326",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B475"
    },
    "position": {
      "x": 1174.2875885124076,
      "y": 4692.392889983906
    },
    "dwg_pos_img": [
      1174.2875885124076,
      4692.392889983906
    ],
    "pos_dxf": [
      331.2064461082214,
      473.6239701725508
    ],
    "type": "B17_A01KT232XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT232XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_327",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B49E"
    },
    "position": {
      "x": 1065.8057575681391,
      "y": 4692.309461312064
    },
    "dwg_pos_img": [
      1065.8057575681391,
      4692.309461312064
    ],
    "pos_dxf": [
      312.8067009303809,
      473.6239701725508
    ],
    "type": "B17_A01KT234XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT234XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_328",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B4C7"
    },
    "position": {
      "x": 957.3239266238728,
      "y": 4692.226032640223
    },
    "dwg_pos_img": [
      957.3239266238728,
      4692.226032640223
    ],
    "pos_dxf": [
      294.4069557525406,
      473.6239701725508
    ],
    "type": "B17_A01KT236XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B17_A01KT236XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B17 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_329",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B519"
    },
    "position": {
      "x": 775.7285086691492,
      "y": 1976.600483928767
    },
    "dwg_pos_img": [
      775.7285086691492,
      1976.600483928767
    ],
    "pos_dxf": [
      263.6063194914998,
      934.1695358034749
    ],
    "type": "B2_A01KT23AXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT23AXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_330",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B542"
    },
    "position": {
      "x": 577.6285106646261,
      "y": 1828.355097390252
    },
    "dwg_pos_img": [
      577.6285106646261,
      1828.355097390252
    ],
    "pos_dxf": [
      230.0063198299215,
      959.2860688838327
    ],
    "type": "B2_A01KT23CXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT23CXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F1,G],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_331",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B56B"
    },
    "position": {
      "x": 577.6285106645793,
      "y": 1976.44813381095
    },
    "dwg_pos_img": [
      577.6285106645793,
      1976.44813381095
    ],
    "pos_dxf": [
      230.0063198299215,
      934.1695358034749
    ],
    "type": "B2_A01KT23EXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B2_A01KT23EXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_332",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B594"
    },
    "position": {
      "x": 5397.967922562576,
      "y": 2424.2814407842234
    },
    "dwg_pos_img": [
      5397.967922562576,
      2424.2814407842234
    ],
    "pos_dxf": [
      1047.590389693131,
      858.8458711187222
    ],
    "type": "B14_A01KT2SHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B14_A01KT2SHXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B14 02F03 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I,I1],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_333",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B5BD"
    },
    "position": {
      "x": 4401.665957423751,
      "y": 4964.72349049802
    },
    "dwg_pos_img": [
      4401.665957423751,
      4964.72349049802
    ],
    "pos_dxf": [
      878.6063108003332,
      427.857737388483
    ],
    "type": "B11_A01KT36QXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT36QXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_334",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B5E6"
    },
    "position": {
      "x": 4169.134300430564,
      "y": 4964.544660484411
    },
    "dwg_pos_img": [
      4169.134300430564,
      4964.544660484411
    ],
    "pos_dxf": [
      839.1663124410343,
      427.857737388483
    ],
    "type": "B11_A01KT36TXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT36TXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_335",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B60F"
    },
    "position": {
      "x": 4401.66595742379,
      "y": 4842.317279943543
    },
    "dwg_pos_img": [
      4401.66595742379,
      4842.317279943543
    ],
    "pos_dxf": [
      878.6063108003332,
      448.6177927627211
    ],
    "type": "B11_A01KT36WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT36WXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_336",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B638"
    },
    "position": {
      "x": 4169.134300430603,
      "y": 4842.138449929935
    },
    "dwg_pos_img": [
      4169.134300430603,
      4842.138449929935
    ],
    "pos_dxf": [
      839.1663124410343,
      448.6177927627211
    ],
    "type": "B11_A01KT36ZXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B11_A01KT36ZXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_337",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B661"
    },
    "position": {
      "x": 3513.5262363849693,
      "y": 3480.729633253093
    },
    "dwg_pos_img": [
      3513.5262363849693,
      3480.729633253093
    ],
    "pos_dxf": [
      727.9677715426767,
      679.4267940287841
    ],
    "type": "B30_A01KT3D6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3D6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_338",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B69F"
    },
    "position": {
      "x": 3395.609570906048,
      "y": 3480.6389486591547
    },
    "dwg_pos_img": [
      3395.609570906048,
      3480.6389486591547
    ],
    "pos_dxf": [
      707.9677717441164,
      679.4267940287841
    ],
    "type": "B30_A01KT3D9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3D9XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_339",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B6DD"
    },
    "position": {
      "x": 3277.692905427126,
      "y": 3480.548264065216
    },
    "dwg_pos_img": [
      3277.692905427126,
      3480.548264065216
    ],
    "pos_dxf": [
      687.967771945556,
      679.4267940287841
    ],
    "type": "B30_A01KT3DCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DCXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_340",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B71B"
    },
    "position": {
      "x": 3159.7762399482035,
      "y": 3480.4575794712773
    },
    "dwg_pos_img": [
      3159.7762399482035,
      3480.4575794712773
    ],
    "pos_dxf": [
      667.9677721469955,
      679.4267940287841
    ],
    "type": "B30_A01KT3DFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DFXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_341",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B759"
    },
    "position": {
      "x": 3513.52623638495,
      "y": 3539.69200455461
    },
    "dwg_pos_img": [
      3513.52623638495,
      3539.69200455461
    ],
    "pos_dxf": [
      727.9677715426767,
      669.4267941295052
    ],
    "type": "B30_A01KT3DIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_342",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B797"
    },
    "position": {
      "x": 3395.6095709060287,
      "y": 3539.6013199606714
    },
    "dwg_pos_img": [
      3395.6095709060287,
      3539.6013199606714
    ],
    "pos_dxf": [
      707.9677717441164,
      669.4267941295052
    ],
    "type": "B30_A01KT3DLXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DLXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_343",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B7D5"
    },
    "position": {
      "x": 3277.6929054271077,
      "y": 3539.5106353667325
    },
    "dwg_pos_img": [
      3277.6929054271077,
      3539.5106353667325
    ],
    "pos_dxf": [
      687.967771945556,
      669.4267941295052
    ],
    "type": "B30_A01KT3DOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_344",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B813"
    },
    "position": {
      "x": 3159.7762399481853,
      "y": 3539.419950772794
    },
    "dwg_pos_img": [
      3159.7762399481853,
      3539.419950772794
    ],
    "pos_dxf": [
      667.9677721469955,
      669.4267941295052
    ],
    "type": "B30_A01KT3DRXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DRXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_345",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B851"
    },
    "position": {
      "x": 3513.526236384922,
      "y": 3628.370534726861
    },
    "dwg_pos_img": [
      3513.526236384922,
      3628.370534726861
    ],
    "pos_dxf": [
      727.9677715426767,
      654.3869428953012
    ],
    "type": "B30_A01KT3DUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 B30 02F02 B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_346",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B88F"
    },
    "position": {
      "x": 3395.6095709060005,
      "y": 3628.2798501329225
    },
    "dwg_pos_img": [
      3395.6095709060005,
      3628.2798501329225
    ],
    "pos_dxf": [
      707.9677717441164,
      654.3869428953012
    ],
    "type": "B30_A01KT3DXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3DXXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 B30 02F02 B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_347",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B8CD"
    },
    "position": {
      "x": 3277.692905427076,
      "y": 3628.1891655389836
    },
    "dwg_pos_img": [
      3277.692905427076,
      3628.1891655389836
    ],
    "pos_dxf": [
      687.9677719455553,
      654.3869428953012
    ],
    "type": "B30_A01KT3E0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3E0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_348",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B90B"
    },
    "position": {
      "x": 3159.776239948157,
      "y": 3628.098480945045
    },
    "dwg_pos_img": [
      3159.776239948157,
      3628.098480945045
    ],
    "pos_dxf": [
      667.9677721469955,
      654.3869428953012
    ],
    "type": "B30_A01KT3E3XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3E3XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_349",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B949"
    },
    "position": {
      "x": 3513.5262363849038,
      "y": 3687.332906028379
    },
    "dwg_pos_img": [
      3513.5262363849038,
      3687.332906028379
    ],
    "pos_dxf": [
      727.9677715426767,
      644.3869429960221
    ],
    "type": "B30_A01KT3E6XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3E6XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_350",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B987"
    },
    "position": {
      "x": 3395.6095709059796,
      "y": 3687.2422214344406
    },
    "dwg_pos_img": [
      3395.6095709059796,
      3687.2422214344406
    ],
    "pos_dxf": [
      707.9677717441159,
      644.3869429960221
    ],
    "type": "B30_A01KT3E9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3E9XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_351",
    "source_ids": {
      "object_id": null,
      "dwg_id": "B9C5"
    },
    "position": {
      "x": 3277.692905427057,
      "y": 3687.1515368405016
    },
    "dwg_pos_img": [
      3277.692905427057,
      3687.1515368405016
    ],
    "pos_dxf": [
      687.9677719455553,
      644.3869429960221
    ],
    "type": "B30_A01KT3ECXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3ECXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_352",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BA03"
    },
    "position": {
      "x": 3159.776239948141,
      "y": 3687.060852246563
    },
    "dwg_pos_img": [
      3159.776239948141,
      3687.060852246563
    ],
    "pos_dxf": [
      667.9677721469959,
      644.3869429960221
    ],
    "type": "B30_A01KT3EFXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3EFXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_353",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BA41"
    },
    "position": {
      "x": 3596.5308645415475,
      "y": 3628.43446111132
    },
    "dwg_pos_img": [
      3596.5308645415475,
      3628.43446111132
    ],
    "pos_dxf": [
      742.0462950462847,
      654.3869274406215
    ],
    "type": "B30_A01KT3EIXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3EIXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_354",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BA7F"
    },
    "position": {
      "x": 3655.4891972810033,
      "y": 3628.4798034082896
    },
    "dwg_pos_img": [
      3655.4891972810033,
      3628.4798034082896
    ],
    "pos_dxf": [
      752.0462949455641,
      654.3869274406215
    ],
    "type": "B30_A01KT3ELXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3ELXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_355",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BABD"
    },
    "position": {
      "x": 3596.5308645415294,
      "y": 3687.3968324128396
    },
    "dwg_pos_img": [
      3596.5308645415294,
      3687.3968324128396
    ],
    "pos_dxf": [
      742.0462950462847,
      644.3869275413422
    ],
    "type": "B30_A01KT3EOXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3EOXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_356",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BAFB"
    },
    "position": {
      "x": 3655.489197280985,
      "y": 3687.442174709809
    },
    "dwg_pos_img": [
      3655.489197280985,
      3687.442174709809
    ],
    "pos_dxf": [
      752.0462949455641,
      644.3869275413422
    ],
    "type": "B30_A01KT3ERXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3ERXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_357",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BB39"
    },
    "position": {
      "x": 3596.531484689857,
      "y": 3480.792664470214
    },
    "dwg_pos_img": [
      3596.531484689857,
      3480.792664470214
    ],
    "pos_dxf": [
      742.0464002304423,
      679.4269304750947
    ],
    "type": "B30_A01KT3EUXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3EUXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 B30 02F03 B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_358",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BB77"
    },
    "position": {
      "x": 3655.4898174293144,
      "y": 3480.8380067671833
    },
    "dwg_pos_img": [
      3655.4898174293144,
      3480.8380067671833
    ],
    "pos_dxf": [
      752.0464001297219,
      679.4269304750947
    ],
    "type": "B30_A01KT3EXXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3EXXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_359",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BBB5"
    },
    "position": {
      "x": 3596.5314846898386,
      "y": 3539.755035771733
    },
    "dwg_pos_img": [
      3596.5314846898386,
      3539.755035771733
    ],
    "pos_dxf": [
      742.0464002304425,
      669.4269305758153
    ],
    "type": "B30_A01KT3F0XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3F0XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_360",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BBF3"
    },
    "position": {
      "x": 3655.4898174292953,
      "y": 3539.8003780687027
    },
    "dwg_pos_img": [
      3655.4898174292953,
      3539.8003780687027
    ],
    "pos_dxf": [
      752.0464001297219,
      669.4269305758153
    ],
    "type": "B30_A01KT3F3XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3F3XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_361",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BC31"
    },
    "position": {
      "x": 3513.5262363855186,
      "y": 1731.2039286588306
    },
    "dwg_pos_img": [
      3513.5262363855186,
      1731.2039286588306
    ],
    "pos_dxf": [
      727.9677715426762,
      976.1458113197059
    ],
    "type": "B30_A01KT3F7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3F7XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_362",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BC6F"
    },
    "position": {
      "x": 3513.526236385474,
      "y": 1878.844830132598
    },
    "dwg_pos_img": [
      3513.526236385474,
      1878.844830132598
    ],
    "pos_dxf": [
      727.9677715426767,
      951.105960186223
    ],
    "type": "B30_A01KT3FAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_363",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BCAD"
    },
    "position": {
      "x": 3655.4898174298664,
      "y": 1731.3123021729225
    },
    "dwg_pos_img": [
      3655.4898174298664,
      1731.3123021729225
    ],
    "pos_dxf": [
      752.0464001297219,
      976.145947766016
    ],
    "type": "B30_A01KT3FDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FDXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_364",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BCEB"
    },
    "position": {
      "x": 3395.6095709066153,
      "y": 1672.1508727633718
    },
    "dwg_pos_img": [
      3395.6095709066153,
      1672.1508727633718
    ],
    "pos_dxf": [
      707.9677717441159,
      986.1458112189853
    ],
    "type": "B30_A01KT3FGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_365",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BD29"
    },
    "position": {
      "x": 3159.776239948709,
      "y": 1878.5727763507812
    },
    "dwg_pos_img": [
      3159.776239948709,
      1878.5727763507812
    ],
    "pos_dxf": [
      667.9677721469955,
      951.105960186223
    ],
    "type": "B30_A01KT3FJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B30 B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_366",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BD67"
    },
    "position": {
      "x": 3513.526236385537,
      "y": 1672.2415573573107
    },
    "dwg_pos_img": [
      3513.526236385537,
      1672.2415573573107
    ],
    "pos_dxf": [
      727.9677715426762,
      986.1458112189853
    ],
    "type": "B30_A01KT3FMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_367",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BDA5"
    },
    "position": {
      "x": 3159.776239948728,
      "y": 1819.6104050492613
    },
    "dwg_pos_img": [
      3159.776239948728,
      1819.6104050492613
    ],
    "pos_dxf": [
      667.9677721469955,
      961.1059600855024
    ],
    "type": "B30_A01KT3FPXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FPXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B30 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_368",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BDE3"
    },
    "position": {
      "x": 3596.53148469041,
      "y": 1731.266959875953
    },
    "dwg_pos_img": [
      3596.53148469041,
      1731.266959875953
    ],
    "pos_dxf": [
      742.0464002304425,
      976.145947766016
    ],
    "type": "B30_A01KT3FSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_369",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BE21"
    },
    "position": {
      "x": 3277.6929054276316,
      "y": 1878.66346094472
    },
    "dwg_pos_img": [
      3277.6929054276316,
      1878.66346094472
    ],
    "pos_dxf": [
      687.967771945556,
      951.105960186223
    ],
    "type": "B30_A01KT3FVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FVXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B30 B30 02F02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_370",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BE5F"
    },
    "position": {
      "x": 3395.6095709065717,
      "y": 1819.7917742371392
    },
    "dwg_pos_img": [
      3395.6095709065717,
      1819.7917742371392
    ],
    "pos_dxf": [
      707.9677717441164,
      961.1059600855024
    ],
    "type": "B30_A01KT3FYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3FYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 02F02 B30 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_371",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BE9D"
    },
    "position": {
      "x": 3655.4898174298846,
      "y": 1672.3499308714036
    },
    "dwg_pos_img": [
      3655.4898174298846,
      1672.3499308714036
    ],
    "pos_dxf": [
      752.0464001297219,
      986.1459476652954
    ],
    "type": "B30_A01KT3G1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3G1XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_372",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BEDB"
    },
    "position": {
      "x": 3395.6095709065526,
      "y": 1878.754145538659
    },
    "dwg_pos_img": [
      3395.6095709065526,
      1878.754145538659
    ],
    "pos_dxf": [
      707.9677717441164,
      951.105960186223
    ],
    "type": "B30_A01KT3G4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3G4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_373",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BF19"
    },
    "position": {
      "x": 3596.530864542098,
      "y": 1878.9087565170594
    },
    "dwg_pos_img": [
      3596.530864542098,
      1878.9087565170594
    ],
    "pos_dxf": [
      742.0462950462845,
      951.1059447315429
    ],
    "type": "B30_A01KT3G7XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3G7XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_374",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BF57"
    },
    "position": {
      "x": 3277.692905427678,
      "y": 1731.0225594709527
    },
    "dwg_pos_img": [
      3277.692905427678,
      1731.0225594709527
    ],
    "pos_dxf": [
      687.967771945556,
      976.1458113197059
    ],
    "type": "B30_A01KT3GAXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GAXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 02F01 B30 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_375",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BF95"
    },
    "position": {
      "x": 3596.531484690427,
      "y": 1672.304588574434
    },
    "dwg_pos_img": [
      3596.531484690427,
      1672.304588574434
    ],
    "pos_dxf": [
      742.0464002304423,
      986.1459476652954
    ],
    "type": "B30_A01KT3GDXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GDXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_376",
    "source_ids": {
      "object_id": null,
      "dwg_id": "BFD3"
    },
    "position": {
      "x": 3513.526236385493,
      "y": 1819.882458831078
    },
    "dwg_pos_img": [
      3513.526236385493,
      1819.882458831078
    ],
    "pos_dxf": [
      727.9677715426767,
      961.1059600855024
    ],
    "type": "B30_A01KT3GGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GGXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_377",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C011"
    },
    "position": {
      "x": 3159.7762399487715,
      "y": 1671.969503575494
    },
    "dwg_pos_img": [
      3159.7762399487715,
      1671.969503575494
    ],
    "pos_dxf": [
      667.967772146995,
      986.1458112189853
    ],
    "type": "B30_A01KT3GJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GJXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 02F01 B30 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_378",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C04F"
    },
    "position": {
      "x": 3655.4891972815744,
      "y": 1819.991727512509
    },
    "dwg_pos_img": [
      3655.4891972815744,
      1819.991727512509
    ],
    "pos_dxf": [
      752.0462949455641,
      961.1059446308223
    ],
    "type": "B30_A01KT3GMXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GMXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_379",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C08D"
    },
    "position": {
      "x": 3159.7762399487556,
      "y": 1730.9318748770138
    },
    "dwg_pos_img": [
      3159.7762399487556,
      1730.9318748770138
    ],
    "pos_dxf": [
      667.9677721469955,
      976.1458113197059
    ],
    "type": "B30_A01KT3GPXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GPXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_380",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C0CB"
    },
    "position": {
      "x": 3395.609570906597,
      "y": 1731.1132440648917
    },
    "dwg_pos_img": [
      3395.609570906597,
      1731.1132440648917
    ],
    "pos_dxf": [
      707.9677717441159,
      976.1458113197059
    ],
    "type": "B30_A01KT3GSXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GSXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_381",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C109"
    },
    "position": {
      "x": 3277.6929054276966,
      "y": 1672.0601881694329
    },
    "dwg_pos_img": [
      3277.6929054276966,
      1672.0601881694329
    ],
    "pos_dxf": [
      687.967771945556,
      986.1458112189853
    ],
    "type": "B30_A01KT3GVXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GVXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_382",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C147"
    },
    "position": {
      "x": 3655.4891972815553,
      "y": 1878.9540988140288
    },
    "dwg_pos_img": [
      3655.4891972815553,
      1878.9540988140288
    ],
    "pos_dxf": [
      752.0462949455641,
      951.1059447315429
    ],
    "type": "B30_A01KT3GYXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3GYXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_383",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C185"
    },
    "position": {
      "x": 3277.69290542765,
      "y": 1819.7010896432002
    },
    "dwg_pos_img": [
      3277.69290542765,
      1819.7010896432002
    ],
    "pos_dxf": [
      687.967771945556,
      961.1059600855024
    ],
    "type": "B30_A01KT3H1XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3H1XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "02F02 B30 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_384",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C1C3"
    },
    "position": {
      "x": 3596.530864542117,
      "y": 1819.9463852155395
    },
    "dwg_pos_img": [
      3596.530864542117,
      1819.9463852155395
    ],
    "pos_dxf": [
      742.0462950462845,
      961.1059446308223
    ],
    "type": "B30_A01KT3H4XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3H4XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_385",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C201"
    },
    "position": {
      "x": 6642.649020136081,
      "y": 1340.4630405643948
    },
    "dwg_pos_img": [
      6642.649020136081,
      1340.4630405643948
    ],
    "pos_dxf": [
      1258.702377974254,
      1042.823481856747
    ],
    "type": "B30_A01KT3J5XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3J5XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_386",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C23F"
    },
    "position": {
      "x": 6731.086519245258,
      "y": 1340.531054009849
    },
    "dwg_pos_img": [
      6731.086519245258,
      1340.531054009849
    ],
    "pos_dxf": [
      1273.702377823172,
      1042.823481856747
    ],
    "type": "B30_A01KT3J8XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3J8XE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_387",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C27D"
    },
    "position": {
      "x": 6819.524018354437,
      "y": 1340.5990674553032
    },
    "dwg_pos_img": [
      6819.524018354437,
      1340.5990674553032
    ],
    "pos_dxf": [
      1288.70237767209,
      1042.823481856747
    ],
    "type": "B30_A01KT3JBXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JBXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_388",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C2BB"
    },
    "position": {
      "x": 6642.649020136063,
      "y": 1399.4254118659128
    },
    "dwg_pos_img": [
      6642.649020136063,
      1399.4254118659128
    ],
    "pos_dxf": [
      1258.702377974254,
      1032.823481957468
    ],
    "type": "B30_A01KT3JEXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JEXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_389",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C2F9"
    },
    "position": {
      "x": 6819.524018354419,
      "y": 1399.5614387568212
    },
    "dwg_pos_img": [
      6819.524018354419,
      1399.5614387568212
    ],
    "pos_dxf": [
      1288.70237767209,
      1032.823481957468
    ],
    "type": "B30_A01KT3JHXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JHXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_390",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C337"
    },
    "position": {
      "x": 6731.08651924524,
      "y": 1399.493425311367
    },
    "dwg_pos_img": [
      6731.08651924524,
      1399.493425311367
    ],
    "pos_dxf": [
      1273.702377823172,
      1032.823481957468
    ],
    "type": "B30_A01KT3JKXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JKXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_391",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C375"
    },
    "position": {
      "x": 6642.649020136049,
      "y": 1458.3877831674354
    },
    "dwg_pos_img": [
      6642.649020136049,
      1458.3877831674354
    ],
    "pos_dxf": [
      1258.702377974255,
      1022.823482058188
    ],
    "type": "B30_A01KT3JNXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JNXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_392",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C3B3"
    },
    "position": {
      "x": 6731.086519245228,
      "y": 1458.4557966128896
    },
    "dwg_pos_img": [
      6731.086519245228,
      1458.4557966128896
    ],
    "pos_dxf": [
      1273.702377823173,
      1022.823482058188
    ],
    "type": "B30_A01KT3JQXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JQXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_393",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C3F1"
    },
    "position": {
      "x": 6819.524018354406,
      "y": 1458.5238100583438
    },
    "dwg_pos_img": [
      6819.524018354406,
      1458.5238100583438
    ],
    "pos_dxf": [
      1288.702377672091,
      1022.823482058188
    ],
    "type": "B30_A01KT3JTXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "B30_A01KT3JTXE",
    "dwg_layer": "ADE_ET_BEL_Decke",
    "dwg_rgb": [
      255,
      191,
      0
    ],
    "dwg_txt": "B30 02F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_394",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C5A6"
    },
    "position": {
      "x": 1036.560460591119,
      "y": 1551.1150035766568
    },
    "dwg_pos_img": [
      1036.560460591119,
      1551.1150035766568
    ],
    "pos_dxf": [
      307.8463678740359,
      1006.365762178243
    ],
    "type": "Auslass 400 V_A01U1C5SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1C5SKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "HV51_00.1 | Aufzug BT5.1 FA51_00.1 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_395",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C5CE"
    },
    "position": {
      "x": 980.2430578361578,
      "y": 304.18234623309763
    },
    "dwg_pos_img": [
      980.2430578361578,
      304.18234623309763
    ],
    "pos_dxf": [
      298.2942995621663,
      1217.837808839371
    ],
    "type": "Elektroschloss_A01U1C5YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1C5YKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_396",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C5DF"
    },
    "position": {
      "x": 1285.982657239998,
      "y": 308.60358414913935
    },
    "dwg_pos_img": [
      1285.982657239998,
      308.60358414913935
    ],
    "pos_dxf": [
      350.15119274731,
      1217.127846415195
    ],
    "type": [
      "Ableitung_A01U1C66KH",
      "Rauchansaugsystem_A01U1C5ZKH",
      "Ableitung_A01U1C67KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Ableitung_A01U1C66KH",
      "Rauchansaugsystem_A01U1C5ZKH",
      "Ableitung_A01U1C67KH"
    ],
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "RAS 04/004 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_397",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C5EF"
    },
    "position": {
      "x": 1265.4042373689995,
      "y": 321.80734343191125
    },
    "dwg_pos_img": [
      1265.4042373689995,
      321.80734343191125
    ],
    "pos_dxf": [
      346.6608600483401,
      1214.885808853246
    ],
    "type": "Netzteil inkl. Akku_A01U1C61KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Netzteil inkl. Akku_A01U1C61KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_398",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C61D"
    },
    "position": {
      "x": 1250.1525011334556,
      "y": 318.83859167542505
    },
    "dwg_pos_img": [
      1250.1525011334556,
      318.83859167542505
    ],
    "pos_dxf": [
      344.0739931249948,
      1215.387318920173
    ],
    "type": "Auslass 230 V_A01U1C62KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1C62KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "RAS 26F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_399",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C62E"
    },
    "position": {
      "x": 970.9990248911832,
      "y": 435.75808356048947
    },
    "dwg_pos_img": [
      970.9990248911832,
      435.75808356048947
    ],
    "pos_dxf": [
      296.7264070485369,
      1195.521398850691
    ],
    "type": "Ansaugstutzen RAS_A01U1C65KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Ansaugstutzen RAS_A01U1C65KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_400",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C679"
    },
    "position": {
      "x": 1675.5977496696473,
      "y": 304.71711337469515
    },
    "dwg_pos_img": [
      1675.5977496696473,
      304.71711337469515
    ],
    "pos_dxf": [
      416.2343179651102,
      1217.837808838979
    ],
    "type": "Elektroschloss_A01U1C68KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1C68KH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_401",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C689"
    },
    "position": {
      "x": 4602.058044426305,
      "y": 5039.006078423479
    },
    "dwg_pos_img": [
      4602.058044426305,
      5039.006078423479
    ],
    "pos_dxf": [
      912.595074673588,
      415.2855709917671
    ],
    "type": "Elektroschloss_A01U1C6LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1C6LKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_402",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C699"
    },
    "position": {
      "x": 576.6901419807822,
      "y": 586.3725043090126
    },
    "dwg_pos_img": [
      576.6901419807822,
      586.3725043090126
    ],
    "pos_dxf": [
      229.8471618905457,
      1169.925809365446
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C8QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C8QKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_403",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C6AD"
    },
    "position": {
      "x": 922.5774977179382,
      "y": 334.75126134557377
    },
    "dwg_pos_img": [
      922.5774977179382,
      334.75126134557377
    ],
    "pos_dxf": [
      288.5135685173741,
      1212.645808889234
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C8SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C8SKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_404",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C6BF"
    },
    "position": {
      "x": 920.2191644083636,
      "y": 321.54199149641954
    },
    "dwg_pos_img": [
      920.2191644083636,
      321.54199149641954
    ],
    "pos_dxf": [
      288.1135685214028,
      1214.885789360289
    ],
    "type": "Taster_ AP_ 1S_A01U1C8UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1C8UKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_405",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C6D1"
    },
    "position": {
      "x": 1727.3159991492048,
      "y": 335.3701510322235
    },
    "dwg_pos_img": [
      1727.3159991492048,
      335.3701510322235
    ],
    "pos_dxf": [
      425.0063178768457,
      1212.64580885483
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C8VKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C8VKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_406",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C6E3"
    },
    "position": {
      "x": 1724.9576658396304,
      "y": 322.16088118306834
    },
    "dwg_pos_img": [
      1724.9576658396304,
      322.16088118306834
    ],
    "pos_dxf": [
      424.6063178808745,
      1214.885789325885
    ],
    "type": "Taster_ AP_ 1S_A01U1C8XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1C8XKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_407",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C6F4"
    },
    "position": {
      "x": 2411.680242758012,
      "y": 572.329130009829
    },
    "dwg_pos_img": [
      2411.680242758012,
      572.329130009829
    ],
    "pos_dxf": [
      541.0822319872752,
      1172.546902295421
    ],
    "type": "Druckknopfmelder_A01U1C8YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C8YKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/010 in Hydrant ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_408",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C70B"
    },
    "position": {
      "x": 2400.34755215413,
      "y": 573.6246068700548
    },
    "dwg_pos_img": [
      2400.34755215413,
      573.6246068700548
    ],
    "pos_dxf": [
      539.1600795173574,
      1172.325711678558
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C91KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C91KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_409",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C71D"
    },
    "position": {
      "x": 3647.379859459608,
      "y": 573.1685484285517
    },
    "dwg_pos_img": [
      3647.379859459608,
      573.1685484285517
    ],
    "pos_dxf": [
      750.6708595551981,
      1172.56571167614
    ],
    "type": "Druckknopfmelder_A01U1C93KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C93KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/011 in Hydrant ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_410",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C745"
    },
    "position": {
      "x": 6873.435113914558,
      "y": 2079.1576592135307
    },
    "dwg_pos_img": [
      6873.435113914558,
      2079.1576592135307
    ],
    "pos_dxf": [
      1297.84630907456,
      917.5712053060793
    ],
    "type": "Druckknopfmelder_A01U1C98KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C98KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/007 in Hydrant ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_411",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C75A"
    },
    "position": {
      "x": 6872.020113928813,
      "y": 2067.311918588165
    },
    "dwg_pos_img": [
      6872.020113928813,
      2067.311918588165
    ],
    "pos_dxf": [
      1297.606309076977,
      919.5800546839932
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C9BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C9BKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_412",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C76C"
    },
    "position": {
      "x": 5937.197532978176,
      "y": 4770.691313914506
    },
    "dwg_pos_img": [
      5937.197532978176,
      4770.691313914506
    ],
    "pos_dxf": [
      1139.049828915761,
      460.9658164996756
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C9DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C9DKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_413",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C77E"
    },
    "position": {
      "x": 3647.3798594582845,
      "y": 4768.846339125475
    },
    "dwg_pos_img": [
      3647.3798594582845,
      4768.846339125475
    ],
    "pos_dxf": [
      750.6708595551981,
      460.9800586870326
    ],
    "type": "Druckknopfmelder_A01U1C9FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C9FKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "in Hydrant 03/022 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G7,H],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_414",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C793"
    },
    "position": {
      "x": 3833.779313698909,
      "y": 4769.073636895524
    },
    "dwg_pos_img": [
      3833.779313698909,
      4769.073636895524
    ],
    "pos_dxf": [
      782.2863146914415,
      460.9658214658446
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C9IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C9IKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_415",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C7A5"
    },
    "position": {
      "x": 2400.875498201369,
      "y": 4767.97168199091
    },
    "dwg_pos_img": [
      2400.875498201369,
      4767.97168199091
    ],
    "pos_dxf": [
      539.2496251369016,
      460.9658164996761
    ],
    "type": "1xAP-SD_ SchuKo_A01U1C9KKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1C9KKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_416",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C7B7"
    },
    "position": {
      "x": 2410.736909432857,
      "y": 4767.979265974645
    },
    "dwg_pos_img": [
      2410.736909432857,
      4767.979265974645
    ],
    "pos_dxf": [
      540.9222319888868,
      460.9658164996761
    ],
    "type": "Druckknopfmelder_A01U1C9MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C9MKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "in Hydrant 03/019 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_417",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C7CC"
    },
    "position": {
      "x": 480.08784497955355,
      "y": 4734.838330407159
    },
    "dwg_pos_img": [
      480.08784497955355,
      4734.838330407159
    ],
    "pos_dxf": [
      213.4623199965538,
      466.3346909322011
    ],
    "type": "Druckknopfmelder_A01U1C9PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1C9PKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/016 in Hydrant ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_418",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C7E1"
    },
    "position": {
      "x": 4104.04426789575,
      "y": 5023.528920530382
    },
    "dwg_pos_img": [
      4104.04426789575,
      5023.528920530382
    ],
    "pos_dxf": [
      828.1263069227566,
      417.8455353569761
    ],
    "type": "Druckknopfmelder_A01U1CAJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1CAJKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/031 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_419",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C7F1"
    },
    "position": {
      "x": 483.06910269524167,
      "y": 1861.0669719659336
    },
    "dwg_pos_img": [
      483.06910269524167,
      1861.0669719659336
    ],
    "pos_dxf": [
      213.9679750153157,
      953.7258115431127
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1CAXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1CAXKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 03/001 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F,F1],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_420",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C804"
    },
    "position": {
      "x": 1499.0293348009873,
      "y": 346.986944849471
    },
    "dwg_pos_img": [
      1499.0293348009873,
      346.986944849471
    ],
    "pos_dxf": [
      386.2863182700517,
      1210.645828390676
    ],
    "type": "1xAP-SD_ SchuKo_A01U1CBCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1CBCKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_421",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C816"
    },
    "position": {
      "x": 1499.0293348009964,
      "y": 317.27002472776985
    },
    "dwg_pos_img": [
      1499.0293348009964,
      317.27002472776985
    ],
    "pos_dxf": [
      386.2863182700517,
      1215.685808833529
    ],
    "type": "Druckknopfmelder_A01U1CBEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1CBEKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/005 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_422",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C826"
    },
    "position": {
      "x": 1496.6710014914133,
      "y": 333.77767500031496
    },
    "dwg_pos_img": [
      1496.6710014914133,
      333.77767500031496
    ],
    "pos_dxf": [
      385.8863182740806,
      1212.885808861731
    ],
    "type": "Taster_ AP_ 1S_A01U1CBGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1CBGKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_423",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C837"
    },
    "position": {
      "x": 1538.578584402621,
      "y": 304.611737876784
    },
    "dwg_pos_img": [
      1538.578584402621,
      304.611737876784
    ],
    "pos_dxf": [
      392.9943182024872,
      1217.83780883894
    ],
    "type": "Elektroschloss_A01U1CBHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1CBHKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_424",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C847"
    },
    "position": {
      "x": 1476.6180878571977,
      "y": 436.1195884626468
    },
    "dwg_pos_img": [
      1476.6180878571977,
      436.1195884626468
    ],
    "pos_dxf": [
      382.4851173749939,
      1195.526036519091
    ],
    "type": "Mulitnsensormelder mit integr. Sirene_A01U1CBIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Mulitnsensormelder mit integr. Sirene_A01U1CBIKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/007 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_425",
    "source_ids": {
      "object_id": null,
      "dwg_id": "C8A4"
    },
    "position": {
      "x": 1432.4003283309285,
      "y": 436.5768947149045
    },
    "dwg_pos_img": [
      1432.4003283309285,
      436.5768947149045
    ],
    "pos_dxf": [
      374.98528537053267,
      1195.442710119931
    ],
    "type": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1CBKKH",
      "Schaltkreis_A01U1CBLKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1CBKKH",
      "Schaltkreis_A01U1CBLKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Brandmelder-ZWD",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "ZWB 04/006 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_426",
    "source_ids": {
      "object_id": null,
      "dwg_id": "CD89"
    },
    "position": {
      "x": 3361.28721349333,
      "y": 4749.829574632229
    },
    "dwg_pos_img": [
      3361.28721349333,
      4749.829574632229
    ],
    "pos_dxf": [
      702.1463118296554,
      464.1679804821481
    ],
    "type": "Steckdosenverteiler_A01U1CBSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CBSKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 3 1F6 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_427",
    "source_ids": {
      "object_id": null,
      "dwg_id": "EAD6"
    },
    "position": {
      "x": 5836.9440089120835,
      "y": 4751.746254460173
    },
    "dwg_pos_img": [
      5836.9440089120835,
      4751.746254460173
    ],
    "pos_dxf": [
      1122.045697625385,
      464.1658164674454
    ],
    "type": "Steckdosenverteiler_A01U1CC4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CC4KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 2 1F5 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_428",
    "source_ids": {
      "object_id": null,
      "dwg_id": "FE45"
    },
    "position": {
      "x": 3711.8538245528302,
      "y": 2549.1853608637693
    },
    "dwg_pos_img": [
      3711.8538245528302,
      2549.1853608637693
    ],
    "pos_dxf": [
      761.606373069357,
      837.4422821420899
    ],
    "type": "Steckdosenverteiler_A01U1CCCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCCKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F7 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_429",
    "source_ids": {
      "object_id": null,
      "dwg_id": "10CD0"
    },
    "position": {
      "x": 5503.243461012293,
      "y": 2834.6229478247387
    },
    "dwg_pos_img": [
      5503.243461012293,
      2834.6229478247387
    ],
    "pos_dxf": [
      1065.44631140902,
      789.2658099710716
    ],
    "type": "Steckdosenverteiler_A01U1CCIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1CCIKH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F4 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I1,I2],[38-37]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_430",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11B5B"
    },
    "position": {
      "x": 479.9935116484745,
      "y": 600.8705476624382
    },
    "dwg_pos_img": [
      479.9935116484745,
      600.8705476624382
    ],
    "pos_dxf": [
      213.4463199967149,
      1167.45433339355
    ],
    "type": "Druckknopfmelder_A01U1CE0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1CE0KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/005 in Hydrant ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_431",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11B70"
    },
    "position": {
      "x": 6717.785115409462,
      "y": 801.2372453547641
    },
    "dwg_pos_img": [
      6717.785115409462,
      801.2372453547641
    ],
    "pos_dxf": [
      1271.446309328024,
      1134.285809742569
    ],
    "type": "Druckknopfmelder_A01U1CMYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1CMYKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/002 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_432",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11B80"
    },
    "position": {
      "x": 6704.578448875828,
      "y": 801.2270886802426
    },
    "dwg_pos_img": [
      6704.578448875828,
      801.2270886802426
    ],
    "pos_dxf": [
      1269.206309350586,
      1134.285809742569
    ],
    "type": "1xAP-SD_ SchuKo_A01U1CN0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1CN0KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_433",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11BE3"
    },
    "position": {
      "x": 574.3318086712085,
      "y": 575.5216142976506
    },
    "dwg_pos_img": [
      574.3318086712085,
      575.5216142976506
    ],
    "pos_dxf": [
      229.4471618945747,
      1171.765809346914
    ],
    "type": "optisch akustischer Signalgeber_A01U1CR8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1CR8KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S002/3 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_434",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11BF5"
    },
    "position": {
      "x": 1188.663983518206,
      "y": 618.4475537123117
    },
    "dwg_pos_img": [
      1188.663983518206,
      618.4475537123117
    ],
    "pos_dxf": [
      333.6448452609322,
      1164.565711756717
    ],
    "type": "optisch akustischer Signalgeber_A01U1CRAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1CRAKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S002/4 an KT ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_435",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11D01"
    },
    "position": {
      "x": 2407.6832162495602,
      "y": 615.8701974911664
    },
    "dwg_pos_img": [
      2407.6832162495602,
      615.8701974911664
    ],
    "pos_dxf": [
      540.4042910953842,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CSOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CSOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.10 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_436",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11E41"
    },
    "position": {
      "x": 5021.005324024421,
      "y": 617.8799901969905
    },
    "dwg_pos_img": [
      5021.005324024421,
      617.8799901969905
    ],
    "pos_dxf": [
      983.6532705063019,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CU0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CU0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 25.09 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H3,I],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_437",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11EA5"
    },
    "position": {
      "x": 5374.7553204611495,
      "y": 618.1520439788064
    },
    "dwg_pos_img": [
      5374.7553204611495,
      618.1520439788064
    ],
    "pos_dxf": [
      1043.653269901977,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CUFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.12 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_438",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11EB9"
    },
    "position": {
      "x": 5728.505316897885,
      "y": 618.4240977606223
    },
    "dwg_pos_img": [
      5728.505316897885,
      618.4240977606223
    ],
    "pos_dxf": [
      1103.653269297653,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CUIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.07 an KT ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_439",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11ECD"
    },
    "position": {
      "x": 5657.755317610538,
      "y": 618.3696870042595
    },
    "dwg_pos_img": [
      5657.755317610538,
      618.3696870042595
    ],
    "pos_dxf": [
      1091.653269418518,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CULKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CULKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.06 an KT ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_440",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11EE1"
    },
    "position": {
      "x": 5587.005318323193,
      "y": 618.3152762478958
    },
    "dwg_pos_img": [
      5587.005318323193,
      618.3152762478958
    ],
    "pos_dxf": [
      1079.653269539383,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CUOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.05 an KT ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_441",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11EF5"
    },
    "position": {
      "x": 5940.755314759921,
      "y": 618.5873300297117
    },
    "dwg_pos_img": [
      5940.755314759921,
      618.5873300297117
    ],
    "pos_dxf": [
      1139.653268935058,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CURKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CURKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.08 an KT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_442",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F09"
    },
    "position": {
      "x": 6082.2553133346155,
      "y": 618.6961515424382
    },
    "dwg_pos_img": [
      6082.2553133346155,
      618.6961515424382
    ],
    "pos_dxf": [
      1163.6532686933283,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CUUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.10 an KT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_443",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F1D"
    },
    "position": {
      "x": 6011.505314047268,
      "y": 618.6417407860754
    },
    "dwg_pos_img": [
      6011.505314047268,
      618.6417407860754
    ],
    "pos_dxf": [
      1151.653268814193,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CUXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CUXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.09 an KT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_444",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F31"
    },
    "position": {
      "x": 6365.255022601521,
      "y": 618.9030872963849
    },
    "dwg_pos_img": [
      6365.255022601521,
      618.9030872963849
    ],
    "pos_dxf": [
      1211.653219381745,
      1165.1636453178658
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CV0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CV0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.12 an KT ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_445",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F45"
    },
    "position": {
      "x": 6294.50502331417,
      "y": 618.8486765400221
    },
    "dwg_pos_img": [
      6294.50502331417,
      618.8486765400221
    ],
    "pos_dxf": [
      1199.653219502609,
      1165.1636453178658
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CV3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CV3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.11 an KT ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_446",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F59"
    },
    "position": {
      "x": 6436.005021888864,
      "y": 618.9574980527486
    },
    "dwg_pos_img": [
      6436.005021888864,
      618.9574980527486
    ],
    "pos_dxf": [
      1223.6532192608795,
      1165.1636453178658
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CV6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CV6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.13 an KT ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_447",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F6D"
    },
    "position": {
      "x": 6668.141505419221,
      "y": 775.4502725302773
    },
    "dwg_pos_img": [
      6668.141505419221,
      775.4502725302773
    ],
    "pos_dxf": [
      1263.026191732498,
      1138.652797238006
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CV9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CV9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 an KT 22.16 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_448",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F81"
    },
    "position": {
      "x": 6668.141505419244,
      "y": 704.6954269684556
    },
    "dwg_pos_img": [
      6668.141505419244,
      704.6954269684556
    ],
    "pos_dxf": [
      1263.026191732498,
      1150.652797117141
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.15 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_449",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11F95"
    },
    "position": {
      "x": 6668.141505419266,
      "y": 633.9405814066258
    },
    "dwg_pos_img": [
      6668.141505419266,
      633.9405814066258
    ],
    "pos_dxf": [
      1263.026191732498,
      1162.6527969962774
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 an KT 22.14 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_450",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11FA9"
    },
    "position": {
      "x": 6827.447614154089,
      "y": 1013.0733922940026
    },
    "dwg_pos_img": [
      6827.447614154089,
      1013.0733922940026
    ],
    "pos_dxf": [
      1290.046309115124,
      1098.3727683468344
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.17 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_451",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11FBD"
    },
    "position": {
      "x": 6827.447614154066,
      "y": 1083.828237855827
    },
    "dwg_pos_img": [
      6827.447614154066,
      1083.828237855827
    ],
    "pos_dxf": [
      1290.046309115124,
      1086.372768467699
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.18 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_452",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11FD1"
    },
    "position": {
      "x": 6827.4476141540445,
      "y": 1154.5830834176486
    },
    "dwg_pos_img": [
      6827.4476141540445,
      1154.5830834176486
    ],
    "pos_dxf": [
      1290.046309115124,
      1074.372768588564
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.19 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_453",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11FE5"
    },
    "position": {
      "x": 1483.505359656789,
      "y": 1594.972553718948
    },
    "dwg_pos_img": [
      1483.505359656789,
      1594.972553718948
    ],
    "pos_dxf": [
      383.6532765495458,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.21 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_454",
    "source_ids": {
      "object_id": null,
      "dwg_id": "11FF9"
    },
    "position": {
      "x": 1412.7553603694423,
      "y": 1594.9181429625842
    },
    "dwg_pos_img": [
      1412.7553603694423,
      1594.9181429625842
    ],
    "pos_dxf": [
      371.6532766704106,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.20 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_455",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1200D"
    },
    "position": {
      "x": 1342.0053610820955,
      "y": 1594.8637322062214
    },
    "dwg_pos_img": [
      1342.0053610820955,
      1594.8637322062214
    ],
    "pos_dxf": [
      359.6532767912754,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CVXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CVXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.19 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_456",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12021"
    },
    "position": {
      "x": 1766.5053568061744,
      "y": 1595.190196744401
    },
    "dwg_pos_img": [
      1766.5053568061744,
      1595.190196744401
    ],
    "pos_dxf": [
      431.65327606608616,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CW0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CW0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.23 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_457",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12035"
    },
    "position": {
      "x": 1837.2553560935226,
      "y": 1595.2446075007638
    },
    "dwg_pos_img": [
      1837.2553560935226,
      1595.2446075007638
    ],
    "pos_dxf": [
      443.6532759452216,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CW3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CW3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.24 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_458",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12049"
    },
    "position": {
      "x": 1695.7553575188285,
      "y": 1595.1357859880372
    },
    "dwg_pos_img": [
      1695.7553575188285,
      1595.1357859880372
    ],
    "pos_dxf": [
      419.6532761869512,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CW6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CW6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.22 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G2,G3],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_459",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1205D"
    },
    "position": {
      "x": 2049.5053539555606,
      "y": 1595.4078397698531
    },
    "dwg_pos_img": [
      2049.5053539555606,
      1595.4078397698531
    ],
    "pos_dxf": [
      479.65327558262675,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CW9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CW9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.01 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_460",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12071"
    },
    "position": {
      "x": 2120.255353242908,
      "y": 1595.4622505262168
    },
    "dwg_pos_img": [
      2120.255353242908,
      1595.4622505262168
    ],
    "pos_dxf": [
      491.65327546176195,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.02 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_461",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12085"
    },
    "position": {
      "x": 2191.0053525302546,
      "y": 1595.5166612825797
    },
    "dwg_pos_img": [
      2191.0053525302546,
      1595.5166612825797
    ],
    "pos_dxf": [
      503.65327534089715,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.03 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G3,G4],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_462",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12099"
    },
    "position": {
      "x": 2757.005634711509,
      "y": 1595.9519475548832
    },
    "dwg_pos_img": [
      2757.005634711509,
      1595.9519475548832
    ],
    "pos_dxf": [
      599.6533232021025,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.07 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_463",
    "source_ids": {
      "object_id": null,
      "dwg_id": "120AD"
    },
    "position": {
      "x": 2898.505633286199,
      "y": 1596.0607690676097
    },
    "dwg_pos_img": [
      2898.505633286199,
      1596.0607690676097
    ],
    "pos_dxf": [
      623.6533229603722,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.09 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_464",
    "source_ids": {
      "object_id": null,
      "dwg_id": "120C1"
    },
    "position": {
      "x": 2827.7556339988564,
      "y": 1596.006358311247
    },
    "dwg_pos_img": [
      2827.7556339988564,
      1596.006358311247
    ],
    "pos_dxf": [
      611.6533230812377,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.08 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_465",
    "source_ids": {
      "object_id": null,
      "dwg_id": "120D5"
    },
    "position": {
      "x": 2549.1832148239455,
      "y": 1595.792120344011
    },
    "dwg_pos_img": [
      2549.1832148239455,
      1595.792120344011
    ],
    "pos_dxf": [
      564.4042908536546,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.06 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_466",
    "source_ids": {
      "object_id": null,
      "dwg_id": "120E9"
    },
    "position": {
      "x": 2478.4332155365983,
      "y": 1595.7377095876482
    },
    "dwg_pos_img": [
      2478.4332155365983,
      1595.7377095876482
    ],
    "pos_dxf": [
      552.4042909745194,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.05 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_467",
    "source_ids": {
      "object_id": null,
      "dwg_id": "120FD"
    },
    "position": {
      "x": 2407.6832162492515,
      "y": 1595.6832988312844
    },
    "dwg_pos_img": [
      2407.6832162492515,
      1595.6832988312844
    ],
    "pos_dxf": [
      540.4042910953842,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CWXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CWXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.04 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_468",
    "source_ids": {
      "object_id": null,
      "dwg_id": "122A1"
    },
    "position": {
      "x": 1766.505356805486,
      "y": 3777.0340202178845
    },
    "dwg_pos_img": [
      1766.505356805486,
      3777.0340202178845
    ],
    "pos_dxf": [
      431.65327606608616,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CYOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.10 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G2,G3],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_469",
    "source_ids": {
      "object_id": null,
      "dwg_id": "122B5"
    },
    "position": {
      "x": 2757.0056347108207,
      "y": 3777.7957710283677
    },
    "dwg_pos_img": [
      2757.0056347108207,
      3777.7957710283677
    ],
    "pos_dxf": [
      599.6533232021025,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CYRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.18 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G5,G6],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_470",
    "source_ids": {
      "object_id": null,
      "dwg_id": "122C9"
    },
    "position": {
      "x": 2407.683216248563,
      "y": 3777.527122304769
    },
    "dwg_pos_img": [
      2407.683216248563,
      3777.527122304769
    ],
    "pos_dxf": [
      540.4042910953842,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CYUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.15 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G4,G5],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_471",
    "source_ids": {
      "object_id": null,
      "dwg_id": "122DD"
    },
    "position": {
      "x": 2120.2553532422194,
      "y": 3777.306073999701
    },
    "dwg_pos_img": [
      2120.2553532422194,
      3777.306073999701
    ],
    "pos_dxf": [
      491.65327546176195,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CYXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CYXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.13 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G3,G4],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_472",
    "source_ids": {
      "object_id": null,
      "dwg_id": "122F1"
    },
    "position": {
      "x": 2049.505353954872,
      "y": 3777.2516632433376
    },
    "dwg_pos_img": [
      2049.505353954872,
      3777.2516632433376
    ],
    "pos_dxf": [
      479.65327558262675,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZ0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZ0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.12 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G3,G4],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_473",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12305"
    },
    "position": {
      "x": 2191.005352529566,
      "y": 3777.360484756064
    },
    "dwg_pos_img": [
      2191.005352529566,
      3777.360484756064
    ],
    "pos_dxf": [
      503.65327534089715,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZ3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZ3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.14 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G3,G4],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_474",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12319"
    },
    "position": {
      "x": 2478.4332155359098,
      "y": 3777.581533061132
    },
    "dwg_pos_img": [
      2478.4332155359098,
      3777.581533061132
    ],
    "pos_dxf": [
      552.4042909745194,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZ6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZ6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.16 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G4,G5],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_475",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1232D"
    },
    "position": {
      "x": 2549.183214823257,
      "y": 3777.6359438174954
    },
    "dwg_pos_img": [
      2549.183214823257,
      3777.6359438174954
    ],
    "pos_dxf": [
      564.4042908536546,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZ9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZ9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.17 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G4,G5],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_476",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12341"
    },
    "position": {
      "x": 1837.255356092834,
      "y": 3777.088430974248
    },
    "dwg_pos_img": [
      1837.255356092834,
      3777.088430974248
    ],
    "pos_dxf": [
      443.6532759452216,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.11 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G2,G3],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_477",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12355"
    },
    "position": {
      "x": 1412.7553603687538,
      "y": 3776.7619664360686
    },
    "dwg_pos_img": [
      1412.7553603687538,
      3776.7619664360686
    ],
    "pos_dxf": [
      371.6532766704106,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.07 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G1,G2],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_478",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12369"
    },
    "position": {
      "x": 2827.755633998168,
      "y": 3777.850181784731
    },
    "dwg_pos_img": [
      2827.755633998168,
      3777.850181784731
    ],
    "pos_dxf": [
      611.6533230812377,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.19 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G5,G6],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_479",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1237D"
    },
    "position": {
      "x": 1483.5053596561006,
      "y": 3776.816377192432
    },
    "dwg_pos_img": [
      1483.5053596561006,
      3776.816377192432
    ],
    "pos_dxf": [
      383.6532765495458,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.08 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G1,G2],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_480",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12391"
    },
    "position": {
      "x": 1695.75535751814,
      "y": 3776.9796094615212
    },
    "dwg_pos_img": [
      1695.75535751814,
      3776.9796094615212
    ],
    "pos_dxf": [
      419.6532761869512,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.09 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G2,G3],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_481",
    "source_ids": {
      "object_id": null,
      "dwg_id": "123A5"
    },
    "position": {
      "x": 1342.005361081407,
      "y": 3776.7075556797054
    },
    "dwg_pos_img": [
      1342.005361081407,
      3776.7075556797054
    ],
    "pos_dxf": [
      359.6532767912754,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.06 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G1,G2],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_482",
    "source_ids": {
      "object_id": null,
      "dwg_id": "123B9"
    },
    "position": {
      "x": 2898.5056332855106,
      "y": 3777.9045925410937
    },
    "dwg_pos_img": [
      2898.5056332855106,
      3777.9045925410937
    ],
    "pos_dxf": [
      623.6533229603722,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.20 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G5,G6],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_483",
    "source_ids": {
      "object_id": null,
      "dwg_id": "123CD"
    },
    "position": {
      "x": 2049.5053539548862,
      "y": 3727.7232711260153
    },
    "dwg_pos_img": [
      2049.5053539548862,
      3727.7232711260153
    ],
    "pos_dxf": [
      479.6532755826265,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1CZXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1CZXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.15 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G3,G4],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_484",
    "source_ids": {
      "object_id": null,
      "dwg_id": "123E1"
    },
    "position": {
      "x": 2191.0053525295775,
      "y": 3727.832092638742
    },
    "dwg_pos_img": [
      2191.0053525295775,
      3727.832092638742
    ],
    "pos_dxf": [
      503.65327534089647,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D00KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D00KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.17 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G3,G4],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_485",
    "source_ids": {
      "object_id": null,
      "dwg_id": "123F5"
    },
    "position": {
      "x": 2120.255353242232,
      "y": 3727.7776818823786
    },
    "dwg_pos_img": [
      2120.255353242232,
      3727.7776818823786
    ],
    "pos_dxf": [
      491.6532754617615,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D03KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D03KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.16 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G3,G4],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_486",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12409"
    },
    "position": {
      "x": 1837.2553560928482,
      "y": 3727.5600388569255
    },
    "dwg_pos_img": [
      1837.2553560928482,
      3727.5600388569255
    ],
    "pos_dxf": [
      443.65327594522137,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D06KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D06KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.14 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G2,G3],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_487",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1241D"
    },
    "position": {
      "x": 1483.505359656116,
      "y": 3727.2879850751096
    },
    "dwg_pos_img": [
      1483.505359656116,
      3727.2879850751096
    ],
    "pos_dxf": [
      383.6532765495458,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D09KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D09KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.11 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G1,G2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_488",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12431"
    },
    "position": {
      "x": 2478.4332155359252,
      "y": 3728.05314094381
    },
    "dwg_pos_img": [
      2478.4332155359252,
      3728.05314094381
    ],
    "pos_dxf": [
      552.4042909745194,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.19 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G4,G5],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_489",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12445"
    },
    "position": {
      "x": 2898.50563328553,
      "y": 3728.3762004237715
    },
    "dwg_pos_img": [
      2898.50563328553,
      3728.3762004237715
    ],
    "pos_dxf": [
      623.6533229603729,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.23 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G5,G6],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_490",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12459"
    },
    "position": {
      "x": 1342.0053610814239,
      "y": 3727.179163562383
    },
    "dwg_pos_img": [
      1342.0053610814239,
      3727.179163562383
    ],
    "pos_dxf": [
      359.65327679127563,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.09 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G1,G2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_491",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1246D"
    },
    "position": {
      "x": 2549.1832148232725,
      "y": 3728.107551700173
    },
    "dwg_pos_img": [
      2549.1832148232725,
      3728.107551700173
    ],
    "pos_dxf": [
      564.4042908536546,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.20 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G4,G5],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_492",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12481"
    },
    "position": {
      "x": 2407.68321624858,
      "y": 3727.9987301874467
    },
    "dwg_pos_img": [
      2407.68321624858,
      3727.9987301874467
    ],
    "pos_dxf": [
      540.4042910953845,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.18 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G4,G5],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_493",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12495"
    },
    "position": {
      "x": 2757.0056347108334,
      "y": 3728.2673789110454
    },
    "dwg_pos_img": [
      2757.0056347108334,
      3728.2673789110454
    ],
    "pos_dxf": [
      599.653323202102,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.21 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G5,G6],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_494",
    "source_ids": {
      "object_id": null,
      "dwg_id": "124A9"
    },
    "position": {
      "x": 1412.7553603687693,
      "y": 3727.2335743187464
    },
    "dwg_pos_img": [
      1412.7553603687693,
      3727.2335743187464
    ],
    "pos_dxf": [
      371.6532766704106,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.10 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G1,G2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_495",
    "source_ids": {
      "object_id": null,
      "dwg_id": "124BD"
    },
    "position": {
      "x": 2827.7556339981834,
      "y": 3728.3217896674087
    },
    "dwg_pos_img": [
      2827.7556339981834,
      3728.3217896674087
    ],
    "pos_dxf": [
      611.6533230812377,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D0XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D0XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.22 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G5,G6],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_496",
    "source_ids": {
      "object_id": null,
      "dwg_id": "124D1"
    },
    "position": {
      "x": 1695.7553575181555,
      "y": 3727.451217344199
    },
    "dwg_pos_img": [
      1695.7553575181555,
      3727.451217344199
    ],
    "pos_dxf": [
      419.6532761869512,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D10KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D10KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.12 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G2,G3],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_497",
    "source_ids": {
      "object_id": null,
      "dwg_id": "124E5"
    },
    "position": {
      "x": 1766.5053568055014,
      "y": 3727.5056281005623
    },
    "dwg_pos_img": [
      1766.5053568055014,
      3727.5056281005623
    ],
    "pos_dxf": [
      431.65327606608616,
      637.345794762638
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D13KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D13KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.13 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G2,G3],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_498",
    "source_ids": {
      "object_id": null,
      "dwg_id": "124F9"
    },
    "position": {
      "x": 3535.25476322418,
      "y": 3778.394288684169
    },
    "dwg_pos_img": [
      3535.25476322418,
      3778.394288684169
    ],
    "pos_dxf": [
      731.6531753882155,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D16KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D16KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.01 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_499",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1250D"
    },
    "position": {
      "x": 4596.505040416858,
      "y": 3779.210450251015
    },
    "dwg_pos_img": [
      4596.505040416858,
      3779.210450251015
    ],
    "pos_dxf": [
      911.6532224033663,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D19KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D19KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.10 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H2,H3],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_500",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12521"
    },
    "position": {
      "x": 3181.5047667874474,
      "y": 3778.122234902353
    },
    "dwg_pos_img": [
      3181.5047667874474,
      3778.122234902353
    ],
    "pos_dxf": [
      671.6531759925397,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.22 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_501",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12535"
    },
    "position": {
      "x": 4667.255039704206,
      "y": 3779.2648610073784
    },
    "dwg_pos_img": [
      4667.255039704206,
      3779.2648610073784
    ],
    "pos_dxf": [
      923.6532222825017,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.11 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H2,H3],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_502",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12549"
    },
    "position": {
      "x": 3959.754758948254,
      "y": 3778.7207532223483
    },
    "dwg_pos_img": [
      3959.754758948254,
      3778.7207532223483
    ],
    "pos_dxf": [
      803.6531746630253,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.05 an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H,H1],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_503",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1255D"
    },
    "position": {
      "x": 3110.754767500102,
      "y": 3778.0678241459896
    },
    "dwg_pos_img": [
      3110.754767500102,
      3778.0678241459896
    ],
    "pos_dxf": [
      659.6531761134047,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.21 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_504",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12571"
    },
    "position": {
      "x": 3252.254766074792,
      "y": 3778.176645658716
    },
    "dwg_pos_img": [
      3252.254766074792,
      3778.176645658716
    ],
    "pos_dxf": [
      683.6531758716744,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.23 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_505",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12585"
    },
    "position": {
      "x": 4176.432622667253,
      "y": 3778.887390771053
    },
    "dwg_pos_img": [
      4176.432622667253,
      3778.887390771053
    ],
    "pos_dxf": [
      840.4041904175128,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.06 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H1,H2],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_506",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12599"
    },
    "position": {
      "x": 3818.254760373565,
      "y": 3778.611931709622
    },
    "dwg_pos_img": [
      3818.254760373565,
      3778.611931709622
    ],
    "pos_dxf": [
      779.6531749047558,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.03 an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H,H1],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_507",
    "source_ids": {
      "object_id": null,
      "dwg_id": "125AD"
    },
    "position": {
      "x": 3606.0047625115217,
      "y": 3778.4486994405324
    },
    "dwg_pos_img": [
      3606.0047625115217,
      3778.4486994405324
    ],
    "pos_dxf": [
      743.6531752673498,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D1XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D1XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.02 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_508",
    "source_ids": {
      "object_id": null,
      "dwg_id": "125C1"
    },
    "position": {
      "x": 4317.932621241946,
      "y": 3778.9962122837796
    },
    "dwg_pos_img": [
      4317.932621241946,
      3778.9962122837796
    ],
    "pos_dxf": [
      864.4041901757832,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D20KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D20KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.08 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H1,H2],[35-34]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_509",
    "source_ids": {
      "object_id": null,
      "dwg_id": "125D5"
    },
    "position": {
      "x": 4247.182621954601,
      "y": 3778.9418015274164
    },
    "dwg_pos_img": [
      4247.182621954601,
      3778.9418015274164
    ],
    "pos_dxf": [
      852.4041902966483,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D23KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D23KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.07 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H1,H2],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_510",
    "source_ids": {
      "object_id": null,
      "dwg_id": "125E9"
    },
    "position": {
      "x": 3889.0047596609134,
      "y": 3778.666342465985
    },
    "dwg_pos_img": [
      3889.0047596609134,
      3778.666342465985
    ],
    "pos_dxf": [
      791.6531747838912,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D26KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D26KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.04 an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H,H1],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_511",
    "source_ids": {
      "object_id": null,
      "dwg_id": "125FD"
    },
    "position": {
      "x": 4525.755041129512,
      "y": 3779.156039494652
    },
    "dwg_pos_img": [
      4525.755041129512,
      3779.156039494652
    ],
    "pos_dxf": [
      899.6532225242313,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D29KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D29KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.09 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H2,H3],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_512",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12611"
    },
    "position": {
      "x": 3464.5047639368336,
      "y": 3778.339877927806
    },
    "dwg_pos_img": [
      3464.5047639368336,
      3778.339877927806
    ],
    "pos_dxf": [
      719.6531755090803,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.24 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_513",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12625"
    },
    "position": {
      "x": 4525.755041129534,
      "y": 3729.6276473773282
    },
    "dwg_pos_img": [
      4525.755041129534,
      3729.6276473773282
    ],
    "pos_dxf": [
      899.6532225242322,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.03 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H2,H3],[36-35]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_514",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12639"
    },
    "position": {
      "x": 4317.9326212419655,
      "y": 3729.467820166456
    },
    "dwg_pos_img": [
      4317.9326212419655,
      3729.467820166456
    ],
    "pos_dxf": [
      864.4041901757837,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.02 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H1,H2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_515",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1264D"
    },
    "position": {
      "x": 4667.255039704225,
      "y": 3729.7364688900548
    },
    "dwg_pos_img": [
      4667.255039704225,
      3729.7364688900548
    ],
    "pos_dxf": [
      923.6532222825022,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.05 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H2,H3],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_516",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12661"
    },
    "position": {
      "x": 4247.18262195462,
      "y": 3729.4134094100928
    },
    "dwg_pos_img": [
      4247.18262195462,
      3729.4134094100928
    ],
    "pos_dxf": [
      852.4041902966487,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.01 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H1,H2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_517",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12675"
    },
    "position": {
      "x": 4596.505040416877,
      "y": 3729.6820581336915
    },
    "dwg_pos_img": [
      4596.505040416877,
      3729.6820581336915
    ],
    "pos_dxf": [
      911.6532224033667,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.04 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H2,H3],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_518",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12689"
    },
    "position": {
      "x": 4176.432622667269,
      "y": 3729.3589986537295
    },
    "dwg_pos_img": [
      4176.432622667269,
      3729.3589986537295
    ],
    "pos_dxf": [
      840.4041904175128,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 20.24 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H1,H2],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_519",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1269D"
    },
    "position": {
      "x": 1347.9011943550613,
      "y": 4700.090238359375
    },
    "dwg_pos_img": [
      1347.9011943550613,
      4700.090238359375
    ],
    "pos_dxf": [
      360.65327678120343,
      472.34114700298346
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D2XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D2XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.12 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_520",
    "source_ids": {
      "object_id": null,
      "dwg_id": "126B1"
    },
    "position": {
      "x": 1412.7553603684628,
      "y": 4698.592321347931
    },
    "dwg_pos_img": [
      1412.7553603684628,
      4698.592321347931
    ],
    "pos_dxf": [
      371.6532766704106,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D30KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D30KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.13 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_521",
    "source_ids": {
      "object_id": null,
      "dwg_id": "126C5"
    },
    "position": {
      "x": 1483.5053596558096,
      "y": 4698.646732104295
    },
    "dwg_pos_img": [
      1483.5053596558096,
      4698.646732104295
    ],
    "pos_dxf": [
      383.6532765495458,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D33KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D33KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.14 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_522",
    "source_ids": {
      "object_id": null,
      "dwg_id": "126D9"
    },
    "position": {
      "x": 1766.504781040227,
      "y": 4698.864374686951
    },
    "dwg_pos_img": [
      1766.504781040227,
      4698.864374686951
    ],
    "pos_dxf": [
      431.6531784098372,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D36KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D36KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.16 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_523",
    "source_ids": {
      "object_id": null,
      "dwg_id": "126ED"
    },
    "position": {
      "x": 1837.2547803275684,
      "y": 4698.918785443315
    },
    "dwg_pos_img": [
      1837.2547803275684,
      4698.918785443315
    ],
    "pos_dxf": [
      443.6531782889715,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D39KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D39KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.17 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_524",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12701"
    },
    "position": {
      "x": 1695.7547817528798,
      "y": 4698.809963930588
    },
    "dwg_pos_img": [
      1695.7547817528798,
      4698.809963930588
    ],
    "pos_dxf": [
      419.653178530702,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.15 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_525",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12715"
    },
    "position": {
      "x": 2120.2553532419283,
      "y": 4699.136428911564
    },
    "dwg_pos_img": [
      2120.2553532419283,
      4699.136428911564
    ],
    "pos_dxf": [
      491.65327546176195,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.19 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G3,G4],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_526",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12729"
    },
    "position": {
      "x": 2049.505353954581,
      "y": 4699.082018155201
    },
    "dwg_pos_img": [
      2049.505353954581,
      4699.082018155201
    ],
    "pos_dxf": [
      479.65327558262675,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.18 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G3,G4],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_527",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1273D"
    },
    "position": {
      "x": 2191.005352529275,
      "y": 4699.190839667926
    },
    "dwg_pos_img": [
      2191.005352529275,
      4699.190839667926
    ],
    "pos_dxf": [
      503.65327534089715,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.20 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G3,G4],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_528",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12751"
    },
    "position": {
      "x": 2544.754773201034,
      "y": 4699.462893006947
    },
    "dwg_pos_img": [
      2544.754773201034,
      4699.462893006947
    ],
    "pos_dxf": [
      563.6531770803228,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.23 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_529",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12765"
    },
    "position": {
      "x": 2474.004773913692,
      "y": 4699.408482250584
    },
    "dwg_pos_img": [
      2474.004773913692,
      4699.408482250584
    ],
    "pos_dxf": [
      551.6531772011886,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.22 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_530",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12779"
    },
    "position": {
      "x": 2403.2547746263454,
      "y": 4699.354071494221
    },
    "dwg_pos_img": [
      2403.2547746263454,
      4699.354071494221
    ],
    "pos_dxf": [
      539.6531773220534,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.21 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_531",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1278D"
    },
    "position": {
      "x": 2898.5053454027366,
      "y": 4699.734947231558
    },
    "dwg_pos_img": [
      2898.5053454027366,
      4699.734947231558
    ],
    "pos_dxf": [
      623.6532741322478,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D3XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D3XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.02 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G5,G6],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_532",
    "source_ids": {
      "object_id": null,
      "dwg_id": "127A1"
    },
    "position": {
      "x": 2827.755346115392,
      "y": 4699.680536475195
    },
    "dwg_pos_img": [
      2827.755346115392,
      4699.680536475195
    ],
    "pos_dxf": [
      611.6532742531131,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D40KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D40KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.01 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G5,G6],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_533",
    "source_ids": {
      "object_id": null,
      "dwg_id": "127B5"
    },
    "position": {
      "x": 2757.0053468280466,
      "y": 4699.626125718833
    },
    "dwg_pos_img": [
      2757.0053468280466,
      4699.626125718833
    ],
    "pos_dxf": [
      599.6532743739781,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D43KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D43KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 16.24 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G5,G6],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_534",
    "source_ids": {
      "object_id": null,
      "dwg_id": "127C9"
    },
    "position": {
      "x": 3181.5053425521255,
      "y": 4699.952590257011
    },
    "dwg_pos_img": [
      3181.5053425521255,
      4699.952590257011
    ],
    "pos_dxf": [
      671.6532736487889,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D46KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D46KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.04 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_535",
    "source_ids": {
      "object_id": null,
      "dwg_id": "127DD"
    },
    "position": {
      "x": 3252.255341839468,
      "y": 4700.007001013375
    },
    "dwg_pos_img": [
      3252.255341839468,
      4700.007001013375
    ],
    "pos_dxf": [
      683.6532735279234,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D49KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D49KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.05 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_536",
    "source_ids": {
      "object_id": null,
      "dwg_id": "127F1"
    },
    "position": {
      "x": 3110.7553432647787,
      "y": 4699.898179500648
    },
    "dwg_pos_img": [
      3110.7553432647787,
      4699.898179500648
    ],
    "pos_dxf": [
      659.6532737696537,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.03 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_537",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12805"
    },
    "position": {
      "x": 3606.005338276202,
      "y": 4700.279054795191
    },
    "dwg_pos_img": [
      3606.005338276202,
      4700.279054795191
    ],
    "pos_dxf": [
      743.6532729235992,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.08 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G7,H],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_538",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12819"
    },
    "position": {
      "x": 3535.2553389888576,
      "y": 4700.224644038828
    },
    "dwg_pos_img": [
      3535.2553389888576,
      4700.224644038828
    ],
    "pos_dxf": [
      731.6532730444644,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.07 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G7,H],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_539",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1282D"
    },
    "position": {
      "x": 3464.5053397015113,
      "y": 4700.170233282464
    },
    "dwg_pos_img": [
      3464.5053397015113,
      4700.170233282464
    ],
    "pos_dxf": [
      719.6532731653292,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.06 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G7,H],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_540",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12841"
    },
    "position": {
      "x": 4307.2545112461285,
      "y": 4700.818355124304
    },
    "dwg_pos_img": [
      4307.2545112461285,
      4700.818355124304
    ],
    "pos_dxf": [
      862.5930619786604,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.11 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_541",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12855"
    },
    "position": {
      "x": 4247.00588939673,
      "y": 4700.772020521933
    },
    "dwg_pos_img": [
      4247.00588939673,
      4700.772020521933
    ],
    "pos_dxf": [
      852.3742144564931,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.10 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_542",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12869"
    },
    "position": {
      "x": 4187.444857736722,
      "y": 4700.72621471536
    },
    "dwg_pos_img": [
      4187.444857736722,
      4700.72621471536
    ],
    "pos_dxf": [
      842.271990005318,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.09 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_543",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1287D"
    },
    "position": {
      "x": 4525.7553290117075,
      "y": 4700.986394627913
    },
    "dwg_pos_img": [
      4525.7553290117075,
      4700.986394627913
    ],
    "pos_dxf": [
      899.6532713523561,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.12 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_544",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12891"
    },
    "position": {
      "x": 4667.255327586397,
      "y": 4701.0952161406385
    },
    "dwg_pos_img": [
      4667.255327586397,
      4701.0952161406385
    ],
    "pos_dxf": [
      923.6532711106256,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D50KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D50KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.14 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_545",
    "source_ids": {
      "object_id": null,
      "dwg_id": "128A5"
    },
    "position": {
      "x": 4596.505328299057,
      "y": 4701.040805384276
    },
    "dwg_pos_img": [
      4596.505328299057,
      4701.040805384276
    ],
    "pos_dxf": [
      911.6532712314915,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D53KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D53KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.13 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_546",
    "source_ids": {
      "object_id": null,
      "dwg_id": "128B9"
    },
    "position": {
      "x": 5021.00532402313,
      "y": 4709.84509189291
    },
    "dwg_pos_img": [
      5021.00532402313,
      4709.84509189291
    ],
    "pos_dxf": [
      983.6532705063019,
      471.1658163285931
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D56KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D56KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.17 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_547",
    "source_ids": {
      "object_id": null,
      "dwg_id": "128CD"
    },
    "position": {
      "x": 4950.255324735785,
      "y": 4709.790681136548
    },
    "dwg_pos_img": [
      4950.255324735785,
      4709.790681136548
    ],
    "pos_dxf": [
      971.6532706271669,
      471.1658163285931
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D59KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D59KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.16 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_548",
    "source_ids": {
      "object_id": null,
      "dwg_id": "128E1"
    },
    "position": {
      "x": 4879.505325448438,
      "y": 4709.73627038019
    },
    "dwg_pos_img": [
      4879.505325448438,
      4709.73627038019
    ],
    "pos_dxf": [
      959.6532707480319,
      471.1658163285922
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D5CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.15 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_549",
    "source_ids": {
      "object_id": null,
      "dwg_id": "128F5"
    },
    "position": {
      "x": 5304.005321172519,
      "y": 4710.06273491836
    },
    "dwg_pos_img": [
      5304.005321172519,
      4710.06273491836
    ],
    "pos_dxf": [
      1031.653270022843,
      471.1658163285938
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D5FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.02 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I,I1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_550",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12909"
    },
    "position": {
      "x": 5233.255321885174,
      "y": 4710.008324161998
    },
    "dwg_pos_img": [
      5233.255321885174,
      4710.008324161998
    ],
    "pos_dxf": [
      1019.6532701437081,
      471.16581632859356
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D5IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.01 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I,I1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_551",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1291D"
    },
    "position": {
      "x": 5374.755320459859,
      "y": 4710.117145674729
    },
    "dwg_pos_img": [
      5374.755320459859,
      4710.117145674729
    ],
    "pos_dxf": [
      1043.653269901977,
      471.16581632859265
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D5LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D5LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.03 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I,I1],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_552",
    "source_ids": {
      "object_id": null,
      "dwg_id": "129D1"
    },
    "position": {
      "x": 4914.8797493281245,
      "y": 1597.61147495976
    },
    "dwg_pos_img": [
      4914.8797493281245,
      1597.61147495976
    ],
    "pos_dxf": [
      965.6531730313504,
      998.9858310792242
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.01 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_553",
    "source_ids": {
      "object_id": null,
      "dwg_id": "129E5"
    },
    "position": {
      "x": 4561.129752891392,
      "y": 1597.3394211779441
    },
    "dwg_pos_img": [
      4561.129752891392,
      1597.3394211779441
    ],
    "pos_dxf": [
      905.6531736356746,
      998.9858310792242
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.23 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_554",
    "source_ids": {
      "object_id": null,
      "dwg_id": "129F9"
    },
    "position": {
      "x": 5268.630321529822,
      "y": 1597.8835291843725
    },
    "dwg_pos_img": [
      5268.630321529822,
      1597.8835291843725
    ],
    "pos_dxf": [
      1025.6532700832745,
      998.9858310792242
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.03 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I,I1],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_555",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A0D"
    },
    "position": {
      "x": 4631.87975217874,
      "y": 1597.3938319343151
    },
    "dwg_pos_img": [
      4631.87975217874,
      1597.3938319343151
    ],
    "pos_dxf": [
      917.6531735148101,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.24 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_556",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A21"
    },
    "position": {
      "x": 4985.629748615471,
      "y": 1597.665885716131
    },
    "dwg_pos_img": [
      4985.629748615471,
      1597.665885716131
    ],
    "pos_dxf": [
      977.6531729104854,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.02 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_557",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A35"
    },
    "position": {
      "x": 5339.38032081717,
      "y": 1597.9379399407426
    },
    "dwg_pos_img": [
      5339.38032081717,
      1597.9379399407426
    ],
    "pos_dxf": [
      1037.65326996241,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 22.04 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I,I1],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_558",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A49"
    },
    "position": {
      "x": 4207.3797564546585,
      "y": 1597.0673673961282
    },
    "dwg_pos_img": [
      4207.3797564546585,
      1597.0673673961282
    ],
    "pos_dxf": [
      845.6531742399989,
      998.9858310792242
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.21 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_559",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A5D"
    },
    "position": {
      "x": 4278.129755742007,
      "y": 1597.1217781524983
    },
    "dwg_pos_img": [
      4278.129755742007,
      1597.1217781524983
    ],
    "pos_dxf": [
      857.6531741191343,
      998.9858310792229
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D6XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D6XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.22 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_560",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A71"
    },
    "position": {
      "x": 1448.130935777761,
      "y": 2606.7396400935786
    },
    "dwg_pos_img": [
      1448.130935777761,
      2606.7396400935786
    ],
    "pos_dxf": [
      377.6533742662266,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D70KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D70KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.02 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_561",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A85"
    },
    "position": {
      "x": 1377.3809364904182,
      "y": 2606.6852293372185
    },
    "dwg_pos_img": [
      1377.3809364904182,
      2606.6852293372185
    ],
    "pos_dxf": [
      365.6533743870921,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D73KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D73KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.01 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_562",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12A99"
    },
    "position": {
      "x": 2155.6315044161993,
      "y": 2607.283748100007
    },
    "dwg_pos_img": [
      2155.6315044161993,
      2607.283748100007
    ],
    "pos_dxf": [
      497.6534707138278,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D76KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D76KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.06 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_563",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12AAD"
    },
    "position": {
      "x": 2084.881505128851,
      "y": 2607.229337343647
    },
    "dwg_pos_img": [
      2084.881505128851,
      2607.229337343647
    ],
    "pos_dxf": [
      485.65347083469237,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D79KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D79KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.05 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_564",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12AC1"
    },
    "position": {
      "x": 1731.131508692119,
      "y": 2606.95728356183
    },
    "dwg_pos_img": [
      1731.131508692119,
      2606.95728356183
    ],
    "pos_dxf": [
      425.6534714390168,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.03 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G2,G3],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_565",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12AD5"
    },
    "position": {
      "x": 1801.8815079794663,
      "y": 2607.011694318191
    },
    "dwg_pos_img": [
      1801.8815079794663,
      2607.011694318191
    ],
    "pos_dxf": [
      437.653471318152,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.04 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G2,G3],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_566",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12AE9"
    },
    "position": {
      "x": 3216.881493726393,
      "y": 2608.0999094454555
    },
    "dwg_pos_img": [
      3216.881493726393,
      2608.0999094454555
    ],
    "pos_dxf": [
      677.653468900854,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.12 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_567",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12AFD"
    },
    "position": {
      "x": 2438.6309258006154,
      "y": 2607.501390682667
    },
    "dwg_pos_img": [
      2438.6309258006154,
      2607.501390682667
    ],
    "pos_dxf": [
      545.653372574119,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.07 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_568",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B11"
    },
    "position": {
      "x": 2863.1314972896594,
      "y": 2607.8278556636387
    },
    "dwg_pos_img": [
      2863.1314972896594,
      2607.8278556636387
    ],
    "pos_dxf": [
      617.6534695051782,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.10 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G5,G6],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_569",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B25"
    },
    "position": {
      "x": 2792.3814980023167,
      "y": 2607.7734449072786
    },
    "dwg_pos_img": [
      2792.3814980023167,
      2607.7734449072786
    ],
    "pos_dxf": [
      605.6534696260437,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.09 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G5,G6],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_570",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B39"
    },
    "position": {
      "x": 3146.1314944390488,
      "y": 2608.0454986890945
    },
    "dwg_pos_img": [
      3146.1314944390488,
      2608.0454986890945
    ],
    "pos_dxf": [
      665.6534690217193,
      827.3858328455885
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.11 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_571",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B4D"
    },
    "position": {
      "x": 2509.3809250879585,
      "y": 2607.555801439027
    },
    "dwg_pos_img": [
      2509.3809250879585,
      2607.555801439027
    ],
    "pos_dxf": [
      557.6533724532535,
      827.385832845589
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D7XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D7XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.08 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_572",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B61"
    },
    "position": {
      "x": 1448.1292084828415,
      "y": 2656.7153744785937
    },
    "dwg_pos_img": [
      1448.1292084828415,
      2656.7153744785937
    ],
    "pos_dxf": [
      377.65308129747973,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D80KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D80KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.14 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_573",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B75"
    },
    "position": {
      "x": 3216.879766431472,
      "y": 2658.075643830467
    },
    "dwg_pos_img": [
      3216.879766431472,
      2658.075643830467
    ],
    "pos_dxf": [
      677.6531759321069,
      818.909963556941
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D83KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D83KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.24 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_574",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B89"
    },
    "position": {
      "x": 2863.129194229771,
      "y": 2657.8035896058554
    },
    "dwg_pos_img": [
      2863.129194229771,
      2657.8035896058554
    ],
    "pos_dxf": [
      617.6530788801822,
      818.909963556941
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D86KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D86KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.22 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G5,G6],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_575",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12B9D"
    },
    "position": {
      "x": 2084.8797778339267,
      "y": 2657.2050717286584
    },
    "dwg_pos_img": [
      2084.8797778339267,
      2657.2050717286584
    ],
    "pos_dxf": [
      485.6531778659446,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D89KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D89KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.17 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_576",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12BB1"
    },
    "position": {
      "x": 1801.8792049195736,
      "y": 2656.987428260407
    },
    "dwg_pos_img": [
      1801.8792049195736,
      2656.987428260407
    ],
    "pos_dxf": [
      437.6530806931553,
      818.909963556941
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.16 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G2,G3],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_577",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12BC5"
    },
    "position": {
      "x": 1731.1292056322268,
      "y": 2656.933017504047
    },
    "dwg_pos_img": [
      1731.1292056322268,
      2656.933017504047
    ],
    "pos_dxf": [
      425.6530808140201,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.15 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G2,G3],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_578",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12BD9"
    },
    "position": {
      "x": 2438.629198505696,
      "y": 2657.4771250676786
    },
    "dwg_pos_img": [
      2438.629198505696,
      2657.4771250676786
    ],
    "pos_dxf": [
      545.6530796053721,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8IKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.19 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_579",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12BED"
    },
    "position": {
      "x": 2792.379194942428,
      "y": 2657.7491788494945
    },
    "dwg_pos_img": [
      2792.379194942428,
      2657.7491788494945
    ],
    "pos_dxf": [
      605.6530790010477,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.21 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G5,G6],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_580",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C01"
    },
    "position": {
      "x": 2155.629777121275,
      "y": 2657.2594824850185
    },
    "dwg_pos_img": [
      2155.629777121275,
      2657.2594824850185
    ],
    "pos_dxf": [
      497.65317774508003,
      818.909963556941
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.18 an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_581",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C15"
    },
    "position": {
      "x": 1377.3792091954947,
      "y": 2656.660963722222
    },
    "dwg_pos_img": [
      1377.3792091954947,
      2656.660963722222
    ],
    "pos_dxf": [
      365.6530814183445,
      818.9099635569419
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8RKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.13 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_582",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C29"
    },
    "position": {
      "x": 3146.129767144124,
      "y": 2658.021233074106
    },
    "dwg_pos_img": [
      3146.129767144124,
      2658.021233074106
    ],
    "pos_dxf": [
      665.6531760529715,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.23 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_583",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C3D"
    },
    "position": {
      "x": 2509.379197793039,
      "y": 2657.5315358240387
    },
    "dwg_pos_img": [
      2509.379197793039,
      2657.5315358240387
    ],
    "pos_dxf": [
      557.6530794845066,
      818.909963556941
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D8XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D8XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.20 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_584",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C51"
    },
    "position": {
      "x": 1316.0053566139213,
      "y": 4753.557916489173
    },
    "dwg_pos_img": [
      1316.0053566139213,
      4753.557916489173
    ],
    "pos_dxf": [
      355.2433820406554,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1DAXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1DAXKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_585",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C86"
    },
    "position": {
      "x": 486.1251783084773,
      "y": 4171.722235625415
    },
    "dwg_pos_img": [
      486.1251783084773,
      4171.722235625415
    ],
    "pos_dxf": [
      214.4863199957765,
      561.8397935478245
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DCHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DCHKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/013 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_586",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12C94"
    },
    "position": {
      "x": 479.99729759034733,
      "y": 4172.434877110332
    },
    "dwg_pos_img": [
      479.99729759034733,
      4172.434877110332
    ],
    "pos_dxf": [
      213.4469621354569,
      561.7181305025329
    ],
    "type": "Druckknopfmelder_A01U1DCJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DCJKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/015 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_587",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CA9"
    },
    "position": {
      "x": 486.125131142766,
      "y": 1164.8318833884514
    },
    "dwg_pos_img": [
      486.125131142766,
      1164.8318833884514
    ],
    "pos_dxf": [
      214.48631199577767,
      1071.807465393752
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DCMKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DCMKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 03/003 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F,F1],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_588",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CBC"
    },
    "position": {
      "x": 479.99351164829625,
      "y": 1165.5445219980402
    },
    "dwg_pos_img": [
      479.99351164829625,
      1165.5445219980402
    ],
    "pos_dxf": [
      213.4463199967149,
      1071.68580234846
    ],
    "type": "Druckknopfmelder_A01U1DCPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DCPKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/004 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F,F1],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_589",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CCC"
    },
    "position": {
      "x": 479.9935116238863,
      "y": 3114.820283642008
    },
    "dwg_pos_img": [
      479.9935116238863,
      3114.820283642008
    ],
    "pos_dxf": [
      213.446319992679,
      741.0892372879016
    ],
    "type": "Druckknopfmelder_A01U1DCRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DCRKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/011 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_590",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CDC"
    },
    "position": {
      "x": 566.0724938398092,
      "y": 4766.560614649703
    },
    "dwg_pos_img": [
      566.0724938398092,
      4766.560614649703
    ],
    "pos_dxf": [
      228.0462887078468,
      460.9658164856285
    ],
    "type": "1xAP-SD_ SchuKo_A01U1DCTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1DCTKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_591",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CEE"
    },
    "position": {
      "x": 2495.5543869047856,
      "y": 4754.543505404387
    },
    "dwg_pos_img": [
      2495.5543869047856,
      4754.543505404387
    ],
    "pos_dxf": [
      555.3082352350193,
      463.2555802218694
    ],
    "type": "RWA-Zentrale_A01U1DCVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Zentrale_A01U1DCVKH",
    "dwg_layer": "ADE_ET_RWA_Zentrale",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "RWA-Z ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_592",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CF8"
    },
    "position": {
      "x": 2528.2095807422916,
      "y": 4768.069579830215
    },
    "dwg_pos_img": [
      2528.2095807422916,
      4768.069579830215
    ],
    "pos_dxf": [
      560.8469253558733,
      460.9658214658446
    ],
    "type": "Auslass 230 V_A01U1DCWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1DCWKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "RWA 22F01 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_593",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D09"
    },
    "position": {
      "x": 2481.0152420582876,
      "y": 4768.043678471963
    },
    "dwg_pos_img": [
      2481.0152420582876,
      4768.043678471963
    ],
    "pos_dxf": [
      552.8422318688276,
      460.9640586871938
    ],
    "type": "RWA-Taster_A01U1DCZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Taster_A01U1DCZKH",
    "dwg_layer": "ADE_ET_RWA_Taster",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_594",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D2C"
    },
    "position": {
      "x": 4752.831512063161,
      "y": 4759.403139205626
    },
    "dwg_pos_img": [
      4752.831512063161,
      4759.403139205626
    ],
    "pos_dxf": [
      938.1679596438016,
      462.72580847911786
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DKQKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DD0KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DKQKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DD0KH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/036 NSHV ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_595",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D3F"
    },
    "position": {
      "x": 6134.469890879996,
      "y": 4770.843027530207
    },
    "dwg_pos_img": [
      6134.469890879996,
      4770.843027530207
    ],
    "pos_dxf": [
      1172.509451457438,
      460.9658164996761
    ],
    "type": "RWA-Taster_A01U1DD3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Taster_A01U1DD3KH",
    "dwg_layer": "ADE_ET_RWA_Taster",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_596",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D61"
    },
    "position": {
      "x": 6161.0509543371745,
      "y": 4754.354005908995
    },
    "dwg_pos_img": [
      6161.0509543371745,
      4754.354005908995
    ],
    "pos_dxf": [
      1177.01790038304,
      463.7658164714742
    ],
    "type": "Auslass 230 V_A01U1DD4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1DD4KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F04 RWA ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_597",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D72"
    },
    "position": {
      "x": 6149.009035726502,
      "y": 4757.342854462633
    },
    "dwg_pos_img": [
      6149.009035726502,
      4757.342854462633
    ],
    "pos_dxf": [
      1174.975454823631,
      463.2573380343515
    ],
    "type": "RWA-Zentrale_A01U1DD7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Zentrale_A01U1DD7KH",
    "dwg_layer": "ADE_ET_RWA_Zentrale",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "RWA-Z ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_598",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D7B"
    },
    "position": {
      "x": 5937.197532978176,
      "y": 4770.69132022552
    },
    "dwg_pos_img": [
      5937.197532978176,
      4770.69132022552
    ],
    "pos_dxf": [
      1139.049828915761,
      460.9658154293297
    ],
    "type": "Druckknopfmelder_A01U1DDBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DDBKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/010 in Hydrant ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_599",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12D90"
    },
    "position": {
      "x": 5503.243461049538,
      "y": 2307.9125179607145
    },
    "dwg_pos_img": [
      5503.243461049538,
      2307.9125179607145
    ],
    "pos_dxf": [
      1065.446311415309,
      878.595735639346
    ],
    "type": "Druckknopfmelder_A01U1DDEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DDEKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/015 in Hydrant ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_600",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12DA5"
    },
    "position": {
      "x": 5509.375080544417,
      "y": 995.3456282551069
    },
    "dwg_pos_img": [
      5509.375080544417,
      995.3456282551069
    ],
    "pos_dxf": [
      1066.486303414371,
      1101.2074731042082
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DDKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DDKKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 05/017 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_601",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12DB8"
    },
    "position": {
      "x": 5509.139294323899,
      "y": 996.0628010943947
    },
    "dwg_pos_img": [
      5509.139294323899,
      996.0628010943947
    ],
    "pos_dxf": [
      1066.446311405237,
      1101.085810058916
    ],
    "type": "Druckknopfmelder_A01U1DDNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DDNKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/018 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_602",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12DC8"
    },
    "position": {
      "x": 4756.369011986477,
      "y": 2641.4774824189235
    },
    "dwg_pos_img": [
      4756.369011986477,
      2641.4774824189235
    ],
    "pos_dxf": [
      938.7679596306821,
      821.9258048907277
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DF9KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DDSKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DF9KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DDSKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR SiBe 04/028 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H2,H3],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_603",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12DDB"
    },
    "position": {
      "x": 4056.6418089541353,
      "y": 2691.6335704238854
    },
    "dwg_pos_img": [
      4056.6418089541353,
      2691.6335704238854
    ],
    "pos_dxf": [
      820.086313886592,
      813.3280812538742
    ],
    "type": "Druckknopfmelder_A01U1DDVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DDVKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "in Hydrant 04/027 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H,H1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_604",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12DF0"
    },
    "position": {
      "x": 1261.3190000271552,
      "y": 2683.0349072993367
    },
    "dwg_pos_img": [
      1261.3190000271552,
      2683.0349072993367
    ],
    "pos_dxf": [
      345.9679576017927,
      814.4218129618539
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DDYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DDYKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR SiBe 04/021 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G1,G2],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_605",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E03"
    },
    "position": {
      "x": 616.1707643435317,
      "y": 4250.891400740037
    },
    "dwg_pos_img": [
      616.1707643435317,
      4250.891400740037
    ],
    "pos_dxf": [
      236.5435218674677,
      548.4296897558438
    ],
    "type": "Auslass RWA-Motor_A01U1DE1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass RWA-Motor_A01U1DE1KH",
    "dwg_layer": "ADE_ET_RWA_Motor",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "M M1.3 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_606",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E10"
    },
    "position": {
      "x": 616.1708956675587,
      "y": 2127.9445917833928
    },
    "dwg_pos_img": [
      616.1708956675587,
      2127.9445917833928
    ],
    "pos_dxf": [
      236.54354414139402,
      908.4808106340975
    ],
    "type": "Auslass RWA-Motor_A01U1DE3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass RWA-Motor_A01U1DE3KH",
    "dwg_layer": "ADE_ET_RWA_Motor",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "M M1.2 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F1,G],[40-39]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_607",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E1B"
    },
    "position": {
      "x": 616.1708956678937,
      "y": 1066.6322728353844
    },
    "dwg_pos_img": [
      616.1708956678937,
      1066.6322728353844
    ],
    "pos_dxf": [
      236.54354414139402,
      1088.4790510086418
    ],
    "type": "Auslass RWA-Motor_A01U1DE5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass RWA-Motor_A01U1DE5KH",
    "dwg_layer": "ADE_ET_RWA_Motor",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "M M1.1 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F1,G],[43-42]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_608",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E26"
    },
    "position": {
      "x": 5503.2062835189945,
      "y": 4349.248304487664
    },
    "dwg_pos_img": [
      5503.2062835189945,
      4349.248304487664
    ],
    "pos_dxf": [
      1065.440005685856,
      532.3858140404993
    ],
    "type": "Druckknopfmelder_A01U1DE7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1DE7KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/012 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_609",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12E36"
    },
    "position": {
      "x": 5509.375080484444,
      "y": 4348.53569446966
    },
    "dwg_pos_img": [
      5509.375080484444,
      4348.53569446966
    ],
    "pos_dxf": [
      1066.4863034043783,
      532.5074770857909
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DE9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DE9KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 05/011 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_610",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12EA3"
    },
    "position": {
      "x": 1924.0110793363056,
      "y": 567.2573291040826
    },
    "dwg_pos_img": [
      1924.0110793363056,
      567.2573291040826
    ],
    "pos_dxf": [
      458.36802759059697,
      1173.3434706065411
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DEYKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DEZKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DEYKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DEZKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 04/009 Sirene ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_611",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12EE3"
    },
    "position": {
      "x": 4793.6478771976845,
      "y": 1271.2205959342818
    },
    "dwg_pos_img": [
      4793.6478771976845,
      1271.2205959342818
    ],
    "pos_dxf": [
      945.0908766982388,
      1054.32581052048
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DF2KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DF3KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DF2KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DF3KH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 04/012 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_612",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12F23"
    },
    "position": {
      "x": 4776.41494004068,
      "y": 2702.8136708052944
    },
    "dwg_pos_img": [
      4776.41494004068,
      2702.8136708052944
    ],
    "pos_dxf": [
      942.1679756964186,
      811.5258209753601
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DFAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DFAKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 04/029 Sirene ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H2,H3],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_613",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12F63"
    },
    "position": {
      "x": 2676.3189817388247,
      "y": 4741.29671954207
    },
    "dwg_pos_img": [
      2676.3189817388247,
      4741.29671954207
    ],
    "pos_dxf": [
      585.9679545001795,
      465.5258084442105
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DFDKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DFEKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DFDKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DFEKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/021 Sirene ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G5,G6],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_614",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12FA3"
    },
    "position": {
      "x": 5481.320719084922,
      "y": 3427.4137500241113
    },
    "dwg_pos_img": [
      5481.320719084922,
      3427.4137500241113
    ],
    "pos_dxf": [
      1061.7279664885052,
      688.7258142122118
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DFHKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DFIKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DFHKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DFIKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/038 Sirene ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I,I1],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_615",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12FB6"
    },
    "position": {
      "x": 483.3051664653152,
      "y": 3396.1202453954324
    },
    "dwg_pos_img": [
      483.3051664653152,
      3396.1202453954324
    ],
    "pos_dxf": [
      214.00801410007466,
      693.381282899235
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DKFKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKCKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DKFKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKCKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 03/012 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_616",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12FF6"
    },
    "position": {
      "x": 483.0691499957094,
      "y": 1261.3593047676159
    },
    "dwg_pos_img": [
      483.0691499957094,
      1261.3593047676159
    ],
    "pos_dxf": [
      213.96798303797777,
      1055.4360460463417
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DEXKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKGKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DEXKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKGKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/002 Sirene ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_617",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13009"
    },
    "position": {
      "x": 2319.7332522535075,
      "y": 3753.039185652424
    },
    "dwg_pos_img": [
      2319.7332522535075,
      3753.039185652424
    ],
    "pos_dxf": [
      525.4869827145847,
      633.0874698070438
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DKMKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKJKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DKMKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKJKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/048 Sirene ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G4,G5],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_618",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13049"
    },
    "position": {
      "x": 4799.762738138896,
      "y": 4741.986600432469
    },
    "dwg_pos_img": [
      4799.762738138896,
      4741.986600432469
    ],
    "pos_dxf": [
      946.1280262573587,
      465.6857693800994
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1DKNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1DKNKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 03/037 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_619",
    "source_ids": {
      "object_id": null,
      "dwg_id": "130B6"
    },
    "position": {
      "x": 6869.435704577176,
      "y": 1935.5546707387157
    },
    "dwg_pos_img": [
      6869.435704577176,
      1935.5546707387157
    ],
    "pos_dxf": [
      1297.1679640279285,
      941.9257059963325
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DKRKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKSKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DKRKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKSKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 05/006 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I4,I5],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_620",
    "source_ids": {
      "object_id": null,
      "dwg_id": "130C9"
    },
    "position": {
      "x": 6214.762053198046,
      "y": 4755.810985518273
    },
    "dwg_pos_img": [
      6214.762053198046,
      4755.810985518273
    ],
    "pos_dxf": [
      1186.1279100838308,
      463.52571881481117
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DKYKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKVKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DKYKH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKVKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 05/009 Sirene ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I3,I4],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_621",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13109"
    },
    "position": {
      "x": 5506.319052229985,
      "y": 3356.9142094980753
    },
    "dwg_pos_img": [
      5506.319052229985,
      3356.9142094980753
    ],
    "pos_dxf": [
      1065.967966456572,
      700.685775013163
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1DL2KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKZKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1DL2KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1DKZKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 05/013 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[I1,I2],[37-36]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_622",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13191"
    },
    "position": {
      "x": 6212.905853156065,
      "y": 1277.8832001089322
    },
    "dwg_pos_img": [
      6212.905853156065,
      1277.8832001089322
    ],
    "pos_dxf": [
      1185.81307756769,
      1053.3809512428297
    ],
    "type": [
      "1xAP-SD_ SchuKo_A01U1E1GKH",
      "Schaltkreis_A01U1E1HKH",
      "1xAP-SD_ SchuKo_A01U1E1KKH",
      "1xAP-SD_ SchuKo_A01U1E2GKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1E1GKH",
      "Schaltkreis_A01U1E1HKH",
      "1xAP-SD_ SchuKo_A01U1E1KKH",
      "1xAP-SD_ SchuKo_A01U1E2GKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F02 Staplerladestation ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_623",
    "source_ids": {
      "object_id": null,
      "dwg_id": "131AD"
    },
    "position": {
      "x": 6159.32463356674,
      "y": 1277.9602057614802
    },
    "dwg_pos_img": [
      6159.32463356674,
      1277.9602057614802
    ],
    "pos_dxf": [
      1176.725096859953,
      1053.3609024148784
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1E24KH",
      "Schaltkreis_A01U1E1LKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1E24KH",
      "Schaltkreis_A01U1E1LKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F01 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_624",
    "source_ids": {
      "object_id": null,
      "dwg_id": "131C9"
    },
    "position": {
      "x": 5936.134695444079,
      "y": 1277.6703474137757
    },
    "dwg_pos_img": [
      5936.134695444079,
      1277.6703474137757
    ],
    "pos_dxf": [
      1138.86955965184,
      1053.3809512428297
    ],
    "type": [
      "1xAP-SD_ SchuKo_A01U1E1OKH",
      "Schaltkreis_A01U1E1PKH",
      "1xAP-SD_ SchuKo_A01U1E1SKH",
      "1xAP-SD_ SchuKo_A01U1E1WKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1E1OKH",
      "Schaltkreis_A01U1E1PKH",
      "1xAP-SD_ SchuKo_A01U1E1SKH",
      "1xAP-SD_ SchuKo_A01U1E1WKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F02 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_625",
    "source_ids": {
      "object_id": null,
      "dwg_id": "131E5"
    },
    "position": {
      "x": 5882.553475854755,
      "y": 1277.7473530663237
    },
    "dwg_pos_img": [
      5882.553475854755,
      1277.7473530663237
    ],
    "pos_dxf": [
      1129.781578944103,
      1053.3609024148784
    ],
    "type": "Schaltkreis_A01U1E1TKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1E1TKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F01 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_626",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13201"
    },
    "position": {
      "x": 5997.56324199179,
      "y": 1277.8358020900369
    },
    "dwg_pos_img": [
      5997.56324199179,
      1277.8358020900369
    ],
    "pos_dxf": [
      1149.288535744746,
      1053.3609024148784
    ],
    "type": [
      "1xAP-SD_ SchuKo_A01U1E20KH",
      "Schaltkreis_A01U1E1XKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "1xAP-SD_ SchuKo_A01U1E20KH",
      "Schaltkreis_A01U1E1XKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F03 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_627",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1321D"
    },
    "position": {
      "x": 6051.144461581114,
      "y": 1277.7587964374889
    },
    "dwg_pos_img": [
      6051.144461581114,
      1277.7587964374889
    ],
    "pos_dxf": [
      1158.376516452483,
      1053.3809512428297
    ],
    "type": "Schaltkreis_A01U1E21KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1E21KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F04 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_628",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1323C"
    },
    "position": {
      "x": 6105.234547573927,
      "y": 1277.8003947769985
    },
    "dwg_pos_img": [
      6105.234547573927,
      1277.8003947769985
    ],
    "pos_dxf": [
      1167.550806656218,
      1053.3809512428297
    ],
    "type": "Schaltkreis_A01U1E25KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1E25KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 14F01 Staplerladestation ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I2,I3],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_629",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1325B"
    },
    "position": {
      "x": 6382.005705285913,
      "y": 1278.9555827313716
    },
    "dwg_pos_img": [
      6382.005705285913,
      1278.9555827313716
    ],
    "pos_dxf": [
      1214.494324572068,
      1053.2211314749125
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1E28KH",
      "Schaltkreis_A01U1E29KH",
      "1xAP-SD_ SchuKo_A01U1E2CKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1E28KH",
      "Schaltkreis_A01U1E29KH",
      "1xAP-SD_ SchuKo_A01U1E2CKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 14F02 Staplerladestation ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_630",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13277"
    },
    "position": {
      "x": 6327.915619293095,
      "y": 1277.9716491326453
    },
    "dwg_pos_img": [
      6327.915619293095,
      1277.9716491326453
    ],
    "pos_dxf": [
      1205.320034368332,
      1053.3809512428297
    ],
    "type": "Schaltkreis_A01U1E2DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1E2DKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F04 Staplerladestation ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_631",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13293"
    },
    "position": {
      "x": 6274.33439970377,
      "y": 1278.0486547851933
    },
    "dwg_pos_img": [
      6274.33439970377,
      1278.0486547851933
    ],
    "pos_dxf": [
      1196.232053660595,
      1053.3609024148784
    ],
    "type": "Schaltkreis_A01U1E2HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1E2HKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 13F03 Staplerladestation ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_632",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132A2"
    },
    "position": {
      "x": 1212.246480466331,
      "y": 907.1557117740522
    },
    "dwg_pos_img": [
      1212.246480466331,
      907.1557117740522
    ],
    "pos_dxf": [
      337.6447034005621,
      1115.603973531841
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1E2KKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1E2KKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.01/02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[G,G1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_633",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132B0"
    },
    "position": {
      "x": 1215.6504473331142,
      "y": 887.3367209662856
    },
    "dwg_pos_img": [
      1215.6504473331142,
      887.3367209662856
    ],
    "pos_dxf": [
      338.2220546712526,
      1118.965712216003
    ],
    "type": "Geräteanschluß 230 V_A01U1E2MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 230 V_A01U1E2MKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Einspeisung KSS 20F02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_634",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132C1"
    },
    "position": {
      "x": 1215.6056638675554,
      "y": 2645.125770468634
    },
    "dwg_pos_img": [
      1215.6056638675554,
      2645.125770468634
    ],
    "pos_dxf": [
      338.2144588892024,
      820.8452283484371
    ],
    "type": "Geräteanschluß 230 V_A01U1E2PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 230 V_A01U1E2PKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Einspeisung KSS 20F04 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_635",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132D2"
    },
    "position": {
      "x": 1195.747670880779,
      "y": 2676.045892222164
    },
    "dwg_pos_img": [
      1195.747670880779,
      2676.045892222164
    ],
    "pos_dxf": [
      334.8463187359673,
      815.5985951686062
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1E2SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1E2SKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.07/10 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_636",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132E0"
    },
    "position": {
      "x": 1215.5992123235042,
      "y": 2656.413261500702
    },
    "dwg_pos_img": [
      1215.5992123235042,
      2656.413261500702
    ],
    "pos_dxf": [
      338.2133646343816,
      818.9308725261008
    ],
    "type": "Geräteanschluß 230 V_A01U1E2UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 230 V_A01U1E2UKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Einspeisung KSS 20F03 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_637",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132F1"
    },
    "position": {
      "x": 1212.256004047826,
      "y": 2676.058588065316
    },
    "dwg_pos_img": [
      1212.256004047826,
      2676.058588065316
    ],
    "pos_dxf": [
      337.64631870776543,
      815.5985951686062
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1E2XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1E2XKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_638",
    "source_ids": {
      "object_id": null,
      "dwg_id": "132FA"
    },
    "position": {
      "x": 3796.5857055338333,
      "y": 4781.309696060343
    },
    "dwg_pos_img": [
      3796.5857055338333,
      4781.309696060343
    ],
    "pos_dxf": [
      775.9778581828732,
      458.8857383956267
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E4MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E4MKH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ06 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_639",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1330C"
    },
    "position": {
      "x": 3789.982372267014,
      "y": 4780.8332945302045
    },
    "dwg_pos_img": [
      3789.982372267014,
      4780.8332945302045
    ],
    "pos_dxf": [
      774.8578581941538,
      458.9656746630676
    ],
    "type": "Magnetkontakt_A01U1E4OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E4OKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK17 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_640",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13318"
    },
    "position": {
      "x": 3739.64401910845,
      "y": 4759.684640206804
    },
    "dwg_pos_img": [
      3739.64401910845,
      4759.684640206804
    ],
    "pos_dxf": [
      766.3199043015275,
      462.5459141616366
    ],
    "type": "Türcontroller_A01U1E4QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E4QKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM16 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_641",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13329"
    },
    "position": {
      "x": 3838.6469098184657,
      "y": 4806.536254660299
    },
    "dwg_pos_img": [
      3838.6469098184657,
      4806.536254660299
    ],
    "pos_dxf": [
      783.1119140332771,
      454.6128079924142
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E4SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E4SKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS06 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_642",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1333C"
    },
    "position": {
      "x": 4102.076237575492,
      "y": 5059.2407058115205
    },
    "dwg_pos_img": [
      4102.076237575492,
      5059.2407058115205
    ],
    "pos_dxf": [
      827.7925067270962,
      411.7885709473228
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E4UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E4UKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS05 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_643",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1334F"
    },
    "position": {
      "x": 4081.7615654117376,
      "y": 5019.539654571573
    },
    "dwg_pos_img": [
      4081.7615654117376,
      5019.539654571573
    ],
    "pos_dxf": [
      824.3469086215782,
      418.519207254991
    ],
    "type": "Türcontroller_A01U1E4WKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E4WKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM15 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_644",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1335F"
    },
    "position": {
      "x": 4141.022705293505,
      "y": 5033.086187217166
    },
    "dwg_pos_img": [
      4141.022705293505,
      5033.086187217166
    ],
    "pos_dxf": [
      834.3982680361623,
      416.2294490517872
    ],
    "type": "Magnetkontakt_A01U1E4YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E4YKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK15 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_645",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13369"
    },
    "position": {
      "x": 4119.798827456717,
      "y": 5033.541188045978
    },
    "dwg_pos_img": [
      4119.798827456717,
      5033.541188045978
    ],
    "pos_dxf": [
      830.7984583677289,
      416.1495127843464
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E50KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E50KH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ05 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_646",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13379"
    },
    "position": {
      "x": 4079.991664024508,
      "y": 4999.925566322976
    },
    "dwg_pos_img": [
      4079.991664024508,
      4999.925566322976
    ],
    "pos_dxf": [
      824.0467133332836,
      421.8455196918426
    ],
    "type": "Auslass 230 V_A01U1E52KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E52KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F02 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_647",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1338A"
    },
    "position": {
      "x": 5907.463143841515,
      "y": 4782.933080297955
    },
    "dwg_pos_img": [
      5907.463143841515,
      4782.933080297955
    ],
    "pos_dxf": [
      1134.006540298939,
      458.8857384060645
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E55KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E55KH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ04 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_648",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1339A"
    },
    "position": {
      "x": 5938.270711207807,
      "y": 4808.150984213775
    },
    "dwg_pos_img": [
      5938.270711207807,
      4808.150984213775
    ],
    "pos_dxf": [
      1139.231852078386,
      454.612808002852
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E57KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E57KH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS04 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[I2,I3],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_649",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133AD"
    },
    "position": {
      "x": 5808.255622268662,
      "y": 4761.74779465324
    },
    "dwg_pos_img": [
      5808.255622268662,
      4761.74779465324
    ],
    "pos_dxf": [
      1117.1798228590062,
      462.46581647339167
    ],
    "type": "Türcontroller_A01U1E59KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E59KH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM13 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_650",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133BD"
    },
    "position": {
      "x": 5900.859810574705,
      "y": 4782.456678767816
    },
    "dwg_pos_img": [
      5900.859810574705,
      4782.456678767816
    ],
    "pos_dxf": [
      1132.886540310221,
      458.9656746735054
    ],
    "type": "Magnetkontakt_A01U1E5BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E5BKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK13 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_651",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133C7"
    },
    "position": {
      "x": 3808.5469576062546,
      "y": 552.7725536502412
    },
    "dwg_pos_img": [
      3808.5469576062546,
      552.7725536502412
    ],
    "pos_dxf": [
      778.0066217850381,
      1176.04588737885
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E5DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E5DKH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ03 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_652",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133D7"
    },
    "position": {
      "x": 3801.943624339439,
      "y": 552.2961521201005
    },
    "dwg_pos_img": [
      3801.943624339439,
      552.2961521201005
    ],
    "pos_dxf": [
      776.8866217963191,
      1176.125823646291
    ],
    "type": [
      "Polygon_A01U1FVKKH",
      "Magnetkontakt_A01U1E5FKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Polygon_A01U1FVKKH",
      "Magnetkontakt_A01U1E5FKH"
    ],
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK08 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_653",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133E1"
    },
    "position": {
      "x": 3837.11411126175,
      "y": 540.7665545138334
    },
    "dwg_pos_img": [
      3837.11411126175,
      540.7665545138334
    ],
    "pos_dxf": [
      782.8519340658318,
      1178.085827175845
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E5HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E5HKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS03 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[H,H1],[45-44]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_654",
    "source_ids": {
      "object_id": null,
      "dwg_id": "133F4"
    },
    "position": {
      "x": 3597.790764051601,
      "y": 577.6956562177384
    },
    "dwg_pos_img": [
      3597.790764051601,
      577.6956562177384
    ],
    "pos_dxf": [
      742.2599882492402,
      1171.791447604789
    ],
    "type": "Auslass 230 V_A01U1E5JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E5JKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_655",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13405"
    },
    "position": {
      "x": 582.2652487067274,
      "y": 538.2634968638395
    },
    "dwg_pos_img": [
      582.2652487067274,
      538.2634968638395
    ],
    "pos_dxf": [
      230.7927630313402,
      1178.085809289355
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E5OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E5OKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[F1,G],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_656",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13418"
    },
    "position": {
      "x": 525.2738844969291,
      "y": 549.3056477605478
    },
    "dwg_pos_img": [
      525.2738844969291,
      549.3056477605478
    ],
    "pos_dxf": [
      221.1263832360319,
      1176.205630435094
    ],
    "type": "Magnetkontakt_A01U1E5QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E5QKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK05 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_657",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13422"
    },
    "position": {
      "x": 503.57684474426685,
      "y": 568.3922910095498
    },
    "dwg_pos_img": [
      503.57684474426685,
      568.3922910095498
    ],
    "pos_dxf": [
      217.4463199564266,
      1172.965711672112
    ],
    "type": "Auslass 230 V_A01U1E5SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E5SKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_658",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13433"
    },
    "position": {
      "x": 479.9929357285465,
      "y": 3115.8566722374762
    },
    "dwg_pos_img": [
      479.9929357285465,
      3115.8566722374762
    ],
    "pos_dxf": [
      213.4462223143175,
      740.9134660281898
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1E6HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1E6HKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS08 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_659",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13446"
    },
    "position": {
      "x": 471.030463235364,
      "y": 3094.418644151977
    },
    "dwg_pos_img": [
      471.030463235364,
      3094.418644151977
    ],
    "pos_dxf": [
      211.9260856370263,
      744.5481799563518
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E6JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E6JKH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ08 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_660",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13456"
    },
    "position": {
      "x": 471.03046323537285,
      "y": 3073.1933125096966
    },
    "dwg_pos_img": [
      471.03046323537285,
      3073.1933125096966
    ],
    "pos_dxf": [
      211.9260856370267,
      748.1479896247852
    ],
    "type": [
      "Polygon_A01U1FVSKH",
      "Magnetkontakt_A01U1E6LKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Polygon_A01U1FVSKH",
      "Magnetkontakt_A01U1E6LKH"
    ],
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK21 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_661",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13460"
    },
    "position": {
      "x": 474.33385716335295,
      "y": 4134.415139838064
    },
    "dwg_pos_img": [
      474.33385716335295,
      4134.415139838064
    ],
    "pos_dxf": [
      212.4863786001335,
      568.165527468394
    ],
    "type": [
      "Polygon_A01U1FVTKH",
      "Magnetkontakt_A01U1E6NKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Polygon_A01U1FVTKH",
      "Magnetkontakt_A01U1E6NKH"
    ],
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK19 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_662",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1346A"
    },
    "position": {
      "x": 473.8625662532248,
      "y": 4155.640109030943
    },
    "dwg_pos_img": [
      473.8625662532248,
      4155.640109030943
    ],
    "pos_dxf": [
      212.4064423326924,
      564.5657177999606
    ],
    "type": "Elektromagnetischer Türöffner_A01U1E6PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1E6PKH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ07 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_663",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1347A"
    },
    "position": {
      "x": 2384.583376033879,
      "y": 4780.223786362049
    },
    "dwg_pos_img": [
      2384.583376033879,
      4780.223786362049
    ],
    "pos_dxf": [
      536.4862969954179,
      458.8857383851887
    ],
    "type": "Magnetkontakt_A01U1E6RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E6RKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK18 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_664",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13484"
    },
    "position": {
      "x": 3739.6440191084534,
      "y": 4747.8921659464995
    },
    "dwg_pos_img": [
      3739.6440191084534,
      4747.8921659464995
    ],
    "pos_dxf": [
      766.3199043015275,
      464.5459141414924
    ],
    "type": "Türcontroller_A01U1E6TKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E6TKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM17 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_665",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13494"
    },
    "position": {
      "x": 3720.2153829771764,
      "y": 4748.798050760548
    },
    "dwg_pos_img": [
      3720.2153829771764,
      4748.798050760548
    ],
    "pos_dxf": [
      763.0245879259021,
      464.3897422464399
    ],
    "type": "Auslass 230 V_A01U1E6VKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E6VKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_666",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134A5"
    },
    "position": {
      "x": 5790.107843177162,
      "y": 4756.722036295252
    },
    "dwg_pos_img": [
      5790.107843177162,
      4756.722036295252
    ],
    "pos_dxf": [
      1114.101754320516,
      463.3158164864444
    ],
    "type": "Auslass 230 V_A01U1E6YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E6YKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_667",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134B6"
    },
    "position": {
      "x": 5808.372849291831,
      "y": 4747.596915695095
    },
    "dwg_pos_img": [
      5808.372849291831,
      4747.596915695095
    ],
    "pos_dxf": [
      1117.1997058876702,
      464.86581644921876
    ],
    "type": "Türcontroller_A01U1E71KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E71KH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM14 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_668",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134C6"
    },
    "position": {
      "x": 6894.306594010338,
      "y": 1995.4788289517164
    },
    "dwg_pos_img": [
      6894.306594010338,
      1995.4788289517164
    ],
    "pos_dxf": [
      1301.386348101404,
      931.7658312889939
    ],
    "type": "Magnetkontakt_A01U1E73KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E73KH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK11 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_669",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134D0"
    },
    "position": {
      "x": 6735.236666820676,
      "y": 818.9397236044342
    },
    "dwg_pos_img": [
      6735.236666820676,
      818.9397236044342
    ],
    "pos_dxf": [
      1274.406289779399,
      1131.285751154415
    ],
    "type": "Magnetkontakt_A01U1E75KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E75KH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK10 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_670",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134DA"
    },
    "position": {
      "x": 6720.261365228988,
      "y": 879.5792049129595
    },
    "dwg_pos_img": [
      6720.261365228988,
      879.5792049129595
    ],
    "pos_dxf": [
      1271.866309297418,
      1120.9993606626663
    ],
    "type": "Türcontroller_A01U1E77KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E77KH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM10 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_671",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134EA"
    },
    "position": {
      "x": 6703.4926344865935,
      "y": 881.1800353836825
    },
    "dwg_pos_img": [
      6703.4926344865935,
      881.1800353836825
    ],
    "pos_dxf": [
      1269.022142952416,
      1120.725673135777
    ],
    "type": "Auslass 230 V_A01U1E79KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E79KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F01 ZKS ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_672",
    "source_ids": {
      "object_id": null,
      "dwg_id": "134FB"
    },
    "position": {
      "x": 2323.4660182379894,
      "y": 563.7771513245852
    },
    "dwg_pos_img": [
      2323.4660182379894,
      563.7771513245852
    ],
    "pos_dxf": [
      526.1201020333372,
      1173.985809292861
    ],
    "type": "Türcontroller_A01U1E7CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1E7CKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM07 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_673",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1350B"
    },
    "position": {
      "x": 2381.2815955244614,
      "y": 551.6754813019197
    },
    "dwg_pos_img": [
      2381.2815955244614,
      551.6754813019197
    ],
    "pos_dxf": [
      535.9262776861733,
      1176.045789766089
    ],
    "type": "Magnetkontakt_A01U1E7EKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1E7EKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK07 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_674",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13515"
    },
    "position": {
      "x": 2310.83750752601,
      "y": 593.4861488935085
    },
    "dwg_pos_img": [
      2310.83750752601,
      593.4861488935085
    ],
    "pos_dxf": [
      523.9781638207046,
      1168.945525353538
    ],
    "type": "Auslass 230 V_A01U1E7GKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E7GKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F01 ZKS ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_675",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13526"
    },
    "position": {
      "x": 3597.7907640515973,
      "y": 589.4881304780365
    },
    "dwg_pos_img": [
      3597.7907640515973,
      589.4881304780365
    ],
    "pos_dxf": [
      742.2599882492402,
      1169.791447624934
    ],
    "type": "Auslass 230 V_A01U1E7ZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E7ZKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_676",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13537"
    },
    "position": {
      "x": 503.5768447442607,
      "y": 587.4033165289056
    },
    "dwg_pos_img": [
      503.5768447442607,
      587.4033165289056
    ],
    "pos_dxf": [
      217.4463199564266,
      1169.741447635875
    ],
    "type": "Auslass 230 V_A01U1E82KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1E82KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_677",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13548"
    },
    "position": {
      "x": 531.8772177637487,
      "y": 549.781861401917
    },
    "dwg_pos_img": [
      531.8772177637487,
      549.781861401917
    ],
    "pos_dxf": [
      222.2463832247513,
      1176.12572603353
    ],
    "type": "Elektromagnetischer Türöffner_A01U1EF9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektromagnetischer Türöffner_A01U1EF9KH",
    "dwg_layer": "ADE_ET_ZKS_Oeffner",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZTÖ02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_678",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13558"
    },
    "position": {
      "x": 480.1054241136102,
      "y": 1303.1580125818227
    },
    "dwg_pos_img": [
      480.1054241136102,
      1303.1580125818227
    ],
    "pos_dxf": [
      213.4653016162808,
      1048.346611591191
    ],
    "type": "Auslass 230 V_A01U1EFEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EFEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F02 BMA Sirene ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_679",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13572"
    },
    "position": {
      "x": 904.5331313610924,
      "y": 2391.4347608697426
    },
    "dwg_pos_img": [
      904.5331313610924,
      2391.4347608697426
    ],
    "pos_dxf": [
      285.45303994812275,
      863.830571213125
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1FC7KH",
      "Schaltkreis_A01U1EG2KH",
      "AP-SD_ Drehstrom_A01U1FCAKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1FC7KH",
      "Schaltkreis_A01U1EG2KH",
      "AP-SD_ Drehstrom_A01U1FCAKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Kran 25F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_680",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13581"
    },
    "position": {
      "x": 865.4784705810665,
      "y": 2928.1474271323386
    },
    "dwg_pos_img": [
      865.4784705810665,
      2928.1474271323386
    ],
    "pos_dxf": [
      278.8289278723823,
      772.799175383112
    ],
    "type": "Auslass 400 V_A01U1EG5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1EG5KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_681",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1358A"
    },
    "position": {
      "x": 869.406256327068,
      "y": 2910.0828202434896
    },
    "dwg_pos_img": [
      869.406256327068,
      2910.0828202434896
    ],
    "pos_dxf": [
      279.49512474802873,
      775.8634394209616
    ],
    "type": "Schaltkreis_A01U1EG6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1EG6KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Kran 25F03 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_682",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1367C"
    },
    "position": {
      "x": 477.1163450094988,
      "y": 4688.937682443477
    },
    "dwg_pos_img": [
      477.1163450094988,
      4688.937682443477
    ],
    "pos_dxf": [
      212.95832000163,
      474.1190390234458
    ],
    "type": "Beleuchtungstableau_A01U1EH8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Beleuchtungstableau_A01U1EH8KH",
    "dwg_layer": "ADE_ET_NSV_Tableau",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_683",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13695"
    },
    "position": {
      "x": 3583.7173308887263,
      "y": 3735.86121247847
    },
    "dwg_pos_img": [
      3583.7173308887263,
      3735.86121247847
    ],
    "pos_dxf": [
      739.8729748507574,
      636.1657124103258
    ],
    "type": "Beleuchtungstableau_A01U1EH9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Beleuchtungstableau_A01U1EH9KH",
    "dwg_layer": "ADE_ET_NSV_Tableau",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_684",
    "source_ids": {
      "object_id": null,
      "dwg_id": "136AD"
    },
    "position": {
      "x": 5500.271961078801,
      "y": 4442.524508968079
    },
    "dwg_pos_img": [
      5500.271961078801,
      4442.524508968079
    ],
    "pos_dxf": [
      1064.942311420386,
      516.5658159396689
    ],
    "type": "Beleuchtungstableau_A01U1EHAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Beleuchtungstableau_A01U1EHAKH",
    "dwg_layer": "ADE_ET_NSV_Tableau",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_685",
    "source_ids": {
      "object_id": null,
      "dwg_id": "136C5"
    },
    "position": {
      "x": 5500.265401985368,
      "y": 2359.848158363611
    },
    "dwg_pos_img": [
      5500.265401985368,
      2359.848158363611
    ],
    "pos_dxf": [
      1064.941198923862,
      869.7870786892618
    ],
    "type": "Beleuchtungstableau_A01U1EHBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Beleuchtungstableau_A01U1EHBKH",
    "dwg_layer": "ADE_ET_NSV_Tableau",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I1,I2],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_686",
    "source_ids": {
      "object_id": null,
      "dwg_id": "136DD"
    },
    "position": {
      "x": 6060.903246289748,
      "y": 4740.333452387829
    },
    "dwg_pos_img": [
      6060.903246289748,
      4740.333452387829
    ],
    "pos_dxf": [
      1160.031716685936,
      466.1306355609386
    ],
    "type": "Auslass 230 V_A01U1EHCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EHCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F01 EDV Rack ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_687",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13925"
    },
    "position": {
      "x": 3261.6699352932756,
      "y": 1577.434212265839
    },
    "dwg_pos_img": [
      3261.6699352932756,
      1577.434212265839
    ],
    "pos_dxf": [
      685.2500950322901,
      1002.192257501703
    ],
    "type": "Auslass 230 V_A01U1EHIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EHIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F03 EDV Rack ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_688",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13936"
    },
    "position": {
      "x": 3218.818506413058,
      "y": 1577.4302164825249
    },
    "dwg_pos_img": [
      3218.818506413058,
      1577.4302164825249
    ],
    "pos_dxf": [
      677.9820081550745,
      1002.187345997731
    ],
    "type": "Auslass 230 V_A01U1EJVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EJVKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F01 EDV Rack ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_689",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13947"
    },
    "position": {
      "x": 6082.3289607298575,
      "y": 4740.335450279488
    },
    "dwg_pos_img": [
      6082.3289607298575,
      4740.335450279488
    ],
    "pos_dxf": [
      1163.665760124544,
      466.1330913129243
    ],
    "type": "Auslass 230 V_A01U1EJYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EJYKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F02 EDV Rack ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_690",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13958"
    },
    "position": {
      "x": 6103.7546751699665,
      "y": 4740.337448171144
    },
    "dwg_pos_img": [
      6103.7546751699665,
      4740.337448171144
    ],
    "pos_dxf": [
      1167.299803563152,
      466.1355470649105
    ],
    "type": "Auslass 230 V_A01U1EK1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EK1KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F03 EDV Rack ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_691",
    "source_ids": {
      "object_id": null,
      "dwg_id": "139B9"
    },
    "position": {
      "x": 483.08157837677766,
      "y": 2045.5416491721526
    },
    "dwg_pos_img": [
      483.08157837677766,
      2045.5416491721526
    ],
    "pos_dxf": [
      213.97009103198184,
      922.4389650880553
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1EPZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1EPZKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/006 Brandschutztor ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_692",
    "source_ids": {
      "object_id": null,
      "dwg_id": "139F3"
    },
    "position": {
      "x": 483.1337330735563,
      "y": 3106.340249691726
    },
    "dwg_pos_img": [
      483.1337330735563,
      3106.340249691726
    ],
    "pos_dxf": [
      213.97893705834736,
      742.5278580023923
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1EQ7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1EQ7KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 03/010 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_693",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13A89"
    },
    "position": {
      "x": 482.23169683053027,
      "y": 2670.644536184688
    },
    "dwg_pos_img": [
      482.23169683053027,
      2670.644536184688
    ],
    "pos_dxf": [
      213.8259415118036,
      816.4215983293702
    ],
    "type": "Auslass 230 V_A01U1ETVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1ETVKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F04 BMA Sirene ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F,F1],[39-38]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_694",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13A9A"
    },
    "position": {
      "x": 479.9929357286052,
      "y": 2929.9387184497855
    },
    "dwg_pos_img": [
      479.9929357286052,
      2929.9387184497855
    ],
    "pos_dxf": [
      213.4462223143175,
      772.4450933713938
    ],
    "type": "Druckknopfmelder_A01U1ETYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1ETYKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/009 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_695",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13AAA"
    },
    "position": {
      "x": 483.0691026961616,
      "y": 2921.9222017556312
    },
    "dwg_pos_img": [
      483.0691026961616,
      2921.9222017556312
    ],
    "pos_dxf": [
      213.9679750155285,
      773.8050933481582
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1EU0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1EU0KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 03/008 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_696",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13ABD"
    },
    "position": {
      "x": 482.4634314934582,
      "y": 3438.535276950922
    },
    "dwg_pos_img": [
      482.4634314934582,
      3438.535276950922
    ],
    "pos_dxf": [
      213.8652463309986,
      686.1875969035959
    ],
    "type": "Auslass 230 V_A01U1EU3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EU3KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F04 BMA Sirene ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[F,F1],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_697",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B11"
    },
    "position": {
      "x": 1890.1340982273382,
      "y": 572.8916634152429
    },
    "dwg_pos_img": [
      1890.1340982273382,
      572.8916634152429
    ],
    "pos_dxf": [
      452.6221085332415,
      1172.383470619042
    ],
    "type": "Auslass 230 V_A01U1EUIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EUIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F02 BMA Sirene ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_698",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B22"
    },
    "position": {
      "x": 3758.0762361972324,
      "y": 589.906324763967
    },
    "dwg_pos_img": [
      3758.0762361972324,
      589.906324763967
    ],
    "pos_dxf": [
      769.4462167403935,
      1169.741428320989
    ],
    "type": "Auslass 230 V_A01U1EURKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EURKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_699",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B33"
    },
    "position": {
      "x": 3758.076236197238,
      "y": 570.8952992446057
    },
    "dwg_pos_img": [
      3758.076236197238,
      570.8952992446057
    ],
    "pos_dxf": [
      769.4462167403935,
      1172.965692357227
    ],
    "type": "Auslass 230 V_A01U1EUUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EUUKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_700",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B44"
    },
    "position": {
      "x": 479.99346448163135,
      "y": 1165.5444747918673
    },
    "dwg_pos_img": [
      479.99346448163135,
      1165.5444747918673
    ],
    "pos_dxf": [
      213.4463119967152,
      1071.68581034846
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EV0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EV0KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F,F1],[43-42]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_701",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B56"
    },
    "position": {
      "x": 479.99351164807433,
      "y": 1869.2826502688195
    },
    "dwg_pos_img": [
      479.99351164807433,
      1869.2826502688195
    ],
    "pos_dxf": [
      213.4463199967149,
      952.3320338943495
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EV2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EV2KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F,F1],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_702",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B68"
    },
    "position": {
      "x": 480.0057985293307,
      "y": 2053.558166164029
    },
    "dwg_pos_img": [
      480.0057985293307,
      2053.558166164029
    ],
    "pos_dxf": [
      213.4484039907188,
      921.07896511129
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EV4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EV4KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_703",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B7A"
    },
    "position": {
      "x": 479.9929357286054,
      "y": 2929.4466603765495
    },
    "dwg_pos_img": [
      479.9929357286054,
      2929.4466603765495
    ],
    "pos_dxf": [
      213.4462223143175,
      772.5285462681172
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EV6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EV6KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_704",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B8C"
    },
    "position": {
      "x": 505.7073280376213,
      "y": 3114.37644533558
    },
    "dwg_pos_img": [
      505.7073280376213,
      3114.37644533558
    ],
    "pos_dxf": [
      217.8076740133865,
      741.1678660256275
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EV8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EV8KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_705",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13B9E"
    },
    "position": {
      "x": 502.7169379746023,
      "y": 4172.452349800509
    },
    "dwg_pos_img": [
      502.7169379746023,
      4172.452349800509
    ],
    "pos_dxf": [
      217.3004700451568,
      561.7181305025329
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EVAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EVAKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_706",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13BB0"
    },
    "position": {
      "x": 923.701993258063,
      "y": 1509.0394663533189
    },
    "dwg_pos_img": [
      923.701993258063,
      1509.0394663533189
    ],
    "pos_dxf": [
      288.7042956761861,
      1013.487039922079
    ],
    "type": "Präsenzmelder AP 360°_A01U1EVCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder AP 360°_A01U1EVCKH",
    "dwg_layer": "ADE_ET_NSV_BWM_DALI",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "DALI ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G,G1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_707",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13BDD"
    },
    "position": {
      "x": 991.9281600636226,
      "y": 1661.1165678042626
    },
    "dwg_pos_img": [
      991.9281600636226,
      1661.1165678042626
    ],
    "pos_dxf": [
      300.2762250283829,
      987.7037095068085
    ],
    "type": "Präsenzmelder AP 360°_A01U1EVEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder AP 360°_A01U1EVEKH",
    "dwg_layer": "ADE_ET_NSV_BWM_DALI",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "DALI ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_708",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C0A"
    },
    "position": {
      "x": 1012.7076509275661,
      "y": 1623.8580802685892
    },
    "dwg_pos_img": [
      1012.7076509275661,
      1623.8580802685892
    ],
    "pos_dxf": [
      303.8006616413493,
      994.0254477515182
    ],
    "type": [
      "Auslass 400 V_A01U1EVRKH",
      "Auslass 230 V_A01U1EVOKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1EVRKH",
      "Auslass 230 V_A01U1EVOKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F05 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_709",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C24"
    },
    "position": {
      "x": 1004.1799729104647,
      "y": 1623.1439735451959
    },
    "dwg_pos_img": [
      1004.1799729104647,
      1623.1439735451959
    ],
    "pos_dxf": [
      302.35427102360654,
      994.1454477503803
    ],
    "type": "Schaltkreis_A01U1EVSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1EVSKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A DLE 24F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_710",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C33"
    },
    "position": {
      "x": 1060.5032060016838,
      "y": 1623.8948377573324
    },
    "dwg_pos_img": [
      1060.5032060016838,
      1623.8948377573324
    ],
    "pos_dxf": [
      311.9073282263648,
      994.0254477515182
    ],
    "type": "Auslass 230 V_A01U1EVVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EVVKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F05 Armatur ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_711",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C44"
    },
    "position": {
      "x": 1036.605428464667,
      "y": 1623.8764590129613
    },
    "dwg_pos_img": [
      1036.605428464667,
      1623.8764590129613
    ],
    "pos_dxf": [
      307.8539949338642,
      994.0254477515182
    ],
    "type": "Auslass 230 V_A01U1EVYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EVYKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F05 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G,G1],[41-40]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_712",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C82"
    },
    "position": {
      "x": 6244.479817603074,
      "y": 576.2404018808911
    },
    "dwg_pos_img": [
      6244.479817603074,
      576.2404018808911
    ],
    "pos_dxf": [
      1191.168378957962,
      1172.383470619042
    ],
    "type": "Auslass 230 V_A01U1EW5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EW5KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "25F01 BMA Sirene ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_713",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13C93"
    },
    "position": {
      "x": 6215.705156217213,
      "y": 570.5578849083895
    },
    "dwg_pos_img": [
      6215.705156217213,
      570.5578849083895
    ],
    "pos_dxf": [
      1186.2878710197201,
      1173.3434706065411
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1EW4KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EW8KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1EW4KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EW8KH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sirene 05/001 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I3,I4],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_714",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CA6"
    },
    "position": {
      "x": 5835.296638169821,
      "y": 991.8326095443945
    },
    "dwg_pos_img": [
      5835.296638169821,
      991.8326095443945
    ],
    "pos_dxf": [
      1121.766284919782,
      1101.845790513437
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EWBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EWBKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_715",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CB8"
    },
    "position": {
      "x": 5465.038461532927,
      "y": 996.0288850563365
    },
    "dwg_pos_img": [
      5465.038461532927,
      996.0288850563365
    ],
    "pos_dxf": [
      1058.966311497222,
      1101.085810058916
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EWDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EWDKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I,I1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_716",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CCA"
    },
    "position": {
      "x": 5503.243461049952,
      "y": 996.0582668646975
    },
    "dwg_pos_img": [
      5503.243461049952,
      996.0582668646975
    ],
    "pos_dxf": [
      1065.446311415309,
      1101.085810058916
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EWFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EWFKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_717",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CDC"
    },
    "position": {
      "x": 6857.694979402875,
      "y": 2007.601017711132
    },
    "dwg_pos_img": [
      6857.694979402875,
      2007.601017711132
    ],
    "pos_dxf": [
      1295.176604281053,
      929.7051365146899
    ],
    "type": "Auslass 230 V_A01U1EWKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EWKKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 21F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_718",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CED"
    },
    "position": {
      "x": 6863.8587237726215,
      "y": 1911.7877562883687
    },
    "dwg_pos_img": [
      6863.8587237726215,
      1911.7877562883687
    ],
    "pos_dxf": [
      1296.222045022207,
      945.9558399058733
    ],
    "type": "Auslass 230 V_A01U1EWNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EWNKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "25F02 BMA Sirene ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I4,I5],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_719",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13CFE"
    },
    "position": {
      "x": 6244.703128940838,
      "y": 4761.494399529478
    },
    "dwg_pos_img": [
      6244.703128940838,
      4761.494399529478
    ],
    "pos_dxf": [
      1191.206255086146,
      462.5657188273117
    ],
    "type": "Auslass 230 V_A01U1EWQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EWQKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F06 BMA Sirene ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I3,I4],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_720",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D0F"
    },
    "position": {
      "x": 5465.038759667123,
      "y": 4349.218951500214
    },
    "dwg_pos_img": [
      5465.038759667123,
      4349.218951500214
    ],
    "pos_dxf": [
      1058.966362064332,
      532.3858140404993
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EWWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EWWKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I,I1],[34-33]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_721",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D21"
    },
    "position": {
      "x": 5503.243413823311,
      "y": 4349.248333042971
    },
    "dwg_pos_img": [
      5503.243413823311,
      4349.248333042971
    ],
    "pos_dxf": [
      1065.446303405316,
      532.3858140404993
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EWYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EWYKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_722",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D33"
    },
    "position": {
      "x": 5507.849648823386,
      "y": 3334.0566911725373
    },
    "dwg_pos_img": [
      5507.849648823386,
      3334.0566911725373
    ],
    "pos_dxf": [
      1066.227572945911,
      704.5626026756522
    ],
    "type": "Auslass 230 V_A01U1EX0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EX0KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F05 BMA Sirene ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[I1,I2],[37-36]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_723",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D44"
    },
    "position": {
      "x": 5475.743737690897,
      "y": 3404.767910373554
    },
    "dwg_pos_img": [
      5475.743737690897,
      3404.767910373554
    ],
    "pos_dxf": [
      1060.782047382803,
      692.5658141830718
    ],
    "type": "Auslass 230 V_A01U1EX3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EX3KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F02 BMA Sirene ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I,I1],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_724",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D55"
    },
    "position": {
      "x": 4741.35874511026,
      "y": 2669.531980361684
    },
    "dwg_pos_img": [
      4741.35874511026,
      2669.531980361684
    ],
    "pos_dxf": [
      936.2220486410761,
      817.1658129185789
    ],
    "type": "Geräteanschluß 400 V_A01U1EX6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1EX6KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "SiBe Zentrale 1F8 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H2,H3],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_725",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D68"
    },
    "position": {
      "x": 5503.243461049564,
      "y": 2227.424054383275
    },
    "dwg_pos_img": [
      5503.243461049564,
      2227.424054383275
    ],
    "pos_dxf": [
      1065.446311415309,
      892.2465541173133
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EXFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EXFKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_726",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D7A"
    },
    "position": {
      "x": 5465.038806893374,
      "y": 2227.3990475828596
    },
    "dwg_pos_img": [
      5465.038806893374,
      2227.3990475828596
    ],
    "pos_dxf": [
      1058.966370074325,
      892.2458121623677
    ],
    "type": "1xAP-SD_ SchuKo_A01U1EXHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1EXHKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I,I1],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_727",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13D8C"
    },
    "position": {
      "x": 5509.375127710698,
      "y": 2226.711415809963
    },
    "dwg_pos_img": [
      5509.375127710698,
      2226.711415809963
    ],
    "pos_dxf": [
      1066.4863114143714,
      892.3682171626047
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1EXJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1EXJKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Brandschutztor 05/016 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_728",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13DB0"
    },
    "position": {
      "x": 5455.683771378068,
      "y": 1792.86460643977
    },
    "dwg_pos_img": [
      5455.683771378068,
      1792.86460643977
    ],
    "pos_dxf": [
      1057.379650269584,
      965.9414985166873
    ],
    "type": "Auslass 230 V_A01U1EXPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EXPKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "EDV Rack 25F02 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I,I1],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_729",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13DC1"
    },
    "position": {
      "x": 5455.669292673642,
      "y": 1816.1785732575963
    },
    "dwg_pos_img": [
      5455.669292673642,
      1816.1785732575963
    ],
    "pos_dxf": [
      1057.377194517598,
      961.9874550813024
    ],
    "type": "Auslass 230 V_A01U1EXSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EXSKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "EDV Rack 25F03 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I,I1],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_730",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13DD2"
    },
    "position": {
      "x": 4813.067287473541,
      "y": 4764.874300384149
    },
    "dwg_pos_img": [
      4813.067287473541,
      4764.874300384149
    ],
    "pos_dxf": [
      948.3846282646514,
      461.805757897466
    ],
    "type": "Auslass 230 V_A01U1EXVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EXVKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F03 BMA Sirene ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_731",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13DE3"
    },
    "position": {
      "x": 2689.7518186478896,
      "y": 4763.476854537661
    },
    "dwg_pos_img": [
      2689.7518186478896,
      4763.476854537661
    ],
    "pos_dxf": [
      588.2463155306953,
      461.7658164916184
    ],
    "type": "Auslass 230 V_A01U1EY1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EY1KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "22F03 BMA Sirene ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G5,G6],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_732",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13DF4"
    },
    "position": {
      "x": 2331.971585807488,
      "y": 4752.53162468319
    },
    "dwg_pos_img": [
      2331.971585807488,
      4752.53162468319
    ],
    "pos_dxf": [
      527.5627424693785,
      463.5754581748836
    ],
    "type": "Auslass 230 V_A01U1EY4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EY4KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ZKS 20F03 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_733",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E05"
    },
    "position": {
      "x": 2324.408545489538,
      "y": 4758.59624397603
    },
    "dwg_pos_img": [
      2324.408545489538,
      4758.59624397603
    ],
    "pos_dxf": [
      526.2799653129764,
      462.5459141616366
    ],
    "type": "Türcontroller_A01U1EY7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EY7KH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM18 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_734",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E15"
    },
    "position": {
      "x": 1215.6504474382868,
      "y": 2690.3111196249065
    },
    "dwg_pos_img": [
      1215.6504474382868,
      2690.3111196249065
    ],
    "pos_dxf": [
      338.2220546891876,
      813.1818129764547
    ],
    "type": "Geräteanschluß 400 V_A01U1EYCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1EYCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "SiBe Zentrale 1F8 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_735",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E28"
    },
    "position": {
      "x": 2281.606922177504,
      "y": 3755.343938329626
    },
    "dwg_pos_img": [
      2281.606922177504,
      3755.343938329626
    ],
    "pos_dxf": [
      519.0203260232436,
      632.6916115826753
    ],
    "type": "Auslass 230 V_A01U1EYFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EYFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "22F03 BMA Sirene ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G3,G4],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_736",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E39"
    },
    "position": {
      "x": 4759.046292093787,
      "y": 2691.9512841255337
    },
    "dwg_pos_img": [
      4759.046292093787,
      2691.9512841255337
    ],
    "pos_dxf": [
      939.2220566100168,
      813.3658129663654
    ],
    "type": "Auslass 230 V_A01U1EYIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EYIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F01 BMA Sirene ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H2,H3],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_737",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E4A"
    },
    "position": {
      "x": 2995.391243878971,
      "y": 2690.817408635641
    },
    "dwg_pos_img": [
      2995.391243878971,
      2690.817408635641
    ],
    "pos_dxf": [
      640.0862180433164,
      813.3280812538742
    ],
    "type": "Druckknopfmelder_A01U1EYLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1EYLKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "in Hydrant 04/024 ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G5,G6],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_738",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E5F"
    },
    "position": {
      "x": 1580.3918338970097,
      "y": 2689.7291939511733
    },
    "dwg_pos_img": [
      1580.3918338970097,
      2689.7291939511733
    ],
    "pos_dxf": [
      400.0863181168629,
      813.3280812538742
    ],
    "type": "Druckknopfmelder_A01U1EYUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1EYUKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/022 in Hydrant ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G1,G2],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_739",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13E74"
    },
    "position": {
      "x": 2286.7127069860626,
      "y": 2691.691107428216
    },
    "dwg_pos_img": [
      2286.7127069860626,
      2691.691107428216
    ],
    "pos_dxf": [
      519.8863248599746,
      813.0874680156853
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1EZ0KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EYXKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1EZ0KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EYXKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 04/023 Sirene ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G3,G4],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_740",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13EB4"
    },
    "position": {
      "x": 2294.587936112056,
      "y": 2709.06700159506
    },
    "dwg_pos_img": [
      2294.587936112056,
      2709.06700159506
    ],
    "pos_dxf": [
      521.2220527682723,
      810.1415489301285
    ],
    "type": "Auslass 230 V_A01U1EZ1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EZ1KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F03 BMA Sirene ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G3,G4],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_741",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13EC5"
    },
    "position": {
      "x": 3590.792330818033,
      "y": 1927.3726858330374
    },
    "dwg_pos_img": [
      3590.792330818033,
      1927.3726858330374
    ],
    "pos_dxf": [
      741.0729748386709,
      942.8857288522695
    ],
    "type": "Beleuchtungstableau_A01U1EZ4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Beleuchtungstableau_A01U1EZ4KH",
    "dwg_layer": "ADE_ET_NSV_Tableau",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_742",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13EDD"
    },
    "position": {
      "x": 4757.4548306022725,
      "y": 1276.0819174031913
    },
    "dwg_pos_img": [
      4757.4548306022725,
      1276.0819174031913
    ],
    "pos_dxf": [
      938.9521267456557,
      1053.496611182943
    ],
    "type": "Auslass 230 V_A01U1EZ5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EZ5KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "25F04 BMA Sirene ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H2,H3],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_743",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F1B"
    },
    "position": {
      "x": 2294.5879361123907,
      "y": 1647.7443182951702
    },
    "dwg_pos_img": [
      2294.5879361123907,
      1647.7443182951702
    ],
    "pos_dxf": [
      521.2220527682723,
      990.1415470955399
    ],
    "type": "Auslass 230 V_A01U1EZ9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1EZ9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F03 BMA Sirene ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G3,G4],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_744",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F2C"
    },
    "position": {
      "x": 2286.7127069863977,
      "y": 1630.3684241283263
    },
    "dwg_pos_img": [
      2286.7127069863977,
      1630.3684241283263
    ],
    "pos_dxf": [
      519.8863248599746,
      993.0874661810967
    ],
    "type": [
      "Netzteil inkl. Akku_A01U1EZ8KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EZCKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Netzteil inkl. Akku_A01U1EZ8KH",
      "Bus-Steuerkoppler BMA (I_O)_A01U1EZCKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 04/020 Sirene ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G3,G4],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_745",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F3F"
    },
    "position": {
      "x": 483.9654610020142,
      "y": 562.3630469379095
    },
    "dwg_pos_img": [
      483.9654610020142,
      562.3630469379095
    ],
    "pos_dxf": [
      214.1200075195752,
      1173.985711650662
    ],
    "type": "Türcontroller_A01U1EZFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EZFKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM05 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_746",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F4F"
    },
    "position": {
      "x": 483.96546100201056,
      "y": 574.155521198215
    },
    "dwg_pos_img": [
      483.96546100201056,
      574.155521198215
    ],
    "pos_dxf": [
      214.1200075195752,
      1171.985711670806
    ],
    "type": "Türcontroller_A01U1EZHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EZHKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM06 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F,F1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_747",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F5F"
    },
    "position": {
      "x": 3738.4648524549807,
      "y": 576.6584155481269
    },
    "dwg_pos_img": [
      3738.4648524549807,
      576.6584155481269
    ],
    "pos_dxf": [
      766.119904303542,
      1171.985711670806
    ],
    "type": "Türcontroller_A01U1EZJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EZJKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM09 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_748",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F6F"
    },
    "position": {
      "x": 3738.4648524549843,
      "y": 564.8659412878214
    },
    "dwg_pos_img": [
      3738.4648524549843,
      564.8659412878214
    ],
    "pos_dxf": [
      766.119904303542,
      1173.985711650662
    ],
    "type": "Türcontroller_A01U1EZLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EZLKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM08 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_749",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F7F"
    },
    "position": {
      "x": 6876.383030617447,
      "y": 1994.795176726363
    },
    "dwg_pos_img": [
      6876.383030617447,
      1994.795176726363
    ],
    "pos_dxf": [
      1298.3463090806995,
      931.8794406924953
    ],
    "type": "Türcontroller_A01U1EZNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1EZNKH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM11 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_750",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F8F"
    },
    "position": {
      "x": 3614.690356832712,
      "y": 1906.793781048027
    },
    "dwg_pos_img": [
      3614.690356832712,
      1906.793781048027
    ],
    "pos_dxf": [
      745.1263502757918,
      946.3790217878077
    ],
    "type": "1xUP-SD_ SchuKo_A01U1EZZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1EZZKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_751",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13F9B"
    },
    "position": {
      "x": 3538.8470614118346,
      "y": 1697.2617124760109
    },
    "dwg_pos_img": [
      3538.8470614118346,
      1697.2617124760109
    ],
    "pos_dxf": [
      732.2624697803569,
      981.9057033049803
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F01KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F01KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_752",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FA7"
    },
    "position": {
      "x": 3689.684774785001,
      "y": 1854.0993471293268
    },
    "dwg_pos_img": [
      3689.684774785001,
      1854.0993471293268
    ],
    "pos_dxf": [
      757.8462515539254,
      955.3257631039455
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F03KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F03KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F05 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_753",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FB5"
    },
    "position": {
      "x": 3552.0537279454734,
      "y": 1699.6303640025953
    },
    "dwg_pos_img": [
      3552.0537279454734,
      1699.6303640025953
    ],
    "pos_dxf": [
      734.5024697577956,
      981.5057033090088
    ],
    "type": "Taster_ UP_ 1S_A01U1F05KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F05KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_754",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FBB"
    },
    "position": {
      "x": 3538.516205159784,
      "y": 1836.175526990054
    },
    "dwg_pos_img": [
      3538.516205159784,
      1836.175526990054
    ],
    "pos_dxf": [
      732.2063528188858,
      958.3459202610261
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F06KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F06KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_755",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FC7"
    },
    "position": {
      "x": 3139.694888437454,
      "y": 1903.110080374715
    },
    "dwg_pos_img": [
      3139.694888437454,
      1903.110080374715
    ],
    "pos_dxf": [
      664.5617478623997,
      946.941821782139
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F08KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F08KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_756",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FD5"
    },
    "position": {
      "x": 3271.9331418496854,
      "y": 1633.9661219305044
    },
    "dwg_pos_img": [
      3271.9331418496854,
      1633.9661219305044
    ],
    "pos_dxf": [
      686.9908509146537,
      992.6058017909572
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0AKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0AKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.12/13 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_757",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FE3"
    },
    "position": {
      "x": 3531.971011648124,
      "y": 1882.75134780184
    },
    "dwg_pos_img": [
      3531.971011648124,
      1882.75134780184
    ],
    "pos_dxf": [
      731.0962139900546,
      950.4458217848446
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0CKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 18.01/02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_758",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FF1"
    },
    "position": {
      "x": 3689.684774785041,
      "y": 1726.7406251180482
    },
    "dwg_pos_img": [
      3689.684774785041,
      1726.7406251180482
    ],
    "pos_dxf": [
      757.8462515539254,
      976.9257628863884
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F0EKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F0EKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F05 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_759",
    "source_ids": {
      "object_id": null,
      "dwg_id": "13FFF"
    },
    "position": {
      "x": 3131.8614306806026,
      "y": 1731.5000912547175
    },
    "dwg_pos_img": [
      3131.8614306806026,
      1731.5000912547175
    ],
    "pos_dxf": [
      663.2331048506267,
      976.0458010202515
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F0GKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F0GKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_760",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1400B"
    },
    "position": {
      "x": 3551.722871693421,
      "y": 1838.544178516634
    },
    "dwg_pos_img": [
      3551.722871693421,
      1838.544178516634
    ],
    "pos_dxf": [
      734.4463527963242,
      957.9459202650551
    ],
    "type": "Taster_ UP_ 1S_A01U1F0IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F0IKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_761",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14011"
    },
    "position": {
      "x": 3132.946264003007,
      "y": 1733.8594204050423
    },
    "dwg_pos_img": [
      3132.946264003007,
      1733.8594204050423
    ],
    "pos_dxf": [
      663.4171048487733,
      975.6458010242804
    ],
    "type": "Taster_ UP_ 1S_A01U1F0JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F0JKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_762",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14017"
    },
    "position": {
      "x": 3685.203941272785,
      "y": 1815.6133882395243
    },
    "dwg_pos_img": [
      3685.203941272785,
      1815.6133882395243
    ],
    "pos_dxf": [
      757.0862515235824,
      961.8523853611596
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0KKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0KKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 18.05/06 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_763",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14025"
    },
    "position": {
      "x": 3498.4097609656887,
      "y": 1634.1402952770604
    },
    "dwg_pos_img": [
      3498.4097609656887,
      1634.1402952770604
    ],
    "pos_dxf": [
      725.4038463831221,
      992.6058017909572
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0MKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.16/17 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_764",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14033"
    },
    "position": {
      "x": 3435.3104372636994,
      "y": 1882.6770103457875
    },
    "dwg_pos_img": [
      3435.3104372636994,
      1882.6770103457875
    ],
    "pos_dxf": [
      714.7014875926836,
      950.4458217848446
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0OKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.22/23 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_765",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14041"
    },
    "position": {
      "x": 3401.74108121598,
      "y": 1634.0659515875222
    },
    "dwg_pos_img": [
      3401.74108121598,
      1634.0659515875222
    ],
    "pos_dxf": [
      709.0077452241483,
      992.6058017909572
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0QKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.14/15 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_766",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1404F"
    },
    "position": {
      "x": 3134.849438983837,
      "y": 1732.4847023082111
    },
    "dwg_pos_img": [
      3134.849438983837,
      1732.4847023082111
    ],
    "pos_dxf": [
      663.739904845522,
      975.8792010219295
    ],
    "type": "002 Sirene_A01U1F0SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F0SKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/015 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_767",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1405D"
    },
    "position": {
      "x": 3685.203941272826,
      "y": 1688.2546662282457
    },
    "dwg_pos_img": [
      3685.203941272826,
      1688.2546662282457
    ],
    "pos_dxf": [
      757.0862515235824,
      983.4523851436024
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0UKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 18.03/04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_768",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1406B"
    },
    "position": {
      "x": 3469.454513250163,
      "y": 1634.3538765368958
    },
    "dwg_pos_img": [
      3469.454513250163,
      1634.3538765368958
    ],
    "pos_dxf": [
      720.4927089614037,
      992.5658017913606
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F0WKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F0WKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_769",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14079"
    },
    "position": {
      "x": 3178.1747654955875,
      "y": 1882.4792584513734
    },
    "dwg_pos_img": [
      3178.1747654955875,
      1882.4792584513734
    ],
    "pos_dxf": [
      671.0883701196135,
      950.4458217848446
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F0YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F0YKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.18/19 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_770",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14087"
    },
    "position": {
      "x": 3256.1035376159257,
      "y": 1903.1996052187123
    },
    "dwg_pos_img": [
      3256.1035376159257,
      1903.1996052187123
    ],
    "pos_dxf": [
      684.3059710446291,
      946.941821782139
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F10KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F10KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_771",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14095"
    },
    "position": {
      "x": 3482.572051366645,
      "y": 1903.3737723317836
    },
    "dwg_pos_img": [
      3482.572051366645,
      1903.3737723317836
    ],
    "pos_dxf": [
      722.7175917514944,
      946.941821782139
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F12KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F12KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_772",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140A9"
    },
    "position": {
      "x": 3177.3550297661573,
      "y": 1634.1292354911047
    },
    "dwg_pos_img": [
      3177.3550297661573,
      1634.1292354911047
    ],
    "pos_dxf": [
      670.9493336707922,
      992.5658017913606
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F15KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F15KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_773",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140B7"
    },
    "position": {
      "x": 3613.7081110092736,
      "y": 1903.8048126678013
    },
    "dwg_pos_img": [
      3613.7081110092736,
      1903.8048126678013
    ],
    "pos_dxf": [
      744.9597502774698,
      946.8858217827028
    ],
    "type": "002 Sirene_A01U1F17KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F17KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/014 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_774",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140C5"
    },
    "position": {
      "x": 3614.6903568327893,
      "y": 1661.4308185740283
    },
    "dwg_pos_img": [
      3614.6903568327893,
      1661.4308185740283
    ],
    "pos_dxf": [
      745.1263502757918,
      987.9925041811734
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F19KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F19KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_775",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140D1"
    },
    "position": {
      "x": 3148.69619472869,
      "y": 1633.8713457386702
    },
    "dwg_pos_img": [
      3148.69619472869,
      1633.8713457386702
    ],
    "pos_dxf": [
      666.0884711909353,
      992.6058017909572
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F1BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F1BKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.10/11 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_776",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140DF"
    },
    "position": {
      "x": 3305.502497897404,
      "y": 1882.5771806887697
    },
    "dwg_pos_img": [
      3305.502497897404,
      1882.5771806887697
    ],
    "pos_dxf": [
      692.6845932831891,
      950.4458217848446
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F1DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F1DKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.20/21 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_777",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140ED"
    },
    "position": {
      "x": 3612.3320235232145,
      "y": 1648.2214337106107
    },
    "dwg_pos_img": [
      3612.3320235232145,
      1648.2214337106107
    ],
    "pos_dxf": [
      744.7263502798205,
      990.2325041586118
    ],
    "type": "Taster_ UP_ 1S_A01U1F1FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F1FKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_778",
    "source_ids": {
      "object_id": null,
      "dwg_id": "140F3"
    },
    "position": {
      "x": 3430.399916253448,
      "y": 1634.3238413399567
    },
    "dwg_pos_img": [
      3430.399916253448,
      1634.3238413399567
    ],
    "pos_dxf": [
      713.8686077040052,
      992.5658017913606
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F1GKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F1GKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_779",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14101"
    },
    "position": {
      "x": 3396.8305602055657,
      "y": 1903.307832269129
    },
    "dwg_pos_img": [
      3396.8305602055657,
      1903.307832269129
    ],
    "pos_dxf": [
      708.1748653354698,
      946.941821782139
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F1IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F1IKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_780",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1410F"
    },
    "position": {
      "x": 3242.9778941341588,
      "y": 1634.1797031903407
    },
    "dwg_pos_img": [
      3242.9778941341588,
      1634.1797031903407
    ],
    "pos_dxf": [
      682.0797134929353,
      992.5658017913606
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F1KKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F1KKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_781",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1411D"
    },
    "position": {
      "x": 3613.708111009359,
      "y": 1631.7130280353977
    },
    "dwg_pos_img": [
      3613.708111009359,
      1631.7130280353977
    ],
    "pos_dxf": [
      744.9597502774698,
      993.03250413041
    ],
    "type": "002 Sirene_A01U1F1MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F1MKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/013 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_782",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1412B"
    },
    "position": {
      "x": 3471.1969243755098,
      "y": 2367.622440798901
    },
    "dwg_pos_img": [
      3471.1969243755098,
      2367.622440798901
    ],
    "pos_dxf": [
      720.7882415904771,
      868.2039078108928
    ],
    "type": "Präsenzmelder UP 360°_A01U1F1QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1F1QKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_783",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14149"
    },
    "position": {
      "x": 3618.5927562241573,
      "y": 2338.2546108905626
    },
    "dwg_pos_img": [
      3618.5927562241573,
      2338.2546108905626
    ],
    "pos_dxf": [
      745.7882413386753,
      873.2039077605327
    ],
    "type": "Präsenzmelder UP 360°_A01U1F1TKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1F1TKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_784",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14166"
    },
    "position": {
      "x": 3663.3779379037564,
      "y": 2402.7953751496443
    },
    "dwg_pos_img": [
      3663.3779379037564,
      2402.7953751496443
    ],
    "pos_dxf": [
      753.3843145564258,
      862.2636555548693
    ],
    "type": "Präsenzmelder UP 360°_A01U1F1YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1F1YKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_785",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14183"
    },
    "position": {
      "x": 3679.2300786575647,
      "y": 2304.5388947805804
    },
    "dwg_pos_img": [
      3679.2300786575647,
      2304.5388947805804
    ],
    "pos_dxf": [
      756.0730168750897,
      878.9299917968083
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F23KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F23KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_786",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1418F"
    },
    "position": {
      "x": 3383.866486995788,
      "y": 2420.1407828327256
    },
    "dwg_pos_img": [
      3383.866486995788,
      2420.1407828327256
    ],
    "pos_dxf": [
      705.9760119288903,
      859.2854226150453
    ],
    "type": "Auslass 230 V_A01U1F28KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1F28KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Urinal 21F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_787",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141A0"
    },
    "position": {
      "x": 3692.239824359826,
      "y": 2379.3108186162053
    },
    "dwg_pos_img": [
      3692.239824359826,
      2379.3108186162053
    ],
    "pos_dxf": [
      758.2796168528641,
      866.2503935715176
    ],
    "type": "002 Sirene_A01U1F2MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F2MKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/026 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_788",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141AE"
    },
    "position": {
      "x": 3430.1487981787127,
      "y": 2420.1765808167856
    },
    "dwg_pos_img": [
      3430.1487981787127,
      2420.1765808167856
    ],
    "pos_dxf": [
      713.8260152390744,
      859.2853879716677
    ],
    "type": "Auslass 230 V_A01U1F2UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1F2UKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Urinal 21F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_789",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141BF"
    },
    "position": {
      "x": 3693.2220701832625,
      "y": 2392.519145190411
    },
    "dwg_pos_img": [
      3693.2220701832625,
      2392.519145190411
    ],
    "pos_dxf": [
      758.4462168511864,
      864.0103935940792
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F34KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F34KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_790",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141CB"
    },
    "position": {
      "x": 3476.431089379186,
      "y": 2420.2122760033963
    },
    "dwg_pos_img": [
      3476.431089379186,
      2420.2122760033963
    ],
    "pos_dxf": [
      721.6760151600088,
      859.2853707600993
    ],
    "type": [
      "Auslass 400 V_A01U1GIBKH",
      "Auslass 230 V_A01U1F3EKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1GIBKH",
      "Auslass 230 V_A01U1F3EKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F02 Urinal ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_791",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141DC"
    },
    "position": {
      "x": 3692.436745191198,
      "y": 2305.531364560986
    },
    "dwg_pos_img": [
      3692.436745191198,
      2305.531364560986
    ],
    "pos_dxf": [
      758.3130168525277,
      878.7633917984863
    ],
    "type": "002 Sirene_A01U1F48KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F48KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/025 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_792",
    "source_ids": {
      "object_id": null,
      "dwg_id": "141F3"
    },
    "position": {
      "x": 3664.3028084670627,
      "y": 2249.989798022839
    },
    "dwg_pos_img": [
      3664.3028084670627,
      2249.989798022839
    ],
    "pos_dxf": [
      753.5411830618548,
      888.1795547109868
    ],
    "type": [
      "Auslass 400 V_A01U1F4HKH",
      "Schaltkreis_A01U1F4IKH",
      "Auslass 400 V_A01U1GD4KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1F4HKH",
      "Schaltkreis_A01U1F4IKH",
      "Auslass 400 V_A01U1GD4KH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE 24F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_793",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14202"
    },
    "position": {
      "x": 3242.977894133586,
      "y": 3442.9113079395906
    },
    "dwg_pos_img": [
      3242.977894133586,
      3442.9113079395906
    ],
    "pos_dxf": [
      682.0797134929348,
      685.8054821830851
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F4UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F4UKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_794",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14210"
    },
    "position": {
      "x": 3493.037846345372,
      "y": 3443.1036182049343
    },
    "dwg_pos_img": [
      3493.037846345372,
      3443.1036182049343
    ],
    "pos_dxf": [
      724.4927089211149,
      685.8054821830851
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F4WKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F4WKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_795",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1421E"
    },
    "position": {
      "x": 3430.399916252875,
      "y": 3443.055446089207
    },
    "dwg_pos_img": [
      3430.399916252875,
      3443.055446089207
    ],
    "pos_dxf": [
      713.8686077040047,
      685.8054821830851
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F4YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F4YKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_796",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1422C"
    },
    "position": {
      "x": 3243.1327044126715,
      "y": 3711.6842335686115
    },
    "dwg_pos_img": [
      3243.1327044126715,
      3711.6842335686115
    ],
    "pos_dxf": [
      682.1059710667871,
      640.2216974859582
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F50KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F50KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_797",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1423A"
    },
    "position": {
      "x": 3689.684774784467,
      "y": 3547.465159365956
    },
    "dwg_pos_img": [
      3689.684774784467,
      3547.465159365956
    ],
    "pos_dxf": [
      757.8462515539254,
      668.1314461519569
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F52KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F52KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F05 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_798",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14248"
    },
    "position": {
      "x": 3134.8494389832417,
      "y": 3610.7905177349567
    },
    "dwg_pos_img": [
      3134.8494389832417,
      3610.7905177349567
    ],
    "pos_dxf": [
      663.7399048455216,
      657.3191168450016
    ],
    "type": "002 Sirene_A01U1F54KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F54KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/041 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_799",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14256"
    },
    "position": {
      "x": 3178.174765495014,
      "y": 3690.9738621066117
    },
    "dwg_pos_img": [
      3178.174765495014,
      3690.9738621066117
    ],
    "pos_dxf": [
      671.088370119613,
      643.725697488663
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F56KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F56KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.03/04 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_800",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14264"
    },
    "position": {
      "x": 3538.6583947464983,
      "y": 3509.883301177516
    },
    "dwg_pos_img": [
      3538.6583947464983,
      3509.883301177516
    ],
    "pos_dxf": [
      732.2304697806794,
      674.4856190158494
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F58KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F58KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_801",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14270"
    },
    "position": {
      "x": 3132.9462640024117,
      "y": 3612.1652358317874
    },
    "dwg_pos_img": [
      3132.9462640024117,
      3612.1652358317874
    ],
    "pos_dxf": [
      663.4171048487729,
      657.0857168473526
    ],
    "type": "Taster_ UP_ 1S_A01U1F5AKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F5AKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_802",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14276"
    },
    "position": {
      "x": 3396.8305602049927,
      "y": 3711.8024359243614
    },
    "dwg_pos_img": [
      3396.8305602049927,
      3711.8024359243614
    ],
    "pos_dxf": [
      708.1748653354693,
      640.2216974859582
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F5BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F5BKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_803",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14284"
    },
    "position": {
      "x": 3435.3104372631265,
      "y": 3691.171614001026
    },
    "dwg_pos_img": [
      3435.3104372631265,
      3691.171614001026
    ],
    "pos_dxf": [
      714.7014875926832,
      643.725697488663
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F5DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F5DKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.23/24 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_804",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14292"
    },
    "position": {
      "x": 3614.6904719851323,
      "y": 3715.288384791819
    },
    "dwg_pos_img": [
      3614.6904719851323,
      3715.288384791819
    ],
    "pos_dxf": [
      745.1263698070411,
      639.6588974916269
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F5FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F5FKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_805",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1429E"
    },
    "position": {
      "x": 3139.694888436881,
      "y": 3711.6046840299473
    },
    "dwg_pos_img": [
      3139.694888436881,
      3711.6046840299473
    ],
    "pos_dxf": [
      664.5617478623992,
      640.2216974859582
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F5HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F5HKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_806",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142AC"
    },
    "position": {
      "x": 3401.741081215407,
      "y": 3442.7975563367736
    },
    "dwg_pos_img": [
      3401.741081215407,
      3442.7975563367736
    ],
    "pos_dxf": [
      709.0077452241478,
      685.8454821826817
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F5JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F5JKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.17/18 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_807",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142BA"
    },
    "position": {
      "x": 3531.971011647551,
      "y": 3691.2459514570787
    },
    "dwg_pos_img": [
      3531.971011647551,
      3691.2459514570787
    ],
    "pos_dxf": [
      731.0962139900541,
      643.725697488663
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F5LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F5LKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.21/22 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_808",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142C8"
    },
    "position": {
      "x": 3552.0537279448595,
      "y": 3642.912482281851
    },
    "dwg_pos_img": [
      3552.0537279448595,
      3642.912482281851
    ],
    "pos_dxf": [
      734.5024697577956,
      651.9256583055749
    ],
    "type": "Taster_ UP_ 1S_A01U1F5NKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F5NKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_809",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142CE"
    },
    "position": {
      "x": 3614.6902882010313,
      "y": 3469.9254221764786
    },
    "dwg_pos_img": [
      3614.6902882010313,
      3469.9254221764786
    ],
    "pos_dxf": [
      745.1263386351663,
      681.2723798849929
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F5OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F5OKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_810",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142DA"
    },
    "position": {
      "x": 3538.6583947464565,
      "y": 3640.543685659917
    },
    "dwg_pos_img": [
      3538.6583947464565,
      3640.543685659917
    ],
    "pos_dxf": [
      732.2304697806794,
      652.3256583015464
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F5QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F5QKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_811",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142E6"
    },
    "position": {
      "x": 3613.708226161694,
      "y": 3712.299416411591
    },
    "dwg_pos_img": [
      3613.708226161694,
      3712.299416411591
    ],
    "pos_dxf": [
      744.9597698087191,
      640.1656974865223
    ],
    "type": "002 Sirene_A01U1F5SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F5SKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/039 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_812",
    "source_ids": {
      "object_id": null,
      "dwg_id": "142F4"
    },
    "position": {
      "x": 3177.355029765587,
      "y": 3442.8608402403547
    },
    "dwg_pos_img": [
      3177.355029765587,
      3442.8608402403547
    ],
    "pos_dxf": [
      670.9493336707922,
      685.8054821830851
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F5UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F5UKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_813",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14302"
    },
    "position": {
      "x": 3305.502497896837,
      "y": 3691.071784344008
    },
    "dwg_pos_img": [
      3305.502497896837,
      3691.071784344008
    ],
    "pos_dxf": [
      692.6845932831898,
      643.725697488663
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F5WKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F5WKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.01/02 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_814",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14310"
    },
    "position": {
      "x": 3685.203941272251,
      "y": 3508.979200476154
    },
    "dwg_pos_img": [
      3685.203941272251,
      3508.979200476154
    ],
    "pos_dxf": [
      757.0862515235824,
      674.6580684091709
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F5YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F5YKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.05/06 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_815",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1431E"
    },
    "position": {
      "x": 3479.6477180621955,
      "y": 3711.866127009086
    },
    "dwg_pos_img": [
      3479.6477180621955,
      3711.866127009086
    ],
    "pos_dxf": [
      722.2215917564897,
      640.2216974859582
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F60KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F60KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_816",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1432C"
    },
    "position": {
      "x": 3552.0537279449013,
      "y": 3512.252097799447
    },
    "dwg_pos_img": [
      3552.0537279449013,
      3512.252097799447
    ],
    "pos_dxf": [
      734.5024697577956,
      674.0856190198783
    ],
    "type": "Taster_ UP_ 1S_A01U1F62KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F62KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_817",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14332"
    },
    "position": {
      "x": 3689.647808670888,
      "y": 3666.1310888292087
    },
    "dwg_pos_img": [
      3689.647808670888,
      3666.1310888292087
    ],
    "pos_dxf": [
      757.8399816830774,
      648.005736470057
    ],
    "type": "3xUP-SD_ SchuKo_A01U1F63KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1F63KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F05 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_818",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14340"
    },
    "position": {
      "x": 3148.6961947281193,
      "y": 3442.602950487921
    },
    "dwg_pos_img": [
      3148.6961947281193,
      3442.602950487921
    ],
    "pos_dxf": [
      666.0884711909353,
      685.8454821826817
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F65KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F65KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.13/14 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_819",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1434E"
    },
    "position": {
      "x": 3685.1669751586746,
      "y": 3627.64512993941
    },
    "dwg_pos_img": [
      3685.1669751586746,
      3627.64512993941
    ],
    "pos_dxf": [
      757.0799816527347,
      654.5323587272705
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F67KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F67KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.07/08 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_820",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1435C"
    },
    "position": {
      "x": 3612.3321386755547,
      "y": 3714.2016634679926
    },
    "dwg_pos_img": [
      3612.3321386755547,
      3714.2016634679926
    ],
    "pos_dxf": [
      744.7263698110698,
      639.8428974897736
    ],
    "type": "Taster_ UP_ 1S_A01U1F69KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1F69KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_821",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14362"
    },
    "position": {
      "x": 3613.708042377602,
      "y": 3440.207631637847
    },
    "dwg_pos_img": [
      3613.708042377602,
      3440.207631637847
    ],
    "pos_dxf": [
      744.9597386368443,
      686.3123798342294
    ],
    "type": "002 Sirene_A01U1F6AKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1F6AKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/040 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_822",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14376"
    },
    "position": {
      "x": 3271.933141849112,
      "y": 3442.6977266797558
    },
    "dwg_pos_img": [
      3271.933141849112,
      3442.6977266797558
    ],
    "pos_dxf": [
      686.9908509146533,
      685.8454821826817
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F6DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F6DKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.15/16 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_823",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14384"
    },
    "position": {
      "x": 3499.3174633929852,
      "y": 3442.8725981008856
    },
    "dwg_pos_img": [
      3499.3174633929852,
      3442.8725981008856
    ],
    "pos_dxf": [
      725.5578029786614,
      685.8454821826817
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1F6FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1F6FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.19/20 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_824",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14392"
    },
    "position": {
      "x": 3131.8614306800073,
      "y": 3609.805906681463
    },
    "dwg_pos_img": [
      3131.8614306800073,
      3609.805906681463
    ],
    "pos_dxf": [
      663.2331048506262,
      657.4857168433236
    ],
    "type": "1xUP-SD_ SchuKo_A01U1F6HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1F6HKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_825",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1439E"
    },
    "position": {
      "x": 4264.7604551754175,
      "y": 4653.346184315886
    },
    "dwg_pos_img": [
      4264.7604551754175,
      4653.346184315886
    ],
    "pos_dxf": [
      855.3855895708994,
      480.6493751892031
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F8JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F8JKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 14F03 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_826",
    "source_ids": {
      "object_id": null,
      "dwg_id": "143B5"
    },
    "position": {
      "x": 4264.760455175436,
      "y": 4594.761151956787
    },
    "dwg_pos_img": [
      4264.760455175436,
      4594.761151956787
    ],
    "pos_dxf": [
      855.3855895708994,
      490.5853785207917
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1F9AKH",
      "1xAP-SD_ SchuKo_A01U1F8MKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1F9AKH",
      "1xAP-SD_ SchuKo_A01U1F8MKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 14F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_827",
    "source_ids": {
      "object_id": null,
      "dwg_id": "143CC"
    },
    "position": {
      "x": 4264.760455175427,
      "y": 4624.053668136337
    },
    "dwg_pos_img": [
      4264.760455175427,
      4624.053668136337
    ],
    "pos_dxf": [
      855.3855895708994,
      485.6173768549972
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F8PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F8PKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 14F02 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_828",
    "source_ids": {
      "object_id": null,
      "dwg_id": "143E3"
    },
    "position": {
      "x": 4264.760455175455,
      "y": 4536.176119597689
    },
    "dwg_pos_img": [
      4264.760455175455,
      4536.176119597689
    ],
    "pos_dxf": [
      855.3855895708994,
      500.5213818523803
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F8SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F8SKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 13F04 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_829",
    "source_ids": {
      "object_id": null,
      "dwg_id": "143FA"
    },
    "position": {
      "x": 4264.760455175464,
      "y": 4506.88360341814
    },
    "dwg_pos_img": [
      4264.760455175464,
      4506.88360341814
    ],
    "pos_dxf": [
      855.3855895708994,
      505.4893835181745
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F8VKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F8VKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 13F03 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_830",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14411"
    },
    "position": {
      "x": 4264.760455175473,
      "y": 4477.591087238591
    },
    "dwg_pos_img": [
      4264.760455175473,
      4477.591087238591
    ],
    "pos_dxf": [
      855.3855895708994,
      510.4573851839689
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F8YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F8YKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 13F02 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_831",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14428"
    },
    "position": {
      "x": 4264.760455175482,
      "y": 4448.298571059042
    },
    "dwg_pos_img": [
      4264.760455175482,
      4448.298571059042
    ],
    "pos_dxf": [
      855.3855895708994,
      515.4253868497631
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F91KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F91KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 13F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_832",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1443F"
    },
    "position": {
      "x": 4264.760455175491,
      "y": 4419.006054879493
    },
    "dwg_pos_img": [
      4264.760455175491,
      4419.006054879493
    ],
    "pos_dxf": [
      855.3855895708994,
      520.3933885155575
    ],
    "type": "AP-SD_ Drehstrom_A01U1F94KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "AP-SD_ Drehstrom_A01U1F94KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "15F01 Staplerladestation ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[H1,H2],[34-33]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_833",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14459"
    },
    "position": {
      "x": 4264.760455175408,
      "y": 4682.638700495436
    },
    "dwg_pos_img": [
      4264.760455175408,
      4682.638700495436
    ],
    "pos_dxf": [
      855.3855895708994,
      475.6813735234086
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F97KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F97KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Staplerladestation 14F04 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_834",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14480"
    },
    "position": {
      "x": 4278.351247038546,
      "y": 4562.801813849619
    },
    "dwg_pos_img": [
      4278.351247038546,
      4562.801813849619
    ],
    "pos_dxf": [
      857.6907415476812,
      496.0074450300126
    ],
    "type": "Schaltkreis_A01U1F9BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1F9BKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 15F02 Staplerladestation ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_835",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1448F"
    },
    "position": {
      "x": 4556.372637253026,
      "y": 5023.875644496463
    },
    "dwg_pos_img": [
      4556.372637253026,
      5023.875644496463
    ],
    "pos_dxf": [
      904.8463130328837,
      417.8457290682261
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F9EKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F9EKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_836",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144A1"
    },
    "position": {
      "x": 4554.014303943448,
      "y": 5026.845419303918
    },
    "dwg_pos_img": [
      4554.014303943448,
      5026.845419303918
    ],
    "pos_dxf": [
      904.4463130369127,
      417.3417485796858
    ],
    "type": "Taster_ AP_ 1S_A01U1F9GKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1F9GKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_837",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144B2"
    },
    "position": {
      "x": 1240.889715598637,
      "y": 4916.844010334396
    },
    "dwg_pos_img": [
      1240.889715598637,
      4916.844010334396
    ],
    "pos_dxf": [
      342.5029199603234,
      435.5658167555068
    ],
    "type": "1xAP-SD_ SchuKo_A01U1F9HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1F9HKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_838",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144C4"
    },
    "position": {
      "x": 1237.9182156285688,
      "y": 4919.20021993469
    },
    "dwg_pos_img": [
      1237.9182156285688,
      4919.20021993469
    ],
    "pos_dxf": [
      341.9989199653999,
      435.1658167595356
    ],
    "type": "Taster_ AP_ 1S_A01U1F9JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1F9JKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_839",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144D5"
    },
    "position": {
      "x": 1315.7335139494094,
      "y": 4865.9558457730245
    },
    "dwg_pos_img": [
      1315.7335139494094,
      4865.9558457730245
    ],
    "pos_dxf": [
      355.1972744509208,
      444.206195702855
    ],
    "type": "Ansaugstutzen RAS_A01U1F9KKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Ansaugstutzen RAS_A01U1F9KKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_840",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144E1"
    },
    "position": {
      "x": 1223.7839916071366,
      "y": 4860.441362884054
    },
    "dwg_pos_img": [
      1223.7839916071366,
      4860.441362884054
    ],
    "pos_dxf": [
      339.6015957497457,
      445.1294571531246
    ],
    "type": "Elektroschloss_A01U1F9LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1F9LKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G,G1],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_841",
    "source_ids": {
      "object_id": null,
      "dwg_id": "144F1"
    },
    "position": {
      "x": 4698.64319359998,
      "y": 4786.719843256218
    },
    "dwg_pos_img": [
      4698.64319359998,
      4786.719843256218
    ],
    "pos_dxf": [
      928.9770081023375,
      458.0858360599329
    ],
    "type": "Elektroschloss_A01U1F9MKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1F9MKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_842",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14501"
    },
    "position": {
      "x": 4607.347012073426,
      "y": 4915.756129854915
    },
    "dwg_pos_img": [
      4607.347012073426,
      4915.756129854915
    ],
    "pos_dxf": [
      913.492143391115,
      436.1894139211008
    ],
    "type": "Mulitnsensormelder mit integr. Sirene_A01U1F9NKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Mulitnsensormelder mit integr. Sirene_A01U1F9NKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/034 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_843",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14519"
    },
    "position": {
      "x": 1293.6407290670181,
      "y": 4753.900570492331
    },
    "dwg_pos_img": [
      1293.6407290670181,
      4753.900570492331
    ],
    "pos_dxf": [
      351.4500883224498,
      463.2078540616251
    ],
    "type": [
      "Ableitung_A01U1FADKH",
      "Rauchansaugsystem_A01U1F9QKH",
      "Ableitung_A01U1FAEKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Ableitung_A01U1FADKH",
      "Rauchansaugsystem_A01U1F9QKH",
      "Ableitung_A01U1FAEKH"
    ],
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "RAS 03/018 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_844",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14527"
    },
    "position": {
      "x": 1273.0623091960206,
      "y": 4767.104329775103
    },
    "dwg_pos_img": [
      1273.0623091960206,
      4767.104329775103
    ],
    "pos_dxf": [
      347.9597556234801,
      460.9658164996761
    ],
    "type": "Netzteil inkl. Akku_A01U1F9SKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Netzteil inkl. Akku_A01U1F9SKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_845",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14554"
    },
    "position": {
      "x": 1254.7687276966094,
      "y": 4767.090260974877
    },
    "dwg_pos_img": [
      1254.7687276966094,
      4767.090260974877
    ],
    "pos_dxf": [
      344.8569573479592,
      460.9658164996761
    ],
    "type": "Auslass 230 V_A01U1F9TKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1F9TKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "RAS 22F02 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_846",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14565"
    },
    "position": {
      "x": 1496.4351680753389,
      "y": 4869.819498611245
    },
    "dwg_pos_img": [
      1496.4351680753389,
      4869.819498611245
    ],
    "pos_dxf": [
      385.8463182602895,
      443.574490614938
    ],
    "type": "Ansaugstutzen RAS_A01U1FABKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Ansaugstutzen RAS_A01U1FABKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_847",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14571"
    },
    "position": {
      "x": 1606.2135844580234,
      "y": 4866.179141700626
    },
    "dwg_pos_img": [
      1606.2135844580234,
      4866.179141700626
    ],
    "pos_dxf": [
      404.4659789895222,
      444.2062126115875
    ],
    "type": "Elektroschloss_A01U1FACKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1FACKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G2,G3],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_848",
    "source_ids": {
      "object_id": null,
      "dwg_id": "145BF"
    },
    "position": {
      "x": 1309.7445569012184,
      "y": 4849.441775961445
    },
    "dwg_pos_img": [
      1309.7445569012184,
      4849.441775961445
    ],
    "pos_dxf": [
      354.1814796158903,
      447.0061956746533
    ],
    "type": "Leitung_A01U1FAFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Leitung_A01U1FAFKH",
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_849",
    "source_ids": {
      "object_id": null,
      "dwg_id": "145C6"
    },
    "position": {
      "x": 1316.3687855091612,
      "y": 4853.171553400605
    },
    "dwg_pos_img": [
      1316.3687855091612,
      4853.171553400605
    ],
    "pos_dxf": [
      355.3050236907368,
      446.3744905867361
    ],
    "type": "Leitung_A01U1FAGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Leitung_A01U1FAGKH",
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_850",
    "source_ids": {
      "object_id": null,
      "dwg_id": "145CC"
    },
    "position": {
      "x": 1586.0529853626736,
      "y": 4919.467955289155
    },
    "dwg_pos_img": [
      1586.0529853626736,
      4919.467955289155
    ],
    "pos_dxf": [
      401.0465134185797,
      435.1658167595356
    ],
    "type": "Taster_ AP_ 1S_A01U1FANKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1FANKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_851",
    "source_ids": {
      "object_id": null,
      "dwg_id": "145DD"
    },
    "position": {
      "x": 1572.8463188290361,
      "y": 4917.099303762572
    },
    "dwg_pos_img": [
      1572.8463188290361,
      4917.099303762572
    ],
    "pos_dxf": [
      398.8065134411411,
      435.5658167555068
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FAOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FAOKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_852",
    "source_ids": {
      "object_id": null,
      "dwg_id": "145F8"
    },
    "position": {
      "x": 1578.6943201338986,
      "y": 4860.9128977359915
    },
    "dwg_pos_img": [
      1578.6943201338986,
      4860.9128977359915
    ],
    "pos_dxf": [
      399.79840058825334,
      445.0957765696194
    ],
    "type": [
      "Auslass 400 V_A01U1FAQKH",
      "Schaltkreis_A01U1FARKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1FAQKH",
      "Schaltkreis_A01U1FARKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 24F02 VENT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_853",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14607"
    },
    "position": {
      "x": 4069.376808969358,
      "y": 4639.64999498615
    },
    "dwg_pos_img": [
      4069.376808969358,
      4639.64999498615
    ],
    "pos_dxf": [
      822.2463138892799,
      482.9467604206391
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FAUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FAUKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_854",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14619"
    },
    "position": {
      "x": 4066.405308999289,
      "y": 4642.006204586443
    },
    "dwg_pos_img": [
      4066.405308999289,
      4642.006204586443
    ],
    "pos_dxf": [
      821.7423138943564,
      482.546760424668
    ],
    "type": "Taster_ AP_ 1S_A01U1FAWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1FAWKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_855",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1462A"
    },
    "position": {
      "x": 4069.4613803849784,
      "y": 4554.695491827761
    },
    "dwg_pos_img": [
      4069.4613803849784,
      4554.695491827761
    ],
    "pos_dxf": [
      822.2606581576492,
      497.3550288582319
    ],
    "type": "Geräteanschluß 230 V_A01U1FB1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 230 V_A01U1FB1KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sprinklerzentrale 22F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_856",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1463B"
    },
    "position": {
      "x": 4072.4062522419213,
      "y": 4561.6859662300885
    },
    "dwg_pos_img": [
      4072.4062522419213,
      4561.6859662300885
    ],
    "pos_dxf": [
      822.7601417234919,
      496.1698306709054
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FB4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FB4KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Sprinklerzentrale 03/024 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_857",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1464E"
    },
    "position": {
      "x": 4069.376808969358,
      "y": 4639.64999498615
    },
    "dwg_pos_img": [
      4069.376808969358,
      4639.64999498615
    ],
    "pos_dxf": [
      822.2463138892799,
      482.9467604206391
    ],
    "type": "Druckknopfmelder_A01U1FB7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1FB7KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/023 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_858",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1465E"
    },
    "position": {
      "x": 4145.0521266181795,
      "y": 4562.825976553012
    },
    "dwg_pos_img": [
      4145.0521266181795,
      4562.825976553012
    ],
    "pos_dxf": [
      835.0817034551637,
      495.9859606032007
    ],
    "type": "Mulitnsensormelder mit integr. Sirene_A01U1FB9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Mulitnsensormelder mit integr. Sirene_A01U1FB9KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/025 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_859",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14676"
    },
    "position": {
      "x": 4656.5628040458205,
      "y": 4793.094418240262
    },
    "dwg_pos_img": [
      4656.5628040458205,
      4793.094418240262
    ],
    "pos_dxf": [
      921.8396982132876,
      456.999221498668
    ],
    "type": "002 Sirene_A01U1FBBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1FBBKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/035 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_860",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14684"
    },
    "position": {
      "x": 4654.774344462315,
      "y": 4809.445799004092
    },
    "dwg_pos_img": [
      4654.774344462315,
      4809.445799004092
    ],
    "pos_dxf": [
      921.5363552450613,
      454.2257991167544
    ],
    "type": "Taster_ AP_ 1S_A01U1FBGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1FBGKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_861",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14695"
    },
    "position": {
      "x": 4657.1326777718905,
      "y": 4822.655068853248
    },
    "dwg_pos_img": [
      4657.1326777718905,
      4822.655068853248
    ],
    "pos_dxf": [
      921.9363552410327,
      451.9858186456993
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FBHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FBHKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_862",
    "source_ids": {
      "object_id": null,
      "dwg_id": "146A7"
    },
    "position": {
      "x": 4556.372637253026,
      "y": 5023.875529482198
    },
    "dwg_pos_img": [
      4556.372637253026,
      5023.875529482198
    ],
    "pos_dxf": [
      904.8463130328837,
      417.8457485746098
    ],
    "type": "Druckknopfmelder_A01U1FBJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1FBJKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "03/032 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_863",
    "source_ids": {
      "object_id": null,
      "dwg_id": "146FB"
    },
    "position": {
      "x": 4608.157729051584,
      "y": 4942.194339122278
    },
    "dwg_pos_img": [
      4608.157729051584,
      4942.194339122278
    ],
    "pos_dxf": [
      913.6296501577299,
      431.7056075662622
    ],
    "type": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1FBLKH",
      "Schaltkreis_A01U1FBMKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1FBLKH",
      "Schaltkreis_A01U1FBMKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Brandmelder-ZWD",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "ZWB 03/033 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_864",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14705"
    },
    "position": {
      "x": 4549.491491715485,
      "y": 4963.728330637774
    },
    "dwg_pos_img": [
      4549.491491715485,
      4963.728330637774
    ],
    "pos_dxf": [
      903.6791929417063,
      428.0457973379964
    ],
    "type": "RJ-45-Datendose 2-fach_ AP_A01U1FBRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ AP_A01U1FBRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 14.18/19 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_865",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14714"
    },
    "position": {
      "x": 1116.908588795502,
      "y": 304.28744976713733
    },
    "dwg_pos_img": [
      1116.908588795502,
      304.28744976713733
    ],
    "pos_dxf": [
      321.4743189475146,
      1217.837808839251
    ],
    "type": "Elektroschloss_A01U1FBTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Elektroschloss_A01U1FBTKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_866",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14724"
    },
    "position": {
      "x": 1150.9393384527043,
      "y": 346.7192438353268
    },
    "dwg_pos_img": [
      1150.9393384527043,
      346.7192438353268
    ],
    "pos_dxf": [
      327.2463188893789,
      1210.64582840644
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FBUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FBUKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_867",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14736"
    },
    "position": {
      "x": 1150.9393384527134,
      "y": 317.00232371362654
    },
    "dwg_pos_img": [
      1150.9393384527134,
      317.00232371362654
    ],
    "pos_dxf": [
      327.2463188893789,
      1215.685808849293
    ],
    "type": "Druckknopfmelder_A01U1FBWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1FBWKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/001 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_868",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14746"
    },
    "position": {
      "x": 1148.5810051431308,
      "y": 333.50997398617073
    },
    "dwg_pos_img": [
      1148.5810051431308,
      333.50997398617073
    ],
    "pos_dxf": [
      326.8463188934079,
      1212.885808877495
    ],
    "type": "Taster_ AP_ 1S_A01U1FBYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1FBYKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_869",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14757"
    },
    "position": {
      "x": 1216.7298722946716,
      "y": 435.9197197061658
    },
    "dwg_pos_img": [
      1216.7298722946716,
      435.9197197061658
    ],
    "pos_dxf": [
      338.4051373502207,
      1195.526036519091
    ],
    "type": "Mulitnsensormelder mit integr. Sirene_A01U1FBZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Mulitnsensormelder mit integr. Sirene_A01U1FBZKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "04/003 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_870",
    "source_ids": {
      "object_id": null,
      "dwg_id": "147B3"
    },
    "position": {
      "x": 1172.5121127684029,
      "y": 436.3770259584235
    },
    "dwg_pos_img": [
      1172.5121127684029,
      436.3770259584235
    ],
    "pos_dxf": [
      330.9053053457594,
      1195.442710119931
    ],
    "type": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1FC4KH",
      "Schaltkreis_A01U1FC5KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "069 Multisensormelder (Kombination RMO WMD)_A01U1FC4KH",
      "Schaltkreis_A01U1FC5KH"
    ],
    "dwg_layer": "ADE_ET_BMA_Brandmelder-ZWD",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "ZWB 04/002 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_871",
    "source_ids": {
      "object_id": null,
      "dwg_id": "147CD"
    },
    "position": {
      "x": 874.3657100104916,
      "y": 2370.4725997100404
    },
    "dwg_pos_img": [
      874.3657100104916,
      2370.4725997100404
    ],
    "pos_dxf": [
      280.33630417133736,
      867.3818124592044
    ],
    "type": "Schaltkreis_A01U1FC8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FC8KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F02 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_872",
    "source_ids": {
      "object_id": null,
      "dwg_id": "147E7"
    },
    "position": {
      "x": 900.2287653055349,
      "y": 2370.4924898643103
    },
    "dwg_pos_img": [
      900.2287653055349,
      2370.4924898643103
    ],
    "pos_dxf": [
      284.72297079382156,
      867.3818124592044
    ],
    "type": "Schaltkreis_A01U1FCBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FCBKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F03 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_873",
    "source_ids": {
      "object_id": null,
      "dwg_id": "147F1"
    },
    "position": {
      "x": 864.6376738352818,
      "y": 2336.361282965391
    },
    "dwg_pos_img": [
      864.6376738352818,
      2336.361282965391
    ],
    "pos_dxf": [
      278.6863192370231,
      873.1658123624629
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FCDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FCDKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.03/04 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_874",
    "source_ids": {
      "object_id": null,
      "dwg_id": "147FF"
    },
    "position": {
      "x": 890.5007291303237,
      "y": 2336.381173119662
    },
    "dwg_pos_img": [
      890.5007291303237,
      2336.381173119662
    ],
    "pos_dxf": [
      283.07298585950707,
      873.1658123624629
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FCFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FCFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.05/06 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_875",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1480D"
    },
    "position": {
      "x": 871.5127766665222,
      "y": 2356.225096963195
    },
    "dwg_pos_img": [
      871.5127766665222,
      2356.225096963195
    ],
    "pos_dxf": [
      279.8524144168821,
      869.7978123963849
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FCHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FCHKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Prüfstand 6206 11F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F1,G],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_876",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14824"
    },
    "position": {
      "x": 890.3540414053358,
      "y": 2356.23958696285
    },
    "dwg_pos_img": [
      890.3540414053358,
      2356.23958696285
    ],
    "pos_dxf": [
      283.0481059626904,
      869.7978123963849
    ],
    "type": "1xAP-SD_ SchuKo_A01U1FCKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1FCKKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Prüfstand 6206 11F02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G,G1],[39-38]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_877",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1483B"
    },
    "position": {
      "x": 864.6364943861405,
      "y": 2984.947366234438
    },
    "dwg_pos_img": [
      864.6364943861405,
      2984.947366234438
    ],
    "pos_dxf": [
      278.6861191891469,
      763.1658134942363
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FCNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FCNKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.13/14 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_878",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14849"
    },
    "position": {
      "x": 890.4995496811838,
      "y": 2984.967256388709
    },
    "dwg_pos_img": [
      890.4995496811838,
      2984.967256388709
    ],
    "pos_dxf": [
      283.0727858116311,
      763.1658134942363
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FCPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FCPKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.15/16 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_879",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14867"
    },
    "position": {
      "x": 876.7694274863969,
      "y": 2949.8083316103075
    },
    "dwg_pos_img": [
      876.7694274863969,
      2949.8083316103075
    ],
    "pos_dxf": [
      280.7440018351265,
      769.1269653961967
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1FCRKH",
      "Schaltkreis_A01U1FCSKH",
      "AP-SD_ Drehstrom_A01U1FCVKH",
      "AP-SD_ Drehstrom_A01U1FD1KH",
      "AP-SD_ Drehstrom_A01U1FD4KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1FCRKH",
      "Schaltkreis_A01U1FCSKH",
      "AP-SD_ Drehstrom_A01U1FCVKH",
      "AP-SD_ Drehstrom_A01U1FD1KH",
      "AP-SD_ Drehstrom_A01U1FD4KH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Prüfstand APL 3333 14F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_880",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14886"
    },
    "position": {
      "x": 898.6704828213489,
      "y": 2949.8251747622216
    },
    "dwg_pos_img": [
      898.6704828213489,
      2949.8251747622216
    ],
    "pos_dxf": [
      284.4586684643791,
      769.1269653961967
    ],
    "type": "Schaltkreis_A01U1FCWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FCWKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A Prüfstand APL 3333 14F02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_881",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14895"
    },
    "position": {
      "x": 877.5701190464532,
      "y": 2966.0893541078112
    },
    "dwg_pos_img": [
      877.5701190464532,
      2966.0893541078112
    ],
    "pos_dxf": [
      280.87980817746916,
      766.3658134620055
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FCZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FCZKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.11/12 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_882",
    "source_ids": {
      "object_id": null,
      "dwg_id": "148B3"
    },
    "position": {
      "x": 898.3242744918413,
      "y": 2930.006759285924
    },
    "dwg_pos_img": [
      898.3242744918413,
      2930.006759285924
    ],
    "pos_dxf": [
      284.3999476169704,
      772.488117362343
    ],
    "type": "Schaltkreis_A01U1FD2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FD2KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A 15F02 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G,G1],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_883",
    "source_ids": {
      "object_id": null,
      "dwg_id": "148CD"
    },
    "position": {
      "x": 876.4232191568896,
      "y": 2929.98991613401
    },
    "dwg_pos_img": [
      876.4232191568896,
      2929.98991613401
    ],
    "pos_dxf": [
      280.68528098771776,
      772.488117362343
    ],
    "type": "Schaltkreis_A01U1FD5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FD5KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A 15F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_884",
    "source_ids": {
      "object_id": null,
      "dwg_id": "148D7"
    },
    "position": {
      "x": 627.6204127392904,
      "y": 1535.6082117257856
    },
    "dwg_pos_img": [
      627.6204127392904,
      1535.6082117257856
    ],
    "pos_dxf": [
      238.4855117012335,
      1008.942370497324
    ],
    "type": "Polygon_A01U1FD7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygon_A01U1FD7KH",
    "dwg_layer": "ADE_ET_Allg_TXT",
    "dwg_rgb": [
      255,
      255,
      255
    ],
    "dwg_txt": "an bauseitiger Stahlunterkonstruktion",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_885",
    "source_ids": {
      "object_id": null,
      "dwg_id": "148E7"
    },
    "position": {
      "x": 4240.505526792829,
      "y": 4527.200276617492
    },
    "dwg_pos_img": [
      4240.505526792829,
      4527.200276617492
    ],
    "pos_dxf": [
      851.2716794565281,
      502.0405184268875
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FD8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FD8KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Alarm BT5.1 03/026 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_886",
    "source_ids": {
      "object_id": null,
      "dwg_id": "148FA"
    },
    "position": {
      "x": 4241.71248986958,
      "y": 4621.54099892288
    },
    "dwg_pos_img": [
      4241.71248986958,
      4621.54099892288
    ],
    "pos_dxf": [
      851.4763940419894,
      486.0405185880413
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FDBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FDBKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Alarm BT5.1 03/028 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_887",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1490D"
    },
    "position": {
      "x": 4241.821300905175,
      "y": 4668.208620242452
    },
    "dwg_pos_img": [
      4241.821300905175,
      4668.208620242452
    ],
    "pos_dxf": [
      851.4948496240008,
      478.12571866776034
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FDEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FDEKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Alarm BT5.1 03/029 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_888",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14920"
    },
    "position": {
      "x": 4241.780705901852,
      "y": 4726.155744719588
    },
    "dwg_pos_img": [
      4241.780705901852,
      4726.155744719588
    ],
    "pos_dxf": [
      851.4879642524156,
      468.2978990203758
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FDHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FDHKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/030 Alarm BT5.1 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_889",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14933"
    },
    "position": {
      "x": 4241.712489869596,
      "y": 4573.868742478179
    },
    "dwg_pos_img": [
      4241.712489869596,
      4573.868742478179
    ],
    "pos_dxf": [
      851.4763940419894,
      494.12571850660606
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FDKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FDKKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Alarm BT5.1 03/027 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_890",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14946"
    },
    "position": {
      "x": 1301.354874540525,
      "y": 427.7328392643931
    },
    "dwg_pos_img": [
      1301.354874540525,
      427.7328392643931
    ],
    "pos_dxf": [
      352.7584946216127,
      1196.925566693328
    ],
    "type": "Leitung_A01U1FDNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Leitung_A01U1FDNKH",
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_891",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1494F"
    },
    "position": {
      "x": 984.8649107377106,
      "y": 427.48944055788616
    },
    "dwg_pos_img": [
      984.8649107377106,
      427.48944055788616
    ],
    "pos_dxf": [
      299.0782180755111,
      1196.925566693328
    ],
    "type": "Leitung_A01U1FDOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Leitung_A01U1FDOKH",
    "dwg_layer": "ADE_ET_BMA_RAS",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_892",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1499F"
    },
    "position": {
      "x": 3360.697649297957,
      "y": 1592.43048259831
    },
    "dwg_pos_img": [
      3360.697649297957,
      1592.43048259831
    ],
    "pos_dxf": [
      702.0463150755006,
      999.6618110606305
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FF9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FF9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 2t 1,5 m ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_893",
    "source_ids": {
      "object_id": null,
      "dwg_id": "149B3"
    },
    "position": {
      "x": 1591.9482428792485,
      "y": 1627.0136755464182
    },
    "dwg_pos_img": [
      1591.9482428792485,
      1627.0136755464182
    ],
    "pos_dxf": [
      402.0464157533711,
      993.5658111442499
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Leichtkran 1t 1,5 m ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G1,G2],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_894",
    "source_ids": {
      "object_id": null,
      "dwg_id": "149C7"
    },
    "position": {
      "x": 1591.9470913489886,
      "y": 2652.3928965427604
    },
    "dwg_pos_img": [
      1591.9470913489886,
      2652.3928965427604
    ],
    "pos_dxf": [
      402.046220440873,
      819.6618128958235
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Leichtkran 1t 1,5 m ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_895",
    "source_ids": {
      "object_id": null,
      "dwg_id": "149DB"
    },
    "position": {
      "x": 1946.8762544405108,
      "y": 2652.667008832159
    },
    "dwg_pos_img": [
      1946.8762544405108,
      2652.667008832159
    ],
    "pos_dxf": [
      462.2462198345343,
      819.6616175743657
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFOKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Leichtkran 1t 1,5 m ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_896",
    "source_ids": {
      "object_id": null,
      "dwg_id": "149EF"
    },
    "position": {
      "x": 3360.6970735326518,
      "y": 2653.7531654518407
    },
    "dwg_pos_img": [
      3360.6970735326518,
      2653.7531654518407
    ],
    "pos_dxf": [
      702.0462174192512,
      819.6618128958235
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFRKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "1,5 m Brückenkran 5t ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_897",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A03"
    },
    "position": {
      "x": 3714.448221499321,
      "y": 2654.025220119249
    },
    "dwg_pos_img": [
      3714.448221499321,
      2654.025220119249
    ],
    "pos_dxf": [
      762.0464121274249,
      819.6618128958235
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFUKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "1,5 m Brückenkran 5t ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_898",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A17"
    },
    "position": {
      "x": 1945.6976635503547,
      "y": 3713.9876341947165
    },
    "dwg_pos_img": [
      1945.6976635503547,
      3713.9876341947165
    ],
    "pos_dxf": [
      462.0463174927977,
      639.6618147087959
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FFXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FFXKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Leichtkran 1t 1,5 m ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G2,G3],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_899",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A2B"
    },
    "position": {
      "x": 3006.9470770955845,
      "y": 3714.803795097369
    },
    "dwg_pos_img": [
      3006.9470770955845,
      3714.803795097369
    ],
    "pos_dxf": [
      642.0462180235756,
      639.6618147087959
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FG0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FG0KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 5t 1,5 m ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G5,G6],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_900",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A3F"
    },
    "position": {
      "x": 3006.9470770955713,
      "y": 3755.5114163293524
    },
    "dwg_pos_img": [
      3006.9470770955713,
      3755.5114163293524
    ],
    "pos_dxf": [
      642.0462180235756,
      632.7578147638471
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FG3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FG3KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 10t 1,5 m ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G5,G6],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_901",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A53"
    },
    "position": {
      "x": 4068.1970664057803,
      "y": 3715.619956442817
    },
    "dwg_pos_img": [
      4068.1970664057803,
      3715.619956442817
    ],
    "pos_dxf": [
      822.0462162106023,
      639.6618147087959
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FG6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FG6KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 5t 1,5 m ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H,H1],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_902",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A67"
    },
    "position": {
      "x": 4068.1976421707373,
      "y": 3752.7426659098737
    },
    "dwg_pos_img": [
      4068.1976421707373,
      3752.7426659098737
    ],
    "pos_dxf": [
      822.0463138668515,
      633.3658147632507
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FG9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FG9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 5t 1,5 m ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H,H1],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_903",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A7B"
    },
    "position": {
      "x": 6190.697620790815,
      "y": 4754.989958054403
    },
    "dwg_pos_img": [
      6190.697620790815,
      4754.989958054403
    ],
    "pos_dxf": [
      1182.046310240905,
      463.6618260517942
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FGCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FGCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Wandlaufkran 5t 1,5 m ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_904",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14A8F"
    },
    "position": {
      "x": 6207.205953957868,
      "y": 4752.031006865621
    },
    "dwg_pos_img": [
      6207.205953957868,
      4752.031006865621
    ],
    "pos_dxf": [
      1184.846310212704,
      464.1658164674454
    ],
    "type": "Auslass 400 V_A01U1FGFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FGFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "1F5 Wandlaufkran 5t ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I3,I4],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_905",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14AA2"
    },
    "position": {
      "x": 1945.6976635500273,
      "y": 4751.753654864502
    },
    "dwg_pos_img": [
      1945.6976635500273,
      4751.753654864502
    ],
    "pos_dxf": [
      462.0463174927977,
      463.657019224833
    ],
    "type": "Taster_ Zugangskontrolle_A01U1FGIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ Zugangskontrolle_A01U1FGIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brückenkran 10t 1,5 m ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_906",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14AB6"
    },
    "position": {
      "x": 5965.082819962857,
      "y": 4753.024047664974
    },
    "dwg_pos_img": [
      5965.082819962857,
      4753.024047664974
    ],
    "pos_dxf": [
      1143.779488899031,
      463.96581650745725
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FGLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FGLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.04/05 in VT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_907",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14ACA"
    },
    "position": {
      "x": 4315.073160602995,
      "y": 4751.165444413049
    },
    "dwg_pos_img": [
      4315.073160602995,
      4751.165444413049
    ],
    "pos_dxf": [
      863.9191933183447,
      464.06582136767156
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FGOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FGOKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 12.19/20 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_908",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14AF2"
    },
    "position": {
      "x": 1513.1379313985667,
      "y": 4749.600249910712
    },
    "dwg_pos_img": [
      1513.1379313985667,
      4749.600249910712
    ],
    "pos_dxf": [
      388.679295785073,
      463.96581650745725
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FH0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FH0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 12.15/16 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_909",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B06"
    },
    "position": {
      "x": 3728.5970698265633,
      "y": 3575.9338268168917
    },
    "dwg_pos_img": [
      3728.5970698265633,
      3575.9338268168917
    ],
    "pos_dxf": [
      764.4462167907541,
      663.3082443746075
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FH3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FH3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 12.13/14 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H,H1],[36-35]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_910",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B1A"
    },
    "position": {
      "x": 3728.5970698271253,
      "y": 1793.2038197219
    },
    "dwg_pos_img": [
      3728.5970698271253,
      1793.2038197219
    ],
    "pos_dxf": [
      764.4462167907541,
      965.6587010790654
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FH6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FH6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 18.23/24 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[H,H1],[41-40]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_911",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B42"
    },
    "position": {
      "x": 6832.164280773051,
      "y": 1619.0573565806853
    },
    "dwg_pos_img": [
      6832.164280773051,
      1619.0573565806853
    ],
    "pos_dxf": [
      1290.846309107066,
      995.5986910118822
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FHCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FHCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 20.07/08 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[I4,I5],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_912",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B69"
    },
    "position": {
      "x": 1761.0502209925412,
      "y": 566.057419306544
    },
    "dwg_pos_img": [
      1761.0502209925412,
      566.057419306544
    ],
    "pos_dxf": [
      430.7280233485237,
      1173.525719663639
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FHOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FHOKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 04/008 ISP ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_913",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B7C"
    },
    "position": {
      "x": 2462.6995778101236,
      "y": 4757.631457158141
    },
    "dwg_pos_img": [
      2462.6995778101236,
      4757.631457158141
    ],
    "pos_dxf": [
      549.7356881094188,
      462.7275792506407
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FHRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FHRKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR ISP 03/020 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_914",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14B8F"
    },
    "position": {
      "x": 5506.323306753581,
      "y": 2733.8042428313156
    },
    "dwg_pos_img": [
      5506.323306753581,
      2733.8042428313156
    ],
    "pos_dxf": [
      1065.9686880718484,
      806.3650328022181
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FHUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FHUKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR ISP 05/014 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I1,I2],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_915",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14BA2"
    },
    "position": {
      "x": 1148.7742835401132,
      "y": 572.4262266587057
    },
    "dwg_pos_img": [
      1148.7742835401132,
      572.4262266587057
    ],
    "pos_dxf": [
      326.879101095029,
      1172.3657116781537
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FHXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FHXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 18.23/24 in VT ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_916",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14BB6"
    },
    "position": {
      "x": 1513.4130561557486,
      "y": 4730.441833121437
    },
    "dwg_pos_img": [
      1513.4130561557486,
      4730.441833121437
    ],
    "pos_dxf": [
      388.7259600548414,
      467.2151139424018
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1FI0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1FI0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 in VT 12.17/18 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_917",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14BDE"
    },
    "position": {
      "x": 972.2704500141866,
      "y": 322.9749814524939
    },
    "dwg_pos_img": [
      972.2704500141866,
      322.9749814524939
    ],
    "pos_dxf": [
      296.9420551259309,
      1214.649543848999
    ],
    "type": "Auslass 400 V_A01U1FI6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FI6KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "VEN 23F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_918",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14BF1"
    },
    "position": {
      "x": 987.4570320996701,
      "y": 314.13813036052215
    },
    "dwg_pos_img": [
      987.4570320996701,
      314.13813036052215
    ],
    "pos_dxf": [
      299.5178711686999,
      1216.1502518682394
    ],
    "type": "Schaltkreis_A01U1FI9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FI9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_919",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14BF6"
    },
    "position": {
      "x": 1915.5608016035244,
      "y": 619.0294697611407
    },
    "dwg_pos_img": [
      1915.5608016035244,
      619.0294697611407
    ],
    "pos_dxf": [
      456.9347649362753,
      1164.56182941153
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIAKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/1 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_920",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C0D"
    },
    "position": {
      "x": 2621.460339695594,
      "y": 619.5729225034111
    },
    "dwg_pos_img": [
      2621.460339695594,
      619.5729225034111
    ],
    "pos_dxf": [
      576.6633084996865,
      1164.561731718885
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIDKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/2 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G4,G5],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_921",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C24"
    },
    "position": {
      "x": 3406.119148840738,
      "y": 616.9524141948395
    },
    "dwg_pos_img": [
      3406.119148840738,
      616.9524141948395
    ],
    "pos_dxf": [
      709.750314997905,
      1165.108513550781
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIGKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/3 an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G7,H],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_922",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C48"
    },
    "position": {
      "x": 4057.540375054667,
      "y": 623.0528253976827
    },
    "dwg_pos_img": [
      4057.540375054667,
      623.0528253976827
    ],
    "pos_dxf": [
      820.2387208575965,
      1164.1588517229434
    ],
    "type": [
      "optisch akustischer Signalgeber_A01U1FIJKH",
      "Schaltkreis_A01U1FIKKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "optisch akustischer Signalgeber_A01U1FIJKH",
      "Schaltkreis_A01U1FIKKH"
    ],
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/6 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_923",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C4D"
    },
    "position": {
      "x": 4059.6614423457945,
      "y": 634.8639120417984
    },
    "dwg_pos_img": [
      4059.6614423457945,
      634.8639120417984
    ],
    "pos_dxf": [
      820.5984778539723,
      1162.155971743116
    ],
    "type": "Schaltkreis_A01U1FILKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FILKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_924",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C52"
    },
    "position": {
      "x": 4773.339301693892,
      "y": 621.2272632773911
    },
    "dwg_pos_img": [
      4773.339301693892,
      621.2272632773911
    ],
    "pos_dxf": [
      941.6463126551553,
      1164.56182941153
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIMKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIMKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/5 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H2,H3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_925",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C69"
    },
    "position": {
      "x": 6188.952454143035,
      "y": 622.3052429144745
    },
    "dwg_pos_img": [
      6188.952454143035,
      622.3052429144745
    ],
    "pos_dxf": [
      1181.750310243887,
      1164.563645323909
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIPKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S001/1 an KT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I2,I3],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_926",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C80"
    },
    "position": {
      "x": 6669.320672298045,
      "y": 746.0432230394363
    },
    "dwg_pos_img": [
      6669.320672298045,
      746.0432230394363
    ],
    "pos_dxf": [
      1263.226191768481,
      1143.640377518719
    ],
    "type": "optisch akustischer Signalgeber_A01U1FISKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FISKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S001/2 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_927",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14C97"
    },
    "position": {
      "x": 6849.8517807994585,
      "y": 1968.3220649920195
    },
    "dwg_pos_img": [
      6849.8517807994585,
      1968.3220649920195
    ],
    "pos_dxf": [
      1293.846309111566,
      936.3658117203727
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIVKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S006/1 4 m ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_928",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14CAE"
    },
    "position": {
      "x": 6849.851780798673,
      "y": 4444.741659576741
    },
    "dwg_pos_img": [
      6849.851780798673,
      4444.741659576741
    ],
    "pos_dxf": [
      1293.846309111565,
      516.3658159640538
    ],
    "type": "optisch akustischer Signalgeber_A01U1FIYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FIYKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/2 4 m ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I4,I5],[33-32]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_929",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14CC5"
    },
    "position": {
      "x": 6542.0856875235195,
      "y": 4735.778870029582
    },
    "dwg_pos_img": [
      6542.0856875235195,
      4735.778870029582
    ],
    "pos_dxf": [
      1241.645699651444,
      466.9658527933727
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJ1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJ1KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/1 an KT ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I3,I4],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_930",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14CDC"
    },
    "position": {
      "x": 5875.738030245025,
      "y": 4735.26641090065
    },
    "dwg_pos_img": [
      5875.738030245025,
      4735.26641090065
    ],
    "pos_dxf": [
      1128.625602303768,
      466.9658528005004
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJ4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJ4KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S009/3 an KT ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_931",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14CF3"
    },
    "position": {
      "x": 4821.9496062820745,
      "y": 4727.380718386992
    },
    "dwg_pos_img": [
      4821.9496062820745,
      4727.380718386992
    ],
    "pos_dxf": [
      949.8911699706914,
      468.165816320811
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJ7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJ7KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "5,7 m S037/2 an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H3,I],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_932",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D0F"
    },
    "position": {
      "x": 4108.292904325314,
      "y": 4718.341294494652
    },
    "dwg_pos_img": [
      4108.292904325314,
      4718.341294494652
    ],
    "pos_dxf": [
      828.8469237023137,
      469.6058163068703
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJBKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S037/1 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_933",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D3D"
    },
    "position": {
      "x": 2627.92035615974,
      "y": 4717.215563664809
    },
    "dwg_pos_img": [
      2627.92035615974,
      4717.215563664809
    ],
    "pos_dxf": [
      577.7590003383484,
      469.6036522995767
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJHKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S022/2 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_934",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D54"
    },
    "position": {
      "x": 1916.0978356017063,
      "y": 4716.668131832583
    },
    "dwg_pos_img": [
      1916.0978356017063,
      4716.668131832583
    ],
    "pos_dxf": [
      457.0258519750555,
      469.6036522995767
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJKKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S021/1 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_935",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D6B"
    },
    "position": {
      "x": 1328.9940787009787,
      "y": 4716.21661579303
    },
    "dwg_pos_img": [
      1328.9940787009787,
      4716.21661579303
    ],
    "pos_dxf": [
      357.4464161755623,
      469.6036522995767
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJNKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/5 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_936",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D82"
    },
    "position": {
      "x": 602.6304334715873,
      "y": 4704.5059757784275
    },
    "dwg_pos_img": [
      602.6304334715873,
      4704.5059757784275
    ],
    "pos_dxf": [
      234.2469286453936,
      471.4950323230523
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJQKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/4 an KT ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_937",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14D99"
    },
    "position": {
      "x": 528.3393444520017,
      "y": 4106.625023933591
    },
    "dwg_pos_img": [
      528.3393444520017,
      4106.625023933591
    ],
    "pos_dxf": [
      221.6463199070477,
      572.8857665442852
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJTKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/3 an KT ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_938",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14DB0"
    },
    "position": {
      "x": 479.9975580730021,
      "y": 3377.143624677433
    },
    "dwg_pos_img": [
      479.9975580730021,
      3377.143624677433
    ],
    "pos_dxf": [
      213.447006316218,
      696.5992804746179
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJWKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/1 4 m ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_939",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14DC7"
    },
    "position": {
      "x": 506.056089418188,
      "y": 1984.8442318454681
    },
    "dwg_pos_img": [
      506.056089418188,
      1984.8442318454681
    ],
    "pos_dxf": [
      217.8668278870618,
      932.7362248615509
    ],
    "type": "optisch akustischer Signalgeber_A01U1FJZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FJZKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S002/2 an KT ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_940",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14DDE"
    },
    "position": {
      "x": 479.99351152336874,
      "y": 1254.4865287079892
    },
    "dwg_pos_img": [
      479.99351152336874,
      1254.4865287079892
    ],
    "pos_dxf": [
      213.4463199755305,
      1056.601265575102
    ],
    "type": "optisch akustischer Signalgeber_A01U1FK2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FK2KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S002/1 4 m ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_941",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14DF5"
    },
    "position": {
      "x": 6828.6267810327245,
      "y": 1581.5128741119552
    },
    "dwg_pos_img": [
      6828.6267810327245,
      1581.5128741119552
    ],
    "pos_dxf": [
      1290.246309151107,
      1001.965762200553
    ],
    "type": "optisch akustischer Signalgeber_A01U1FK5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FK5KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S006/2 an KT ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_942",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E15"
    },
    "position": {
      "x": 6428.947546712642,
      "y": 1464.4205436037755
    },
    "dwg_pos_img": [
      6428.947546712642,
      1464.4205436037755
    ],
    "pos_dxf": [
      1222.456191669197,
      1021.7724542970705
    ],
    "type": [
      "Auslass 400 V_A01U1FK8KH",
      "Schaltkreis_A01U1FK9KH",
      "Auslass 400 V_A01U1GDCKH",
      "Auslass 400 V_A01U1GDGKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1FK8KH",
      "Schaltkreis_A01U1FK9KH",
      "Auslass 400 V_A01U1GDCKH",
      "Auslass 400 V_A01U1GDGKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE 23F03 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_943",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E24"
    },
    "position": {
      "x": 6465.5699833830495,
      "y": 1482.469226604212
    },
    "dwg_pos_img": [
      6465.5699833830495,
      1482.469226604212
    ],
    "pos_dxf": [
      1228.667771033795,
      1018.716179982919
    ],
    "type": "Auslass 230 V_A01U1FKFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FKFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F02 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_944",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E35"
    },
    "position": {
      "x": 6435.64632862089,
      "y": 1299.0108724791116
    },
    "dwg_pos_img": [
      6435.64632862089,
      1299.0108724791116
    ],
    "pos_dxf": [
      1223.592380826772,
      1049.826756990457
    ],
    "type": "Auslass 400 V_A01U1FKIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FKIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "DLE 23F01 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_945",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E48"
    },
    "position": {
      "x": 6441.438641466995,
      "y": 1279.4314703467135
    },
    "dwg_pos_img": [
      6441.438641466995,
      1279.4314703467135
    ],
    "pos_dxf": [
      1224.574822581588,
      1053.1481730257153
    ],
    "type": "Schaltkreis_A01U1FKLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1FKLKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_946",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E4D"
    },
    "position": {
      "x": 6423.367273189026,
      "y": 1297.916521557694
    },
    "dwg_pos_img": [
      6423.367273189026,
      1297.916521557694
    ],
    "pos_dxf": [
      1221.509714181083,
      1050.010756988675
    ],
    "type": "Auslass 230 V_A01U1FKMKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FKMKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F02 Armatur ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_947",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E5E"
    },
    "position": {
      "x": 6442.292291670489,
      "y": 1363.4982216462504
    },
    "dwg_pos_img": [
      6442.292291670489,
      1363.4982216462504
    ],
    "pos_dxf": [
      1224.719611308687,
      1038.890589402158
    ],
    "type": "Präsenzmelder UP 360°_A01U1FKSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1FKSKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_948",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E7B"
    },
    "position": {
      "x": 6467.766348776835,
      "y": 1400.0744881577566
    },
    "dwg_pos_img": [
      6467.766348776835,
      1400.0744881577566
    ],
    "pos_dxf": [
      1229.040299439804,
      1032.690588563703
    ],
    "type": "Präsenzmelder UP 360°_A01U1FKTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1FKTKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_949",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14E98"
    },
    "position": {
      "x": 6410.730515775932,
      "y": 1430.2051684523258
    },
    "dwg_pos_img": [
      6410.730515775932,
      1430.2051684523258
    ],
    "pos_dxf": [
      1219.366377234698,
      1027.572995239287
    ],
    "type": "002 Sirene_A01U1FKUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1FKUKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/005 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_950",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14EA6"
    },
    "position": {
      "x": 6407.742507472688,
      "y": 1450.4941809644206
    },
    "dwg_pos_img": [
      6407.742507472688,
      1450.4941809644206
    ],
    "pos_dxf": [
      1218.859577239802,
      1024.131595273949
    ],
    "type": "1xUP-SD_ SchuKo_A01U1FKWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1FKWKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_951",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14EB2"
    },
    "position": {
      "x": 6410.730515775968,
      "y": 1314.4440548550392
    },
    "dwg_pos_img": [
      6410.730515775968,
      1314.4440548550392
    ],
    "pos_dxf": [
      1219.366377234698,
      1047.206044229016
    ],
    "type": "002 Sirene_A01U1FL1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1FL1KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/004 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_952",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14EC0"
    },
    "position": {
      "x": 6418.464288326592,
      "y": 1313.4676894582435
    },
    "dwg_pos_img": [
      6418.464288326592,
      1313.4676894582435
    ],
    "pos_dxf": [
      1220.678112508303,
      1047.372644227339
    ],
    "type": "1xUP-SD_ SchuKo_A01U1FL9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1FL9KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_953",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14ECC"
    },
    "position": {
      "x": 6557.934839799579,
      "y": 1484.5890505565021
    },
    "dwg_pos_img": [
      6557.934839799579,
      1484.5890505565021
    ],
    "pos_dxf": [
      1244.333895090321,
      1018.368705809004
    ],
    "type": "Auslass 230 V_A01U1FLBKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FLBKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Urinal 20F04 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_954",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14EDD"
    },
    "position": {
      "x": 6410.053301619097,
      "y": 1482.4265311317604
    },
    "dwg_pos_img": [
      6410.053301619097,
      1482.4265311317604
    ],
    "pos_dxf": [
      1219.251514056156,
      1018.716179982919
    ],
    "type": "Auslass 230 V_A01U1FLEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FLEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F02 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_955",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14EEE"
    },
    "position": {
      "x": 6556.203847886019,
      "y": 1400.142501625398
    },
    "dwg_pos_img": [
      6556.203847886019,
      1400.142501625398
    ],
    "pos_dxf": [
      1244.040299288723,
      1032.69058855994
    ],
    "type": "Präsenzmelder UP 360°_A01U1FLHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Präsenzmelder UP 360°_A01U1FLHKH",
    "dwg_layer": "ADE_ET_NSV_BWM",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_956",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F0B"
    },
    "position": {
      "x": 6518.3823910398505,
      "y": 1484.3601952356312
    },
    "dwg_pos_img": [
      6518.3823910398505,
      1484.3601952356312
    ],
    "pos_dxf": [
      1237.625352544496,
      1018.40236070472
    ],
    "type": "Auslass 230 V_A01U1FLIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FLIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Urinal 20F04 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_957",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F1C"
    },
    "position": {
      "x": 6864.237613751045,
      "y": 1352.3529335094909
    },
    "dwg_pos_img": [
      6864.237613751045,
      1352.3529335094909
    ],
    "pos_dxf": [
      1296.286309046786,
      1040.835861889936
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FLLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FLLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.01/02 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_958",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F2A"
    },
    "position": {
      "x": 6692.999031214457,
      "y": 1503.2143316481179
    },
    "dwg_pos_img": [
      6692.999031214457,
      1503.2143316481179
    ],
    "pos_dxf": [
      1267.242309181909,
      1015.227480569296
    ],
    "type": "1xUP-SD_ SchuKo_A01U1FLNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1FLNKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_959",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F36"
    },
    "position": {
      "x": 6868.718447263269,
      "y": 1359.4739483030216
    },
    "dwg_pos_img": [
      6868.718447263269,
      1359.4739483030216
    ],
    "pos_dxf": [
      1297.046309077129,
      1039.628724430911
    ],
    "type": "3xUP-SD_ SchuKo_A01U1FLPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1FLPKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_960",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F44"
    },
    "position": {
      "x": 6690.64069790488,
      "y": 1502.1276103242953
    },
    "dwg_pos_img": [
      6690.64069790488,
      1502.1276103242953
    ],
    "pos_dxf": [
      1266.842309185938,
      1015.411480567442
    ],
    "type": "Taster_ UP_ 1S_A01U1FLRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1FLRKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_961",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F4A"
    },
    "position": {
      "x": 6613.287770431746,
      "y": 1322.998413980321
    },
    "dwg_pos_img": [
      6613.287770431746,
      1322.998413980321
    ],
    "pos_dxf": [
      1253.7223780243974,
      1045.7816474731385
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FLSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FLSKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.20/21 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_962",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F58"
    },
    "position": {
      "x": 6597.34543725898,
      "y": 1373.3318954041497
    },
    "dwg_pos_img": [
      6597.34543725898,
      1373.3318954041497
    ],
    "pos_dxf": [
      1251.018378051632,
      1037.243025236189
    ],
    "type": "3xUP-SD_ SchuKo_A01U1FLUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1FLUKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_963",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F66"
    },
    "position": {
      "x": 6692.016785391024,
      "y": 1482.421412386835
    },
    "dwg_pos_img": [
      6692.016785391024,
      1482.421412386835
    ],
    "pos_dxf": [
      1267.075709183587,
      1018.753825115866
    ],
    "type": "002 Sirene_A01U1FLWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "002 Sirene_A01U1FLWKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/003 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_964",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F74"
    },
    "position": {
      "x": 6864.23761375101,
      "y": 1461.0186717121805
    },
    "dwg_pos_img": [
      6864.23761375101,
      1461.0186717121805
    ],
    "pos_dxf": [
      1296.286309046786,
      1022.4061863681509
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FLYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FLYKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 20.03/04 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_965",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F82"
    },
    "position": {
      "x": 6613.287770431712,
      "y": 1431.6641521830197
    },
    "dwg_pos_img": [
      6613.287770431712,
      1431.6641521830197
    ],
    "pos_dxf": [
      1253.7223780243974,
      1027.351971951352
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FM0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FM0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.22/23 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_966",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F90"
    },
    "position": {
      "x": 6868.718447263246,
      "y": 1432.3613195999533
    },
    "dwg_pos_img": [
      6868.718447263246,
      1432.3613195999533
    ],
    "pos_dxf": [
      1297.046309077129,
      1027.267048848008
    ],
    "type": "3xUP-SD_ SchuKo_A01U1FM2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1FM2KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_967",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14F9E"
    },
    "position": {
      "x": 6597.3454372589495,
      "y": 1470.1344045009719
    },
    "dwg_pos_img": [
      6597.3454372589495,
      1470.1344045009719
    ],
    "pos_dxf": [
      1251.018378051632,
      1020.825349694139
    ],
    "type": "3xUP-SD_ SchuKo_A01U1FM4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1FM4KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_968",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14FAC"
    },
    "position": {
      "x": 5503.243461008145,
      "y": 1259.7379912559309
    },
    "dwg_pos_img": [
      5503.243461008145,
      1259.7379912559309
    ],
    "pos_dxf": [
      1065.446311408232,
      1056.365810521063
    ],
    "type": "optisch akustischer Signalgeber_A01U1FM6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FM6KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S001/4 4 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I1,I2],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_969",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14FC3"
    },
    "position": {
      "x": 5437.210128381788,
      "y": 905.9129801433683
    },
    "dwg_pos_img": [
      5437.210128381788,
      905.9129801433683
    ],
    "pos_dxf": [
      1054.246311528116,
      1116.365809905015
    ],
    "type": "optisch akustischer Signalgeber_A01U1FM9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FM9KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/4 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I,I1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_970",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14FDA"
    },
    "position": {
      "x": 5503.24727581743,
      "y": 4089.931816649832
    },
    "dwg_pos_img": [
      5503.24727581743,
      4089.931816649832
    ],
    "pos_dxf": [
      1065.446958443174,
      576.3658153578306
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMFKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S013/1 4 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_971",
    "source_ids": {
      "object_id": null,
      "dwg_id": "14FF1"
    },
    "position": {
      "x": 5454.614628162089,
      "y": 4089.89441547142
    },
    "dwg_pos_img": [
      5454.614628162089,
      4089.89441547142
    ],
    "pos_dxf": [
      1057.198311491025,
      576.3658153439344
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMIKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S037/3 4 m ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I,I1],[34-33]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_972",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15008"
    },
    "position": {
      "x": 5503.2434610066475,
      "y": 3386.3243871977274
    },
    "dwg_pos_img": [
      5503.2434610066475,
      3386.3243871977274
    ],
    "pos_dxf": [
      1065.446311408092,
      695.6974168352272
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMLKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4 m S013/2 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I1,I2],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_973",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1501F"
    },
    "position": {
      "x": 5458.435128125489,
      "y": 3382.34889801998
    },
    "dwg_pos_img": [
      5458.435128125489,
      3382.34889801998
    ],
    "pos_dxf": [
      1057.84631148478,
      696.36581413767
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMOKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S038/1 4 m ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I,I1],[36-35]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_974",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15036"
    },
    "position": {
      "x": 5437.205411756337,
      "y": 2653.5585256771883
    },
    "dwg_pos_img": [
      5437.205411756337,
      2653.5585256771883
    ],
    "pos_dxf": [
      1054.2455115352,
      819.9656663928531
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMRKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S038/2 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I,I1],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_975",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1504D"
    },
    "position": {
      "x": 5503.243461394514,
      "y": 2668.939241274833
    },
    "dwg_pos_img": [
      5503.243461394514,
      2668.939241274833
    ],
    "pos_dxf": [
      1065.44631147384,
      817.3657152537403
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMUKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4 m S006/4 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I1,I2],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_976",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15064"
    },
    "position": {
      "x": 5437.210128381454,
      "y": 1967.2356635707092
    },
    "dwg_pos_img": [
      5437.210128381454,
      1967.2356635707092
    ],
    "pos_dxf": [
      1054.246311528116,
      936.365811717988
    ],
    "type": "optisch akustischer Signalgeber_A01U1FMXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FMXKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S029/2 an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I,I1],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_977",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1507B"
    },
    "position": {
      "x": 5503.247969440263,
      "y": 1967.2864504525523
    },
    "dwg_pos_img": [
      5503.247969440263,
      1967.2864504525523
    ],
    "pos_dxf": [
      1065.447076089336,
      936.3658117108598
    ],
    "type": "optisch akustischer Signalgeber_A01U1FN0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FN0KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S006/3 4 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_978",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15092"
    },
    "position": {
      "x": 4795.743468134682,
      "y": 1259.1938838034548
    },
    "dwg_pos_img": [
      4795.743468134682,
      1259.1938838034548
    ],
    "pos_dxf": [
      945.4463126168812,
      1056.365810502211
    ],
    "type": "optisch akustischer Signalgeber_A01U1FN3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FN3KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4 m S012/1 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H3,I],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_979",
    "source_ids": {
      "object_id": null,
      "dwg_id": "150A9"
    },
    "position": {
      "x": 4393.629687970548,
      "y": 1565.370923638875
    },
    "dwg_pos_img": [
      4393.629687970548,
      1565.370923638875
    ],
    "pos_dxf": [
      877.2432686314091,
      1004.385831024834
    ],
    "type": "optisch akustischer Signalgeber_A01U1FN6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FN6KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/2 an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H1,H2],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_980",
    "source_ids": {
      "object_id": null,
      "dwg_id": "150C0"
    },
    "position": {
      "x": 4795.748184842799,
      "y": 1966.7429188502438
    },
    "dwg_pos_img": [
      4795.748184842799,
      1966.7429188502438
    ],
    "pos_dxf": [
      945.4471126239496,
      936.3657140551636
    ],
    "type": "optisch akustischer Signalgeber_A01U1FN9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FN9KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4 m S029/3 ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[H3,I],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_981",
    "source_ids": {
      "object_id": null,
      "dwg_id": "150D7"
    },
    "position": {
      "x": 3756.8796943844304,
      "y": 1564.8812268736283
    },
    "dwg_pos_img": [
      3756.8796943844304,
      1564.8812268736283
    ],
    "pos_dxf": [
      769.243269719193,
      1004.385831017707
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNCKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/3 an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[H,H1],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_982",
    "source_ids": {
      "object_id": null,
      "dwg_id": "150EE"
    },
    "position": {
      "x": 3004.5893195099325,
      "y": 1564.3026729695503
    },
    "dwg_pos_img": [
      3004.5893195099325,
      1564.3026729695503
    ],
    "pos_dxf": [
      641.6463156767772,
      1004.385831017706
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNFKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S020/2 an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G5,G6],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_983",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15105"
    },
    "position": {
      "x": 4692.103401126739,
      "y": 2627.3704938680266
    },
    "dwg_pos_img": [
      4692.103401126739,
      2627.3704938680266
    ],
    "pos_dxf": [
      927.867785350576,
      824.3099634997839
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNIKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S029/1 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H2,H3],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_984",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1511C"
    },
    "position": {
      "x": 4065.8435906670843,
      "y": 2626.8888645893703
    },
    "dwg_pos_img": [
      4065.8435906670843,
      2626.8888645893703
    ],
    "pos_dxf": [
      821.6470401135211,
      824.3099635025519
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNLKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S029/4 an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H,H1],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_985",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15133"
    },
    "position": {
      "x": 3032.871368343583,
      "y": 2626.0944504482404
    },
    "dwg_pos_img": [
      3032.871368343583,
      2626.0944504482404
    ],
    "pos_dxf": [
      646.4432709560435,
      824.3099635025519
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNOKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S023/2 an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_986",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1514A"
    },
    "position": {
      "x": 1589.5887580394196,
      "y": 2624.9844844229365
    },
    "dwg_pos_img": [
      1589.5887580394196,
      2624.9844844229365
    ],
    "pos_dxf": [
      401.6462204449019,
      824.3099634954242
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNRKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S023/1 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_987",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15161"
    },
    "position": {
      "x": 1634.3797157633362,
      "y": 3780.4701503951055
    },
    "dwg_pos_img": [
      1634.3797157633362,
      3780.4701503951055
    ],
    "pos_dxf": [
      409.2432733451392,
      628.3457948152886
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNUKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S048/2 an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G2,G3],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_988",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15178"
    },
    "position": {
      "x": 2341.8782105175715,
      "y": 3781.014256806599
    },
    "dwg_pos_img": [
      2341.8782105175715,
      3781.014256806599
    ],
    "pos_dxf": [
      529.2430180385293,
      628.3457948152886
    ],
    "type": "optisch akustischer Signalgeber_A01U1FNXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FNXKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S048/1 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G4,G5],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_989",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1518F"
    },
    "position": {
      "x": 3049.3782033910757,
      "y": 3781.558364497673
    },
    "dwg_pos_img": [
      3049.3782033910757,
      3781.558364497673
    ],
    "pos_dxf": [
      649.2430168298872,
      628.3457947936745
    ],
    "type": "optisch akustischer Signalgeber_A01U1FO0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FO0KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "an KT S048/3 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_990",
    "source_ids": {
      "object_id": null,
      "dwg_id": "151A6"
    },
    "position": {
      "x": 4110.628192701331,
      "y": 3782.4216957401636
    },
    "dwg_pos_img": [
      4110.628192701331,
      3782.4216957401636
    ],
    "pos_dxf": [
      829.2430150169239,
      628.3377947937549
    ],
    "type": "optisch akustischer Signalgeber_A01U1FO3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FO3KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "an KT S038/4 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H1,H2],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_991",
    "source_ids": {
      "object_id": null,
      "dwg_id": "151BD"
    },
    "position": {
      "x": 4712.149879584214,
      "y": 3782.8371299599457
    },
    "dwg_pos_img": [
      4712.149879584214,
      3782.8371299599457
    ],
    "pos_dxf": [
      931.2678947709896,
      628.3457948152886
    ],
    "type": "optisch akustischer Signalgeber_A01U1FO6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FO6KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S038/3 an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H2,H3],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_992",
    "source_ids": {
      "object_id": null,
      "dwg_id": "151D4"
    },
    "position": {
      "x": 2328.6164286610206,
      "y": 1563.782811490877
    },
    "dwg_pos_img": [
      2328.6164286610206,
      1563.782811490877
    ],
    "pos_dxf": [
      526.9936698789938,
      1004.385831024834
    ],
    "type": "optisch akustischer Signalgeber_A01U1FO9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FO9KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S020/1 an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G4,G5],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_993",
    "source_ids": {
      "object_id": null,
      "dwg_id": "151EB"
    },
    "position": {
      "x": 1589.5839003050778,
      "y": 1563.214453621621
    },
    "dwg_pos_img": [
      1589.5839003050778,
      1563.214453621621
    ],
    "pos_dxf": [
      401.6453965181722,
      1004.385831024834
    ],
    "type": "optisch akustischer Signalgeber_A01U1FOCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FOCKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S020/3 an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_994",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15202"
    },
    "position": {
      "x": 3533.327820288298,
      "y": 2457.3961521167157
    },
    "dwg_pos_img": [
      3533.327820288298,
      2457.3961521167157
    ],
    "pos_dxf": [
      731.3263440774647,
      852.9864180363506
    ],
    "type": "optisch akustischer Signalgeber_A01U1FOFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FOFKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "4 m S029/5 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_995",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15219"
    },
    "position": {
      "x": 3695.1093127140152,
      "y": 2969.0524294367015
    },
    "dwg_pos_img": [
      3695.1093127140152,
      2969.0524294367015
    ],
    "pos_dxf": [
      758.766314524278,
      766.2307734199194
    ],
    "type": "optisch akustischer Signalgeber_A01U1FOIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FOIKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S029/6 4 m ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_996",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15230"
    },
    "position": {
      "x": 5819.438456244685,
      "y": 905.0277001824843
    },
    "dwg_pos_img": [
      5819.438456244685,
      905.0277001824843
    ],
    "pos_dxf": [
      1119.076557950141,
      1116.565807828186
    ],
    "type": "optisch akustischer Signalgeber_A01U1FOLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FOLKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S001/3 4 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_997",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15247"
    },
    "position": {
      "x": 479.9977815087717,
      "y": 2691.726496841461
    },
    "dwg_pos_img": [
      479.9977815087717,
      2691.726496841461
    ],
    "pos_dxf": [
      213.4470442134143,
      812.8458129621231
    ],
    "type": "optisch akustischer Signalgeber_A01U1FPXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "optisch akustischer Signalgeber_A01U1FPXKH",
    "dwg_layer": "ADE_ET_BMA_Sirene-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "S012/2 4 m ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_998",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15267"
    },
    "position": {
      "x": 499.5774359951728,
      "y": 4164.431052904908
    },
    "dwg_pos_img": [
      499.5774359951728,
      4164.431052904908
    ],
    "pos_dxf": [
      216.76797500977568,
      563.0781304792979
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FQZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FQZKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR Löschwasserbarriere ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_999",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15275"
    },
    "position": {
      "x": 516.7835111661933,
      "y": 4766.522708669893
    },
    "dwg_pos_img": [
      516.7835111661933,
      4766.522708669893
    ],
    "pos_dxf": [
      219.6863199151423,
      460.9658164789569
    ],
    "type": "Warnschild_A01U1FR6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Warnschild_A01U1FR6KH",
    "dwg_layer": "ADE_ET_BMA_Sirene-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "W017/1 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1000",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15293"
    },
    "position": {
      "x": 491.3268585483264,
      "y": 4756.125753659033
    },
    "dwg_pos_img": [
      491.3268585483264,
      4756.125753659033
    ],
    "pos_dxf": [
      215.36858378207262,
      462.72581647042216
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FR9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FR9KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR 03/017 Warnschild ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1001",
    "source_ids": {
      "object_id": null,
      "dwg_id": "152A6"
    },
    "position": {
      "x": 540.8416137948437,
      "y": 4753.238086112977
    },
    "dwg_pos_img": [
      540.8416137948437,
      4753.238086112977
    ],
    "pos_dxf": [
      223.7668461560465,
      463.2220222883102
    ],
    "type": "Auslass 230 V_A01U1FRCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FRCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F02 Warnschild ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1002",
    "source_ids": {
      "object_id": null,
      "dwg_id": "152B7"
    },
    "position": {
      "x": 479.9972975903469,
      "y": 4173.938618868675
    },
    "dwg_pos_img": [
      479.9972975903469,
      4173.938618868675
    ],
    "pos_dxf": [
      213.4469621354569,
      561.4630963663535
    ],
    "type": "Kartenleser Zutritt Anlage_A01U1FSRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Kartenleser Zutritt Anlage_A01U1FSRKH",
    "dwg_layer": "ADE_ET_ZKS_Leser",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "ZKS07 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1003",
    "source_ids": {
      "object_id": null,
      "dwg_id": "152D8"
    },
    "position": {
      "x": 3590.7255594461453,
      "y": 2257.2823239244035
    },
    "dwg_pos_img": [
      3590.7255594461453,
      2257.2823239244035
    ],
    "pos_dxf": [
      741.0616496590046,
      886.9331477675669
    ],
    "type": [
      "Auslass 400 V_A01U1GD8KH",
      "Auslass 230 V_A01U1FTWKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1GD8KH",
      "Auslass 230 V_A01U1FTWKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F03 Armatur ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1004",
    "source_ids": {
      "object_id": null,
      "dwg_id": "152E9"
    },
    "position": {
      "x": 1664.8201663313166,
      "y": 436.2916713126706
    },
    "dwg_pos_img": [
      1664.8201663313166,
      436.2916713126706
    ],
    "pos_dxf": [
      414.4063179642683,
      1195.521398850691
    ],
    "type": "Ansaugstutzen RAS_A01U1FURKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Ansaugstutzen RAS_A01U1FURKH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-D",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1005",
    "source_ids": {
      "object_id": null,
      "dwg_id": "152F5"
    },
    "position": {
      "x": 577.8693154176723,
      "y": 538.2601161421771
    },
    "dwg_pos_img": [
      577.8693154176723,
      538.2601161421771
    ],
    "pos_dxf": [
      230.0471630388497,
      1178.085809289355
    ],
    "type": "Blitzleuchte_A01U1FV0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Blitzleuchte_A01U1FV0KH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[F1,G],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1006",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15316"
    },
    "position": {
      "x": 1242.8826092728473,
      "y": 4722.467921508352
    },
    "dwg_pos_img": [
      1242.8826092728473,
      4722.467921508352
    ],
    "pos_dxf": [
      342.8409372619462,
      468.5322011165363
    ],
    "type": "Geräteanschluß 230 V_A01U1FVDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 230 V_A01U1FVDKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F01 Einspeisung KSS ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1007",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15327"
    },
    "position": {
      "x": 1221.886787792604,
      "y": 4704.7535386382915
    },
    "dwg_pos_img": [
      1221.886787792604,
      4704.7535386382915
    ],
    "pos_dxf": [
      339.27980853031113,
      471.5338164392117
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1FVGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1FVGKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 24.17/18 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1008",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15335"
    },
    "position": {
      "x": 628.384701222877,
      "y": 563.3501275947856
    },
    "dwg_pos_img": [
      628.384701222877,
      563.3501275947856
    ],
    "pos_dxf": [
      238.6151436701291,
      1173.837139933848
    ],
    "type": "Polygon_A01U1FVJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygon_A01U1FVJKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1009",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15348"
    },
    "position": {
      "x": 5765.490125073859,
      "y": 4763.716286456674
    },
    "dwg_pos_img": [
      5765.490125073859,
      4763.716286456674
    ],
    "pos_dxf": [
      1109.926310967303,
      462.1263828942367
    ],
    "type": "Polygon_A01U1FVLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygon_A01U1FVLKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1010",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15351"
    },
    "position": {
      "x": 3861.0416467576374,
      "y": 4766.028657791434
    },
    "dwg_pos_img": [
      3861.0416467576374,
      4766.028657791434
    ],
    "pos_dxf": [
      786.9103146448688,
      461.4858048524777
    ],
    "type": "Polygon_A01U1FVMKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygon_A01U1FVMKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1011",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1536C"
    },
    "position": {
      "x": 6722.690462827579,
      "y": 1304.3706862663194
    },
    "dwg_pos_img": [
      6722.690462827579,
      1304.3706862663194
    ],
    "pos_dxf": [
      1272.27831171699,
      1048.955173906853
    ],
    "type": "Auslass 230 V_A01U1FVUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1FVUKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ULK 20F01 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1012",
    "source_ids": {
      "object_id": null,
      "dwg_id": "153BD"
    },
    "position": {
      "x": 483.06900773356267,
      "y": 2328.0489525613975
    },
    "dwg_pos_img": [
      483.06900773356267,
      2328.0489525613975
    ],
    "pos_dxf": [
      213.96795890876615,
      874.525812347526
    ],
    "type": "Bus-Steuerkoppler BMA (I_O)_A01U1FWLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Bus-Steuerkoppler BMA (I_O)_A01U1FWLKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "STR SiBe 03/007 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[F,F1],[39-38]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1013",
    "source_ids": {
      "object_id": null,
      "dwg_id": "153D0"
    },
    "position": {
      "x": 483.0187463600406,
      "y": 2292.4990779261625
    },
    "dwg_pos_img": [
      483.0187463600406,
      2292.4990779261625
    ],
    "pos_dxf": [
      213.9594340114884,
      880.5550535124612
    ],
    "type": "Geräteanschluß 400 V_A01U1FWOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1FWOKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "SiBe Zentrale 1F7 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1014",
    "source_ids": {
      "object_id": null,
      "dwg_id": "153E3"
    },
    "position": {
      "x": 6820.371777908975,
      "y": 2323.9417299526103
    },
    "dwg_pos_img": [
      6820.371777908975,
      2323.9417299526103
    ],
    "pos_dxf": [
      1288.846167278566,
      876.0489816268737
    ],
    "type": "Auslass 400 V_A01U1FWRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FWRKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Schaltschrank Langgutanlage xxFxx ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I4,I5],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1015",
    "source_ids": {
      "object_id": null,
      "dwg_id": "153F6"
    },
    "position": {
      "x": 6368.928301393247,
      "y": 2451.3632144439225
    },
    "dwg_pos_img": [
      6368.928301393247,
      2451.3632144439225
    ],
    "pos_dxf": [
      1212.276249000228,
      854.3794547769635
    ],
    "type": "Auslass 400 V_A01U1FWUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FWUKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Schaltschrank Sägezelle ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[I3,I4],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1016",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15409"
    },
    "position": {
      "x": 6323.045836541702,
      "y": 3261.8485114380665
    },
    "dwg_pos_img": [
      6323.045836541702,
      3261.8485114380665
    ],
    "pos_dxf": [
      1204.49406414912,
      716.9154150592026
    ],
    "type": "Auslass 400 V_A01U1FWXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FWXKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Nasstrennschleifer ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[I3,I4],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1017",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1541C"
    },
    "position": {
      "x": 6241.630821897187,
      "y": 3379.682292466321
    },
    "dwg_pos_img": [
      6241.630821897187,
      3379.682292466321
    ],
    "pos_dxf": [
      1190.685157071601,
      696.920223211323
    ],
    "type": "Auslass 400 V_A01U1FX0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FX0KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Säge 3 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I3,I4],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1018",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1542F"
    },
    "position": {
      "x": 6210.1579182718215,
      "y": 3504.878119819574
    },
    "dwg_pos_img": [
      6210.1579182718215,
      3504.878119819574
    ],
    "pos_dxf": [
      1185.346996739386,
      675.6829446261331
    ],
    "type": "Auslass 400 V_A01U1FX3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FX3KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Säge 1 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I3,I4],[36-35]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1019",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15442"
    },
    "position": {
      "x": 6210.157918271568,
      "y": 3803.7898787701947
    },
    "dwg_pos_img": [
      6210.157918271568,
      3803.7898787701947
    ],
    "pos_dxf": [
      1185.346996739359,
      624.9876029460302
    ],
    "type": "Auslass 400 V_A01U1FX6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FX6KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Säge 2 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[I3,I4],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1020",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15455"
    },
    "position": {
      "x": 6210.157918271372,
      "y": 3899.532689373642
    },
    "dwg_pos_img": [
      6210.157918271372,
      3899.532689373642
    ],
    "pos_dxf": [
      1185.346996739331,
      608.7496519400379
    ],
    "type": "Auslass 400 V_A01U1FX9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FX9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Säge 4 ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[I3,I4],[35-34]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1021",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15468"
    },
    "position": {
      "x": 6089.386593921559,
      "y": 4128.634459144292
    },
    "dwg_pos_img": [
      6089.386593921559,
      4128.634459144292
    ],
    "pos_dxf": [
      1164.862814517451,
      569.8783103723074
    ],
    "type": "Auslass 400 V_A01U1FXCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1FXCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx Anfasmaschine ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I2,I3],[34-33]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1022",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1597E"
    },
    "position": {
      "x": 563.7141605302269,
      "y": 4769.530504495377
    },
    "dwg_pos_img": [
      563.7141605302269,
      4769.530504495377
    ],
    "pos_dxf": [
      227.6462887118751,
      460.461816486642
    ],
    "type": "Taster_ AP_ 1S_A01U1G1PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G1PKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1023",
    "source_ids": {
      "object_id": null,
      "dwg_id": "159AA"
    },
    "position": {
      "x": 477.0343928925953,
      "y": 2055.914375836869
    },
    "dwg_pos_img": [
      477.0343928925953,
      2055.914375836869
    ],
    "pos_dxf": [
      212.9444199957952,
      920.678965115319
    ],
    "type": "Taster_ AP_ 1S_A01U1G1TKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G1TKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1024",
    "source_ids": {
      "object_id": null,
      "dwg_id": "159C0"
    },
    "position": {
      "x": 477.0220115456485,
      "y": 1871.6382839697426
    },
    "dwg_pos_img": [
      477.0220115456485,
      1871.6382839697426
    ],
    "pos_dxf": [
      212.9423199793421,
      951.9321315707157
    ],
    "type": "Taster_ AP_ 1S_A01U1G1VKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G1VKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F,F1],[41-40]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1025",
    "source_ids": {
      "object_id": null,
      "dwg_id": "159EC"
    },
    "position": {
      "x": 3610.80480911568,
      "y": 3420.0503901101497
    },
    "dwg_pos_img": [
      3610.80480911568,
      3420.0503901101497
    ],
    "pos_dxf": [
      744.4673174475417,
      689.7306630764051
    ],
    "type": [
      "Taster_ UP_ 1S_A01U1F6CKH",
      "Taster_ AP_ 1S_A01U1G1ZKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Taster_ UP_ 1S_A01U1F6CKH",
      "Taster_ AP_ 1S_A01U1G1ZKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1026",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A02"
    },
    "position": {
      "x": 3731.5262560788283,
      "y": 2673.4723517678185
    },
    "dwg_pos_img": [
      3731.5262560788283,
      2673.4723517678185
    ],
    "pos_dxf": [
      764.943039900631,
      816.3658129134542
    ],
    "type": "Taster_ AP_ 1S_A01U1G21KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G21KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[H,H1],[38-37]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1027",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A18"
    },
    "position": {
      "x": 3589.460503206475,
      "y": 1943.8805392031736
    },
    "dwg_pos_img": [
      3589.460503206475,
      1943.8805392031736
    ],
    "pos_dxf": [
      740.8470818162166,
      940.085828324135
    ],
    "type": [
      "Taster_ UP_ 1S_A01U1F14KH",
      "Taster_ AP_ 1S_A01U1G23KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Taster_ UP_ 1S_A01U1F14KH",
      "Taster_ AP_ 1S_A01U1G23KH"
    ],
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1028",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A2E"
    },
    "position": {
      "x": 5478.24512783483,
      "y": 998.8686884441031
    },
    "dwg_pos_img": [
      5478.24512783483,
      998.8686884441031
    ],
    "pos_dxf": [
      1061.206311435356,
      1100.605902853276
    ],
    "type": "Taster_ AP_ 1S_A01U1G25KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G25KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I,I1],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1029",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A44"
    },
    "position": {
      "x": 5500.271961079887,
      "y": 998.41447646499
    },
    "dwg_pos_img": [
      5500.271961079887,
      998.41447646499
    ],
    "pos_dxf": [
      1064.942311420386,
      1100.685810062945
    ],
    "type": "Taster_ AP_ 1S_A01U1G27KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G27KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1030",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A5A"
    },
    "position": {
      "x": 5500.27638268886,
      "y": 2229.7846421263775
    },
    "dwg_pos_img": [
      5500.27638268886,
      2229.7846421263775
    ],
    "pos_dxf": [
      1064.943061375331,
      891.8458121663966
    ],
    "type": "Taster_ AP_ 1S_A01U1G29KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G29KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1031",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A70"
    },
    "position": {
      "x": 5478.245473427015,
      "y": 2229.7676991094395
    },
    "dwg_pos_img": [
      5478.245473427015,
      2229.7676991094395
    ],
    "pos_dxf": [
      1061.206370051764,
      891.8458121663966
    ],
    "type": "Taster_ AP_ 1S_A01U1G2BKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G2BKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I,I1],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1032",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A86"
    },
    "position": {
      "x": 5478.245080725281,
      "y": 4351.587602761105
    },
    "dwg_pos_img": [
      5478.245080725281,
      4351.587602761105
    ],
    "pos_dxf": [
      1061.206303445223,
      531.9858140445281
    ],
    "type": "Taster_ AP_ 1S_A01U1G2DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G2DKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I,I1],[34-33]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1033",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15A9C"
    },
    "position": {
      "x": 5500.275641842986,
      "y": 4351.600864435091
    },
    "dwg_pos_img": [
      5500.275641842986,
      4351.600864435091
    ],
    "pos_dxf": [
      1064.942935719607,
      531.9864383537429
    ],
    "type": "Taster_ AP_ 1S_A01U1G2FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G2FKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1034",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15AB2"
    },
    "position": {
      "x": 5834.589291002783,
      "y": 4754.716147640718
    },
    "dwg_pos_img": [
      5834.589291002783,
      4754.716147640718
    ],
    "pos_dxf": [
      1121.646310842182,
      463.6618163744288
    ],
    "type": "Taster_ AP_ 1S_A01U1G2HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G2HKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1035",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15AC8"
    },
    "position": {
      "x": 502.77097418126607,
      "y": 3116.732729135122
    },
    "dwg_pos_img": [
      502.77097418126607,
      3116.732729135122
    ],
    "pos_dxf": [
      217.3096351967606,
      740.7678580296565
    ],
    "type": "Taster_ AP_ 1S_A01U1G2JKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1G2JKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "WS ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1036",
    "source_ids": {
      "object_id": null,
      "dwg_id": "15ADE"
    },
    "position": {
      "x": 6566.237354585345,
      "y": 1281.7819698368476
    },
    "dwg_pos_img": [
      6566.237354585345,
      1281.7819698368476
    ],
    "pos_dxf": [
      1245.742095478003,
      1052.76580675731
    ],
    "type": "Auslass 230 V_A01U1G2LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1G2LKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Spülstation 20F05 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1037",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16011"
    },
    "position": {
      "x": 3628.4588923993974,
      "y": 2257.3113429944633
    },
    "dwg_pos_img": [
      3628.4588923993974,
      2257.3113429944633
    ],
    "pos_dxf": [
      747.4616495945434,
      886.9331477675669
    ],
    "type": "Auslass 230 V_A01U1G7NKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1G7NKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F03 Armatur ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1038",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16022"
    },
    "position": {
      "x": 3683.0021326881374,
      "y": 2257.3532898352905
    },
    "dwg_pos_img": [
      3683.0021326881374,
      2257.3532898352905
    ],
    "pos_dxf": [
      756.7127998908738,
      886.9331477675669
    ],
    "type": "Auslass 230 V_A01U1G7QKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1G7QKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F03 Armatur ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1039",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16033"
    },
    "position": {
      "x": 3624.162952753432,
      "y": 2380.248011696355
    },
    "dwg_pos_img": [
      3624.162952753432,
      2380.248011696355
    ],
    "pos_dxf": [
      746.7330096545977,
      866.0825665289267
    ],
    "type": [
      "Auslass 400 V_A01U1G7WKH",
      "Auslass 230 V_A01U1G7TKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1G7WKH",
      "Auslass 230 V_A01U1G7TKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 21F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1040",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1604D"
    },
    "position": {
      "x": 3648.826245665817,
      "y": 2362.1455944652344
    },
    "dwg_pos_img": [
      3648.826245665817,
      2362.1455944652344
    ],
    "pos_dxf": [
      750.9161830107641,
      869.1559477579453
    ],
    "type": "Schaltkreis_A01U1G7XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1G7XKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE 24F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1041",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1605C"
    },
    "position": {
      "x": 3522.1233938388846,
      "y": 2420.2933378577945
    },
    "dwg_pos_img": [
      3522.1233938388846,
      2420.2933378577945
    ],
    "pos_dxf": [
      729.4259466584795,
      859.277582422721
    ],
    "type": "Auslass 230 V_A01U1G80KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1G80KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F02 Urinal ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1042",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1606D"
    },
    "position": {
      "x": 1667.978776174602,
      "y": 322.96908235216506
    },
    "dwg_pos_img": [
      1667.978776174602,
      322.96908235216506
    ],
    "pos_dxf": [
      414.9420539094135,
      1214.741286800826
    ],
    "type": "Auslass 400 V_A01U1G8DKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1G8DKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "VEN 23F02 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1043",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16080"
    },
    "position": {
      "x": 1683.1653582600852,
      "y": 314.13223126018966
    },
    "dwg_pos_img": [
      1683.1653582600852,
      314.13223126018966
    ],
    "pos_dxf": [
      417.51786995218254,
      1216.2419948200668
    ],
    "type": "Schaltkreis_A01U1G8GKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1G8GKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G2,G3],[45-44]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1044",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16085"
    },
    "position": {
      "x": 3237.665212961892,
      "y": 1741.8715556887983
    },
    "dwg_pos_img": [
      3237.665212961892,
      1741.8715556887983
    ],
    "pos_dxf": [
      681.1786226934039,
      974.3006040407968
    ],
    "type": "Auslass 230 V_A01U1G8HKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1G8HKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "ULK BG61 20F01 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1045",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1609F"
    },
    "position": {
      "x": 1253.7604160985657,
      "y": 4860.627391191311
    },
    "dwg_pos_img": [
      1253.7604160985657,
      4860.627391191311
    ],
    "pos_dxf": [
      344.6859362995326,
      445.10181668787936
    ],
    "type": [
      "Auslass 400 V_A01U1G8NKH",
      "Schaltkreis_A01U1G8OKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1G8NKH",
      "Schaltkreis_A01U1G8OKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 24F01 VENT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1046",
    "source_ids": {
      "object_id": null,
      "dwg_id": "160B7"
    },
    "position": {
      "x": 3609.759568178321,
      "y": 2249.9478511820125
    },
    "dwg_pos_img": [
      3609.759568178321,
      2249.9478511820125
    ],
    "pos_dxf": [
      744.2900327655241,
      888.1795547109868
    ],
    "type": "Schaltkreis_A01U1GD5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GD5KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE 24F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1047",
    "source_ids": {
      "object_id": null,
      "dwg_id": "160CF"
    },
    "position": {
      "x": 3572.0262352250697,
      "y": 2249.918832111952
    },
    "dwg_pos_img": [
      3572.0262352250697,
      2249.918832111952
    ],
    "pos_dxf": [
      737.8900328299853,
      888.1795547109868
    ],
    "type": "Schaltkreis_A01U1GD9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GD9KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE 24F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[G7,H],[40-39]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1048",
    "source_ids": {
      "object_id": null,
      "dwg_id": "160E7"
    },
    "position": {
      "x": 6390.585278304654,
      "y": 1437.455845763685
    },
    "dwg_pos_img": [
      6390.585278304654,
      1437.455845763685
    ],
    "pos_dxf": [
      1215.949517168896,
      1026.3406550354723
    ],
    "type": "Schaltkreis_A01U1GDDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GDDKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A 24F01 DLE ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1049",
    "source_ids": {
      "object_id": null,
      "dwg_id": "160FF"
    },
    "position": {
      "x": 6452.700878566306,
      "y": 1464.4927130324168
    },
    "dwg_pos_img": [
      6452.700878566306,
      1464.4927130324168
    ],
    "pos_dxf": [
      1226.485025340493,
      1021.7633125733832
    ],
    "type": "Schaltkreis_A01U1GDHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GDHKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 23F02 DLE ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1050",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1610E"
    },
    "position": {
      "x": 4180.301532777713,
      "y": 4399.794145086269
    },
    "dwg_pos_img": [
      4180.301532777713,
      4399.794145086269
    ],
    "pos_dxf": [
      841.0604013196739,
      523.640706335905
    ],
    "type": "Auslass 230 V_A01U1GDNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1GDNKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "E-Heizkorper 21F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[H1,H2],[34-33]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1051",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16159"
    },
    "position": {
      "x": 859.404257607964,
      "y": 650.068074455362
    },
    "dwg_pos_img": [
      859.404257607964,
      650.068074455362
    ],
    "pos_dxf": [
      277.79867266834117,
      1159.159935310617
    ],
    "type": [
      "AP-SD_ Drehstrom_A01U1GG4KH",
      "Schaltkreis_A01U1GG5KH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "AP-SD_ Drehstrom_A01U1GG4KH",
      "Schaltkreis_A01U1GG5KH"
    ],
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 12F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1052",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1617D"
    },
    "position": {
      "x": 3689.69504513954,
      "y": 3037.1844638447546
    },
    "dwg_pos_img": [
      3689.69504513954,
      3037.1844638447546
    ],
    "pos_dxf": [
      757.8479935222497,
      754.6748953071228
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GHLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GHLKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1053",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1618B"
    },
    "position": {
      "x": 3685.214211627323,
      "y": 2998.6985049549503
    },
    "dwg_pos_img": [
      3685.214211627323,
      2998.6985049549503
    ],
    "pos_dxf": [
      757.0879934919064,
      761.2015175643373
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GHNKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GHNKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.07/08 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1054",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16199"
    },
    "position": {
      "x": 3627.6612306815746,
      "y": 3135.846144264133
    },
    "dwg_pos_img": [
      3627.6612306815746,
      3135.846144264133
    ],
    "pos_dxf": [
      747.3263571477512,
      737.9338137049285
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GHPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GHPKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1055",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161A7"
    },
    "position": {
      "x": 3666.1411077397092,
      "y": 3115.215322340792
    },
    "dwg_pos_img": [
      3666.1411077397092,
      3115.215322340792
    ],
    "pos_dxf": [
      753.852979404965,
      741.4378137076342
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GHRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GHRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.09/10 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1056",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161B5"
    },
    "position": {
      "x": 3394.068136549919,
      "y": 2956.2940900873546
    },
    "dwg_pos_img": [
      3394.068136549919,
      2956.2940900873546
    ],
    "pos_dxf": [
      707.7063270476422,
      768.355318487017
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GHTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GHTKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.11/12 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1057",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161C3"
    },
    "position": {
      "x": 3378.1258033771787,
      "y": 2927.621031403285
    },
    "dwg_pos_img": [
      3378.1258033771787,
      2927.621031403285
    ],
    "pos_dxf": [
      705.002327074877,
      773.2161809668742
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GHVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GHVKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1058",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161D1"
    },
    "position": {
      "x": 3685.1875887686624,
      "y": 2597.0164147423357
    },
    "dwg_pos_img": [
      3685.1875887686624,
      2597.0164147423357
    ],
    "pos_dxf": [
      757.0834779540203,
      829.3266721037053
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GHXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GHXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.05/06 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1059",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161DF"
    },
    "position": {
      "x": 3689.6684222808794,
      "y": 2635.502373632138
    },
    "dwg_pos_img": [
      3689.6684222808794,
      2635.502373632138
    ],
    "pos_dxf": [
      757.8434779843635,
      822.8000498464912
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GHZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GHZKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1060",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161ED"
    },
    "position": {
      "x": 3572.2670636510625,
      "y": 2449.794732469244
    },
    "dwg_pos_img": [
      3572.2670636510625,
      2449.794732469244
    ],
    "pos_dxf": [
      737.9308800541928,
      854.2806953670647
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GI1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GI1KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1061",
    "source_ids": {
      "object_id": null,
      "dwg_id": "161FB"
    },
    "position": {
      "x": 3601.222311366588,
      "y": 2449.581151209406
    },
    "dwg_pos_img": [
      3601.222311366588,
      2449.581151209406
    ],
    "pos_dxf": [
      742.8420174759112,
      854.3206953666618
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GI3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GI3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.01/02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1062",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16209"
    },
    "position": {
      "x": 3691.275937328414,
      "y": 3132.947384525063
    },
    "dwg_pos_img": [
      3691.275937328414,
      3132.947384525063
    ],
    "pos_dxf": [
      758.1161307133009,
      738.4337398368889
    ],
    "type": "1xAP-SD_ SchuKo_A01U1GI5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1GI5KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "12F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1063",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1621B"
    },
    "position": {
      "x": 3448.539807270467,
      "y": 2448.537329648603
    },
    "dwg_pos_img": [
      3448.539807270467,
      2448.537329648603
    ],
    "pos_dxf": [
      716.945338335913,
      854.4778125310891
    ],
    "type": "1xAP-SD_ SchuKo_A01U1GI7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1GI7KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "12F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1064",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1622D"
    },
    "position": {
      "x": 3465.0481404375146,
      "y": 2448.5500254917542
    },
    "dwg_pos_img": [
      3465.0481404375146,
      2448.5500254917542
    ],
    "pos_dxf": [
      719.7453383077111,
      854.4778125310891
    ],
    "type": "1xAP-SD_ SchuKo_A01U1GI9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1GI9KH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "12F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1065",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16248"
    },
    "position": {
      "x": 3475.172240599864,
      "y": 2488.6039924524976
    },
    "dwg_pos_img": [
      3475.172240599864,
      2488.6039924524976
    ],
    "pos_dxf": [
      721.4625001727068,
      847.6859926522366
    ],
    "type": "Schaltkreis_A01U1GICKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GICKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 22F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1066",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1625B"
    },
    "position": {
      "x": 3501.47573178061,
      "y": 2980.4472402248184
    },
    "dwg_pos_img": [
      3501.47573178061,
      2980.4472402248184
    ],
    "pos_dxf": [
      725.9238697016265,
      764.2729610716083
    ],
    "type": [
      "Auslass 400 V_A01U1GIEKH",
      "Schaltkreis_A01U1GIFKH"
    ],
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": [
      "Auslass 400 V_A01U1GIEKH",
      "Schaltkreis_A01U1GIFKH"
    ],
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A 22F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1067",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16265"
    },
    "position": {
      "x": 3685.1875887686842,
      "y": 2528.6772508484073
    },
    "dwg_pos_img": [
      3685.1875887686842,
      2528.6772508484073
    ],
    "pos_dxf": [
      757.0834779540203,
      840.9169731206271
    ],
    "type": "RJ-45-Datendose 2-fach_ UP_A01U1GIHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 2-fach_ UP_A01U1GIHKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 22.03/04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1068",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16273"
    },
    "position": {
      "x": 3689.6684222808985,
      "y": 2575.2528470807774
    },
    "dwg_pos_img": [
      3689.6684222808985,
      2575.2528470807774
    ],
    "pos_dxf": [
      757.8434779843635,
      833.018350877232
    ],
    "type": "3xUP-SD_ SchuKo_A01U1GIJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "3xUP-SD_ SchuKo_A01U1GIJKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F03 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G7,H],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1069",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16281"
    },
    "position": {
      "x": 6690.709971271055,
      "y": 1476.7030888701747
    },
    "dwg_pos_img": [
      6690.709971271055,
      1476.7030888701747
    ],
    "pos_dxf": [
      1266.854058732143,
      1019.7234805620096
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GMYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GMYKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.21 WLAN/an Wand ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1070",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16295"
    },
    "position": {
      "x": 3467.0210254995795,
      "y": 1937.8901245769011
    },
    "dwg_pos_img": [
      3467.0210254995795,
      1937.8901245769011
    ],
    "pos_dxf": [
      720.0799619224513,
      941.0858307908002
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1GNWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1GNWKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 Infoscreen 16.04/05 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1071",
    "source_ids": {
      "object_id": null,
      "dwg_id": "162A9"
    },
    "position": {
      "x": 3468.006337763198,
      "y": 1926.3342575627348
    },
    "dwg_pos_img": [
      3468.006337763198,
      1926.3342575627348
    ],
    "pos_dxf": [
      720.2470820237006,
      943.0458307710592
    ],
    "type": "2xAP-SD_ SchuKo_A01U1GNZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xAP-SD_ SchuKo_A01U1GNZKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Infoscreen 11F06 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1072",
    "source_ids": {
      "object_id": null,
      "dwg_id": "162C7"
    },
    "position": {
      "x": 3470.3641796793904,
      "y": 3416.905292232839
    },
    "dwg_pos_img": [
      3470.3641796793904,
      3416.905292232839
    ],
    "pos_dxf": [
      720.6469986738769,
      690.2457527822326
    ],
    "type": "2xAP-SD_ SchuKo_A01U1GO2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xAP-SD_ SchuKo_A01U1GO2KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "11F06 Infoscreen ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1073",
    "source_ids": {
      "object_id": null,
      "dwg_id": "162E5"
    },
    "position": {
      "x": 3474.7640186069007,
      "y": 3389.196361244804
    },
    "dwg_pos_img": [
      3474.7640186069007,
      3389.196361244804
    ],
    "pos_dxf": [
      721.3932611068108,
      694.945752769092
    ],
    "type": "RJ45-Steckdose_ AP_A01U1GO5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ45-Steckdose_ AP_A01U1GO5KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 Infoscreen 12.23/24 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1074",
    "source_ids": {
      "object_id": null,
      "dwg_id": "162F9"
    },
    "position": {
      "x": 492.96434477627656,
      "y": 4619.376293289457
    },
    "dwg_pos_img": [
      492.96434477627656,
      4619.376293289457
    ],
    "pos_dxf": [
      215.64631996207117,
      485.91869614830193
    ],
    "type": "2xRJ45-Steckdose_ AP_A01U1GOEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "2xRJ45-Steckdose_ AP_A01U1GOEKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "2x RJ 45 Zeiterfassung 16.11/12 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1075",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1630D"
    },
    "position": {
      "x": 4587.501946021539,
      "y": 4889.327477413401
    },
    "dwg_pos_img": [
      4587.501946021539,
      4889.327477413401
    ],
    "pos_dxf": [
      910.1261957922043,
      440.66911675745564
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GOHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GOHKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an KT 10.22 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1076",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16321"
    },
    "position": {
      "x": 2297.130351418865,
      "y": 3777.4421008905765
    },
    "dwg_pos_img": [
      2297.130351418865,
      3777.4421008905765
    ],
    "pos_dxf": [
      521.6532751525235,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GOKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GOKKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Reserve/an KT 10.06 ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G3,G4],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1077",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16335"
    },
    "position": {
      "x": 4812.3698359164655,
      "y": 2645.1106693485463
    },
    "dwg_pos_img": [
      4812.3698359164655,
      2645.1106693485463
    ],
    "pos_dxf": [
      948.2663325940798,
      821.3169217998652
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GONKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GONKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.14 WLAN/an KT ",
    "grid_cols": [
      "H3",
      "I"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H3,I],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1078",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16349"
    },
    "position": {
      "x": 592.014343853128,
      "y": 1590.646058452453
    },
    "dwg_pos_img": [
      592.014343853128,
      1590.646058452453
    ],
    "pos_dxf": [
      232.44631980534564,
      999.6033245871836
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GOQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GOQKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.16 WLAN/an LS ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F1,G],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1079",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1635D"
    },
    "position": {
      "x": 5535.080960690051,
      "y": 1259.721448572186
    },
    "dwg_pos_img": [
      5535.080960690051,
      1259.721448572186
    ],
    "pos_dxf": [
      1070.846311354284,
      1056.372768776437
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GP9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GP9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 18.20 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I1,I2],[42-41]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1080",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16371"
    },
    "position": {
      "x": 3349.56017419267,
      "y": 4700.081833940293
    },
    "dwg_pos_img": [
      3349.56017419267,
      4700.081833940293
    ],
    "pos_dxf": [
      700.1572733616945,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GPCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.20 WLAN/an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G6,G7],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1081",
    "source_ids": {
      "object_id": null,
      "dwg_id": "163AD"
    },
    "position": {
      "x": 1583.3163215454388,
      "y": 3776.8964985069238
    },
    "dwg_pos_img": [
      1583.3163215454388,
      3776.8964985069238
    ],
    "pos_dxf": [
      400.5823442905066,
      628.9452247792551
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GPRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPRKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.15 WLAN/an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G1,G2],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1082",
    "source_ids": {
      "object_id": null,
      "dwg_id": "163C1"
    },
    "position": {
      "x": 4012.935868752554,
      "y": 2609.1594639402947
    },
    "dwg_pos_img": [
      4012.935868752554,
      2609.1594639402947
    ],
    "pos_dxf": [
      812.6732922269498,
      827.3099635103345
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GPUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPUKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.13 WLAN/an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H,H1],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1083",
    "source_ids": {
      "object_id": null,
      "dwg_id": "163D5"
    },
    "position": {
      "x": 5436.030961502411,
      "y": 2671.0971701632607
    },
    "dwg_pos_img": [
      5436.030961502411,
      2671.0971701632607
    ],
    "pos_dxf": [
      1054.046311492132,
      816.9909645379225
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GPXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GPXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 18.15 WLAN/an KT ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I,I1],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1084",
    "source_ids": {
      "object_id": null,
      "dwg_id": "163E9"
    },
    "position": {
      "x": 2615.5266970372318,
      "y": 2657.6131692626013
    },
    "dwg_pos_img": [
      2615.5266970372318,
      2657.6131692626013
    ],
    "pos_dxf": [
      575.656895610744,
      818.9099635569405
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQ0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQ0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.11 WLAN/an KT ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G4,G5],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1085",
    "source_ids": {
      "object_id": null,
      "dwg_id": "163FD"
    },
    "position": {
      "x": 3356.7313497433247,
      "y": 1642.5218628689063
    },
    "dwg_pos_img": [
      3356.7313497433247,
      1642.5218628689063
    ],
    "pos_dxf": [
      701.3735858224204,
      991.1658111594634
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQ3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQ3KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.23 WLAN/an KT ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1086",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16425"
    },
    "position": {
      "x": 593.429343838067,
      "y": 4149.940510261412
    },
    "dwg_pos_img": [
      593.429343838067,
      4149.940510261412
    ],
    "pos_dxf": [
      232.6863198029282,
      565.5479632909335
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQ9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQ9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.18 WLAN/an LS ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1087",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16439"
    },
    "position": {
      "x": 1943.3839509113322,
      "y": 4699.000404786097
    },
    "dwg_pos_img": [
      1943.3839509113322,
      4699.000404786097
    ],
    "pos_dxf": [
      461.65388566715023,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQCKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.19 WLAN/an KT ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1088",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16461"
    },
    "position": {
      "x": 1624.3476626537117,
      "y": 615.2677680864081
    },
    "dwg_pos_img": [
      1624.3476626537117,
      615.2677680864081
    ],
    "pos_dxf": [
      407.5417237009333,
      1165.1618294054858
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQIKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/ Aussen/an KT 14.18 ",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1089",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1649D"
    },
    "position": {
      "x": 3004.63034398153,
      "y": 3777.9862084539695
    },
    "dwg_pos_img": [
      3004.63034398153,
      3777.9862084539695
    ],
    "pos_dxf": [
      641.6532738911596,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQYKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.16 WLAN/an KT ",
    "grid_cols": [
      "G5",
      "G6"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G5,G6],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1090",
    "source_ids": {
      "object_id": null,
      "dwg_id": "164B1"
    },
    "position": {
      "x": 1510.9673462918645,
      "y": 2656.8572631586476
    },
    "dwg_pos_img": [
      1510.9673462918645,
      2656.8572631586476
    ],
    "pos_dxf": [
      388.31114000714547,
      818.8940953701212
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GR1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GR1KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.10 WLAN/an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G1,G2],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1091",
    "source_ids": {
      "object_id": null,
      "dwg_id": "164C5"
    },
    "position": {
      "x": 4773.382583007282,
      "y": 1926.630729754058
    },
    "dwg_pos_img": [
      4773.382583007282,
      1926.630729754058
    ],
    "pos_dxf": [
      941.6536536553763,
      943.1658117094503
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GR7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GR7KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 18.14 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[H2,H3],[41-40]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1092",
    "source_ids": {
      "object_id": null,
      "dwg_id": "164D9"
    },
    "position": {
      "x": 6843.761978629221,
      "y": 4718.322164526289
    },
    "dwg_pos_img": [
      6843.761978629221,
      4718.322164526289
    ],
    "pos_dxf": [
      1292.813409803686,
      469.96585280828185
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GRAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GRAKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/ Aussen/an KT 24.24 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I4,I5],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1093",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16501"
    },
    "position": {
      "x": 4773.3803260568675,
      "y": 4701.1832120493
    },
    "dwg_pos_img": [
      4773.3803260568675,
      4701.1832120493
    ],
    "pos_dxf": [
      941.6532708512141,
      472.60257029958575
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GRGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GRGKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.21 WLAN/an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H2,H3],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1094",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16515"
    },
    "position": {
      "x": 6827.4476141541045,
      "y": 963.1095874439525
    },
    "dwg_pos_img": [
      6827.4476141541045,
      963.1095874439525
    ],
    "pos_dxf": [
      1290.046309115124,
      1106.846614164756
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GRJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GRJKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1095",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16529"
    },
    "position": {
      "x": 2650.883943784833,
      "y": 4708.04785336112
    },
    "dwg_pos_img": [
      2650.883943784833,
      4708.04785336112
    ],
    "pos_dxf": [
      581.653884458508,
      471.16148830715906
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GS2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GS2KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Reserve/an Wand 10.08 ",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G4,G5],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1096",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1653D"
    },
    "position": {
      "x": 5834.630315787187,
      "y": 619.8955504980149
    },
    "dwg_pos_img": [
      5834.630315787187,
      619.8955504980149
    ],
    "pos_dxf": [
      1121.65326910928,
      1164.9261135483719
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GS5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GS5KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an KT 18.16 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I1,I2],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1097",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16551"
    },
    "position": {
      "x": 6611.78077987561,
      "y": 619.0926795656633
    },
    "dwg_pos_img": [
      6611.78077987561,
      619.0926795656633
    ],
    "pos_dxf": [
      1253.466775385863,
      1165.1636453178658
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GS8KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GS8KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/ Aussen/an KT 18.17 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1098",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16565"
    },
    "position": {
      "x": 5457.255961246563,
      "y": 3736.0811914038045
    },
    "dwg_pos_img": [
      5457.255961246563,
      3736.0811914038045
    ],
    "pos_dxf": [
      1057.646311448797,
      636.3727730067076
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GSFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GSFKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 24.20 4 m ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[I,I1],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1099",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1657E"
    },
    "position": {
      "x": 5535.080960687225,
      "y": 1967.2699041904107
    },
    "dwg_pos_img": [
      5535.080960687225,
      1967.2699041904107
    ],
    "pos_dxf": [
      1070.8463113538426,
      936.3727699850856
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GSJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GSJKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 18.22 3,8 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1100",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16597"
    },
    "position": {
      "x": 5726.128934046182,
      "y": 4717.462641418095
    },
    "dwg_pos_img": [
      5726.128934046182,
      4717.462641418095
    ],
    "pos_dxf": [
      1103.250207895463,
      469.96585280828185
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GSXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GSXKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.22 WLAN/an KT ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1101",
    "source_ids": {
      "object_id": null,
      "dwg_id": "165D3"
    },
    "position": {
      "x": 5535.084775495911,
      "y": 4089.915274034976
    },
    "dwg_pos_img": [
      5535.084775495911,
      4089.915274034976
    ],
    "pos_dxf": [
      1070.846958388645,
      576.3727736015205
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GT9KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GT9KH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 24.21 WLAN/an Wand 3,8 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1102",
    "source_ids": {
      "object_id": null,
      "dwg_id": "165EC"
    },
    "position": {
      "x": 4091.7773320892506,
      "y": 4992.108823204164
    },
    "dwg_pos_img": [
      4091.7773320892506,
      4992.108823204164
    ],
    "pos_dxf": [
      826.0456959025696,
      423.17277412775934
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GTDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTDKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Aussen/an Wand 10.23 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1103",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16600"
    },
    "position": {
      "x": 3374.418849564589,
      "y": 3451.029433279068
    },
    "dwg_pos_img": [
      3374.418849564589,
      3451.029433279068
    ],
    "pos_dxf": [
      704.3735857922038,
      684.4457947175192
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GTGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTGKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.17 WLAN/an KT ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1104",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16614"
    },
    "position": {
      "x": 4723.7874521764925,
      "y": 3729.779945516947
    },
    "dwg_pos_img": [
      4723.7874521764925,
      3729.779945516947
    ],
    "pos_dxf": [
      933.2417586735655,
      637.3457947626382
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GTJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTJKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/Reserve/an KT 12.07 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H2,H3],[36-35]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1105",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16628"
    },
    "position": {
      "x": 4075.9268335427582,
      "y": 4700.640451038955
    },
    "dwg_pos_img": [
      4075.9268335427582,
      4700.640451038955
    ],
    "pos_dxf": [
      823.3572721208147,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GTPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTPKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.09 WLAN/Reserve/an KT ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1106",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1663C"
    },
    "position": {
      "x": 5565.743339728865,
      "y": 3382.373409714156
    },
    "dwg_pos_img": [
      5565.743339728865,
      3382.373409714156
    ],
    "pos_dxf": [
      1076.0469975517976,
      696.3756533615783
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GTSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GTSKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 24.19 3,8 m ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[I1,I2],[36-35]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1107",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16669"
    },
    "position": {
      "x": 3524.29258165676,
      "y": 2853.1292093278544
    },
    "dwg_pos_img": [
      3524.29258165676,
      2853.1292093278544
    ],
    "pos_dxf": [
      729.7938654403335,
      785.869035695719
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GU6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GU6KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.12 WLAN/an LS ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1108",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1667D"
    },
    "position": {
      "x": 1446.0849749407926,
      "y": 408.97473661746335
    },
    "dwg_pos_img": [
      1446.0849749407926,
      408.97473661746335
    ],
    "pos_dxf": [
      377.3063561736194,
      1200.125812491508
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GUGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GUGKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.17 WLAN/an LS ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1109",
    "source_ids": {
      "object_id": null,
      "dwg_id": "166A0"
    },
    "position": {
      "x": 593.4293438384926,
      "y": 2800.6026855092687
    },
    "dwg_pos_img": [
      593.4293438384926,
      2800.6026855092687
    ],
    "pos_dxf": [
      232.6863198029282,
      794.395240185775
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GUPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GUPKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.17 WLAN/an LS ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F1,G],[38-37]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1110",
    "source_ids": {
      "object_id": null,
      "dwg_id": "166C8"
    },
    "position": {
      "x": 6787.378923356366,
      "y": 4763.090205176739
    },
    "dwg_pos_img": [
      6787.378923356366,
      4763.090205176739
    ],
    "pos_dxf": [
      1283.25020608249,
      462.36585284683224
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GUYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GUYKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/ Aussen/an KT 24.23 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I4,I5],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1111",
    "source_ids": {
      "object_id": null,
      "dwg_id": "166DC"
    },
    "position": {
      "x": 4065.880333602527,
      "y": 3778.802369799657
    },
    "dwg_pos_img": [
      4065.880333602527,
      3778.802369799657
    ],
    "pos_dxf": [
      821.6532721309018,
      628.9457948092452
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GVAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GVAKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.18 WLAN/an KT ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[H,H1],[35-34]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1112",
    "source_ids": {
      "object_id": null,
      "dwg_id": "166F0"
    },
    "position": {
      "x": 1557.7466444675238,
      "y": 1595.0144077878867
    },
    "dwg_pos_img": [
      1557.7466444675238,
      1595.0144077878867
    ],
    "pos_dxf": [
      396.2454379308815,
      998.9884160640581
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GVHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GVHKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 14.21 WLAN/an KT ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G1,G2],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1113",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16704"
    },
    "position": {
      "x": 6669.0238681242045,
      "y": 895.7663902928416
    },
    "dwg_pos_img": [
      6669.0238681242045,
      895.7663902928416
    ],
    "pos_dxf": [
      1263.175850424516,
      1118.247336041647
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GVKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GVKKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an KT 18.18 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I4,I5],[44-43]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1114",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16718"
    },
    "position": {
      "x": 6829.805947444014,
      "y": 1968.2656210176447
    },
    "dwg_pos_img": [
      6829.805947444014,
      1968.2656210176447
    ],
    "pos_dxf": [
      1290.446309107813,
      936.3727699874698
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GVQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GVQKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 WLAN/an Wand 18.23 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I4,I5],[40-39]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1115",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1672C"
    },
    "position": {
      "x": 2297.1303514192336,
      "y": 2607.839912323183
    },
    "dwg_pos_img": [
      2297.1303514192336,
      2607.839912323183
    ],
    "pos_dxf": [
      521.6532751525235,
      827.3099635103345
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GW0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GW0KH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.05 WLAN/Reserve/an KT ",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G3,G4],[39-38]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1116",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16745"
    },
    "position": {
      "x": 3665.3943130133307,
      "y": 2966.6710820669687
    },
    "dwg_pos_img": [
      3665.3943130133307,
      2966.6710820669687
    ],
    "pos_dxf": [
      753.7263145750412,
      766.6307734158904
    ],
    "type": "1xUP-SD_ SchuKo_A01U1GWDKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xUP-SD_ SchuKo_A01U1GWDKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1117",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16751"
    },
    "position": {
      "x": 4104.0407614038595,
      "y": 5023.057737035485
    },
    "dwg_pos_img": [
      4104.0407614038595,
      5023.057737035485
    ],
    "pos_dxf": [
      828.1257121820827,
      417.9254474743248
    ],
    "type": "1xAP-SD_ SchuKo_A01U1GWIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1GWIKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "10F01 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1118",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16763"
    },
    "position": {
      "x": 4101.682428094281,
      "y": 5026.027511842938
    },
    "dwg_pos_img": [
      4101.682428094281,
      5026.027511842938
    ],
    "pos_dxf": [
      827.7257121861117,
      417.4214669857847
    ],
    "type": "Taster_ AP_ 1S_A01U1GWKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ AP_ 1S_A01U1GWKKH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1119",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16774"
    },
    "position": {
      "x": 1528.2553544759612,
      "y": 4753.721148758263
    },
    "dwg_pos_img": [
      1528.2553544759612,
      4753.721148758263
    ],
    "pos_dxf": [
      391.2433816780608,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWOKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1120",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1677D"
    },
    "position": {
      "x": 1356.0970228767505,
      "y": 4753.588749251112
    },
    "dwg_pos_img": [
      1356.0970228767505,
      4753.588749251112
    ],
    "pos_dxf": [
      362.0433819721652,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWPKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWPKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1121",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16786"
    },
    "position": {
      "x": 1488.1636882131306,
      "y": 4753.690315996324
    },
    "dwg_pos_img": [
      1488.1636882131306,
      4753.690315996324
    ],
    "pos_dxf": [
      384.4433817465508,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWQKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1122",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1678F"
    },
    "position": {
      "x": 1431.5636887832534,
      "y": 4753.646787391233
    },
    "dwg_pos_img": [
      1431.5636887832534,
      4753.646787391233
    ],
    "pos_dxf": [
      374.8433818432427,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWRKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1123",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16798"
    },
    "position": {
      "x": 1374.9636893533761,
      "y": 4753.603258786143
    },
    "dwg_pos_img": [
      1374.9636893533761,
      4753.603258786143
    ],
    "pos_dxf": [
      365.2433819399346,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWSKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1124",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167A1"
    },
    "position": {
      "x": 1259.405357184044,
      "y": 4753.514387884083
    },
    "dwg_pos_img": [
      1259.405357184044,
      4753.514387884083
    ],
    "pos_dxf": [
      345.6433821373473,
      463.2688851322537
    ],
    "type": "E-Verteiler_A01U1GWTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWTKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G1,G2],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1125",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167AB"
    },
    "position": {
      "x": 1169.8823053289916,
      "y": 611.9769504302676
    },
    "dwg_pos_img": [
      1169.8823053289916,
      611.9769504302676
    ],
    "pos_dxf": [
      330.4592602677058,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWUKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1126",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167B4"
    },
    "position": {
      "x": 1141.5823056140534,
      "y": 611.9551861277223
    },
    "dwg_pos_img": [
      1141.5823056140534,
      611.9551861277223
    ],
    "pos_dxf": [
      325.6592603160518,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWVKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1127",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167BD"
    },
    "position": {
      "x": 1122.7156391374274,
      "y": 611.9406765926915
    },
    "dwg_pos_img": [
      1122.7156391374274,
      611.9406765926915
    ],
    "pos_dxf": [
      322.4592603482824,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWWKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1128",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167C6"
    },
    "position": {
      "x": 1103.8489726608022,
      "y": 611.9261670576616
    },
    "dwg_pos_img": [
      1103.8489726608022,
      611.9261670576616
    ],
    "pos_dxf": [
      319.2592603805131,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWXKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1129",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167CF"
    },
    "position": {
      "x": 1084.9823061841762,
      "y": 611.9116575226317
    },
    "dwg_pos_img": [
      1084.9823061841762,
      611.9116575226317
    ],
    "pos_dxf": [
      316.0592604127437,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWYKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1130",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167D8"
    },
    "position": {
      "x": 1066.1156397075501,
      "y": 611.8971479876018
    },
    "dwg_pos_img": [
      1066.1156397075501,
      611.8971479876018
    ],
    "pos_dxf": [
      312.8592604449743,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GWZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GWZKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1131",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167E1"
    },
    "position": {
      "x": 1026.02397344472,
      "y": 611.8663152256622
    },
    "dwg_pos_img": [
      1026.02397344472,
      611.8663152256622
    ],
    "pos_dxf": [
      306.0592605134643,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GX0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GX0KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1132",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167F3"
    },
    "position": {
      "x": 912.8239745849654,
      "y": 611.779258015481
    },
    "dwg_pos_img": [
      912.8239745849654,
      611.779258015481
    ],
    "pos_dxf": [
      286.8592607068481,
      1165.660674340528
    ],
    "type": "E-Verteiler_A01U1GX2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GX2KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1133",
    "source_ids": {
      "object_id": null,
      "dwg_id": "167FD"
    },
    "position": {
      "x": 3678.6009795469677,
      "y": 2969.0397335935504
    },
    "dwg_pos_img": [
      3678.6009795469677,
      2969.0397335935504
    ],
    "pos_dxf": [
      755.9663145524798,
      766.2307734199194
    ],
    "type": "Taster_ UP_ 1S_A01U1GX7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Taster_ UP_ 1S_A01U1GX7KH",
    "dwg_layer": "ADE_ET_NSV_Schalter",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1134",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16803"
    },
    "position": {
      "x": 1178.4204923360567,
      "y": 4797.70639926663
    },
    "dwg_pos_img": [
      1178.4204923360567,
      4797.70639926663
    ],
    "pos_dxf": [
      331.9074333291999,
      455.7633706986264
    ],
    "type": "Steckdosenverteiler_A01U1GY1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1GY1KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F8 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G,G1],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1135",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16CDC"
    },
    "position": {
      "x": 6130.445192901017,
      "y": 4801.514789372494
    },
    "dwg_pos_img": [
      6130.445192901017,
      4801.514789372494
    ],
    "pos_dxf": [
      1171.826817171252,
      455.763370248465
    ],
    "type": "Steckdosenverteiler_A01U1GY3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1GY3KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F4 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[I2,I3],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1136",
    "source_ids": {
      "object_id": null,
      "dwg_id": "171B5"
    },
    "position": {
      "x": 6905.980113644219,
      "y": 1601.0296767565887
    },
    "dwg_pos_img": [
      6905.980113644219,
      1601.0296767565887
    ],
    "pos_dxf": [
      1303.366309028686,
      998.665807852467
    ],
    "type": "Steckdosenverteiler_A01U1GY5KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1GY5KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F4 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1137",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1768E"
    },
    "position": {
      "x": 4432.919973504044,
      "y": 541.2248685411723
    },
    "dwg_pos_img": [
      4432.919973504044,
      541.2248685411723
    ],
    "pos_dxf": [
      883.9073453296201,
      1178.085809270199
    ],
    "type": "Steckdosenverteiler_A01U1GY7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Steckdosenverteiler_A01U1GY7KH",
    "dwg_layer": "ADE_ET_NSHV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Typ 1 1F8 ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[H2,H3],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1138",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17B67"
    },
    "position": {
      "x": 1612.9368334544765,
      "y": 4766.186439606967
    },
    "dwg_pos_img": [
      1612.9368334544765,
      4766.186439606967
    ],
    "pos_dxf": [
      405.6063180419196,
      461.1658208224508
    ],
    "type": "E-Verteiler_A01U1GYGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYGKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1139",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17B70"
    },
    "position": {
      "x": 1643.5951664789973,
      "y": 4753.238295915053
    },
    "dwg_pos_img": [
      1643.5951664789973,
      4753.238295915053
    ],
    "pos_dxf": [
      410.8063179895448,
      463.3658208002928
    ],
    "type": "Polygonsäule_A01U1GYHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYHKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1140",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17B87"
    },
    "position": {
      "x": 1612.9368334544806,
      "y": 4753.214717920628
    },
    "dwg_pos_img": [
      1612.9368334544806,
      4753.214717920628
    ],
    "pos_dxf": [
      405.6063180419196,
      463.365820800293
    ],
    "type": "Polygonsäule_A01U1GYIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYIKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G2,G3],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1141",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17B9E"
    },
    "position": {
      "x": 4339.641805962397,
      "y": 4756.490952733956
    },
    "dwg_pos_img": [
      4339.641805962397,
      4756.490952733956
    ],
    "pos_dxf": [
      868.0863133793068,
      463.1658213387377
    ],
    "type": "Polygonsäule_A01U1GYJKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYJKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1142",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17BB5"
    },
    "position": {
      "x": 4376.195972260858,
      "y": 4756.519064958077
    },
    "dwg_pos_img": [
      4376.195972260858,
      4756.519064958077
    ],
    "pos_dxf": [
      874.2863133168598,
      463.1658213387377
    ],
    "type": "Polygonsäule_A01U1GYKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYKKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1143",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17BCC"
    },
    "position": {
      "x": 4339.6418059623875,
      "y": 4769.462674420287
    },
    "dwg_pos_img": [
      4339.6418059623875,
      4769.462674420287
    ],
    "pos_dxf": [
      868.0863133793059,
      460.9658213608968
    ],
    "type": "E-Verteiler_A01U1GYLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYLKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1144",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17BD5"
    },
    "position": {
      "x": 1611.9946792567926,
      "y": 596.5914747291881
    },
    "dwg_pos_img": [
      1611.9946792567926,
      596.5914747291881
    ],
    "pos_dxf": [
      405.4465180364355,
      1168.327711749313
    ],
    "type": "Polygonsäule_A01U1GYMKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYMKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1145",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17BF5"
    },
    "position": {
      "x": 1642.6530122813092,
      "y": 596.5132117229914
    },
    "dwg_pos_img": [
      1642.6530122813092,
      596.5132117229914
    ],
    "pos_dxf": [
      410.6465179840607,
      1168.344983951456
    ],
    "type": "Polygonsäule_A01U1GYOKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYOKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G2",
      "G3"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G2,G3],[44-43]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1146",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C23"
    },
    "position": {
      "x": 5458.19929479908,
      "y": 871.7309465901008
    },
    "dwg_pos_img": [
      5458.19929479908,
      871.7309465901008
    ],
    "pos_dxf": [
      1057.80631148582,
      1122.165809856108
    ],
    "type": "Polygonsäule_A01U1GYQKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYQKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1147",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C3A"
    },
    "position": {
      "x": 5481.782627894864,
      "y": 871.749083508882
    },
    "dwg_pos_img": [
      5481.782627894864,
      871.749083508882
    ],
    "pos_dxf": [
      1061.806311445532,
      1122.165809856109
    ],
    "type": "E-Verteiler_A01U1GYRKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYRKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[I,I1],[44-43]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1148",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C43"
    },
    "position": {
      "x": 3729.7762364813675,
      "y": 3523.062467161387
    },
    "dwg_pos_img": [
      3729.7762364813675,
      3523.062467161387
    ],
    "pos_dxf": [
      764.6462167887394,
      672.2753643872229
    ],
    "type": "Polygonsäule_A01U1GYSKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYSKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H,H1],[36-35]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1149",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C5A"
    },
    "position": {
      "x": 3729.7762364813593,
      "y": 3547.826663108023
    },
    "dwg_pos_img": [
      3729.7762364813593,
      3547.826663108023
    ],
    "pos_dxf": [
      764.6462167887394,
      668.075364429526
    ],
    "type": "Polygonsäule_A01U1GYTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYTKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[H,H1],[36-35]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1150",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C71"
    },
    "position": {
      "x": 3716.80540327868,
      "y": 3547.8166878026896
    },
    "dwg_pos_img": [
      3716.80540327868,
      3547.8166878026896
    ],
    "pos_dxf": [
      762.446216810898,
      668.075364429526
    ],
    "type": "E-Verteiler_A01U1GYUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYUKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1151",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C7A"
    },
    "position": {
      "x": 3728.5976455504065,
      "y": 1762.1476310447897
    },
    "dwg_pos_img": [
      3728.5976455504065,
      1762.1476310447897
    ],
    "pos_dxf": [
      764.4463144399308,
      970.9258211289462
    ],
    "type": "Polygonsäule_A01U1GYVKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYVKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[H,H1],[41-40]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1152",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17C91"
    },
    "position": {
      "x": 3728.5976455504174,
      "y": 1737.3834350981506
    },
    "dwg_pos_img": [
      3728.5976455504174,
      1737.3834350981506
    ],
    "pos_dxf": [
      764.4463144399313,
      975.1258210866436
    ],
    "type": "Polygonsäule_A01U1GYWKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYWKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[H,H1],[41-40]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1153",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CA8"
    },
    "position": {
      "x": 3715.626812347727,
      "y": 1762.137655739456
    },
    "dwg_pos_img": [
      3715.626812347727,
      1762.137655739456
    ],
    "pos_dxf": [
      762.2463144620895,
      970.9258211289462
    ],
    "type": "E-Verteiler_A01U1GYXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GYXKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G7,H],[41-40]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1154",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CB1"
    },
    "position": {
      "x": 5990.967125741639,
      "y": 4757.760958212192
    },
    "dwg_pos_img": [
      5990.967125741639,
      4757.760958212192
    ],
    "pos_dxf": [
      1148.169759843846,
      463.1658140824377
    ],
    "type": "Polygonsäule_A01U1GYYKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYYKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1155",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CC8"
    },
    "position": {
      "x": 6015.729625492215,
      "y": 4757.780001976919
    },
    "dwg_pos_img": [
      6015.729625492215,
      4757.780001976919
    ],
    "pos_dxf": [
      1152.369759801544,
      463.1658140824377
    ],
    "type": "Polygonsäule_A01U1GYZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GYZKH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1156",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CDF"
    },
    "position": {
      "x": 5990.967125741636,
      "y": 4770.732679898529
    },
    "dwg_pos_img": [
      5990.967125741636,
      4770.732679898529
    ],
    "pos_dxf": [
      1148.169759843846,
      460.9658141045959
    ],
    "type": "E-Verteiler_A01U1GZ0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GZ0KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I2,I3],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1157",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CE8"
    },
    "position": {
      "x": 6848.453129676686,
      "y": 1591.1976625591633
    },
    "dwg_pos_img": [
      6848.453129676686,
      1591.1976625591633
    ],
    "pos_dxf": [
      1293.609082065987,
      1000.325811067075
    ],
    "type": "Polygonsäule_A01U1GZ1KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GZ1KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1158",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17CFF"
    },
    "position": {
      "x": 6848.453129676696,
      "y": 1560.5372294823692
    },
    "dwg_pos_img": [
      6848.453129676696,
      1560.5372294823692
    ],
    "pos_dxf": [
      1293.609082065987,
      1005.525811014701
    ],
    "type": "Polygonsäule_A01U1GZ2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Polygonsäule_A01U1GZ2KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1159",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D16"
    },
    "position": {
      "x": 6872.255947227565,
      "y": 1591.2159682739275
    },
    "dwg_pos_img": [
      6872.255947227565,
      1591.2159682739275
    ],
    "pos_dxf": [
      1297.646309071086,
      1000.325811067075
    ],
    "type": "E-Verteiler_A01U1GZ3KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "E-Verteiler_A01U1GZ3KH",
    "dwg_layer": "ADE_ET_NSV_Verteiler",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1160",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D20"
    },
    "position": {
      "x": 479.99351147101663,
      "y": 4191.519752943936
    },
    "dwg_pos_img": [
      479.99351147101663,
      4191.519752943936
    ],
    "pos_dxf": [
      213.4463199668082,
      558.4813409820565
    ],
    "type": "Auslass 230 V_A01U1H06KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H06KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 21F01 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1161",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D42"
    },
    "position": {
      "x": 486.8368701597084,
      "y": 3134.478605717466
    },
    "dwg_pos_img": [
      486.8368701597084,
      3134.478605717466
    ],
    "pos_dxf": [
      214.6070309810889,
      737.7560845477033
    ],
    "type": "Auslass 230 V_A01U1H0CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H0CKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 21F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1162",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D64"
    },
    "position": {
      "x": 3921.326062871745,
      "y": 4961.143639362428
    },
    "dwg_pos_img": [
      3921.326062871745,
      4961.143639362428
    ],
    "pos_dxf": [
      797.1352332790821,
      428.4022274504548
    ],
    "type": "Geräteanschluß 400 V_A01U1H0VKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H0VKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Schieber WHG-Fläche xxFxx ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1163",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D77"
    },
    "position": {
      "x": 3925.2538486177423,
      "y": 4961.53081169362
    },
    "dwg_pos_img": [
      3925.2538486177423,
      4961.53081169362
    ],
    "pos_dxf": [
      797.8014301547287,
      428.3370754511109
    ],
    "type": "Schaltkreis_A01U1H0YKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1H0YKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1164",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D7C"
    },
    "position": {
      "x": 3846.4416228177283,
      "y": 4998.6463529140065
    },
    "dwg_pos_img": [
      3846.4416228177283,
      4998.6463529140065
    ],
    "pos_dxf": [
      784.4339854960608,
      422.0320115450156
    ],
    "type": "Revisionswolke_A01U1H0ZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Revisionswolke_A01U1H0ZKH",
    "dwg_layer": "ADE_ET_Allg_OFFEN",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1165",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17D9B"
    },
    "position": {
      "x": 597.9101545292416,
      "y": 4766.820949284835
    },
    "dwg_pos_img": [
      597.9101545292416,
      4766.820949284835
    ],
    "pos_dxf": [
      233.4463159625957,
      460.9258164545308
    ],
    "type": "Geräteanschluß 400 V_A01U1H10KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H10KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 23F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1166",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17DAE"
    },
    "position": {
      "x": 597.9101502904338,
      "y": 4790.548964505053
    },
    "dwg_pos_img": [
      597.9101502904338,
      4790.548964505053
    ],
    "pos_dxf": [
      233.4463152436472,
      456.9015524263509
    ],
    "type": "Auslass 230 V_A01U1H13KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H13KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 21F04 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F1,G],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1167",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17DBF"
    },
    "position": {
      "x": 4045.650418361058,
      "y": 4765.698864683045
    },
    "dwg_pos_img": [
      4045.650418361058,
      4765.698864683045
    ],
    "pos_dxf": [
      818.2220497578405,
      461.5658165097204
    ],
    "type": "Geräteanschluß 400 V_A01U1H16KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H16KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 23F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1168",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17DD2"
    },
    "position": {
      "x": 4078.1729777290507,
      "y": 4824.8508461626025
    },
    "dwg_pos_img": [
      4078.1729777290507,
      4824.8508461626025
    ],
    "pos_dxf": [
      823.7382435729137,
      451.5379007578922
    ],
    "type": "Geräteanschluß 400 V_A01U1H19KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H19KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 23F02 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1169",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17DE5"
    },
    "position": {
      "x": 5775.634548031663,
      "y": 4770.567062869801
    },
    "dwg_pos_img": [
      5775.634548031663,
      4770.567062869801
    ],
    "pos_dxf": [
      1111.646919808204,
      460.9658164927553
    ],
    "type": "Geräteanschluß 400 V_A01U1H1CKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H1CKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 21F01 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[I1,I2],[33-32]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1170",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17DF8"
    },
    "position": {
      "x": 5507.394127947122,
      "y": 4330.831671163567
    },
    "dwg_pos_img": [
      5507.394127947122,
      4330.831671163567
    ],
    "pos_dxf": [
      1066.150311454584,
      535.5098155725816
    ],
    "type": "Auslass 230 V_A01U1H1FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H1FKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 20F02 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I1,I2],[34-33]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1171",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E09"
    },
    "position": {
      "x": 5474.800404703659,
      "y": 4328.2122604071865
    },
    "dwg_pos_img": [
      5474.800404703659,
      4328.2122604071865
    ],
    "pos_dxf": [
      1060.622047441554,
      535.9498155681499
    ],
    "type": "Geräteanschluß 400 V_A01U1H1IKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H1IKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 23F03 ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[I,I1],[34-33]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1172",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E1C"
    },
    "position": {
      "x": 5507.6299609904545,
      "y": 2208.6110048386327
    },
    "dwg_pos_img": [
      5507.6299609904545,
      2208.6110048386327
    ],
    "pos_dxf": [
      1066.190311405283,
      895.4378136285331
    ],
    "type": "Auslass 230 V_A01U1H1LKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H1LKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 22F02 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I1,I2],[40-39]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1173",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E2D"
    },
    "position": {
      "x": 5476.306239101211,
      "y": 2205.7567213000157
    },
    "dwg_pos_img": [
      5476.306239101211,
      2205.7567213000157
    ],
    "pos_dxf": [
      1060.877453982368,
      895.9178136236983
    ],
    "type": "Geräteanschluß 400 V_A01U1H1OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H1OKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F03 Sektionaltor ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[I,I1],[40-39]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1174",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E40"
    },
    "position": {
      "x": 5474.91832119496,
      "y": 1018.9626103262926
    },
    "dwg_pos_img": [
      5474.91832119496,
      1018.9626103262926
    ],
    "pos_dxf": [
      1060.642047411633,
      1097.197546008242
    ],
    "type": "Geräteanschluß 400 V_A01U1H1RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H1RKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F02 Sektionaltor ",
    "grid_cols": [
      "I",
      "I1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I,I1],[43-42]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1175",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E53"
    },
    "position": {
      "x": 5507.39412777295,
      "y": 1016.6290912087516
    },
    "dwg_pos_img": [
      5507.39412777295,
      1016.6290912087516
    ],
    "pos_dxf": [
      1066.150311424865,
      1097.597546004213
    ],
    "type": "Auslass 230 V_A01U1H1UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H1UKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 22F03 ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1176",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E64"
    },
    "position": {
      "x": 5839.070086367325,
      "y": 1205.0433309664095
    },
    "dwg_pos_img": [
      5839.070086367325,
      1205.0433309664095
    ],
    "pos_dxf": [
      1122.406304402056,
      1065.685810415468
    ],
    "type": "Auslass 230 V_A01U1H1XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H1XKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "22F01 Schnelllauftor ",
    "grid_cols": [
      "I1",
      "I2"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I1,I2],[43-42]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1177",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E75"
    },
    "position": {
      "x": 3688.7190572234654,
      "y": 2681.862604789838
    },
    "dwg_pos_img": [
      3688.7190572234654,
      2681.862604789838
    ],
    "pos_dxf": [
      757.6824549357586,
      814.9372451826207
    ],
    "type": "Auslass 230 V_A01U1H20KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H20KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F03 Schnelllauftor ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[G7,H],[38-37]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1178",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E86"
    },
    "position": {
      "x": 4031.736252199447,
      "y": 579.7387178580893
    },
    "dwg_pos_img": [
      4031.736252199447,
      579.7387178580893
    ],
    "pos_dxf": [
      815.8620498432779,
      1171.50154526053
    ],
    "type": "Geräteanschluß 400 V_A01U1H23KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H23KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 21F01 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1179",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17E99"
    },
    "position": {
      "x": 817.8247368724095,
      "y": 573.7293101800551
    },
    "dwg_pos_img": [
      817.8247368724095,
      573.7293101800551
    ],
    "pos_dxf": [
      270.7463157944567,
      1172.101542782649
    ],
    "type": "Geräteanschluß 400 V_A01U1H26KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Geräteanschluß 400 V_A01U1H26KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Sektionaltor 22F01 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[F1,G],[44-43]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1180",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17EAC"
    },
    "position": {
      "x": 479.8048450722664,
      "y": 2905.264476328224
    },
    "dwg_pos_img": [
      479.8048450722664,
      2905.264476328224
    ],
    "pos_dxf": [
      213.414320012181,
      776.6298126552397
    ],
    "type": "Auslass 230 V_A01U1H29KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H29KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 21F03 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[F,F1],[38-37]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1181",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17EDF"
    },
    "position": {
      "x": 484.1441783621507,
      "y": 2080.6923968280307
    },
    "dwg_pos_img": [
      484.1441783621507,
      2080.6923968280307
    ],
    "pos_dxf": [
      214.150320004768,
      916.4775477762364
    ],
    "type": "Auslass 230 V_A01U1H2OKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H2OKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F03 Brandschutztor ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "40",
      "39"
    ],
    "chessboard_id": "[F,F1],[40-39]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1182",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17EF0"
    },
    "position": {
      "x": 484.14417824914824,
      "y": 1843.9451221104791
    },
    "dwg_pos_img": [
      484.14417824914824,
      1843.9451221104791
    ],
    "pos_dxf": [
      214.1503199855888,
      956.6298121962445
    ],
    "type": "Auslass 230 V_A01U1H2RKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H2RKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Brandschutztor 21F02 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[F,F1],[41-40]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1183",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F12"
    },
    "position": {
      "x": 479.9935115115503,
      "y": 1148.4220194728778
    },
    "dwg_pos_img": [
      479.9935115115503,
      1148.4220194728778
    ],
    "pos_dxf": [
      213.4463199735203,
      1074.58977347015
    ],
    "type": "Auslass 230 V_A01U1H2XKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1H2XKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F01 Brandschutztor ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[F,F1],[43-42]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1184",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F34"
    },
    "position": {
      "x": 6860.228447253998,
      "y": 2772.576789757327
    },
    "dwg_pos_img": [
      6860.228447253998,
      2772.576789757327
    ],
    "pos_dxf": [
      1295.606309075631,
      799.9658130995617
    ],
    "type": "1xAP-SD_ SchuKo_A01U1H9UKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "1xAP-SD_ SchuKo_A01U1H9UKH",
    "dwg_layer": "ADE_ET_NSV_Steckdose",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "xxFxx ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1185",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F46"
    },
    "position": {
      "x": 6893.8347062349085,
      "y": 2781.3289564450606
    },
    "dwg_pos_img": [
      6893.8347062349085,
      2781.3289564450606
    ],
    "pos_dxf": [
      1301.3063105989,
      798.4858316655082
    ],
    "type": "Magnetkontakt_A01U1H9ZKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Magnetkontakt_A01U1H9ZKH",
    "dwg_layer": "Adenbeck_ET_SWS_Zuko",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "MGK12 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "right side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1186",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F50"
    },
    "position": {
      "x": 6876.383030203967,
      "y": 2864.1360337739716
    },
    "dwg_pos_img": [
      6876.383030203967,
      2864.1360337739716
    ],
    "pos_dxf": [
      1298.346309010615,
      784.4395007609296
    ],
    "type": "Türcontroller_A01U1HA4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Türcontroller_A01U1HA4KH",
    "dwg_layer": "ADE_ET_ZKS_Türsteuereinheit",
    "dwg_rgb": [
      255,
      127,
      0
    ],
    "dwg_txt": "TCT GAM12 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1187",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F60"
    },
    "position": {
      "x": 6873.435113787633,
      "y": 2772.5869464318457
    },
    "dwg_pos_img": [
      6873.435113787633,
      2772.5869464318457
    ],
    "pos_dxf": [
      1297.846309053069,
      799.9658130995622
    ],
    "type": "Druckknopfmelder_A01U1HA6KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Druckknopfmelder_A01U1HA6KH",
    "dwg_layer": "ADE_ET_BMA_Brandmelder-W",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "05/008 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "38",
      "37"
    ],
    "chessboard_id": "[I4,I5],[38-37]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1188",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F70"
    },
    "position": {
      "x": 952.842929947342,
      "y": 4766.8476694249275
    },
    "dwg_pos_img": [
      952.842929947342,
      4766.8476694249275
    ],
    "pos_dxf": [
      293.6469280476908,
      460.9675792360861
    ],
    "type": "Auslass 230 V_A01U1HAAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HAAKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "22F05 RWA ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1189",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F81"
    },
    "position": {
      "x": 920.187736109841,
      "y": 4753.321594999099
    },
    "dwg_pos_img": [
      920.187736109841,
      4753.321594999099
    ],
    "pos_dxf": [
      288.10823792683755,
      463.25733799211116
    ],
    "type": "RWA-Zentrale_A01U1HADKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Zentrale_A01U1HADKH",
    "dwg_layer": "ADE_ET_RWA_Zentrale",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "RWA-Z ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1190",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17F8A"
    },
    "position": {
      "x": 905.6485912633387,
      "y": 4766.821768066676
    },
    "dwg_pos_img": [
      905.6485912633387,
      4766.821768066676
    ],
    "pos_dxf": [
      285.6422345606452,
      460.9658164574355
    ],
    "type": "RWA-Taster_A01U1HAEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RWA-Taster_A01U1HAEKH",
    "dwg_layer": "ADE_ET_RWA_Taster",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[G,G1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1191",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FAC"
    },
    "position": {
      "x": 4565.297729540933,
      "y": 4842.157742317322
    },
    "dwg_pos_img": [
      4565.297729540933,
      4842.157742317322
    ],
    "pos_dxf": [
      906.3601096046755,
      448.6661930758456
    ],
    "type": "FIZ",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "FIZ",
    "dwg_layer": "ADE_ET_BMA_Peripherie",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "FIZ ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1192",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FB2"
    },
    "position": {
      "x": 4553.307243467201,
      "y": 4818.785626330251
    },
    "dwg_pos_img": [
      4553.307243467201,
      4818.785626330251
    ],
    "pos_dxf": [
      904.3263875850998,
      452.6285327635451
    ],
    "type": "Zentralbedientableau RWA_A01U1HAFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Zentralbedientableau RWA_A01U1HAFKH",
    "dwg_layer": "ADE_ET_RWA_Zentralbedientableau",
    "dwg_rgb": [
      127,
      31,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1193",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FC1"
    },
    "position": {
      "x": 4553.307106071425,
      "y": 4802.276162260161
    },
    "dwg_pos_img": [
      4553.307106071425,
      4802.276162260161
    ],
    "pos_dxf": [
      904.3263642812217,
      455.4285327353432
    ],
    "type": "Auslass 230 V_A01U1HAGKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HAGKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "26F04 RWA ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1194",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FD2"
    },
    "position": {
      "x": 461.12684507229267,
      "y": 1535.3419641087821
    },
    "dwg_pos_img": [
      461.12684507229267,
      1535.3419641087821
    ],
    "pos_dxf": [
      210.2463200121097,
      1008.965809960442
    ],
    "type": "Auslass 230 V_A01U1HBFKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HBFKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "21F04 Armatur ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1195",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FE3"
    },
    "position": {
      "x": 461.13149690849457,
      "y": 1521.4771319796782
    },
    "dwg_pos_img": [
      461.13149690849457,
      1521.4771319796782
    ],
    "pos_dxf": [
      210.2471090161291,
      1011.317281799334
    ],
    "type": "Auslass 400 V_A01U1HBIKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1HBIKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "23F03 ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1196",
    "source_ids": {
      "object_id": null,
      "dwg_id": "17FF1"
    },
    "position": {
      "x": 465.22908265278477,
      "y": 1501.8964265061659
    },
    "dwg_pos_img": [
      465.22908265278477,
      1501.8964265061659
    ],
    "pos_dxf": [
      210.9421058914852,
      1014.6386978345913
    ],
    "type": "Schaltkreis_A01U1HBKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1HBKKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "16A DLE ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[F,F1],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1197",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1800A"
    },
    "position": {
      "x": 3498.1138637061836,
      "y": 1607.7252680896963
    },
    "dwg_pos_img": [
      3498.1138637061836,
      1607.7252680896963
    ],
    "pos_dxf": [
      725.3536588620739,
      997.0857436210581
    ],
    "type": "Auslass 230 V_A01U1HBUKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HBUKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1198",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1801B"
    },
    "position": {
      "x": 3460.3805307529324,
      "y": 1607.6962490196356
    },
    "dwg_pos_img": [
      3460.3805307529324,
      1607.6962490196356
    ],
    "pos_dxf": [
      718.9536589265351,
      997.0857436210581
    ],
    "type": "Auslass 230 V_A01U1HBXKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HBXKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 20F02 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1199",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1802C"
    },
    "position": {
      "x": 3481.0287986624858,
      "y": 1608.1618227549998
    },
    "dwg_pos_img": [
      3481.0287986624858,
      1608.1618227549998
    ],
    "pos_dxf": [
      722.4558386426459,
      997.009475649897
    ],
    "type": "Auslass 400 V_A01U1HC0KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1HC0KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "24F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1200",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1803A"
    },
    "position": {
      "x": 3475.7325480491695,
      "y": 1604.4061152595295
    },
    "dwg_pos_img": [
      3475.7325480491695,
      1604.4061152595295
    ],
    "pos_dxf": [
      721.5575346516937,
      997.6457516778446
    ],
    "type": "Schaltkreis_A01U1HC2KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1HC2KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A DLE ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1201",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18044"
    },
    "position": {
      "x": 3457.3932469034457,
      "y": 3736.6140416964217
    },
    "dwg_pos_img": [
      3457.3932469034457,
      3736.6140416964217
    ],
    "pos_dxf": [
      718.446981807301,
      636.0215561347977
    ],
    "type": "Auslass 230 V_A01U1HC4KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HC4KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 21F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1202",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18055"
    },
    "position": {
      "x": 3495.126579856697,
      "y": 3736.6430607664824
    },
    "dwg_pos_img": [
      3495.126579856697,
      3736.6430607664824
    ],
    "pos_dxf": [
      724.8469817428397,
      636.0215561347977
    ],
    "type": "Auslass 230 V_A01U1HC7KH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HC7KH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "Armatur 21F04 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1203",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18066"
    },
    "position": {
      "x": 3478.041514813003,
      "y": 3736.1802273359267
    },
    "dwg_pos_img": [
      3478.041514813003,
      3736.1802273359267
    ],
    "pos_dxf": [
      721.9491615234124,
      636.0978241059584
    ],
    "type": "Auslass 400 V_A01U1HCAKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1HCAKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "25F01 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G7,H],[35-34]",
    "position_description": "upper side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1204",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18074"
    },
    "position": {
      "x": 3472.7588481995485,
      "y": 3732.5943419166692
    },
    "dwg_pos_img": [
      3472.7588481995485,
      3732.5943419166692
    ],
    "pos_dxf": [
      721.0531615324369,
      636.705300134196
    ],
    "type": "Schaltkreis_A01U1HCCKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1HCCKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "32A DLE ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G7,H],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1205",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1807E"
    },
    "position": {
      "x": 6387.003700454559,
      "y": 1482.295000891695
    },
    "dwg_pos_img": [
      6387.003700454559,
      1482.295000891695
    ],
    "pos_dxf": [
      1215.342041067115,
      1018.735481070664
    ],
    "type": "Auslass 230 V_A01U1HCEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HCEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F03 Armatur ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1206",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1808F"
    },
    "position": {
      "x": 6386.98956013761,
      "y": 1505.017549120781
    },
    "dwg_pos_img": [
      6386.98956013761,
      1505.017549120781
    ],
    "pos_dxf": [
      1215.339642709471,
      1014.881742088775
    ],
    "type": "Auslass 230 V_A01U1HCHKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HCHKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F03 Armatur ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1207",
    "source_ids": {
      "object_id": null,
      "dwg_id": "180A0"
    },
    "position": {
      "x": 6387.003700638186,
      "y": 1459.713951479167
    },
    "dwg_pos_img": [
      6387.003700638186,
      1459.713951479167
    ],
    "pos_dxf": [
      1215.342041098259,
      1022.565220052795
    ],
    "type": "Auslass 230 V_A01U1HCKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 230 V_A01U1HCKKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "20F03 Armatur ",
    "grid_cols": [
      "I3",
      "I4"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I3,I4],[42-41]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1208",
    "source_ids": {
      "object_id": null,
      "dwg_id": "180B1"
    },
    "position": {
      "x": 4465.87736419013,
      "y": 2657.066909476408
    },
    "dwg_pos_img": [
      4465.87736419013,
      2657.066909476408
    ],
    "pos_dxf": [
      889.4972914531727,
      819.2439535543149
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1HGKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1HGKKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 10.04 WLAN/Reserve/an KT ",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[H2,H3],[39-38]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1209",
    "source_ids": {
      "object_id": null,
      "dwg_id": "180C5"
    },
    "position": {
      "x": 4745.746917159201,
      "y": 4882.9827737594715
    },
    "dwg_pos_img": [
      4745.746917159201,
      4882.9827737594715
    ],
    "pos_dxf": [
      936.9663322396018,
      441.7658167020197
    ],
    "type": "Verteiler AV-SV_A01U1C4PKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Verteiler AV-SV_A01U1C4PKH",
    "dwg_layer": "ADE_ET_Verteiler_SV",
    "dwg_rgb": [
      255,
      102,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "H2",
      "H3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H2,H3],[32-31]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1210",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1810B"
    },
    "position": {
      "x": 2029.177810252631,
      "y": 4152.588804045532
    },
    "dwg_pos_img": [
      2029.177810252631,
      4152.588804045532
    ],
    "pos_dxf": [
      476.2054943186599,
      565.2860806952203
    ],
    "type": "Auslass 400 V_A01U1GIEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1GIEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G3",
      "G4"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G3,G4],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1211",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1810C"
    },
    "position": {
      "x": 2569.2361381460714,
      "y": 4124.702201261043
    },
    "dwg_pos_img": [
      2569.2361381460714,
      4124.702201261043
    ],
    "pos_dxf": [
      567.8054933960614,
      570.0860806468743
    ],
    "type": "Auslass 400 V_A01U1GIEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1GIEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G4",
      "G5"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[G4,G5],[34-33]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1212",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1810D"
    },
    "position": {
      "x": 3135.236132444992,
      "y": 3924.5127337365425
    },
    "dwg_pos_img": [
      3135.236132444992,
      3924.5127337365425
    ],
    "pos_dxf": [
      663.8054924291569,
      604.1119766761833
    ],
    "type": "Auslass 400 V_A01U1GIEKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Auslass 400 V_A01U1GIEKH",
    "dwg_layer": "ADE_ET_NSV_Anschluss",
    "dwg_rgb": [
      255,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1213",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1810E"
    },
    "position": {
      "x": 3831.76132334979,
      "y": 4700.452673933355
    },
    "dwg_pos_img": [
      3831.76132334979,
      4700.452673933355
    ],
    "pos_dxf": [
      781.9440407099614,
      472.60365230735874
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H,H1],[33-32]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1214",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18113"
    },
    "position": {
      "x": 3847.9132410552133,
      "y": 606.0964709776435
    },
    "dwg_pos_img": [
      3847.9132410552133,
      606.0964709776435
    ],
    "pos_dxf": [
      784.6835885891096,
      1167.0073021400337
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1D4FKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[H,H1],[44-43]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1215",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18116"
    },
    "position": {
      "x": 597.8741237660139,
      "y": 475.87609309526124
    },
    "dwg_pos_img": [
      597.8741237660139,
      475.87609309526124
    ],
    "pos_dxf": [
      233.44020473750766,
      1188.6687295267243
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[F1,G],[45-44]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1216",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18120"
    },
    "position": {
      "x": 3852.7229863210255,
      "y": 505.54901144099586
    },
    "dwg_pos_img": [
      3852.7229863210255,
      505.54901144099586
    ],
    "pos_dxf": [
      785.4993757719988,
      1184.0607474596263
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[H,H1],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1217",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18121"
    },
    "position": {
      "x": 5937.45330266621,
      "y": 4825.496680169083
    },
    "dwg_pos_img": [
      5937.45330266621,
      4825.496680169083
    ],
    "pos_dxf": [
      1139.09321034695,
      451.6708767285222
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "I2",
      "I3"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[I2,I3],[32-31]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1218",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18122"
    },
    "position": {
      "x": 4101.258829033892,
      "y": 5076.586401766828
    },
    "dwg_pos_img": [
      4101.258829033892,
      5076.586401766828
    ],
    "pos_dxf": [
      827.6538649956597,
      408.8466396729932
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1219",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18123"
    },
    "position": {
      "x": 3837.8295012768663,
      "y": 4823.881950615609
    },
    "dwg_pos_img": [
      3837.8295012768663,
      4823.881950615609
    ],
    "pos_dxf": [
      782.9732723018406,
      451.6708767180844
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "H",
      "H1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H,H1],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1220",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18124"
    },
    "position": {
      "x": 550.5994314071194,
      "y": 4174.810380441035
    },
    "dwg_pos_img": [
      550.5994314071194,
      4174.810380441035
    ],
    "pos_dxf": [
      225.42188235880565,
      561.324454634917
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F1,G],[34-33]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1221",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18125"
    },
    "position": {
      "x": 534.0867835449357,
      "y": 3116.6091890895286
    },
    "dwg_pos_img": [
      534.0867835449357,
      3116.6091890895286
    ],
    "pos_dxf": [
      222.62115056586765,
      740.7928949594498
    ],
    "type": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "RJ-45-Datendose 1-fach_ AP_A01U1GQLKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "RJ 45 ",
    "grid_cols": [
      "F1",
      "G"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F1,G],[37-36]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1222",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18488"
    },
    "position": {
      "x": 468.20184503819553,
      "y": 4718.261761356095
    },
    "dwg_pos_img": [
      468.20184503819553,
      4718.261761356095
    ],
    "pos_dxf": [
      211.4463200064977,
      469.1445215939223
    ],
    "type": "_Oblique",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "_Oblique",
    "dwg_layer": "ADE_ET_BEL_BEM",
    "dwg_rgb": [
      165,
      0,
      82
    ],
    "dwg_txt": "1,53",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[F,F1],[33-32]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1223",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1848C"
    },
    "position": {
      "x": 468.2018449213632,
      "y": 4200.636195938778
    },
    "dwg_pos_img": [
      468.2018449213632,
      4200.636195938778
    ],
    "pos_dxf": [
      211.4463199866539,
      556.9336570675716
    ],
    "type": "_Oblique",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "_Oblique",
    "dwg_layer": "ADE_ET_BEL_BEM",
    "dwg_rgb": [
      165,
      0,
      82
    ],
    "dwg_txt": "1,83",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1224",
    "source_ids": {
      "object_id": null,
      "dwg_id": "18490"
    },
    "position": {
      "x": 468.20184490047075,
      "y": 3127.608979274445
    },
    "dwg_pos_img": [
      468.20184490047075,
      3127.608979274445
    ],
    "pos_dxf": [
      211.4463199830529,
      738.9187404641525
    ],
    "type": "_Oblique",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "_Oblique",
    "dwg_layer": "ADE_ET_BEL_BEM",
    "dwg_rgb": [
      165,
      0,
      82
    ],
    "dwg_txt": "1,43",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[F,F1],[37-36]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1225",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3004C"
    },
    "position": {
      "x": 3125.3979832195555,
      "y": 1912.8758433909752
    },
    "dwg_pos_img": [
      3125.3979832195555,
      1912.8758433909752
    ],
    "pos_dxf": [
      662.1368310763237,
      945.2836866305511
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW3SXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW3SXE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1226",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3005C"
    },
    "position": {
      "x": 3525.6019382972386,
      "y": 1549.5135050561075
    },
    "dwg_pos_img": [
      3525.6019382972386,
      1549.5135050561075
    ],
    "pos_dxf": [
      730.015947131935,
      1006.962025908861
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW3TXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW3TXE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G7,H],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1227",
    "source_ids": {
      "object_id": null,
      "dwg_id": "30068"
    },
    "position": {
      "x": 3361.6621758754277,
      "y": 1521.0884592962384
    },
    "dwg_pos_img": [
      3361.6621758754277,
      1521.0884592962384
    ],
    "pos_dxf": [
      702.2099096893437,
      1011.7615219074412
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Bauteilbeschriftung_A01KSW3WXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Bauteilbeschriftung_A01KSW3WXE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "EV 51_00.6 ",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1228",
    "source_ids": {
      "object_id": null,
      "dwg_id": "30072"
    },
    "position": {
      "x": 3125.3979802485783,
      "y": 1549.2057255469017
    },
    "dwg_pos_img": [
      3125.3979802485783,
      1549.2057255469017
    ],
    "pos_dxf": [
      662.1368305723929,
      1006.962025908861
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW3XXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW3XXE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[G6,G7],[42-41]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1229",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3007E"
    },
    "position": {
      "x": 3125.415901178959,
      "y": 3721.357180280017
    },
    "dwg_pos_img": [
      3125.415901178959,
      3721.357180280017
    ],
    "pos_dxf": [
      662.1398701649412,
      638.5658147108759
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW3YXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW3YXE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "36",
      "35"
    ],
    "chessboard_id": "[G6,G7],[36-35]",
    "position_description": "lower side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1230",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3008B"
    },
    "position": {
      "x": 3364.7866337205246,
      "y": 3329.559540678436
    },
    "dwg_pos_img": [
      3364.7866337205246,
      3329.559540678436
    ],
    "pos_dxf": [
      702.739853069528,
      705.0457945100347
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Bauteilbeschriftung_A01KSW40XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Bauteilbeschriftung_A01KSW40XE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "EV 51_00.5 ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1231",
    "source_ids": {
      "object_id": null,
      "dwg_id": "30095"
    },
    "position": {
      "x": 3125.4158982079807,
      "y": 3357.6744178239896
    },
    "dwg_pos_img": [
      3125.4158982079807,
      3357.6744178239896
    ],
    "pos_dxf": [
      662.1398696610102,
      700.2462985114544
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW41XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW41XE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G6,G7],[37-36]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1232",
    "source_ids": {
      "object_id": null,
      "dwg_id": "300A0"
    },
    "position": {
      "x": 3528.6803154248405,
      "y": 3357.984550999624
    },
    "dwg_pos_img": [
      3528.6803154248405,
      3357.984550999624
    ],
    "pos_dxf": [
      730.5380747013783,
      700.2462985114544
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW42XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Pfeil_A01KSW42XE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1233",
    "source_ids": {
      "object_id": null,
      "dwg_id": "300AB"
    },
    "position": {
      "x": 474.07976041318204,
      "y": 4955.169445019834
    },
    "dwg_pos_img": [
      474.07976041318204,
      4955.169445019834
    ],
    "pos_dxf": [
      212.4432809181696,
      428.9658185332278
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW44XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW44XE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_NSV_VTB",
    "dwg_rgb": [
      165,
      0,
      124
    ],
    "dwg_txt": "",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[F,F1],[32-31]",
    "position_description": "upper left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1234",
    "source_ids": {
      "object_id": null,
      "dwg_id": "300BF"
    },
    "position": {
      "x": 1245.6589827619432,
      "y": 5040.197080152893
    },
    "dwg_pos_img": [
      1245.6589827619432,
      5040.197080152893
    ],
    "pos_dxf": [
      343.3118415993367,
      414.6457964074818
    ],
    "type": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW45XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE-ET-UVT-E0$0$Polygon_A01KSW45XE",
    "dwg_layer": "XREF-ADE-ET-UVT-E0$0$ADE_ET_EDV_VTB",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[G1,G2],[32-31]",
    "position_description": "left side",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1235",
    "source_ids": {
      "object_id": null,
      "dwg_id": "308BE"
    },
    "position": {
      "x": 3077.012380010115,
      "y": 3773.6531735498706
    },
    "dwg_pos_img": [
      3077.012380010115,
      3773.6531735498706
    ],
    "pos_dxf": [
      653.9300856557345,
      629.6901171029501
    ],
    "type": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U581Y4P",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U581Y4P",
    "dwg_layer": "XREF-ADE_Allg_EG_KOM-DSP$0$ADE_Allg_Kommentierung-DSP",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "35",
      "34"
    ],
    "chessboard_id": "[G6,G7],[35-34]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1236",
    "source_ids": {
      "object_id": null,
      "dwg_id": "3091C"
    },
    "position": {
      "x": 3062.713986957459,
      "y": 1946.2573835925896
    },
    "dwg_pos_img": [
      3062.713986957459,
      1946.2573835925896
    ],
    "pos_dxf": [
      651.5049165159617,
      939.614011773484
    ],
    "type": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U581Z4P",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U581Z4P",
    "dwg_layer": "XREF-ADE_Allg_EG_KOM-DSP$0$ADE_Allg_Kommentierung-DSP",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "41",
      "40"
    ],
    "chessboard_id": "[G6,G7],[41-40]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1237",
    "source_ids": {
      "object_id": null,
      "dwg_id": "30978"
    },
    "position": {
      "x": 6562.384997884975,
      "y": 1549.6665707608772
    },
    "dwg_pos_img": [
      6562.384997884975,
      1549.6665707608772
    ],
    "pos_dxf": [
      1245.088692221417,
      1007.332158992973
    ],
    "type": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U58204P",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U58204P",
    "dwg_layer": "XREF-ADE_Allg_EG_KOM-DSP$0$ADE_Allg_Kommentierung-DSP",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "42",
      "41"
    ],
    "chessboard_id": "[I4,I5],[42-41]",
    "position_description": "lower left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1238",
    "source_ids": {
      "object_id": null,
      "dwg_id": "309B2"
    },
    "position": {
      "x": 3324.923547665326,
      "y": 2474.3102083802523
    },
    "dwg_pos_img": [
      3324.923547665326,
      2474.3102083802523
    ],
    "pos_dxf": [
      695.9786229258391,
      850.0906167985022
    ],
    "type": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U58224P",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "XREF-ADE_Allg_EG_KOM-DSP$0$Revisionswolke_A01U58224P",
    "dwg_layer": "XREF-ADE_Allg_EG_KOM-DSP$0$ADE_Allg_Kommentierung-DSP",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "",
    "grid_cols": [
      "G6",
      "G7"
    ],
    "grid_rows": [
      "39",
      "38"
    ],
    "chessboard_id": "[G6,G7],[39-38]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1239",
    "source_ids": {
      "object_id": null,
      "dwg_id": "30AA7"
    },
    "position": {
      "x": 3384.5575700261875,
      "y": 3257.291909567579
    },
    "dwg_pos_img": [
      3384.5575700261875,
      3257.291909567579
    ],
    "pos_dxf": [
      706.0932274252575,
      717.3049411076036
    ],
    "type": "*E5118",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "*E5118",
    "dwg_layer": "E-Deckenspiegel",
    "dwg_rgb": [
      128,
      128,
      128
    ],
    "dwg_txt": "Deckenraster 625x625mm Zwischendecke H=2,6m Raumhöhe H=3m ",
    "grid_cols": [
      "G7",
      "H"
    ],
    "grid_rows": [
      "37",
      "36"
    ],
    "chessboard_id": "[G7,H],[37-36]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1240",
    "source_ids": {
      "object_id": null,
      "dwg_id": "52595"
    },
    "position": {
      "x": 6891.49623091035,
      "y": 174.05067117800263
    },
    "dwg_pos_img": [
      6891.49623091035,
      174.05067117800263
    ],
    "pos_dxf": [
      1300.909678741591,
      1240.679115794712
    ],
    "type": "*E5120",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "*E5120",
    "dwg_layer": "0",
    "dwg_rgb": [
      128,
      128,
      128
    ],
    "dwg_txt": "I5 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[I4,I5],[45-44]",
    "position_description": "upper right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1241",
    "source_ids": {
      "object_id": null,
      "dwg_id": "525AC"
    },
    "position": {
      "x": 6891.789055229493,
      "y": 5321.076906313271
    },
    "dwg_pos_img": [
      6891.789055229493,
      5321.076906313271
    ],
    "pos_dxf": [
      1300.959345057481,
      367.7450996617868
    ],
    "type": "*E5121",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "*E5121",
    "dwg_layer": "0",
    "dwg_rgb": [
      128,
      128,
      128
    ],
    "dwg_txt": "I5 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[I4,I5],[32-31]",
    "position_description": "lower right corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1242",
    "source_ids": {
      "object_id": null,
      "dwg_id": "2192"
    },
    "position": {
      "x": 4276.741876389387,
      "y": 4886.456856283546
    },
    "dwg_pos_img": [
      4276.741876389387,
      4886.456856283546
    ],
    "pos_dxf": [
      857.4177740877703,
      441.1154402264549
    ],
    "type": "Schaltkreis_A01KSZC9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KSZC9XE",
    "dwg_layer": "ADE_ET_SIBE_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "US03-2-01-03 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "32",
      "31"
    ],
    "chessboard_id": "[H1,H2],[32-31]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1243",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7ACF"
    },
    "position": {
      "x": 4082.6234742906195,
      "y": 4520.324996147781
    },
    "dwg_pos_img": [
      4082.6234742906195,
      4520.324996147781
    ],
    "pos_dxf": [
      824.4930981133762,
      503.1859710287099
    ],
    "type": "Schaltkreis_A01KT172XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KT172XE",
    "dwg_layer": "ADE_ET_SIBE_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "US03-2-02-03 ",
    "grid_cols": [
      "H1",
      "H2"
    ],
    "grid_rows": [
      "33",
      "32"
    ],
    "chessboard_id": "[H1,H2],[33-32]",
    "position_description": "upper left corner",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1244",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7CE7"
    },
    "position": {
      "x": 1257.8206449324016,
      "y": 414.6790180290127
    },
    "dwg_pos_img": [
      1257.8206449324016,
      414.6790180290127
    ],
    "pos_dxf": [
      345.3745970202285,
      1199.1338124827544
    ],
    "type": "Schaltkreis_A01KT1O9XE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KT1O9XE",
    "dwg_layer": "ADE_ET_BEL_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "lower left area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1245",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7CF1"
    },
    "position": {
      "x": 1133.769789268541,
      "y": 414.58357535345294
    },
    "dwg_pos_img": [
      1133.769789268541,
      414.58357535345294
    ],
    "pos_dxf": [
      324.3341692044339,
      1199.1338193586582
    ],
    "type": "Schaltkreis_A01KT1OCXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KT1OCXE",
    "dwg_layer": "ADE_ET_BEL_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "B11 02F01 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G,G1],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1246",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7D23"
    },
    "position": {
      "x": 1390.828119939882,
      "y": 414.78126776818317
    },
    "dwg_pos_img": [
      1390.828119939882,
      414.78126776818317
    ],
    "pos_dxf": [
      367.9341687529634,
      1199.1338193586582
    ],
    "type": "Schaltkreis_A01KT1OGXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KT1OGXE",
    "dwg_layer": "ADE_ET_BEL_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "B11 02F02 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1247",
    "source_ids": {
      "object_id": null,
      "dwg_id": "7D2D"
    },
    "position": {
      "x": 1514.8789756037422,
      "y": 414.8767104437429
    },
    "dwg_pos_img": [
      1514.8789756037422,
      414.8767104437429
    ],
    "pos_dxf": [
      388.974596568758,
      1199.1338124827544
    ],
    "type": "Schaltkreis_A01KT1OJXE",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01KT1OJXE",
    "dwg_layer": "ADE_ET_BEL_Wand-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "B11 02F02 ",
    "grid_cols": [
      "G1",
      "G2"
    ],
    "grid_rows": [
      "45",
      "44"
    ],
    "chessboard_id": "[G1,G2],[45-44]",
    "position_description": "lower right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1248",
    "source_ids": {
      "object_id": null,
      "dwg_id": "12CA4"
    },
    "position": {
      "x": 508.7859439670045,
      "y": 4253.731787549583
    },
    "dwg_pos_img": [
      508.7859439670045,
      4253.731787549583
    ],
    "pos_dxf": [
      218.32984208627613,
      547.9339546413682
    ],
    "type": "Schaltkreis_A01U1DCLKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1DCLKH",
    "dwg_layer": "ADE_ET_BMA_Peripherie-TXT",
    "dwg_rgb": [
      255,
      0,
      0
    ],
    "dwg_txt": "Brandschutztor ",
    "grid_cols": [
      "F",
      "F1"
    ],
    "grid_rows": [
      "34",
      "33"
    ],
    "chessboard_id": "[F,F1],[34-33]",
    "position_description": "center",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1249",
    "source_ids": {
      "object_id": null,
      "dwg_id": "16493"
    },
    "position": {
      "x": 1208.276432820638,
      "y": 685.7436454745375
    },
    "dwg_pos_img": [
      1208.276432820638,
      685.7436454745375
    ],
    "pos_dxf": [
      336.97133842884205,
      1153.154873536482
    ],
    "type": "Schaltkreis_A01U1GQTKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GQTKH",
    "dwg_layer": "ADE_ET_EDV_Dose-W-TXT",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "WLAN/an KT 14.15 ",
    "grid_cols": [
      "G",
      "G1"
    ],
    "grid_rows": [
      "44",
      "43"
    ],
    "chessboard_id": "[G,G1],[44-43]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  },
  {
    "id": "obj_none_1250",
    "source_ids": {
      "object_id": null,
      "dwg_id": "1651F"
    },
    "position": {
      "x": 6751.0130278257875,
      "y": 935.989713660173
    },
    "dwg_pos_img": [
      6751.0130278257875,
      935.989713660173
    ],
    "pos_dxf": [
      1277.082138995822,
      1111.4361668554188
    ],
    "type": "Schaltkreis_A01U1GRKKH",
    "status": "uninstalled",
    "size": {
      "width": 40,
      "height": 40
    },
    "detectionDate": "2025-07-25",
    "frameReference": "frame_00046",
    "description": "",
    "confidence": 0.95,
    "dwg_name": "Schaltkreis_A01U1GRKKH",
    "dwg_layer": "ADE_ET_EDV_Dose-D-TXT",
    "dwg_rgb": [
      0,
      0,
      255
    ],
    "dwg_txt": "WLAN/ Aussen 18.19 ",
    "grid_cols": [
      "I4",
      "I5"
    ],
    "grid_rows": [
      "43",
      "42"
    ],
    "chessboard_id": "[I4,I5],[43-42]",
    "position_description": "upper right area",
    "match": {
      "distance_px": null,
      "method": "synthetic_from_dwg_unmatched"
    }
  }
];

export const objects = {
  "frame_00001.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_1",
        "name": "steckdose_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1033,
          "ymin": 1853,
          "xmax": 1120,
          "ymax": 2033
        }
      },
      {
        "id": "obj_3",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3247,
          "ymin": 520,
          "xmax": 3843,
          "ymax": 1157
        }
      },
      {
        "id": "obj_2",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3990,
          "ymin": 1637,
          "xmax": 4043,
          "ymax": 1720
        }
      },
      {
        "id": "obj_4",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1677,
          "ymin": 1517,
          "xmax": 2030,
          "ymax": 1533
        }
      },
      {
        "id": "obj_6",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3247,
          "ymin": 1680,
          "xmax": 3407,
          "ymax": 1737
        }
      },
      {
        "id": "obj_5",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2880,
          "ymin": 1590,
          "xmax": 2953,
          "ymax": 1623
        }
      }
    ]
  },
  "frame_00006.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6739,
          "ymin": 2037,
          "xmax": 6810,
          "ymax": 2190
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4802,
          "ymin": 1778,
          "xmax": 4930,
          "ymax": 1803
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5459,
          "ymin": 1667,
          "xmax": 5783,
          "ymax": 1702
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6073,
          "ymin": 493,
          "xmax": 7563,
          "ymax": 1127
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4253,
          "ymin": 1593,
          "xmax": 4337,
          "ymax": 1693
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4210,
          "ymin": 1727,
          "xmax": 4253,
          "ymax": 1787
        }
      }
    ]
  },
  "frame_00007.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_7",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 657,
          "ymin": 1055,
          "xmax": 714,
          "ymax": 1101
        }
      },
      {
        "id": "obj_8",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1468,
          "ymin": 1116,
          "xmax": 1500,
          "ymax": 1143
        }
      },
      {
        "id": "obj_9",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1673,
          "ymin": 1274,
          "xmax": 1698,
          "ymax": 1301
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6589,
          "ymin": 2007,
          "xmax": 6638,
          "ymax": 2119
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5616,
          "ymin": 1720,
          "xmax": 5883,
          "ymax": 1741
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6156,
          "ymin": 1289,
          "xmax": 6877,
          "ymax": 1414
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4606,
          "ymin": 1611,
          "xmax": 4778,
          "ymax": 1702
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4973,
          "ymin": 1790,
          "xmax": 5109,
          "ymax": 1807
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4453,
          "ymin": 1728,
          "xmax": 4547,
          "ymax": 1777
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3069,
          "ymin": 1034,
          "xmax": 3334,
          "ymax": 1142
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2841,
          "ymin": 1263,
          "xmax": 2897,
          "ymax": 1309
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2624,
          "ymin": 1418,
          "xmax": 2711,
          "ymax": 1479
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2540,
          "ymin": 1524,
          "xmax": 2590,
          "ymax": 1568
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2484,
          "ymin": 1592,
          "xmax": 2524,
          "ymax": 1622
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2444,
          "ymin": 1640,
          "xmax": 2471,
          "ymax": 1667
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2414,
          "ymin": 1674,
          "xmax": 2438,
          "ymax": 1697
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2392,
          "ymin": 1701,
          "xmax": 2410,
          "ymax": 1720
        }
      }
    ]
  },
  "frame_00011.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4692,
          "ymin": 995,
          "xmax": 5012,
          "ymax": 1123
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3779,
          "ymin": 931,
          "xmax": 4217,
          "ymax": 989
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3152,
          "ymin": 1069,
          "xmax": 3397,
          "ymax": 1193
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2860,
          "ymin": 1279,
          "xmax": 2984,
          "ymax": 1373
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2702,
          "ymin": 1437,
          "xmax": 2777,
          "ymax": 1492
        }
      },
      {
        "id": "obj_11",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 159,
          "ymin": 656,
          "xmax": 229,
          "ymax": 685
        }
      },
      {
        "id": "obj_12",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1185,
          "ymin": 804,
          "xmax": 1236,
          "ymax": 840
        }
      },
      {
        "id": "obj_13",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1598,
          "ymin": 1052,
          "xmax": 1634,
          "ymax": 1086
        }
      },
      {
        "id": "obj_14",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1798,
          "ymin": 1244,
          "xmax": 1821,
          "ymax": 1270
        }
      },
      {
        "id": "obj_10",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6994,
          "ymin": 873,
          "xmax": 7046,
          "ymax": 906
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6664,
          "ymin": 1120,
          "xmax": 6702,
          "ymax": 1148
        }
      },
      {
        "id": "obj_15",
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 328,
          "ymin": 2058,
          "xmax": 900,
          "ymax": 2836
        }
      }
    ]
  },
  "frame_00016.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2994,
          "ymin": 1207,
          "xmax": 3156,
          "ymax": 1309
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2790,
          "ymin": 1383,
          "xmax": 2875,
          "ymax": 1464
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2676,
          "ymin": 1501,
          "xmax": 2736,
          "ymax": 1551
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2606,
          "ymin": 1579,
          "xmax": 2649,
          "ymax": 1618
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2558,
          "ymin": 1634,
          "xmax": 2587,
          "ymax": 1662
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3900,
          "ymin": 1524,
          "xmax": 4052,
          "ymax": 1541
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4217,
          "ymin": 1518,
          "xmax": 4368,
          "ymax": 1540
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3622,
          "ymin": 1547,
          "xmax": 3753,
          "ymax": 1566
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3397,
          "ymin": 1583,
          "xmax": 3505,
          "ymax": 1603
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3224,
          "ymin": 1619,
          "xmax": 3306,
          "ymax": 1639
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5041,
          "ymin": 1062,
          "xmax": 5290,
          "ymax": 1201
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5449,
          "ymin": 1301,
          "xmax": 5570,
          "ymax": 1394
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5653,
          "ymin": 1454,
          "xmax": 5722,
          "ymax": 1519
        }
      },
      {
        "id": null,
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6469,
          "ymin": 1980,
          "xmax": 6554,
          "ymax": 2235
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6549,
          "ymin": 1351,
          "xmax": 6575,
          "ymax": 1368
        }
      },
      {
        "id": "obj_16",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6735,
          "ymin": 1154,
          "xmax": 6771,
          "ymax": 1181
        }
      },
      {
        "id": "obj_17",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7220,
          "ymin": 844,
          "xmax": 7272,
          "ymax": 879
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4205,
          "ymin": 920,
          "xmax": 4644,
          "ymax": 990
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3377,
          "ymin": 981,
          "xmax": 3723,
          "ymax": 1093
        }
      },
      {
        "id": "obj_18",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 363,
          "ymin": 700,
          "xmax": 424,
          "ymax": 731
        }
      },
      {
        "id": "obj_19",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1195,
          "ymin": 843,
          "xmax": 1235,
          "ymax": 890
        }
      },
      {
        "id": "obj_21",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1897,
          "ymin": 1355,
          "xmax": 1920,
          "ymax": 1377
        }
      },
      {
        "id": "obj_20",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1491,
          "ymin": 2070,
          "xmax": 1572,
          "ymax": 2234
        }
      }
    ]
  },
  "frame_00021.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_22",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6835,
          "ymin": 1040,
          "xmax": 6876,
          "ymax": 1060
        }
      },
      {
        "id": "obj_23",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7274,
          "ymin": 779,
          "xmax": 7331,
          "ymax": 817
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5837,
          "ymin": 1584,
          "xmax": 5877,
          "ymax": 1623
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5743,
          "ymin": 1503,
          "xmax": 5802,
          "ymax": 1556
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5577,
          "ymin": 1377,
          "xmax": 5679,
          "ymax": 1455
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5272,
          "ymin": 1186,
          "xmax": 5450,
          "ymax": 1299
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4628,
          "ymin": 972,
          "xmax": 4986,
          "ymax": 1086
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3740,
          "ymin": 952,
          "xmax": 4142,
          "ymax": 1016
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3180,
          "ymin": 1143,
          "xmax": 3416,
          "ymax": 1222
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2931,
          "ymin": 1329,
          "xmax": 3022,
          "ymax": 1397
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2782,
          "ymin": 1463,
          "xmax": 2842,
          "ymax": 1509
        }
      },
      {
        "id": "obj_24",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 665,
          "ymin": 655,
          "xmax": 741,
          "ymax": 680
        }
      },
      {
        "id": "obj_25",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1638,
          "ymin": 998,
          "xmax": 1672,
          "ymax": 1039
        }
      },
      {
        "id": "obj_26",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1861,
          "ymin": 1206,
          "xmax": 1887,
          "ymax": 1236
        }
      },
      {
        "id": "obj_27",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1988,
          "ymin": 1354,
          "xmax": 2006,
          "ymax": 1378
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6598,
          "ymin": 2020,
          "xmax": 6646,
          "ymax": 2123
        }
      }
    ]
  },
  "frame_00026.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_28",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7610,
          "ymin": 690,
          "xmax": 7655,
          "ymax": 719
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6679,
          "ymin": 1245,
          "xmax": 6702,
          "ymax": 1269
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6573,
          "ymin": 1384,
          "xmax": 6593,
          "ymax": 1405
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5475,
          "ymin": 1281,
          "xmax": 5610,
          "ymax": 1375
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5702,
          "ymin": 1440,
          "xmax": 5787,
          "ymax": 1506
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5835,
          "ymin": 1546,
          "xmax": 5886,
          "ymax": 1592
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5912,
          "ymin": 1616,
          "xmax": 5950,
          "ymax": 1649
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5015,
          "ymin": 1065,
          "xmax": 5276,
          "ymax": 1181
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4173,
          "ymin": 951,
          "xmax": 4603,
          "ymax": 995
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3425,
          "ymin": 1036,
          "xmax": 3729,
          "ymax": 1129
        }
      },
      {
        "id": "obj_29",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 971,
          "ymin": 674,
          "xmax": 1035,
          "ymax": 730
        }
      },
      {
        "id": "obj_30",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1604,
          "ymin": 927,
          "xmax": 1650,
          "ymax": 967
        }
      },
      {
        "id": "obj_31",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1918,
          "ymin": 1202,
          "xmax": 1943,
          "ymax": 1230
        }
      }
    ]
  },
  "frame_00031.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_34",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 165,
          "ymin": 569,
          "xmax": 249,
          "ymax": 600
        }
      },
      {
        "id": "obj_35",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1473,
          "ymin": 732,
          "xmax": 1532,
          "ymax": 773
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5604,
          "ymin": 1350,
          "xmax": 5709,
          "ymax": 1423
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5788,
          "ymin": 1483,
          "xmax": 5859,
          "ymax": 1536
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5901,
          "ymin": 1574,
          "xmax": 5946,
          "ymax": 1612
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5973,
          "ymin": 1632,
          "xmax": 6004,
          "ymax": 1663
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5234,
          "ymin": 1153,
          "xmax": 5444,
          "ymax": 1259
        }
      },
      {
        "id": "obj_33",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7059,
          "ymin": 835,
          "xmax": 7113,
          "ymax": 866
        }
      },
      {
        "id": "obj_32",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6772,
          "ymin": 1099,
          "xmax": 6808,
          "ymax": 1126
        }
      },
      {
        "id": "obj_36",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1227,
          "ymin": 2160,
          "xmax": 1362,
          "ymax": 2401
        }
      },
      {
        "id": "obj_37",
        "name": "steckdosen_1-fach",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1739,
          "ymin": 2108,
          "xmax": 1802,
          "ymax": 2209
        }
      }
    ]
  },
  "frame_00036.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_38",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 480,
          "ymin": 448,
          "xmax": 574,
          "ymax": 480
        }
      },
      {
        "id": "obj_39",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1748,
          "ymin": 710,
          "xmax": 1785,
          "ymax": 767
        }
      },
      {
        "id": "obj_40",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2073,
          "ymin": 1036,
          "xmax": 2101,
          "ymax": 1072
        }
      },
      {
        "id": "obj_41",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2225,
          "ymin": 1285,
          "xmax": 2247,
          "ymax": 1312
        }
      }
    ]
  },
  "frame_00041.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_44",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 349,
          "ymin": 758,
          "xmax": 414,
          "ymax": 796
        }
      },
      {
        "id": "obj_45",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1902,
          "ymin": 1151,
          "xmax": 1934,
          "ymax": 1185
        }
      },
      {
        "id": "obj_46",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2075,
          "ymin": 1309,
          "xmax": 2100,
          "ymax": 1337
        }
      },
      {
        "id": "obj_42",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7069,
          "ymin": 1140,
          "xmax": 7104,
          "ymax": 1163
        }
      },
      {
        "id": "obj_43",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7397,
          "ymin": 931,
          "xmax": 7440,
          "ymax": 962
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6844,
          "ymin": 1350,
          "xmax": 6875,
          "ymax": 1373
        }
      },
      {
        "id": "obj_47",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2171,
          "ymin": 1985,
          "xmax": 2206,
          "ymax": 2061
        }
      }
    ]
  },
  "frame_00044.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_48",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1886,
          "ymin": 1257,
          "xmax": 1915,
          "ymax": 1287
        }
      },
      {
        "id": "obj_49",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2053,
          "ymin": 1379,
          "xmax": 2076,
          "ymax": 1399
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 284,
          "ymin": 931,
          "xmax": 333,
          "ymax": 966
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7456,
          "ymin": 1085,
          "xmax": 7490,
          "ymax": 1116
        }
      },
      {
        "id": "obj_50",
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2791,
          "ymin": 1957,
          "xmax": 2923,
          "ymax": 2173
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1465,
          "ymin": 2087,
          "xmax": 1547,
          "ymax": 2236
        }
      }
    ]
  },
  "frame_00046.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 26,
          "ymin": 1408,
          "xmax": 54,
          "ymax": 1425
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 308,
          "ymin": 1352,
          "xmax": 333,
          "ymax": 1372
        }
      },
      {
        "id": null,
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2414,
          "ymin": 1975,
          "xmax": 2597,
          "ymax": 2276
        }
      },
      {
        "id": "obj_51",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2305,
          "ymin": 1394,
          "xmax": 2330,
          "ymax": 1412
        }
      },
      {
        "id": "obj_114",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2276,
          "ymin": 1402,
          "xmax": 2289,
          "ymax": 1412
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7485,
          "ymin": 1465,
          "xmax": 7506,
          "ymax": 1482
        }
      },
      {
        "id": "obj_52",
        "name": "rj_45_dev",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2927,
          "ymin": 1390,
          "xmax": 2966,
          "ymax": 1412
        }
      }
    ]
  },
  "frame_00051.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_53",
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3525,
          "ymin": 1939,
          "xmax": 3671,
          "ymax": 2133
        }
      },
      {
        "id": null,
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1736,
          "ymin": 1984,
          "xmax": 1810,
          "ymax": 2142
        }
      },
      {
        "id": "obj_54",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3537,
          "ymin": 1512,
          "xmax": 3563,
          "ymax": 1531
        }
      },
      {
        "id": "obj_55",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4482,
          "ymin": 1317,
          "xmax": 4512,
          "ymax": 1340
        }
      },
      {
        "id": "obj_56",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4856,
          "ymin": 1324,
          "xmax": 4890,
          "ymax": 1350
        }
      },
      {
        "id": "obj_57",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5405,
          "ymin": 1425,
          "xmax": 5422,
          "ymax": 1443
        }
      },
      {
        "id": "obj_58",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5730,
          "ymin": 1533,
          "xmax": 5747,
          "ymax": 1549
        }
      }
    ]
  },
  "frame_00054.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3268,
          "ymin": 1548,
          "xmax": 3295,
          "ymax": 1563
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3389,
          "ymin": 1483,
          "xmax": 3418,
          "ymax": 1501
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3778,
          "ymin": 1307,
          "xmax": 3810,
          "ymax": 1329
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4563,
          "ymin": 1165,
          "xmax": 4600,
          "ymax": 1198
        }
      },
      {
        "id": "obj_60",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5039,
          "ymin": 1197,
          "xmax": 5084,
          "ymax": 1224
        }
      }
    ]
  },
  "frame_00056.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3453,
          "ymin": 1410,
          "xmax": 3489,
          "ymax": 1429
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3675,
          "ymin": 1299,
          "xmax": 3708,
          "ymax": 1325
        }
      },
      {
        "id": "obj_61",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5376,
          "ymin": 1217,
          "xmax": 5418,
          "ymax": 1249
        }
      },
      {
        "id": "obj_62",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5690,
          "ymin": 1338,
          "xmax": 5716,
          "ymax": 1367
        }
      }
    ]
  },
  "frame_00061.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_63",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3458,
          "ymin": 1399,
          "xmax": 3491,
          "ymax": 1421
        }
      },
      {
        "id": "obj_65",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5849,
          "ymin": 1356,
          "xmax": 5878,
          "ymax": 1383
        }
      },
      {
        "id": "obj_66",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6015,
          "ymin": 1459,
          "xmax": 6035,
          "ymax": 1481
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3161,
          "ymin": 1600,
          "xmax": 3180,
          "ymax": 1613
        }
      },
      {
        "id": "obj_64",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5373,
          "ymin": 2092,
          "xmax": 5451,
          "ymax": 2210
        }
      }
    ]
  },
  "frame_00066.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3360,
          "ymin": 1482,
          "xmax": 3384,
          "ymax": 1499
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3511,
          "ymin": 1380,
          "xmax": 3536,
          "ymax": 1402
        }
      },
      {
        "id": "obj_67",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3757,
          "ymin": 1245,
          "xmax": 3792,
          "ymax": 1274
        }
      },
      {
        "id": "obj_113",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4719,
          "ymin": 1040,
          "xmax": 4745,
          "ymax": 1080
        }
      },
      {
        "id": "obj_68",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5605,
          "ymin": 1204,
          "xmax": 5643,
          "ymax": 1237
        }
      },
      {
        "id": "obj_69",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6011,
          "ymin": 1413,
          "xmax": 6039,
          "ymax": 1435
        }
      },
      {
        "id": "obj_70",
        "name": "elektro_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5030,
          "ymin": 1975,
          "xmax": 5455,
          "ymax": 2650
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3830,
          "ymin": 385,
          "xmax": 4905,
          "ymax": 505
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5830,
          "ymin": 595,
          "xmax": 6190,
          "ymax": 890
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6300,
          "ymin": 1065,
          "xmax": 6400,
          "ymax": 1245
        }
      }
    ]
  },
  "frame_00071.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4965,
          "ymin": 440,
          "xmax": 5765,
          "ymax": 680
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3100,
          "ymin": 1321,
          "xmax": 3143,
          "ymax": 1405
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3212,
          "ymin": 1056,
          "xmax": 3325,
          "ymax": 1196
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3540,
          "ymin": 621,
          "xmax": 3949,
          "ymax": 824
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6135,
          "ymin": 898,
          "xmax": 6291,
          "ymax": 1069
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6382,
          "ymin": 1224,
          "xmax": 6451,
          "ymax": 1334
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3237,
          "ymin": 1648,
          "xmax": 3254,
          "ymax": 1659
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3347,
          "ymin": 1571,
          "xmax": 3370,
          "ymax": 1586
        }
      },
      {
        "id": "obj_71",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3532,
          "ymin": 1450,
          "xmax": 3558,
          "ymax": 1472
        }
      },
      {
        "id": "obj_72",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3944,
          "ymin": 1259,
          "xmax": 3985,
          "ymax": 1278
        }
      },
      {
        "id": "obj_73",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4391,
          "ymin": 1143,
          "xmax": 4436,
          "ymax": 1172
        }
      },
      {
        "id": "obj_74",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4973,
          "ymin": 1121,
          "xmax": 5013,
          "ymax": 1151
        }
      },
      {
        "id": "obj_75",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5569,
          "ymin": 1239,
          "xmax": 5600,
          "ymax": 1266
        }
      },
      {
        "id": "obj_76",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5954,
          "ymin": 1404,
          "xmax": 5976,
          "ymax": 1423
        }
      },
      {
        "id": "obj_77",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6097,
          "ymin": 1484,
          "xmax": 6110,
          "ymax": 1500
        }
      },
      {
        "id": "obj_78",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6191,
          "ymin": 1542,
          "xmax": 6208,
          "ymax": 1560
        }
      }
    ]
  },
  "frame_00076.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1645,
          "ymin": 1280,
          "xmax": 1852,
          "ymax": 1356
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3166,
          "ymin": 1256,
          "xmax": 3221,
          "ymax": 1363
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3100,
          "ymin": 1439,
          "xmax": 3125,
          "ymax": 1505
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3058,
          "ymin": 1547,
          "xmax": 3078,
          "ymax": 1590
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3294,
          "ymin": 928,
          "xmax": 3459,
          "ymax": 1113
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3812,
          "ymin": 503,
          "xmax": 4507,
          "ymax": 664
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5605,
          "ymin": 517,
          "xmax": 6067,
          "ymax": 759
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6302,
          "ymin": 1002,
          "xmax": 6415,
          "ymax": 1157
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6492,
          "ymin": 1294,
          "xmax": 6538,
          "ymax": 1381
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6568,
          "ymin": 1451,
          "xmax": 6598,
          "ymax": 1508
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3275,
          "ymin": 1652,
          "xmax": 3293,
          "ymax": 1666
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3350,
          "ymin": 1599,
          "xmax": 3372,
          "ymax": 1613
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3479,
          "ymin": 1512,
          "xmax": 3507,
          "ymax": 1530
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3606,
          "ymin": 1438,
          "xmax": 3638,
          "ymax": 1457
        }
      },
      {
        "id": null,
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3789,
          "ymin": 1341,
          "xmax": 3822,
          "ymax": 1359
        }
      },
      {
        "id": "obj_78",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4221,
          "ymin": 1180,
          "xmax": 4266,
          "ymax": 1205
        }
      },
      {
        "id": "obj_79",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4935,
          "ymin": 1104,
          "xmax": 4974,
          "ymax": 1131
        }
      },
      {
        "id": "obj_80",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5472,
          "ymin": 1187,
          "xmax": 5505,
          "ymax": 1209
        }
      },
      {
        "id": "obj_81",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5811,
          "ymin": 1302,
          "xmax": 5841,
          "ymax": 1324
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4993,
          "ymin": 1383,
          "xmax": 5176,
          "ymax": 1417
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4585,
          "ymin": 1383,
          "xmax": 4783,
          "ymax": 1410
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5659,
          "ymin": 1482,
          "xmax": 5775,
          "ymax": 1521
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5362,
          "ymin": 1423,
          "xmax": 5516,
          "ymax": 1466
        }
      }
    ]
  },
  "frame_00081.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3095,
          "ymin": 1150,
          "xmax": 3140,
          "ymax": 1281
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3055,
          "ymin": 1381,
          "xmax": 3089,
          "ymax": 1454
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3037,
          "ymin": 1515,
          "xmax": 3061,
          "ymax": 1558
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3188,
          "ymin": 698,
          "xmax": 3350,
          "ymax": 942
        }
      },
      {
        "id": "obj_82",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3565,
          "ymin": 1267,
          "xmax": 3596,
          "ymax": 1291
        }
      },
      {
        "id": "obj_83",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3870,
          "ymin": 1052,
          "xmax": 3922,
          "ymax": 1087
        }
      },
      {
        "id": "obj_84",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4489,
          "ymin": 846,
          "xmax": 4535,
          "ymax": 900
        }
      },
      {
        "id": "obj_85",
        "name": "rj_45_dev",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5537,
          "ymin": 909,
          "xmax": 5590,
          "ymax": 944
        }
      },
      {
        "id": "obj_86",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6150,
          "ymin": 1218,
          "xmax": 6180,
          "ymax": 1252
        }
      },
      {
        "id": "obj_87",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6330,
          "ymin": 1371,
          "xmax": 6353,
          "ymax": 1396
        }
      },
      {
        "id": "obj_88",
        "name": "rj_45",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6435,
          "ymin": 1476,
          "xmax": 6451,
          "ymax": 1495
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6423,
          "ymin": 617,
          "xmax": 6603,
          "ymax": 903
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3823,
          "ymin": 137,
          "xmax": 5747,
          "ymax": 343
        }
      }
    ]
  },
  "frame_00086.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6739,
          "ymin": 1634,
          "xmax": 7093,
          "ymax": 1665
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3211,
          "ymin": 1294,
          "xmax": 3254,
          "ymax": 1377
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3165,
          "ymin": 1448,
          "xmax": 3194,
          "ymax": 1505
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3138,
          "ymin": 1548,
          "xmax": 3160,
          "ymax": 1582
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3118,
          "ymin": 1610,
          "xmax": 3136,
          "ymax": 1637
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2156,
          "ymin": 1431,
          "xmax": 2262,
          "ymax": 1482
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2361,
          "ymin": 1516,
          "xmax": 2435,
          "ymax": 1560
        }
      }
    ]
  },
  "frame_00091.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_89",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2652,
          "ymin": 2148,
          "xmax": 2786,
          "ymax": 2426
        }
      },
      {
        "id": "obj_90",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4870,
          "ymin": 820,
          "xmax": 4992,
          "ymax": 1370
        }
      },
      {
        "id": "obj_91",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4958,
          "ymin": 1534,
          "xmax": 4996,
          "ymax": 1648
        }
      }
    ]
  },
  "frame_00096.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_92",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5816,
          "ymin": 1554,
          "xmax": 6090,
          "ymax": 1646
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5556,
          "ymin": 1690,
          "xmax": 5656,
          "ymax": 1742
        }
      },
      {
        "id": "obj_93",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5050,
          "ymin": 1654,
          "xmax": 5068,
          "ymax": 1734
        }
      },
      {
        "id": "obj_94",
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4360,
          "ymin": 1694,
          "xmax": 4506,
          "ymax": 1742
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2708,
          "ymin": 1498,
          "xmax": 3222,
          "ymax": 1516
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1028,
          "ymin": 1962,
          "xmax": 1064,
          "ymax": 2036
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 1,
        "difficult": 0,
        "bndbox": {
          "xmin": 1,
          "ymin": 1470,
          "xmax": 308,
          "ymax": 1564
        }
      }
    ]
  },
  "frame_00101.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2535,
          "ymin": 510,
          "xmax": 2845,
          "ymax": 830
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 95,
          "ymin": 310,
          "xmax": 1365,
          "ymax": 500
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2935,
          "ymin": 1060,
          "xmax": 3005,
          "ymax": 1200
        }
      }
    ]
  },
  "frame_00106.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1135,
          "ymin": 630,
          "xmax": 1795,
          "ymax": 740
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2305,
          "ymin": 840,
          "xmax": 2585,
          "ymax": 1050
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 175,
          "ymin": 810,
          "xmax": 535,
          "ymax": 1020
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2725,
          "ymin": 1200,
          "xmax": 2845,
          "ymax": 1310
        }
      },
      {
        "id": "obj_95",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4513,
          "ymin": 1981,
          "xmax": 4552,
          "ymax": 2066
        }
      }
    ]
  },
  "frame_00111.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6124,
          "ymin": 2001,
          "xmax": 6173,
          "ymax": 2101
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 307,
          "ymin": 1126,
          "xmax": 534,
          "ymax": 1228
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 74,
          "ymin": 1328,
          "xmax": 162,
          "ymax": 1400
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 869,
          "ymin": 975,
          "xmax": 1241,
          "ymax": 1031
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1718,
          "ymin": 974,
          "xmax": 2050,
          "ymax": 1061
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2352,
          "ymin": 1159,
          "xmax": 2524,
          "ymax": 1261
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2671,
          "ymin": 1345,
          "xmax": 2763,
          "ymax": 1413
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2838,
          "ymin": 1471,
          "xmax": 2892,
          "ymax": 1512
        }
      }
    ]
  },
  "frame_00116.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4654,
          "ymin": 611,
          "xmax": 5393,
          "ymax": 668
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3927,
          "ymin": 870,
          "xmax": 4161,
          "ymax": 1049
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1388,
          "ymin": 1128,
          "xmax": 1688,
          "ymax": 1153
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 790,
          "ymin": 1174,
          "xmax": 1048,
          "ymax": 1204
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2014,
          "ymin": 1191,
          "xmax": 2231,
          "ymax": 1250
        }
      }
    ]
  },
  "frame_00133.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_96",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2114,
          "ymin": 2013,
          "xmax": 2161,
          "ymax": 2081
        }
      }
    ]
  },
  "frame_00136.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1961,
          "ymin": 2002,
          "xmax": 1985,
          "ymax": 2045
        }
      }
    ]
  },
  "frame_00171.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_97",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 971,
          "ymin": 2055,
          "xmax": 1040,
          "ymax": 2188
        }
      }
    ]
  },
  "frame_00176.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_98",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1141,
          "ymin": 2047,
          "xmax": 1165,
          "ymax": 2072
        }
      },
      {
        "id": "obj_99",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1032,
          "ymin": 2060,
          "xmax": 1065,
          "ymax": 2084
        }
      },
      {
        "id": "obj_100",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 908,
          "ymin": 2077,
          "xmax": 938,
          "ymax": 2099
        }
      },
      {
        "id": "obj_101",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 741,
          "ymin": 2093,
          "xmax": 773,
          "ymax": 2117
        }
      },
      {
        "id": "obj_102",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 580,
          "ymin": 2110,
          "xmax": 621,
          "ymax": 2135
        }
      },
      {
        "id": "obj_103",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 399,
          "ymin": 2121,
          "xmax": 431,
          "ymax": 2151
        }
      },
      {
        "id": "obj_104",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 209,
          "ymin": 2130,
          "xmax": 242,
          "ymax": 2156
        }
      },
      {
        "id": "obj_105",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 11,
          "ymin": 2127,
          "xmax": 46,
          "ymax": 2159
        }
      },
      {
        "id": "obj_106",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7485,
          "ymin": 2125,
          "xmax": 7513,
          "ymax": 2154
        }
      },
      {
        "id": "obj_107",
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7293,
          "ymin": 2119,
          "xmax": 7354,
          "ymax": 2150
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2304,
          "ymin": 1962,
          "xmax": 2344,
          "ymax": 2039
        }
      }
    ]
  },
  "frame_00181.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00186.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00191.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00196.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5754,
          "ymin": 1965,
          "xmax": 5784,
          "ymax": 2005
        }
      }
    ]
  },
  "frame_00201.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00204.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_108",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1393,
          "ymin": 1983,
          "xmax": 1436,
          "ymax": 2044
        }
      }
    ]
  },
  "frame_00206.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00211.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_109",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2112,
          "ymin": 2039,
          "xmax": 2176,
          "ymax": 2153
        }
      }
    ]
  },
  "frame_00216.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2691,
          "ymin": 1992,
          "xmax": 2734,
          "ymax": 2064
        }
      }
    ]
  },
  "frame_00221.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": []
  },
  "frame_00226.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2003,
          "ymin": 2019,
          "xmax": 2044,
          "ymax": 2076
        }
      }
    ]
  },
  "frame_00231.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_110",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7512,
          "ymin": 1957,
          "xmax": 7562,
          "ymax": 2073
        }
      }
    ]
  },
  "frame_00236.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5276,
          "ymin": 2005,
          "xmax": 5358,
          "ymax": 2196
        }
      }
    ]
  },
  "frame_00241.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_111",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 371,
          "ymin": 1993,
          "xmax": 424,
          "ymax": 2098
        }
      }
    ]
  },
  "frame_00246.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5300,
          "ymin": 2026,
          "xmax": 5364,
          "ymax": 2146
        }
      }
    ]
  },
  "frame_00256.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": "obj_112",
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 2093,
          "ymin": 2164,
          "xmax": 2219,
          "ymax": 2351
        }
      }
    ]
  },
  "frame_00266.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3956,
          "ymin": 2066,
          "xmax": 4046,
          "ymax": 2242
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6,
          "ymin": 2046,
          "xmax": 30,
          "ymax": 2065
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 109,
          "ymin": 2059,
          "xmax": 132,
          "ymax": 2081
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 215,
          "ymin": 2074,
          "xmax": 240,
          "ymax": 2097
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 348,
          "ymin": 2089,
          "xmax": 374,
          "ymax": 2116
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 511,
          "ymin": 2104,
          "xmax": 537,
          "ymax": 2131
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 699,
          "ymin": 2119,
          "xmax": 733,
          "ymax": 2147
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 950,
          "ymin": 2132,
          "xmax": 986,
          "ymax": 2160
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1185,
          "ymin": 2132,
          "xmax": 1222,
          "ymax": 2163
        }
      },
      {
        "id": null,
        "name": "Staplerladestation",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 1423,
          "ymin": 2126,
          "xmax": 1460,
          "ymax": 2162
        }
      }
    ]
  },
  "frame_00276.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3955,
          "ymin": 470,
          "xmax": 6085,
          "ymax": 830
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6635,
          "ymin": 1220,
          "xmax": 6925,
          "ymax": 1570
        }
      }
    ]
  },
  "frame_00281.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4434,
          "ymin": 2112,
          "xmax": 4532,
          "ymax": 2317
        }
      }
    ]
  },
  "frame_00286.jpg": {
    "size": {
      "width": 7680,
      "height": 3840
    },
    "objects": [
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 6615,
          "ymin": 830,
          "xmax": 7035,
          "ymax": 1370
        }
      },
      {
        "id": null,
        "name": "steckdosen_V",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 3655,
          "ymin": 1959,
          "xmax": 3687,
          "ymax": 2036
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 7054,
          "ymin": 1526,
          "xmax": 7110,
          "ymax": 1650
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 5453,
          "ymin": 1619,
          "xmax": 5796,
          "ymax": 1650
        }
      },
      {
        "id": null,
        "name": "led_b2",
        "pose": "Unspecified",
        "truncated": 0,
        "difficult": 0,
        "bndbox": {
          "xmin": 4785,
          "ymin": 1618,
          "xmax": 5153,
          "ymax": 1645
        }
      }
    ]
  }
};

export const TYPE_INFO = {
  "steckdosen_V": {
    "legend_name": "Steckdosenverteiler Typ 1",
    "lv_name": "Steckdosenkombination Typ1",
    "lv_position": "1.3.14.8"
  },
  "led_b2": {
    "legend_name": "Lichtbandleuchte B2",
    "lv_name": "Lichtbandleuchte B2",
    "lv_position": "1.4.1.2"
  },
  "elektro_V": {
    "legend_name": "Elektroverteiler",
    "lv_name": "Installationskleinverteiler Wandverteiler AP",
    "lv_position": "1.3.1.6"
  },
  "rj_45": {
    "legend_name": "RJ45-Datendose 1-fach, AP",
    "lv_name": "Datendose RJ45-1fach, AP",
    "lv_position": "1.9.2.2"
  },
  "steckdosen_1-fach": {
    "legend_name": "Steckdose 1-fach, UP",
    "lv_name": "Schutzkontaktsteckdose UP",
    "lv_position": "1.3.13.4"
  },
  "hemlet": {
    "legend_name": "",
    "lv_name": "",
    "lv_position": ""
  },
  "Staplerladestation": {
    "legend_name": "CEE_Steckdose 400V, AP",
    "lv_name": "CEE-Steckdose 5p 16A AP",
    "lv_position": "1.3.14.3"
  }
};

export const PLAN_CHESSBOARD_X = {
  "F": 460,
  "F1": 529,
  "G": 884,
  "G1": 1237,
  "G2": 1593,
  "G3": 1946,
  "G4": 2300,
  "G5": 2655,
  "G6": 3009,
  "G7": 3364,
  "H": 3718,
  "H1": 4072,
  "H2": 4427,
  "H3": 4782,
  "I": 5135,
  "I1": 5490,
  "I2": 5845,
  "I3": 6199,
  "I4": 6553,
  "I5": 6908
}

export const PLAN_CHESSBOARD_Y = {
  "45": 234,
  "44": 543,
  "43": 900,
  "42": 1254,
  "41": 1609,
  "40": 1962,
  "39": 2316,
  "38": 2671,
  "37": 3025,
  "36": 3379,
  "35": 3733,
  "34": 4088,
  "33": 4442,
  "32": 4797,
  "31": 5151
}

export const FIRST_OBJECT_IMAGE = "data:image/jpeg;base64,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";
export const SECOND_OBJECT_IMAGE = "data:image/jpeg;base64,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";
